(function e$$0(h,c,l){function k(d,a){if(!c[d]){if(!h[d]){var b="function"==typeof require&&require;if(!a&&b)return b(d,!0);if(e)return e(d,!0);b=Error("Cannot find module '"+d+"'");throw b.code="MODULE_NOT_FOUND",b;}b=c[d]={exports:{}};h[d][0].call(b.exports,function(a){var b=h[d][1][a];return k(b?b:a)},b,b.exports,e$$0,h,c,l)}return c[d].exports}for(var e="function"==typeof require&&require,f=0;f<l.length;f++)k(l[f]);return k})({1:[function(n,h,c){function l(a){return a.replace(g,"&lt;").replace(p,
"&gt;")}function k(a){return a.replace(m,"&quote;")}function e(a){return a.replace(y,'"')}function f(a){return a.replace(t,function(a,b){return"x"===b[0]||"X"===b[0]?String.fromCharCode(parseInt(b.substr(1),16)):String.fromCharCode(parseInt(b,10))})}function d(a){return a.replace(q,":").replace(z," ")}function a(a){for(var b="",d=0,c=a.length;d<c;d++)b+=32>a.charCodeAt(d)?" ":a.charAt(d);return b.trim()}function b(b){b=e(b);b=f(b);b=d(b);return b=a(b)}function v(a){a=k(a);return a=l(a)}var g=/</g,
p=/>/g,m=/"/g,y=/&quot;/g,t=/&#([a-zA-Z0-9]*);?/img,q=/&colon;?/img,z=/&newline;?/img,w=/\/\*|\*\//mg,r=/((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/ig,x=/e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/ig,s=/u\s*r\s*l\s*\(.*/ig,u=/\x3c!--[\s\S]*?--\x3e/g;c.whiteList={a:["target","href","title"],abbr:["title"],address:[],area:["shape","coords","href","alt"],article:[],aside:[],b:[],bdi:["dir"],bdo:["dir"],big:[],blockquote:["cite"],br:[],caption:[],center:[],
cite:[],code:[],col:["align","valign","span","width"],colgroup:["align","valign","span","width"],dd:[],del:["datetime"],details:["open"],div:["style","class"],dl:[],dt:[],em:[],font:["color","size","face"],footer:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],header:[],hr:[],i:[],ins:["datetime"],li:[],label:["class"],mark:[],nav:[],ol:[],p:["class"],pre:[],s:[],section:[],small:[],span:["class"],sub:[],sup:[],strong:[],table:["width","border","align","valign"],tbody:["align","valign"],td:["width","colspan",
"align","valign"],tfoot:["align","valign"],th:["width","colspan","align","valign"],thead:["align","valign"],tr:["rowspan","align","valign"],tt:[],u:[],ul:[]};c.onTag=function(a,b,d){};c.onIgnoreTag=function(a,b,d){};c.onTagAttr=function(a,b,d){};c.onIgnoreTagAttr=function(a,b,d){};c.safeAttrValue=function(a,d,c){c=b(c);if("href"===d||"src"===d){c=c.trim();if("#"===c)return"#";if("http://"!==c.substr(0,7)&&"https://"!==c.substr(0,8)&&"mailto:"!==c.substr(0,7)&&"/"!==c[0])return""}else if("background"===
d){if(r.lastIndex=0,r.test(c))return""}else if("style"===d){w.lastIndex=0;if(w.test(c))return"";x.lastIndex=0;if(x.test(c))return"";s.lastIndex=0;if(s.test(c)&&(r.lastIndex=0,r.test(c)))return""}return c=v(c)};c.escapeHtml=l;c.escapeQuote=k;c.unescapeQuote=e;c.escapeHtmlEntities=f;c.escapeDangerHtml5Entities=d;c.clearNonPrintableCharacter=a;c.friendlyAttrValue=b;c.escapeAttrValue=v;c.onIgnoreTagStripAll=function(){return""};c.StripTagBody=function(a,b){"function"!==typeof b&&(b=function(){});var d=
!Array.isArray(a),c=[],k=!1;return{onIgnoreTag:function(g,f,e){var m;m=d?!0:-1!==a.indexOf(g);if(m){if(e.isClosing)return c.push([!1!==k?k:e.position,e.position+10]),k=!1,"[/removed]";k||(k=e.position);return"[removed]"}return b(g,f,e)},remove:function(a){var b="",d=0;c.forEach(function(c){b+=a.slice(d,c[0]);d=c[1]});return b+=a.slice(d)}}};c.stripCommentTag=function(a){return a.replace(u,"")}},{}],2:[function(n,h,c){var l=n("./default"),k=n("./parser"),e=n("./xss");c=h.exports=function(d,a){return(new e(a)).process(d)};
c.FilterXSS=e;for(var f in l)c[f]=l[f];for(f in k)c[f]=k[f];"undefined"!==typeof window&&(Array.prototype.indexOf||(Array.prototype.indexOf=function(d){for(var a=0;a<this.length;a++)if(this[a]==d)return a;return-1}),Array.prototype.forEach||(Array.prototype.forEach=function(d,a){for(var b=0;b<this.length;b++)d.call(a,this[b],b,this)}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/(^\s*)|(\s*$)/g,"")}),window.filterXSS=h.exports)},{"./default":1,"./parser":3,"./xss":4}],
3:[function(n,h,c){var l=/[^a-zA-Z0-9_:\.\-]/img;c.parseTag=function(c,e,f){"user strict";for(var d="",a=0,b=!1,l=!1,g=0,p=c.length,m="",h="",g=0;g<p;g++)if(m=c.charAt(g),!1===b)"<"===m&&(b=g);else if(!1===l)if("<"===m)d+=f(c.slice(a,g)),a=b=g;else if(">"===m)d+=f(c.slice(a,b)),a=m=c.slice(b,g+1),h=a.indexOf(" "),a=-1===h?a.slice(1,-1):a.slice(1,h+1),a=a.trim().toLowerCase(),"/"===a[0]&&(a=a.slice(1)),"/"===a[a.length-1]&&(a=a.slice(0,-1)),h=a,d+=e(b,d.length,h,m,"</"===m.slice(0,2)),a=g+1,b=!1;else{if('"'===
m||"'"===m)l=m}else m===l&&(l=!1);a<c.length&&(d+=f(c.substr(a)));return d};c.parseAttr=function(c,e){function f(b,c){b=b.trim();b=b.replace(l,"").toLowerCase();1>b.length||a.push(e(b,c||""))}"user strict";for(var d=0,a=[],b=!1,h=c.length,g=0;g<h;g++){var p=c.charAt(g);if(!1===b&&"="===p)b=c.slice(d,g),d=g+1;else{if(!1!==b&&g===d&&('"'===p||"'"===p))if(g=c.indexOf(p,g+1),-1===g)break;else{d=c.slice(d+1,g).trim();f(b,d);b=!1;d=g+1;continue}" "===p&&(d=c.slice(d,g).trim(),!1===b?f(d):f(b,d),b=!1,d=
g+1)}}d<c.length&&(!1===b?f(c.slice(d)):f(b,c.slice(d)));return a.join(" ").trim()}},{}],4:[function(n,h,c){function l(a){var b=a.indexOf(" ");if(-1===b)return{html:"",closing:"/"===a[a.length-2]};a=a.slice(b+1,-1).trim();(b="/"===a[a.length-1])&&(a=a.slice(0,-1).trim());return{html:a,closing:b}}function k(a){a=a||{};a.stripIgnoreTag&&(a.onIgnoreTag&&console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'),a.onIgnoreTag=e.onIgnoreTagStripAll);a.whiteList=
a.whiteList||e.whiteList;a.onTag=a.onTag||e.onTag;a.onTagAttr=a.onTagAttr||e.onTagAttr;a.onIgnoreTag=a.onIgnoreTag||e.onIgnoreTag;a.onIgnoreTagAttr=a.onIgnoreTagAttr||e.onIgnoreTagAttr;a.safeAttrValue=a.safeAttrValue||e.safeAttrValue;a.escapeHtml=a.escapeHtml||e.escapeHtml;this.options=a}var e=n("./default");n=n("./parser");var f=n.parseTag,d=n.parseAttr;k.prototype.process=function(a){var b=this.options,c=b.whiteList,g=b.onTag,h=b.onIgnoreTag,k=b.onTagAttr,n=b.onIgnoreTagAttr,t=b.safeAttrValue,q=
b.escapeHtml;b.allowCommentTag||(a=e.stripCommentTag(a));b.stripIgnoreTagBody?(b=e.StripTagBody(b.stripIgnoreTagBody,h),h=b.onIgnoreTag):b=!1;a=f(a,function(a,b,e,f,s){a={sourcePosition:a,position:b,isClosing:s,isWhite:e in c};b=g(e,f,a);if(void 0!==b&&null!==b)return b;if(a.isWhite){if(a.isClosing)return"</"+e+">";a=l(f);var u=c[e];b=d(a.html,function(a,b){var c=-1!==u.indexOf(a),d=k(e,a,b,c);if(void 0!==d&&null!==d)return d;if(c)return(b=t(e,a,b))?a+'="'+b+'"':a;d=n(e,a,b,c);if(void 0!==d&&null!==
d)return d});f="<"+e;b&&(f+=" "+b);a.closing&&(f+=" /");return f+">"}b=h(e,f,a);return void 0!==b&&null!==b?b:q(f)},q);b&&(a=b.remove(a));return a};h.exports=k},{"./default":1,"./parser":3}]},{},[2]);

/*!
* jquery.inputmask.min.js
* http://github.com/RobinHerbots/jquery.inputmask
* Copyright (c) 2010 - 2015 Robin Herbots
* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
* Version: 3.1.63-22
*/
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){function b(a){var b=document.createElement("input"),c="on"+a,d=c in b;return d||(b.setAttribute(c,"return;"),d="function"==typeof b[c]),b=null,d}function c(a){var b="text"==a||"tel"==a||"password"==a;if(!b){var c=document.createElement("input");c.setAttribute("type",a),b="text"===c.type,c=null}return b}function d(b,c,e){var f=e.aliases[b];return f?(f.alias&&d(f.alias,void 0,e),a.extend(!0,e,f),a.extend(!0,e,c),!0):!1}function e(b,c){function d(c){function d(a,b,c,d){this.matches=[],this.isGroup=a||!1,this.isOptional=b||!1,this.isQuantifier=c||!1,this.isAlternator=d||!1,this.quantifier={min:1,max:1}}function e(c,d,e){var f=b.definitions[d],g=0==c.matches.length;if(e=void 0!=e?e:c.matches.length,f&&!m){f.placeholder=a.isFunction(f.placeholder)?f.placeholder.call(this,b):f.placeholder;for(var h=f.prevalidator,i=h?h.length:0,j=1;j<f.cardinality;j++){var k=i>=j?h[j-1]:[],l=k.validator,n=k.cardinality;c.matches.splice(e++,0,{fn:l?"string"==typeof l?new RegExp(l):new function(){this.test=l}:new RegExp("."),cardinality:n?n:1,optionality:c.isOptional,newBlockMarker:g,casing:f.casing,def:f.definitionSymbol||d,placeholder:f.placeholder,mask:d})}c.matches.splice(e++,0,{fn:f.validator?"string"==typeof f.validator?new RegExp(f.validator):new function(){this.test=f.validator}:new RegExp("."),cardinality:f.cardinality,optionality:c.isOptional,newBlockMarker:g,casing:f.casing,def:f.definitionSymbol||d,placeholder:f.placeholder,mask:d})}else c.matches.splice(e++,0,{fn:null,cardinality:0,optionality:c.isOptional,newBlockMarker:g,casing:null,def:d,placeholder:void 0,mask:d}),m=!1}for(var f,g,h,i,j,k,l=/(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?\})\??|[^.?*+^${[]()|\\]+|./g,m=!1,n=new d,o=[],p=[];f=l.exec(c);)switch(g=f[0],g.charAt(0)){case b.optionalmarker.end:case b.groupmarker.end:if(h=o.pop(),o.length>0){if(i=o[o.length-1],i.matches.push(h),i.isAlternator){j=o.pop();for(var q=0;q<j.matches.length;q++)j.matches[q].isGroup=!1;o.length>0?(i=o[o.length-1],i.matches.push(j)):n.matches.push(j)}}else n.matches.push(h);break;case b.optionalmarker.start:o.push(new d(!1,!0));break;case b.groupmarker.start:o.push(new d(!0));break;case b.quantifiermarker.start:var r=new d(!1,!1,!0);g=g.replace(/[{}]/g,"");var s=g.split(","),t=isNaN(s[0])?s[0]:parseInt(s[0]),u=1==s.length?t:isNaN(s[1])?s[1]:parseInt(s[1]);if(("*"==u||"+"==u)&&(t="*"==u?0:1),r.quantifier={min:t,max:u},o.length>0){var v=o[o.length-1].matches;if(f=v.pop(),!f.isGroup){var w=new d(!0);w.matches.push(f),f=w}v.push(f),v.push(r)}else{if(f=n.matches.pop(),!f.isGroup){var w=new d(!0);w.matches.push(f),f=w}n.matches.push(f),n.matches.push(r)}break;case b.escapeChar:m=!0;break;case b.alternatormarker:o.length>0?(i=o[o.length-1],k=i.matches.pop()):k=n.matches.pop(),k.isAlternator?o.push(k):(j=new d(!1,!1,!1,!0),j.matches.push(k),o.push(j));break;default:if(o.length>0){if(i=o[o.length-1],i.matches.length>0&&!i.isAlternator&&(k=i.matches[i.matches.length-1],k.isGroup&&(k.isGroup=!1,e(k,b.groupmarker.start,0),e(k,b.groupmarker.end))),e(i,g),i.isAlternator){j=o.pop();for(var q=0;q<j.matches.length;q++)j.matches[q].isGroup=!1;o.length>0?(i=o[o.length-1],i.matches.push(j)):n.matches.push(j)}}else n.matches.length>0&&(k=n.matches[n.matches.length-1],k.isGroup&&(k.isGroup=!1,e(k,b.groupmarker.start,0),e(k,b.groupmarker.end))),e(n,g)}return n.matches.length>0&&(k=n.matches[n.matches.length-1],k.isGroup&&(k.isGroup=!1,e(k,b.groupmarker.start,0),e(k,b.groupmarker.end)),p.push(n)),p}function e(e,f){if(void 0==e||""==e)return void 0;if(1==e.length&&0==b.greedy&&0!=b.repeat&&(b.placeholder=""),b.repeat>0||"*"==b.repeat||"+"==b.repeat){var g="*"==b.repeat?0:"+"==b.repeat?1:b.repeat;e=b.groupmarker.start+e+b.groupmarker.end+b.quantifiermarker.start+g+","+b.repeat+b.quantifiermarker.end}var h;return void 0==a.inputmask.masksCache[e]||c===!0?(h={mask:e,maskToken:d(e),validPositions:{},_buffer:void 0,buffer:void 0,tests:{},metadata:f},c!==!0&&(a.inputmask.masksCache[e]=h)):h=a.extend(!0,{},a.inputmask.masksCache[e]),h}function f(a){if(a=a.toString(),b.numericInput){a=a.split("").reverse();for(var c=0;c<a.length;c++)a[c]==b.optionalmarker.start?a[c]=b.optionalmarker.end:a[c]==b.optionalmarker.end?a[c]=b.optionalmarker.start:a[c]==b.groupmarker.start?a[c]=b.groupmarker.end:a[c]==b.groupmarker.end&&(a[c]=b.groupmarker.start);a=a.join("")}return a}var g=void 0;if(a.isFunction(b.mask)&&(b.mask=b.mask.call(this,b)),a.isArray(b.mask)){if(b.mask.length>1){b.keepStatic=void 0==b.keepStatic?!0:b.keepStatic;var h="(";return a.each(b.mask,function(b,c){h.length>1&&(h+=")|("),h+=f(void 0==c.mask||a.isFunction(c.mask)?c:c.mask)}),h+=")",e(h,b.mask)}b.mask=b.mask.pop()}return b.mask&&(g=void 0==b.mask.mask||a.isFunction(b.mask.mask)?e(f(b.mask),b.mask):e(f(b.mask.mask),b.mask)),g}function f(d,e,f){function g(a,b,c){b=b||0;var d,e,f,g=[],h=0;do{if(a===!0&&l().validPositions[h]){var i=l().validPositions[h];e=i.match,d=i.locator.slice(),g.push(c===!0?i.input:G(h,e))}else f=q(h,d,h-1),e=f.match,d=f.locator.slice(),g.push(G(h,e));h++}while((void 0==da||da>h-1)&&null!=e.fn||null==e.fn&&""!=e.def||b>=h);return g.pop(),g}function l(){return e}function m(a){var b=l();b.buffer=void 0,b.tests={},a!==!0&&(b._buffer=void 0,b.validPositions={},b.p=0)}function n(a,b){var c=l(),d=-1,e=c.validPositions;void 0==a&&(a=-1);var f=d,g=d;for(var h in e){var i=parseInt(h);e[i]&&(b||null!=e[i].match.fn)&&(a>=i&&(f=i),i>=a&&(g=i))}return d=-1!=f&&a-f>1||a>g?f:g}function o(b,c,d){if(f.insertMode&&void 0!=l().validPositions[b]&&void 0==d){var e,g=a.extend(!0,{},l().validPositions),h=n();for(e=b;h>=e;e++)delete l().validPositions[e];l().validPositions[b]=c;var i,j=!0,k=l().validPositions;for(e=i=b;h>=e;e++){var m=g[e];if(void 0!=m)for(var o=i;o<B()&&(null==m.match.fn&&k[e]&&(k[e].match.optionalQuantifier===!0||k[e].match.optionality===!0)||null!=m.match.fn);){if(null==m.match.fn||!f.keepStatic&&k[e]&&(void 0!=k[e+1]&&t(e+1,k[e].locator.slice(),e).length>1||void 0!=k[e].alternation)?o++:o=C(i),s(o,m.match.def)){j=z(o,m.input,!0,!0)!==!1,i=o;break}j=null==m.match.fn}if(!j)break}if(!j)return l().validPositions=a.extend(!0,{},g),!1}else l().validPositions[b]=c;return!0}function p(a,b,c,d){var e,g=a;l().p=a,void 0!=l().validPositions[a]&&l().validPositions[a].input==f.radixPoint&&(b++,g++);for(e=g;b>e;e++)void 0!=l().validPositions[e]&&(c===!0||0!=f.canClearPosition(l(),e,n(),d,f))&&delete l().validPositions[e];for(m(!0),e=g+1;e<=n();){for(;void 0!=l().validPositions[g];)g++;var h=l().validPositions[g];g>e&&(e=g+1);var i=l().validPositions[e];void 0!=i&&void 0==h?(s(g,i.match.def)&&z(g,i.input,!0)!==!1&&(delete l().validPositions[e],e++),g++):e++}var j=n(),k=B();for(j>=a&&void 0!=l().validPositions[j]&&l().validPositions[j].input==f.radixPoint&&delete l().validPositions[j],e=j+1;k>=e;e++)l().validPositions[e]&&delete l().validPositions[e];m(!0)}function q(a,b,c){var d=l().validPositions[a];if(void 0==d)for(var e=t(a,b,c),g=n(),h=l().validPositions[g]||t(0)[0],i=void 0!=h.alternation?h.locator[h.alternation].toString().split(","):[],j=0;j<e.length&&(d=e[j],!(d.match&&(f.greedy&&d.match.optionalQuantifier!==!0||(d.match.optionality===!1||d.match.newBlockMarker===!1)&&d.match.optionalQuantifier!==!0)&&(void 0==h.alternation||h.alternation!=d.alternation||void 0!=d.locator[h.alternation]&&y(d.locator[h.alternation].toString().split(","),i))));j++);return d}function r(a){return l().validPositions[a]?l().validPositions[a].match:t(a)[0].match}function s(a,b){for(var c=!1,d=t(a),e=0;e<d.length;e++)if(d[e].match&&d[e].match.def==b){c=!0;break}return c}function t(b,c,d,e){function f(c,d,e,g){function i(e,g,n){if(h>1e4)return alert("jquery.inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. "+l().mask),!0;if(h==b&&void 0==e.matches)return j.push({match:e,locator:g.reverse()}),!0;if(void 0!=e.matches){if(e.isGroup&&n!==!0){if(e=i(c.matches[m+1],g))return!0}else if(e.isOptional){var o=e;if(e=f(e,d,g,n)){var p=j[j.length-1].match,q=0==a.inArray(p,o.matches);if(!q)return!0;k=!0,h=b}}else if(e.isAlternator){var r,s=e,t=[],u=j.slice(),v=g.length,w=d.length>0?d.shift():-1;if(-1==w||"string"==typeof w){var x=h,y=d.slice(),z=[];"string"==typeof w&&(z=w.split(","));for(var A=0;A<s.matches.length;A++){if(j=[],e=i(s.matches[A],[A].concat(g),n)||e,e!==!0&&void 0!=e&&z[z.length-1]<s.matches.length){var B=c.matches.indexOf(e)+1;c.matches.length>B&&(e=i(c.matches[B],[B].concat(g.slice(1,g.length)),n),e&&(z.push(B.toString()),a.each(j,function(a,b){b.alternation=g.length-1})))}r=j.slice(),h=x,j=[];for(var C=0;C<y.length;C++)d[C]=y[C];for(var D=0;D<r.length;D++){var E=r[D];E.alternation=E.alternation||v;for(var F=0;F<t.length;F++){var G=t[F];if(E.match.mask==G.match.mask&&("string"!=typeof w||-1!=a.inArray(E.locator[E.alternation].toString(),z))){r.splice(D,1),D--,G.locator[E.alternation]=G.locator[E.alternation]+","+E.locator[E.alternation],G.alternation=E.alternation;break}}}t=t.concat(r)}"string"==typeof w&&(t=a.map(t,function(b,c){if(isFinite(c)){var d,e=b.alternation,f=b.locator[e].toString().split(",");b.locator[e]=void 0,b.alternation=void 0;for(var g=0;g<f.length;g++)d=-1!=a.inArray(f[g],z),d&&(void 0!=b.locator[e]?(b.locator[e]+=",",b.locator[e]+=f[g]):b.locator[e]=parseInt(f[g]),b.alternation=e);if(void 0!=b.locator[e])return b}})),j=u.concat(t),h=b,k=j.length>0}else e=s.matches[w]?i(s.matches[w],[w].concat(g),n):!1;if(e)return!0}else if(e.isQuantifier&&n!==!0)for(var H=e,I=d.length>0&&n!==!0?d.shift():0;I<(isNaN(H.quantifier.max)?I+1:H.quantifier.max)&&b>=h;I++){var J=c.matches[a.inArray(H,c.matches)-1];if(e=i(J,[I].concat(g),!0)){var p=j[j.length-1].match;p.optionalQuantifier=I>H.quantifier.min-1;var q=0==a.inArray(p,J.matches);if(q){if(I>H.quantifier.min-1){k=!0,h=b;break}return!0}return!0}}else if(e=f(e,d,g,n))return!0}else h++}for(var m=d.length>0?d.shift():0;m<c.matches.length;m++)if(c.matches[m].isQuantifier!==!0){var n=i(c.matches[m],[m].concat(e),g);if(n&&h==b)return n;if(h>b)break}}var g=l().maskToken,h=c?d:0,i=c||[0],j=[],k=!1;if(e===!0&&l().tests[b])return l().tests[b];if(void 0==c){for(var m,n=b-1;void 0==(m=l().validPositions[n])&&n>-1&&(!l().tests[n]||void 0==(m=l().tests[n][0]));)n--;void 0!=m&&n>-1&&(h=n,i=m.locator.slice())}for(var o=i.shift();o<g.length;o++){var p=f(g[o],i,[o]);if(p&&h==b||h>b)break}return(0==j.length||k)&&j.push({match:{fn:null,cardinality:0,optionality:!0,casing:null,def:""},locator:[]}),l().tests[b]=a.extend(!0,[],j),l().tests[b]}function u(){return void 0==l()._buffer&&(l()._buffer=g(!1,1)),l()._buffer}function v(){return void 0==l().buffer&&(l().buffer=g(!0,n(),!0)),l().buffer}function w(a,b,c){if(c=c||v().slice(),a===!0)m(),a=0,b=c.length;else for(var d=a;b>d;d++)delete l().validPositions[d],delete l().tests[d];for(var d=a;b>d;d++)c[d]!=f.skipOptionalPartCharacter&&z(d,c[d],!0,!0)}function x(a,b){switch(b.casing){case"upper":a=a.toUpperCase();break;case"lower":a=a.toLowerCase()}return a}function y(b,c){for(var d=f.greedy?c:c.slice(0,1),e=!1,g=0;g<b.length;g++)if(-1!=a.inArray(b[g],d)){e=!0;break}return e}function z(b,c,d,e){function g(b,c,d,e){var g=!1;return a.each(t(b),function(h,i){for(var j=i.match,k=c?1:0,q="",r=(v(),j.cardinality);r>k;r--)q+=E(b-(r-1));if(c&&(q+=c),g=null!=j.fn?j.fn.test(q,l(),b,d,f):c!=j.def&&c!=f.skipOptionalPartCharacter||""==j.def?!1:{c:j.def,pos:b},g!==!1){var s=void 0!=g.c?g.c:c;s=s==f.skipOptionalPartCharacter&&null===j.fn?j.def:s;var t=b,u=v();if(void 0!=g.remove&&(a.isArray(g.remove)||(g.remove=[g.remove]),a.each(g.remove.sort(function(a,b){return b-a}),function(a,b){p(b,b+1,!0)})),void 0!=g.insert&&(a.isArray(g.insert)||(g.insert=[g.insert]),a.each(g.insert.sort(function(a,b){return a-b}),function(a,b){z(b.pos,b.c,!0)})),g.refreshFromBuffer){var y=g.refreshFromBuffer;if(d=!0,w(y===!0?y:y.start,y.end,u),void 0==g.pos&&void 0==g.c)return g.pos=n(),!1;if(t=void 0!=g.pos?g.pos:b,t!=b)return g=a.extend(g,z(t,s,!0)),!1}else if(g!==!0&&void 0!=g.pos&&g.pos!=b&&(t=g.pos,w(b,t),t!=b))return g=a.extend(g,z(t,s,!0)),!1;return 1!=g&&void 0==g.pos&&void 0==g.c?!1:(h>0&&m(!0),o(t,a.extend({},i,{input:x(s,j)}),e)||(g=!1),!1)}}),g}function h(b,c,d,e){var g,h,i,j,k=a.extend(!0,{},l().validPositions);for(g=n();g>=0;g--)if(j=l().validPositions[g],j&&void 0!=j.alternation&&j.locator[j.alternation].length>1){h=l().validPositions[g].alternation;break}if(void 0!=h)for(var o in l().validPositions)if(j=l().validPositions[o],parseInt(o)>parseInt(g)&&void 0!=j.alternation){for(var p=l().validPositions[g].locator[h].toString().split(","),q=j.locator[h]||p[0],r=0;r<p.length;r++)if(q<p[r]){for(var s,t,u=o-1;u>=0;u--)if(s=l().validPositions[u],void 0!=s){t=s.locator[h],s.locator[h]=parseInt(p[r]);break}if(q!=s.locator[h]){for(var v=[],w=o;w<n()+1;w++){var x=l().validPositions[w];x&&null!=x.match.fn&&v.push(x.input),delete l().validPositions[w],delete l().tests[w]}for(m(!0),f.keepStatic=!f.keepStatic,i=!0;v.length>0;){var y=v.shift();if(y!=f.skipOptionalPartCharacter&&!(i=z(n()+1,y,!1,!0)))break}if(s.alternation=h,s.locator[h]=t,i){var A=n(b)+1;i=z(b>A?A:b,c,d,e)}if(f.keepStatic=!f.keepStatic,i)return i;m(),l().validPositions=a.extend(!0,{},k)}}break}return!1}function i(b,c){for(var d=l().validPositions[c],e=d.locator,f=e.length,g=b;c>g;g++)if(!A(g)){var h=t(g),i=h[0],j=-1;a.each(h,function(a,b){for(var c=0;f>c;c++)b.locator[c]&&y(b.locator[c].toString().split(","),e[c].toString().split(","))&&c>j&&(j=c,i=b)}),o(g,a.extend({},i,{input:i.match.def}),!0)}}d=d===!0;for(var j=v(),k=b-1;k>-1&&!l().validPositions[k];k--);for(k++;b>k;k++)void 0==l().validPositions[k]&&((!A(k)||j[k]!=G(k))&&t(k).length>1||j[k]==f.radixPoint||"0"==j[k]&&a.inArray(f.radixPoint,j)<k)&&g(k,j[k],!0);var q=b,r=!1,s=a.extend(!0,{},l().validPositions);if(q<B()&&(r=g(q,c,d,e),(!d||e)&&r===!1)){var u=l().validPositions[q];if(!u||null!=u.match.fn||u.match.def!=c&&c!=f.skipOptionalPartCharacter){if((f.insertMode||void 0==l().validPositions[C(q)])&&!A(q))for(var D=q+1,F=C(q);F>=D;D++)if(r=g(D,c,d,e),r!==!1){i(q,D),q=D;break}}else r={caret:C(q)}}if(r===!1&&f.keepStatic&&O(j)&&(r=h(b,c,d,e)),r===!0&&(r={pos:q}),a.isFunction(f.postValidation)&&0!=r&&!d){m(!0);var H=f.postValidation(v(),f);if(!H)return m(!0),l().validPositions=a.extend(!0,{},s),!1}return r}function A(a){var b=r(a);if(null!=b.fn)return b.fn;if(!f.keepStatic&&void 0==l().validPositions[a]){for(var c=t(a),d=!0,e=0;e<c.length;e++)if(""!=c[e].match.def&&(void 0==c[e].alternation||c[e].locator[c[e].alternation].length>1)){d=!1;break}return d}return!1}function B(){var a;da=ca.prop("maxLength"),-1==da&&(da=void 0);var b,c=n(),d=l().validPositions[c],e=void 0!=d?d.locator.slice():void 0;for(b=c+1;void 0==d||null!=d.match.fn||null==d.match.fn&&""!=d.match.def;b++)d=q(b,e,b-1),e=d.locator.slice();var f=r(b-1);return a=""!=f.def?b:b-1,void 0==da||da>a?a:da}function C(a){var b=B();if(a>=b)return b;for(var c=a;++c<b&&!A(c)&&(f.nojumps!==!0||f.nojumpsThreshold>c););return c}function D(a){var b=a;if(0>=b)return 0;for(;--b>0&&!A(b););return b}function E(a){return void 0==l().validPositions[a]?G(a):l().validPositions[a].input}function F(b,c,d,e,g){if(e&&a.isFunction(f.onBeforeWrite)){var h=f.onBeforeWrite.call(b,e,c,d,f);if(h){if(h.refreshFromBuffer){var i=h.refreshFromBuffer;w(i===!0?i:i.start,i.end,h.buffer),m(!0),c=v()}d=h.caret||d}}b._valueSet(c.join("")),void 0!=d&&L(b,d),g===!0&&(ga=!0,a(b).trigger("input"))}function G(a,b){if(b=b||r(a),void 0!=b.placeholder)return b.placeholder;if(null==b.fn){if(!f.keepStatic&&void 0==l().validPositions[a]){for(var c=t(a),d=!0,e=0;e<c.length;e++)if(""!=c[e].match.def&&(null!==c[e].match.fn||void 0==c[e].alternation||c[e].locator[c[e].alternation].length>1)){d=!1;break}if(d)return f.placeholder.charAt(a%f.placeholder.length)}return b.def}return f.placeholder.charAt(a%f.placeholder.length)}function H(b,c,d,e){function f(){var a=!1,b=u().slice(i,C(i)).join("").indexOf(h);if(-1!=b&&!A(i)){a=!0;for(var c=u().slice(i,i+b),d=0;d<c.length;d++)if(" "!=c[d]){a=!1;break}}return a}var g=void 0!=e?e.slice():b._valueGet().split(""),h="",i=0;if(m(),l().p=C(-1),c&&b._valueSet(""),!d){var j=u().slice(0,C(-1)).join(""),k=g.join("").match(new RegExp(I(j),"g"));k&&k.length>0&&(g.splice(0,k.length*j.length),i=C(i))}a.each(g,function(c,e){var g=a.Event("keypress");g.which=e.charCodeAt(0),h+=e;var j=n(void 0,!0),k=l().validPositions[j],m=q(j+1,k?k.locator.slice():void 0,j);if(!f()||d){var o=d?c:null==m.match.fn&&m.match.optionality&&j+1<l().p?j+1:l().p;U.call(b,g,!0,!1,d,o),i=o+1,h=""}else U.call(b,g,!0,!1,!0,j+1)}),c&&F(b,v(),a(b).is(":focus")?C(n(0)):void 0,a.Event("checkval"))}function I(b){return a.inputmask.escapeRegex(b)}function J(b){if(b.data("_inputmask")&&!b.hasClass("hasDatepicker")){var c=[],d=l().validPositions;for(var e in d)d[e].match&&null!=d[e].match.fn&&c.push(d[e].input);var g=(ea?c.reverse():c).join(""),h=(ea?v().slice().reverse():v()).join("");return a.isFunction(f.onUnMask)&&(g=f.onUnMask.call(b,h,g,f)||g),g}return b[0]._valueGet()}function K(a){if(ea&&"number"==typeof a&&(!f.greedy||""!=f.placeholder)){var b=v().length;a=b-a}return a}function L(b,c,d){var e,g=b.jquery&&b.length>0?b[0]:b;if("number"!=typeof c)return g.setSelectionRange?(c=g.selectionStart,d=g.selectionEnd):window.getSelection?(e=window.getSelection().getRangeAt(0),e.commonAncestorContainer.parentNode==g&&(c=e.startOffset,d=e.endOffset)):document.selection&&document.selection.createRange&&(e=document.selection.createRange(),c=0-e.duplicate().moveStart("character",-1e5),d=c+e.text.length),{begin:K(c),end:K(d)};if(c=K(c),d=K(d),d="number"==typeof d?d:c,a(g).is(":visible")){var h=a(g).css("font-size").replace("px","")*d;if(g.scrollLeft=h>g.scrollWidth?h:0,i||0!=f.insertMode||c!=d||d++,g.setSelectionRange)g.selectionStart=c,g.selectionEnd=d;else if(window.getSelection){e=document.createRange(),e.setStart(g.firstChild,c<g._valueGet().length?c:g._valueGet().length),e.setEnd(g.firstChild,d<g._valueGet().length?d:g._valueGet().length),e.collapse(!0);var j=window.getSelection();j.removeAllRanges(),j.addRange(e)}else g.createTextRange&&(e=g.createTextRange(),e.collapse(!0),e.moveEnd("character",d),e.moveStart("character",c),e.select())}}function M(b){var c,d,e=v(),f=e.length,g=n(),h={},i=l().validPositions[g],j=void 0!=i?i.locator.slice():void 0;for(c=g+1;c<e.length;c++)d=q(c,j,c-1),j=d.locator.slice(),h[c]=a.extend(!0,{},d);var k=i&&void 0!=i.alternation?i.locator[i.alternation]:void 0;for(c=f-1;c>g&&(d=h[c].match,(d.optionality||d.optionalQuantifier||k&&k!=h[c].locator[i.alternation])&&e[c]==G(c,d));c--)f--;return b?{l:f,def:h[f]?h[f].match:void 0}:f}function N(a){for(var b=M(),c=a.length-1;c>b&&!A(c);c--);return a.splice(b,c+1-b),a}function O(b){if(a.isFunction(f.isComplete))return f.isComplete.call(ca,b,f);if("*"==f.repeat)return void 0;{var c=!1,d=M(!0),e=D(d.l);n()}if(void 0==d.def||d.def.newBlockMarker||d.def.optionality||d.def.optionalQuantifier){c=!0;for(var g=0;e>=g;g++){var h=q(g).match;if(null!=h.fn&&void 0==l().validPositions[g]&&h.optionality!==!0&&h.optionalQuantifier!==!0||null==h.fn&&b[g]!=G(g,h)){c=!1;break}}}return c}function P(a,b){return ea?a-b>1||a-b==1&&f.insertMode:b-a>1||b-a==1&&f.insertMode}function Q(b){var c=a._data(b).events,d=!1;a.each(c,function(b,c){a.each(c,function(a,b){if("inputmask"==b.namespace&&"setvalue"!=b.type){var c=b.handler;b.handler=function(a){if(!this.disabled&&(!this.readOnly||"keydown"==a.type&&a.ctrlKey&&67==a.keyCode)){switch(a.type){case"input":if(ga===!0||d===!0)return ga=!1,a.preventDefault();break;case"keydown":fa=!1,d=!1;break;case"keypress":if(fa===!0)return a.preventDefault();fa=!0;break;case"compositionstart":d=!0;break;case"compositionupdate":ga=!0;break;case"compositionend":d=!1}return c.apply(this,arguments)}a.preventDefault()}}})})}function R(b){function c(b){if(void 0==a.valHooks[b]||1!=a.valHooks[b].inputmaskpatch){var c=a.valHooks[b]&&a.valHooks[b].get?a.valHooks[b].get:function(a){return a.value},d=a.valHooks[b]&&a.valHooks[b].set?a.valHooks[b].set:function(a,b){return a.value=b,a};a.valHooks[b]={get:function(b){var d=a(b);if(d.data("_inputmask")){if(d.data("_inputmask").opts.autoUnmask)return d.inputmask("unmaskedvalue");var e=c(b),f=d.data("_inputmask"),g=f.maskset,h=g._buffer;return h=h?h.join(""):"",e!=h?e:""}return c(b)},set:function(b,c){var e,f=a(b),g=f.data("_inputmask");return e=d(b,c),g&&f.triggerHandler("setvalue.inputmask"),e},inputmaskpatch:!0}}}function d(){var b=a(this),c=a(this).data("_inputmask");return c?c.opts.autoUnmask?b.inputmask("unmaskedvalue"):g.call(this)!=u().join("")?g.call(this):"":g.call(this)}function e(b){var c=a(this).data("_inputmask");h.call(this,b),c&&a(this).triggerHandler("setvalue.inputmask")}function f(b){a(b).bind("mouseenter.inputmask",function(){var b=a(this),c=this,d=c._valueGet();""!=d&&d!=v().join("")&&b.triggerHandler("setvalue.inputmask")});
//!! the bound handlers are executed in the order they where bound
var c=a._data(b).events,d=c.mouseover;if(d){for(var e=d[d.length-1],f=d.length-1;f>0;f--)d[f]=d[f-1];d[0]=e}}var g,h;if(!b._valueGet){var i;Object.getOwnPropertyDescriptor&&void 0==b.value?(g=function(){return this.textContent},h=function(a){this.textContent=a},Object.defineProperty(b,"value",{get:d,set:e})):((i=Object.getOwnPropertyDescriptor&&Object.getOwnPropertyDescriptor(b,"value"))&&i.configurable,document.__lookupGetter__&&b.__lookupGetter__("value")?(g=b.__lookupGetter__("value"),h=b.__lookupSetter__("value"),b.__defineGetter__("value",d),b.__defineSetter__("value",e)):(g=function(){return b.value},h=function(a){b.value=a},c(b.type),f(b))),b._valueGet=function(a){return ea&&a!==!0?g.call(this).split("").reverse().join(""):g.call(this)},b._valueSet=function(a){h.call(this,ea?a.split("").reverse().join(""):a)}}}function S(b,c,d,e){function g(){if(f.keepStatic){m(!0);var c,d=[],e=a.extend(!0,{},l().validPositions);for(c=n();c>=0;c--){var g=l().validPositions[c];if(g){if(void 0!=g.alternation&&g.locator[g.alternation]==q(c).locator[g.alternation])break;null!=g.match.fn&&d.push(g.input),delete l().validPositions[c]}}if(c>0)for(;d.length>0;){l().p=C(n());var h=a.Event("keypress");h.which=d.pop().charCodeAt(0),U.call(b,h,!0,!1,!1,l().p)}else l().validPositions=a.extend(!0,{},e)}}if((f.numericInput||ea)&&(c==a.inputmask.keyCode.BACKSPACE?c=a.inputmask.keyCode.DELETE:c==a.inputmask.keyCode.DELETE&&(c=a.inputmask.keyCode.BACKSPACE),ea)){var h=d.end;d.end=d.begin,d.begin=h}if(c==a.inputmask.keyCode.BACKSPACE&&(d.end-d.begin<1||0==f.insertMode)?d.begin=D(d.begin):c==a.inputmask.keyCode.DELETE&&d.begin==d.end&&(d.end=A(d.end)?d.end+1:C(d.end)+1),p(d.begin,d.end,!1,e),e!==!0){g();var i=n(d.begin);i<d.begin?(-1==i&&m(),l().p=C(i)):l().p=d.begin}}function T(c){var d=this,e=a(d),g=c.keyCode,i=L(d);g==a.inputmask.keyCode.BACKSPACE||g==a.inputmask.keyCode.DELETE||h&&127==g||c.ctrlKey&&88==g&&!b("cut")?(c.preventDefault(),88==g&&(_=v().join("")),S(d,g,i),F(d,v(),l().p,c,_!=v().join("")),d._valueGet()==u().join("")?e.trigger("cleared"):O(v())===!0&&e.trigger("complete"),f.showTooltip&&e.prop("title",l().mask)):g==a.inputmask.keyCode.END||g==a.inputmask.keyCode.PAGE_DOWN?setTimeout(function(){var a=C(n());f.insertMode||a!=B()||c.shiftKey||a--,L(d,c.shiftKey?i.begin:a,a)},0):g==a.inputmask.keyCode.HOME&&!c.shiftKey||g==a.inputmask.keyCode.PAGE_UP?L(d,0,c.shiftKey?i.begin:0):(f.undoOnEscape&&g==a.inputmask.keyCode.ESCAPE||90==g&&c.ctrlKey)&&c.altKey!==!0?(H(d,!0,!1,_.split("")),e.click()):g!=a.inputmask.keyCode.INSERT||c.shiftKey||c.ctrlKey?0!=f.insertMode||c.shiftKey||(g==a.inputmask.keyCode.RIGHT?setTimeout(function(){var a=L(d);L(d,a.begin)},0):g==a.inputmask.keyCode.LEFT&&setTimeout(function(){var a=L(d);L(d,ea?a.begin+1:a.begin-1)},0)):(f.insertMode=!f.insertMode,L(d,f.insertMode||i.begin!=B()?i.begin:i.begin-1)),f.onKeyDown.call(this,c,v(),L(d).begin,f),ha=-1!=a.inArray(g,f.ignorables)}function U(b,c,d,e,g){var h=this,i=a(h),j=b.which||b.charCode||b.keyCode;if(!(c===!0||b.ctrlKey&&b.altKey)&&(b.ctrlKey||b.metaKey||ha))return!0;if(j){46==j&&0==b.shiftKey&&","==f.radixPoint&&(j=44);var k,n=c?{begin:g,end:g}:L(h),p=String.fromCharCode(j),q=P(n.begin,n.end);q&&(l().undoPositions=a.extend(!0,{},l().validPositions),S(h,a.inputmask.keyCode.DELETE,n,!0),n.begin=l().p,f.insertMode||(f.insertMode=!f.insertMode,o(n.begin,e),f.insertMode=!f.insertMode),q=!f.multi),l().writeOutBuffer=!0;var r=ea&&!q?n.end:n.begin,s=z(r,p,e);if(s!==!1){if(s!==!0&&(r=void 0!=s.pos?s.pos:r,p=void 0!=s.c?s.c:p),m(!0),void 0!=s.caret)k=s.caret;else{var u=l().validPositions;k=!f.keepStatic&&(void 0!=u[r+1]&&t(r+1,u[r].locator.slice(),r).length>1||void 0!=u[r].alternation)?r+1:C(r)}l().p=k}if(d!==!1){var x=this;if(setTimeout(function(){f.onKeyValidation.call(x,s,f)},0),l().writeOutBuffer&&s!==!1){var y=v();F(h,y,c?void 0:f.numericInput?D(k):k,b,c!==!0),c!==!0&&setTimeout(function(){O(y)===!0&&i.trigger("complete")},0)}else q&&(l().buffer=void 0,l().validPositions=l().undoPositions)}else q&&(l().buffer=void 0,l().validPositions=l().undoPositions);if(f.showTooltip&&i.prop("title",l().mask),c&&a.isFunction(f.onBeforeWrite)){var A=f.onBeforeWrite.call(this,b,v(),k,f);if(A&&A.refreshFromBuffer){var B=A.refreshFromBuffer;w(B===!0?B:B.start,B.end,A.buffer),m(!0),A.caret&&(l().p=A.caret)}}b.preventDefault()}}function V(b){var c=this,d=a(c),e=c._valueGet(!0),g=L(c);if("propertychange"==b.type&&c._valueGet().length<=B())return!0;if("paste"==b.type){var h=e.substr(0,g.begin),i=e.substr(g.end,e.length);h==u().slice(0,g.begin).join("")&&(h=""),i==u().slice(g.end).join("")&&(i=""),window.clipboardData&&window.clipboardData.getData?e=h+window.clipboardData.getData("Text")+i:b.originalEvent&&b.originalEvent.clipboardData&&b.originalEvent.clipboardData.getData&&(e=h+b.originalEvent.clipboardData.getData("text/plain")+i)}var j=e;if(a.isFunction(f.onBeforePaste)){if(j=f.onBeforePaste.call(c,e,f),j===!1)return b.preventDefault(),!1;j||(j=e)}return H(c,!0,!1,ea?j.split("").reverse():j.split("")),d.click(),O(v())===!0&&d.trigger("complete"),!1}function W(b){var c=this;H(c,!0,!1),O(v())===!0&&a(c).trigger("complete"),b.preventDefault()}function X(a){var b=this;_=v().join(""),(""==ba||0!=a.originalEvent.data.indexOf(ba))&&(aa=L(b))}function Y(b){var c=this,d=aa||L(c);0==b.originalEvent.data.indexOf(ba)&&(m(),d={begin:0,end:0});var e=b.originalEvent.data;L(c,d.begin,d.end);for(var g=0;g<e.length;g++){var h=a.Event("keypress");h.which=e.charCodeAt(g),fa=!1,ha=!1,U.call(c,h)}setTimeout(function(){var a=l().p;F(c,v(),f.numericInput?D(a):a)},0),ba=b.originalEvent.data}function Z(){}function $(b){if(ca=a(b),ca.is(":input")&&c(ca.attr("type"))||b.isContentEditable||ca.is("div")){if(ca.data("_inputmask",{maskset:e,opts:f,isRTL:!1}),f.showTooltip&&ca.prop("title",l().mask),("rtl"==b.dir||f.rightAlign)&&ca.css("text-align","right"),"rtl"==b.dir||f.numericInput){b.dir="ltr",ca.removeAttr("dir");var d=ca.data("_inputmask");d.isRTL=!0,ca.data("_inputmask",d),ea=!0}ca.unbind(".inputmask"),(ca.is(":input")||b.isContentEditable)&&(ca.closest("form").bind("submit",function(){_!=v().join("")&&ca.change(),ca[0]._valueGet&&ca[0]._valueGet()==u().join("")&&ca[0]._valueSet(""),f.removeMaskOnSubmit&&ca.inputmask("remove")}).bind("reset",function(){setTimeout(function(){ca.triggerHandler("setvalue.inputmask")},0)}),ca.bind("mouseenter.inputmask",function(){var b=a(this),c=this;!b.is(":focus")&&f.showMaskOnHover&&c._valueGet()!=v().join("")&&F(c,v())}).bind("blur.inputmask",function(b){var c=a(this),d=this;if(c.data("_inputmask")){var e=d._valueGet(),g=v().slice();ia=!0,_!=g.join("")&&setTimeout(function(){c.change(),_=g.join("")},0),""!=e&&(f.clearMaskOnLostFocus&&(e==u().join("")?g=[]:N(g)),O(g)===!1&&(c.trigger("incomplete"),f.clearIncomplete&&(m(),g=f.clearMaskOnLostFocus?[]:u().slice())),F(d,g,void 0,b))}}).bind("focus.inputmask",function(){var b=(a(this),this),c=b._valueGet();f.showMaskOnFocus&&(!f.showMaskOnHover||f.showMaskOnHover&&""==c)&&b._valueGet()!=v().join("")&&F(b,v(),C(n())),_=v().join("")}).bind("mouseleave.inputmask",function(){var b=a(this),c=this;if(f.clearMaskOnLostFocus){var d=v().slice(),e=c._valueGet();b.is(":focus")||e==b.attr("placeholder")||""==e||(e==u().join("")?d=[]:N(d),F(c,d))}}).bind("click.inputmask",function(){var b=a(this),c=this;if(b.is(":focus")){var d=L(c);if(d.begin==d.end)if(f.radixFocus&&""!=f.radixPoint&&-1!=a.inArray(f.radixPoint,v())&&(ia||v().join("")==u().join("")))L(c,a.inArray(f.radixPoint,v())),ia=!1;else{var e=ea?K(d.begin):d.begin,g=C(n(e));g>e?L(c,A(e)?e:C(e)):L(c,g)}}}).bind("dblclick.inputmask",function(){var a=this;setTimeout(function(){L(a,0,C(n()))},0)}).bind(k+".inputmask dragdrop.inputmask drop.inputmask",V).bind("cut.inputmask",function(b){ga=!0;var c=this,d=a(c),e=L(c);S(c,a.inputmask.keyCode.DELETE,e),F(c,v(),l().p,b,_!=v().join("")),c._valueGet()==u().join("")&&d.trigger("cleared"),f.showTooltip&&d.prop("title",l().mask)}).bind("complete.inputmask",f.oncomplete).bind("incomplete.inputmask",f.onincomplete).bind("cleared.inputmask",f.oncleared),ca.bind("keydown.inputmask",T).bind("keypress.inputmask",U),j||ca.bind("compositionstart.inputmask",X).bind("compositionupdate.inputmask",Y).bind("compositionend.inputmask",Z),"paste"===k&&ca.bind("input.inputmask",W)),ca.bind("setvalue.inputmask",function(){var b=this,c=b._valueGet();b._valueSet(a.isFunction(f.onBeforeMask)?f.onBeforeMask.call(b,c,f)||c:c),H(b,!0,!1),_=v().join(""),(f.clearMaskOnLostFocus||f.clearIncomplete)&&b._valueGet()==u().join("")&&b._valueSet("")}),R(b);var g=a.isFunction(f.onBeforeMask)?f.onBeforeMask.call(b,b._valueGet(),f)||b._valueGet():b._valueGet();H(b,!0,!1,g.split(""));var h=v().slice();_=h.join("");var i;try{i=document.activeElement}catch(o){}O(h)===!1&&f.clearIncomplete&&m(),f.clearMaskOnLostFocus&&(h.join("")==u().join("")?h=[]:N(h)),F(b,h),i===b&&L(b,C(n())),Q(b)}}var _,aa,ba,ca,da,ea=!1,fa=!1,ga=!1,ha=!1,ia=!0;if(void 0!=d)switch(d.action){case"isComplete":return ca=a(d.el),e=ca.data("_inputmask").maskset,f=ca.data("_inputmask").opts,O(d.buffer);case"unmaskedvalue":return ca=d.$input,e=ca.data("_inputmask").maskset,f=ca.data("_inputmask").opts,ea=d.$input.data("_inputmask").isRTL,J(d.$input);case"mask":_=v().join(""),$(d.el);break;case"format":ca=a({}),ca.data("_inputmask",{maskset:e,opts:f,isRTL:f.numericInput}),f.numericInput&&(ea=!0);var ja=(a.isFunction(f.onBeforeMask)?f.onBeforeMask.call(ca,d.value,f)||d.value:d.value).split("");return H(ca,!1,!1,ea?ja.reverse():ja),a.isFunction(f.onBeforeWrite)&&f.onBeforeWrite.call(this,void 0,v(),0,f),d.metadata?{value:ea?v().slice().reverse().join(""):v().join(""),metadata:ca.inputmask("getmetadata")}:ea?v().slice().reverse().join(""):v().join("");case"isValid":ca=a({}),ca.data("_inputmask",{maskset:e,opts:f,isRTL:f.numericInput}),f.numericInput&&(ea=!0);var ja=d.value.split("");H(ca,!1,!0,ea?ja.reverse():ja);for(var ka=v(),la=M(),ma=ka.length-1;ma>la&&!A(ma);ma--);return ka.splice(la,ma+1-la),O(ka)&&d.value==ka.join("");case"getemptymask":return ca=a(d.el),e=ca.data("_inputmask").maskset,f=ca.data("_inputmask").opts,u();case"remove":var na=d.el;ca=a(na),e=ca.data("_inputmask").maskset,f=ca.data("_inputmask").opts,na._valueSet(J(ca)),ca.unbind(".inputmask"),ca.removeData("_inputmask");var oa;Object.getOwnPropertyDescriptor&&(oa=Object.getOwnPropertyDescriptor(na,"value")),oa&&oa.get?na._valueGet&&Object.defineProperty(na,"value",{get:na._valueGet,set:na._valueSet}):document.__lookupGetter__&&na.__lookupGetter__("value")&&na._valueGet&&(na.__defineGetter__("value",na._valueGet),na.__defineSetter__("value",na._valueSet));try{delete na._valueGet,delete na._valueSet}catch(pa){na._valueGet=void 0,na._valueSet=void 0}break;case"getmetadata":if(ca=a(d.el),e=ca.data("_inputmask").maskset,f=ca.data("_inputmask").opts,a.isArray(e.metadata)){for(var qa,ra=n(),sa=ra;sa>=0;sa--)if(l().validPositions[sa]&&void 0!=l().validPositions[sa].alternation){qa=l().validPositions[sa].alternation;break}return void 0!=qa?e.metadata[l().validPositions[ra].locator[qa]]:e.metadata[0]}return e.metadata}}if(void 0===a.fn.inputmask){var g=navigator.userAgent,h=null!==g.match(new RegExp("iphone","i")),i=(null!==g.match(new RegExp("android.*safari.*","i")),null!==g.match(new RegExp("android.*chrome.*","i"))),j=null!==g.match(new RegExp("android.*firefox.*","i")),k=(/Kindle/i.test(g)||/Silk/i.test(g)||/KFTT/i.test(g)||/KFOT/i.test(g)||/KFJWA/i.test(g)||/KFJWI/i.test(g)||/KFSOWI/i.test(g)||/KFTHWA/i.test(g)||/KFTHWI/i.test(g)||/KFAPWA/i.test(g)||/KFAPWI/i.test(g),b("paste")?"paste":b("input")?"input":"propertychange");a.inputmask={defaults:{placeholder:"_",optionalmarker:{start:"[",end:"]"},quantifiermarker:{start:"{",end:"}"},groupmarker:{start:"(",end:")"},alternatormarker:"|",escapeChar:"\\",mask:null,oncomplete:a.noop,onincomplete:a.noop,oncleared:a.noop,repeat:0,greedy:!0,autoUnmask:!1,removeMaskOnSubmit:!1,clearMaskOnLostFocus:!0,insertMode:!0,clearIncomplete:!1,aliases:{},alias:null,onKeyDown:a.noop,onBeforeMask:void 0,onBeforePaste:void 0,onBeforeWrite:void 0,onUnMask:void 0,showMaskOnFocus:!0,showMaskOnHover:!0,onKeyValidation:a.noop,skipOptionalPartCharacter:" ",showTooltip:!1,numericInput:!1,rightAlign:!1,undoOnEscape:!0,radixPoint:"",radixFocus:!1,nojumps:!1,nojumpsThreshold:0,keepStatic:void 0,definitions:{9:{validator:"[0-9]",cardinality:1,definitionSymbol:"*"},a:{validator:"[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",cardinality:1,definitionSymbol:"*"},"*":{validator:"[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",cardinality:1}},ignorables:[8,9,13,19,27,33,34,35,36,37,38,39,40,45,46,93,112,113,114,115,116,117,118,119,120,121,122,123],isComplete:void 0,canClearPosition:a.noop,postValidation:void 0},keyCode:{ALT:18,BACKSPACE:8,CAPS_LOCK:20,COMMA:188,COMMAND:91,COMMAND_LEFT:91,COMMAND_RIGHT:93,CONTROL:17,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,INSERT:45,LEFT:37,MENU:93,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SHIFT:16,SPACE:32,TAB:9,UP:38,WINDOWS:91},masksCache:{},escapeRegex:function(a){var b=["/",".","*","+","?","|","(",")","[","]","{","}","\\","$","^"];return a.replace(new RegExp("(\\"+b.join("|\\")+")","gim"),"\\$1")},format:function(b,c,g){var h=a.extend(!0,{},a.inputmask.defaults,c);return d(h.alias,c,h),f({action:"format",value:b,metadata:g},e(h,c&&void 0!==c.definitions),h)},isValid:function(b,c){var g=a.extend(!0,{},a.inputmask.defaults,c);return d(g.alias,c,g),f({action:"isValid",value:b},e(g,c&&void 0!==c.definitions),g)}},a.fn.inputmask=function(b,c){function g(b,c,e){var f=a(b);f.data("inputmask-alias")&&d(f.data("inputmask-alias"),a.extend(!0,{},c),c);for(var g in c){var h=f.data("inputmask-"+g.toLowerCase());void 0!=h&&("mask"==g&&0==h.indexOf("[")?(c[g]=h.replace(/[\s[\]]/g,"").split("','"),c[g][0]=c[g][0].replace("'",""),c[g][c[g].length-1]=c[g][c[g].length-1].replace("'","")):c[g]="boolean"==typeof h?h:h.toString(),e&&(e[g]=c[g]))}return c}var h,i=a.extend(!0,{},a.inputmask.defaults,c);if("string"==typeof b)switch(b){case"mask":return d(i.alias,c,i),this.each(function(){return g(this,i),h=e(i,c&&void 0!==c.definitions),void 0==h?this:void f({action:"mask",el:this},h,i)});case"unmaskedvalue":var j=a(this);return j.data("_inputmask")?f({action:"unmaskedvalue",$input:j}):j.val();case"remove":return this.each(function(){var b=a(this);b.data("_inputmask")&&f({action:"remove",el:this})});case"getemptymask":return this.data("_inputmask")?f({action:"getemptymask",el:this}):"";case"hasMaskedValue":return this.data("_inputmask")?!this.data("_inputmask").opts.autoUnmask:!1;case"isComplete":return this.data("_inputmask")?f({action:"isComplete",buffer:this[0]._valueGet().split(""),el:this}):!0;case"getmetadata":return this.data("_inputmask")?f({action:"getmetadata",el:this}):void 0;default:return d(i.alias,c,i),d(b,c,i)||(i.mask=b),this.each(function(){return g(this,i),h=e(i,c&&void 0!==c.definitions),void 0==h?this:void f({action:"mask",el:this},h,i)})}else{if("object"==typeof b)return i=a.extend(!0,{},a.inputmask.defaults,b),d(i.alias,b,i),this.each(function(){return g(this,i),h=e(i,b&&void 0!==b.definitions),void 0==h?this:void f({action:"mask",el:this},h,i)});if(void 0==b)return this.each(function(){var b=a(this).attr("data-inputmask");if(b&&""!=b)try{b=b.replace(new RegExp("'","g"),'"');var e=a.parseJSON("{"+b+"}");a.extend(!0,e,c),i=a.extend(!0,{},a.inputmask.defaults,e),i=g(this,i),d(i.alias,e,i),i.alias=void 0,a(this).inputmask("mask",i)}catch(f){}if(a(this).attr("data-inputmask-mask")||a(this).attr("data-inputmask-alias")){i=a.extend(!0,{},a.inputmask.defaults,{});var h={};i=g(this,i,h),d(i.alias,h,i),i.alias=void 0,a(this).inputmask("mask",i)}})}}}return a.fn.inputmask});
/* Laura Doktorova https://github.com/olado/doT */(function(){function o(){var a={"&":"&#38;","<":"&#60;",">":"&#62;",'"':"&#34;","'":"&#39;","/":"&#47;"},b=/&(?!#?\w+;)|<|>|"|'|\//g;return function(){return this?this.replace(b,function(c){return a[c]||c}):this}}function p(a,b,c){return(typeof b==="string"?b:b.toString()).replace(a.define||i,function(l,e,f,g){if(e.indexOf("def.")===0)e=e.substring(4);if(!(e in c))if(f===":"){a.defineParams&&g.replace(a.defineParams,function(n,h,d){c[e]={arg:h,text:d}});e in c||(c[e]=g)}else(new Function("def","def['"+
e+"']="+g))(c);return""}).replace(a.use||i,function(l,e){if(a.useParams)e=e.replace(a.useParams,function(g,n,h,d){if(c[h]&&c[h].arg&&d){g=(h+":"+d).replace(/'|\\/g,"_");c.__exp=c.__exp||{};c.__exp[g]=c[h].text.replace(RegExp("(^|[^\\w$])"+c[h].arg+"([^\\w$])","g"),"$1"+d+"$2");return n+"def.__exp['"+g+"']"}});var f=(new Function("def","return "+e))(c);return f?p(a,f,c):f})}function m(a){return a.replace(/\\('|\\)/g,"$1").replace(/[\r\t\n]/g," ")}var j={version:"1.0.1",templateSettings:{evaluate:/\{\{([\s\S]+?(\}?)+)\}\}/g,
interpolate:/\{\{=([\s\S]+?)\}\}/g,encode:/\{\{!([\s\S]+?)\}\}/g,use:/\{\{#([\s\S]+?)\}\}/g,useParams:/(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,define:/\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,defineParams:/^\s*([\w$]+):([\s\S]+)/,conditional:/\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,iterate:/\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,varname:"it",strip:true,append:true,selfcontained:false},template:undefined,
compile:undefined};if(typeof module!=="undefined"&&module.exports)module.exports=j;else if(typeof define==="function"&&define.amd)define(function(){return j});else(function(){return this||(0,eval)("this")})().doT=j;String.prototype.encodeHTML=o();var q={append:{start:"'+(",end:")+'",endencode:"||'').toString().encodeHTML()+'"},split:{start:"';out+=(",end:");out+='",endencode:"||'').toString().encodeHTML();out+='"}},i=/$^/;j.template=function(a,b,c){b=b||j.templateSettings;var l=b.append?q.append:
q.split,e,f=0,g;a=b.use||b.define?p(b,a,c||{}):a;a=("var out='"+(b.strip?a.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""):a).replace(/'|\\/g,"\\$&").replace(b.interpolate||i,function(h,d){return l.start+m(d)+l.end}).replace(b.encode||i,function(h,d){e=true;return l.start+m(d)+l.endencode}).replace(b.conditional||i,function(h,d,k){return d?k?"';}else if("+m(k)+"){out+='":"';}else{out+='":k?"';if("+m(k)+"){out+='":"';}out+='"}).replace(b.iterate||i,function(h,
d,k,r){if(!d)return"';} } out+='";f+=1;g=r||"i"+f;d=m(d);return"';var arr"+f+"="+d+";if(arr"+f+"){var "+k+","+g+"=-1,l"+f+"=arr"+f+".length-1;while("+g+"<l"+f+"){"+k+"=arr"+f+"["+g+"+=1];out+='"}).replace(b.evaluate||i,function(h,d){return"';"+m(d)+"out+='"})+"';return out;").replace(/\n/g,"\\n").replace(/\t/g,"\\t").replace(/\r/g,"\\r").replace(/(\s|;|\}|^|\{)out\+='';/g,"$1").replace(/\+''/g,"").replace(/(\s|;|\}|^|\{)out\+=''\+/g,"$1out+=");if(e&&b.selfcontained)a="String.prototype.encodeHTML=("+
o.toString()+"());"+a;try{return new Function(b.varname,a)}catch(n){typeof console!=="undefined"&&console.log("Could not create a template function: "+a);throw n;}};j.compile=function(a,b){return j.template(a,null,b)}})();

/**
 * jQuery.ajaxq
 * queue ajax requests
 * @param {string} queue Name of queue
 * @param {object} options
 */
jQuery.ajaxq = function(queue, options) {
  'use strict';
  // Initialize storage for request queues if it's not initialized yet
  if (typeof document.ajaxq === 'undefined') {
    document.ajaxq = { q: {}, r: null};
  }

  // Initialize current queue if it's not initialized yet
  if (typeof document.ajaxq.q[queue] === 'undefined') {
    document.ajaxq.q[queue] = [];
  }
  // Request settings are given, enqueue the new request
  if (typeof options !== 'undefined') {
    // Copy the original options, because options.complete is going to be overridden

    var optionsCopy = {};
    /* jslint forin:true */
    for (var o in options) {
      optionsCopy[o] = options[o];
    }
    options = optionsCopy;

    // Override the original callback

    var originalCompleteCallback = options.complete;

    options.complete = function(request, status) {
      // Dequeue the current request
      document.ajaxq.q[queue].shift();
      document.ajaxq.r = null;

      // Run the original callback
      if (originalCompleteCallback) {
        originalCompleteCallback(request, status);
      }

      // Run the next request from the queue
      if (document.ajaxq.q[queue].length > 0) {
        document.ajaxq.r = jQuery.ajax(document.ajaxq.q[queue][0]);
      }
      if (document.ajaxq.q[queue].length === 0) {
        delete document.ajaxq.q[queue];
      }
    };
    if (queue !== 'multiload') {
      var len = document.ajaxq.q[queue].length;
      if (len <= 1) {
        document.ajaxq.q[queue].push(options);
      } else {
        document.ajaxq.q[queue][1] = options;
      }
    //ставим в очередь
    } else {
      // Enqueue the request
      document.ajaxq.q[queue].push(options);
    }

    // Also, if no request is currently running, start it
    if (document.ajaxq.q[queue].length === 1) {
      document.ajaxq.r = jQuery.ajax(options);
    }
    // No request settings are given, stop current request and clear the queue
  } else {
    if (document.ajaxq.r) {
      document.ajaxq.r.abort();
      document.ajaxq.r = null;
    }

    delete document.ajaxq.q[queue];
  }
};


var templates = (function() {
  'use strict';
  // List Template

  var messages =
      '{{~it.message :value :index }}' +
        '<div class="b-message i-message">' +
          '<div class="b-message__inner b-message__inner_status_{{=value.status}}" id="{{=value.id}}">' +
            '<div class="b-message__text {{?value.warning}}b-message__text_warning{{?}}">{{=value.text}}</div>' +
            '{{?value.ref}}' +
              '<div class="l-message__link">' +
                '<a href="{{=value.ref}}" data-href="{{=value.ref}}" target="_blank" class="i-message__more-link {{=value.classes}}">{{=value.refText}}</a>' +
              '</div>' +
            '{{?}}' +
            '<div class="l-message__link">' +
              '<a href="#" data-href="{{=value.dismissRef}}" class="i-message__dismiss-link" data-mn="dismiss">{{=value.dismiss}}</a>' +
            '</div>' +
          '</div>' +
          '<div class="b-message__triangle b-message__triangle_status_{{=value.status}}"></div>' +
        '</div>' +
      '{{~}}';

  //Banner template
  var banner =
      '<div class="b-message i-message">' +
        '<div  class="b-message__inner b-message__inner_status_{{=it.message.status}}" id="{{=it.message.id}}">' +
          '<div class="b-message__text">{{=it.message.text}}</div>' +
            '{{?it.message.ref}}' +
          '<div class="l-message__link">' +
            '<a href="{{=it.message.ref}}" data-href="{{=it.message.ref}}" target="_blank" class="i-message__more-link {{=it.message.classes}}">{{=it.message.refText}}</a>' +
          '</div>' +
          '{{?}}' +
          '<div class="l-message__link">' +
            '<a href="#" data-href="{{=it.message.dismissRef}}" class="i-message__dismiss-link" data-mn="dismiss">{{=it.message.dismiss}}</a>' +
          '</div>' +
        '</div>' +
        '<div class="b-message__triangle b-message__triangle_status_{{=it.message.status}}"></div>' +
      '</div>';

  var toolbar = '{{?it.btng && it.btng.length > 0}}' +
      '<div class="toolbar" {{=it.plidAttr}} {{=it.convertAttr}} id="toolbar-{{=it.id}}">' +
      '<div class="toolbar__btn-move-wr">' +
        '<div class="toolbar__btn-move toolbar__btn-move_dir_left"></div>' +
        '<div class="toolbar__btn-move toolbar__btn-move_dir_right"></div>' +
      '</div>' +
      '<div class="toolbar__inner">' +
    //add toolbar icon
      '{{?it.devMode}}' +
        '<div class="toolbutton-add"><a href="#" class="devel-link-add devel-link-add--toolbutton"  data-tabid="{{=it.id}}"></a></div>' +
      '{{?}}' +
      //foreach
      '{{ var j, l = it.btng.length; for (j = 0; j < l; j++) { }}' +
        '{{ var i = 0, btn = it.btng[j].btn, lb = btn.length; }}' +
        '{{?btn[i] && btn[i].type}}' +
        '<div class="toolgrp ind{{=j}}" {{=lb}} data-name="{{=it.btng[j].name}}" data-id="{{=it.id}}-{{=it.btng[j].name}}" >' +
          '{{ if (btn[i] && btn[i].type) { }}' +
            '<div class="toolbar-button hint {{=btn[i].tClass}} i-tip-target_st_btn_{{=btn[i].type}}" id="tbw-{{=it.id}}-{{=btn[i].tname}}" ' +
              '{{ var hint = ""; if (btn[i].hint) { hint = "data-hint =  \'"  + App.u.escapeQuote(btn[i].hint) + "\'"; hint += "data-hint-mn=\'hint_" + btn[i].tname + "\'"; } }}  {{=hint}}' +
              ' {{ var confirm = ""; if (btn[i].confirm) { confirm = "data-confirm = \'"  + btn[i].confirm + "\'"; confirm += "data-confirm-d = \'"  + btn[i].confirm_delimiter + "\'"; } }}  {{=confirm}}  {{=btn[i].attrs}}>' +
              '<span href="#main-wrapper" data-url="func={{=btn[i].func}}" ' +
                  '{{?btn[i].cgi}} data-cgi="{{=btn[i].cgi}}" {{?}}' +
                  ' {{=btn[i].progressbar}}' +
                  ' {{=it.tabIdAttr}}' +
                  ' data-name="{{=btn[i].tname}}" ' +
                  ' rel="{{=it.id}}"' +
                  ' class="img-link toolbar-button__item-img {{=btn[i].bClass}} " ' +
                  '{{=btn[i].dataType}}' +
                  ' id="{{=btn[i].id}}" data-itemid="{{=it.itemId}}">' +
                '<div class="s-icon s24x24 {{=btn[i].img}}" {{=btn[i].style}}></div>' +
                '<div id="{{=btn[i].progressId}}{{=it.itemId}}"></div>' +
              '</span>' +
              '<span href="#main-wrapper" data-url="func={{=btn[i].func}}" {{?btn[i].cgi}} data-cgi="{{=btn[i].cgi}}" {{?}} {{=btn[i].progressbar}} {{=it.tabIdAttr}} rel="{{=it.id}}" class="toolbar-button__item-text {{=btn[i].bClass}} btntext" {{=btn[i].dataType}}  data-mn="short_{{=btn[i].tname}}" data-name="{{=btn[i].tname}}">{{=btn[i].name}}</span>' +
              '{{?it.devMode}}' +
                '<div class="toolbutton-settings">' +
                  '<a href="#main-wrapper" class="devel-link-settings devel-link-settings--toolbutton" data-elid="{{=btn[i].tname}}" data-tabid="{{=it.id}}"></a>' +
                  '<a href="#main-wrapper" class="devel-link-delete devel-link-delete--toolbutton" data-elid="{{=btn[i].tname}}"  data-name="{{=btn[i].name}}" data-tabid="{{=it.id}}"></a>' +
                '</div>' +
              '{{?}}' +
              '<div class="toolgrp-control" id="tc-{{=it.id}}-{{=it.btng[j].name}}"><div class="triangledown"></div></div>' +
            '</div>' +
            '{{ } }}' +
            //toolgrp-bag
            '<div class="toolgrp-bag" id="tb-{{=it.id}}-{{=it.btng[j].name}}">' +
            '{{ for (i = 1; i < lb; i++) { }}' +
            '{{ if (btn[i].type) { }}' +
              '<div class="toolbar-button hint {{=btn[i].tClass}} ind{{=i}}" id="tbw-{{=it.id}}-{{=btn[i].tname}}" ' +
              '{{ var hint = ""; if (btn[i].hint) { hint = "data-hint = \'"  + App.u.escapeQuote(btn[i].hint) + "\'"; hint += "data-hint-mn=\'hint_" + btn[i].tname + "\'";} }}  {{=hint}}' +
              '  {{ var confirm = ""; if (btn[i].confirm) { confirm = "data-confirm = \'"  + btn[i].confirm + "\'"; confirm += "data-confirm-d = \'"  + btn[i].confirm_delimiter + "\'"; } }}  {{=confirm}} {{=btn[i].attrs}}>' +
                '<span href="#main-wrapper"' +
                  ' data-url="func={{=btn[i].func}}"' +
                  ' {{?btn[i].cgi}} data-cgi="{{=btn[i].cgi}}" {{?}}' +
                  ' {{=btn[i].progressbar}}' +
                  ' {{=it.tabIdAttr}}' +
                  ' data-name="{{=btn[i].tname}}"' +
                  ' rel="{{=it.id}}" ' +
                  ' class="img-link toolbar-button__item-img {{=btn[i].bClass}} "' +
                  ' {{=btn[i].dataType}}' +
                  ' id="{{=btn[i].id}}" data-itemid="{{=it.itemId}}">' +
                  '<div class="s-icon s24x24 {{=btn[i].img}}" {{=btn[i].style}}></div>' +
                  '<div id="{{=btn[i].progressId}}{{=it.itemId}}"></div>' +
                '</span>' +
                '<span href="#main-wrapper"' +
                  ' data-url="func={{=btn[i].func}}"' +
                  ' {{?btn[i].cgi}} data-cgi="{{=btn[i].cgi}}" {{?}}' +
                  ' {{=btn[i].progressbar}}' +
                  ' {{=it.tabIdAttr}}' +
                  ' data-name="{{=btn[i].tname}}" ' +
                  ' rel="{{=it.id}}"' +
                  ' class="{{=btn[i].bClass}} btntext"' +
                  ' {{=btn[i].dataType}} data-mn="short_{{=btn[i].tname}}">{{=btn[i].name}}</span>' +
                //devmode
                '{{?it.devMode}}' +
                  '<div class="toolbutton-settings">' +
                    '<a href="#" class="devel-link-settings devel-link-settings--toolbutton" data-elid="{{=btn[i].tname}}" data-tabid="{{=it.id}}"></a>' +
                    '<a href="#" class="devel-link-delete devel-link-delete--toolbutton" data-elid="{{=btn[i].tname}}" data-name="{{=btn[i].name}}" data-tabid="{{=it.id}}"></a>' +
                  '</div>' +
                '{{?}}' +
              //devmode end
              '</div>' +
            //if end
            '{{ } }}' +
            //for end
          '{{ } }}' +
        '</div>' +
        //toolgrp end
      '</div>' +
      '{{?}}' +
      '{{ }  }}' +
      '</div>' +
      '</div>' +
      //toolbar end
      '{{?}}';

  var tabCont = ' ' +
    '<div id="cont-{{=it.id}}" class="tab-content {{=it.btnview}} {{=it.filter}} init"  data-func={{=it.func}} ' +
    ' data-pnum="{{=it.pNum}}" data-pcnt="{{=it.pcnt}}" data-tabid="{{=it.id}}" ' +
    ' data-tab-type="list" data-itemid="{{=it.itemId}}">' +
      '<div id="{{=it.progressid}}"></div>' +
      '<div id="{{=it.id}}-progressbar-overlay" class="b-tab-overlay" data-tabid="{{=it.id}}"></div>' +
      '<div id="cont-{{=it.id}}-progressbar" class="b-progressbar"></div>' +
      //default progressbar
      '<div id="cont-{{=it.id}}-progressbar-default" class="b-progressbar">' +
        '<div id="{{=it.id}}-progressbar" class="b-progressbar__outer">' +
          '<div class="b-progressbar__inner">' +
            '<div class="b-progressbar__comment">{{=it.comment}}</div>' +
            '<div class="b-progressbar__loader-wr"><div class="b-progressbar__loader b-progressbar__loader_type_animate"></div></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      //end default progressbar
      //default progressbar end

      '<div class="tab-content-wrapper list-content" id="tcw-{{=it.id}}">' +
      //top bar
      '<div class="topBar">' +
        '<div class="rightBar">' +
        '{{?it.devMode}}' +
          '<a href="{{=it.selfurl}}&out=devel" data-hint="{{=it.hDevel}}" target="_blank" class="hint">' +
            '<div class="s-icon s16x16 l-devel"></div>' +
          '</a>' +
        '{{?}}' +
          '<a href="#" class="reload hint" data-tabid="{{=it.id}}" data-hint="{{=it.hReload}}" data-hint-mn="hint_reloadlist"><img src="{{=it.theme}}img/blue-reload.png" width="16" height="16"/></a>' +
          '{{?it.inmenu}}' +
            '<a href="#" class="i-take-favorite hint {{?!it.favorite}}b-elem_style_gracescale{{?}}" data-hint-unfavorite="{{=it.hFavorite}}" data-hint-favorite="{{=it.hUnfavorite}}" data-state="{{?it.favorite}}favorite{{??}}unfavorite{{?}}">' +
              '<div class="s-icon s16x16 mbar-favorite"></div>' +
            '</a>' +
            '<div class="b-pin i-pin hint {{?!it.pin}}b-elem_style_gracescale{{?}}" data-state="{{?it.pin}}pin{{??}}unpin{{?}}" data-hint-pin="{{=it.hintPin}}" data-hint-unpin="{{=it.hintUnpin}}"></div>' +
          '{{?}}' +
          '<a href="{{=it.permaLink}}" data-clipboard-text="{{=it.permaLink}}" data-hint="{{=it.hCopy}}" target="_blank" data-hint-mn="hint_copylink" class="hint b-permalink" id="permalink-{{=it.id}}"><div class="p-permalink s16x16 s-icons"></div></a>' +
          '{{?it.autoupdate}}' +
            '<a href="#" data-hint="{{=it.hAutoupdate}}" data-tabid="{{=it.id}}" data-hint-mn="hint_autoupdate_stop" class="i-list-icon__stop hint"><div class="s-icon s16x16 p-stop"></div></a>' +
          '{{?}}' +
          '<a href="#" data-hint="{{=it.hSelectAll}}" data-tabid="{{=it.id}}" data-hint-mn="hint_selectall" class="select-all hint"><div class="s-icon s16x16 sb-selectall"></div></a>' +
          '<a href="{{=it.selfurl}}&out=csv" data-hint="{{=it.hExport}}" data-hint-mn="hint_export" target="_blank" class="exel hint"><div class="s-icon s16x16 p-excel"></div></a>' +

          '<a href="{{=it.selfurl}}&out=print" data-hint="{{=it.hPrint}}" data-hint-mn="hint_print" target="_blank" class="print hint"><div class="s-icon s16x16 p-print"></div></a>' +
          '<a href="?func=tsetting&elid={{=it.func}}&plid={{=it.tsplid}}" data-hint-mn="msg_tsetting" data-url="func=tsetting&elid={{=it.func}}&plid={{=it.tsplid}}" data-hint="{{=it.tsettings}}" {{=it.tabIdAttr}} rel="{{=it.id}}" class="tsetting hint">' +
            '<div class="s-icon s16x16 l-table"></div>' +
          '</a>' +
          //'<a href="#" class="help hint" data-hint="{{=it.hHelp}}" data-help-type="default" data-help="{{=it.help}}"><div class="s-icon s16x16 sb-help"></div></a>' +
          '<a href="#" class="b-usefulLinks__icon hint i-tip-target_st_help_links" data-hint="{{=it.hHelp}}"><div class="s-icon s16x16 sb-help"></div></a>' +
        '</div>' +
        //top bar end
        //left bar
        '<div class="leftBar b-leftbar b-leftbar_for_list">' +
        //title
          '<div class="reload hint fleft s48x48 s-icon {{=it.tImg}} i-tip-target_st_title_reload" {{=it.tStyle}} data-tabid="{{=it.id}}" data-hint-mn="hint_reloadlist" data-hint="{{=it.hReload}}"></div>' +
          '<span>' +
            '<h2>' +
              '<span class="reload hint b-title i-tip-target_st_typo" data-fn="{{=it.func}}" data-mn="title" data-tabid="{{=it.id}}" data-hint-mn="hint_reloadlist" data-hint="{{=it.hReload}}">{{=it.tabTitle}}</span>' +
              '{{=it.breadcrumb}}' +
              //devmode icons
              '{{ if (it.devMode) { }}' +
              '<div class="list-settings">' +
                '<a href="#" class="devel-link-settings devel-link-settings--list"  data-tabid="{{=it.id}}" data-elid="{{=it.func}}"></a>' + '<a href="#" class="devel-link-settings devel-link-settings--list"  data-tabid="{{=it.id}}" data-elid="{{=it.func}}"></a>' +
              '</div>' +
              '{{ } }}' +

            '</h2>' +
          '</span>' +
          '<div class="clearBoth"></div>' +
        '</div>' +
        //left bar end
        //messages
        messages +
        //messages end
        '<div class="toolbar-wrapper">' +
          //livefilter
          '<div class="tsearch">' +
            '<div class="dib search">' +
              '<input type="text" id="{{=it.id}}-search" data-tabid="{{=it.id}}" class="itsearch b-input" placeholder="Ctrl + Shift + F" value="{{=it.livefilter}}"/>' +
              '<div class="close_tsearch"><a href="javascript:void(0)" data-tabid="{{=it.id}}"><img src="{{=it.theme}}img/search_close.png"/></a></div>' +
            '</div>' +
            '{{?it.filter}}<div class="i-tip-target_st_filter filter-btn b-filter__toggle hint" data-hint-mn="hint_filter" data-hint="{{=it.fHelp}}"></div>{{?}}' +
          '</div>' +
          //livefilter end
          //toolbar
          toolbar +
        '</div>' +
          //toolbar end
        //active filter
      '{{?it.filter}}' +
        '<div class="b-filter__save-bar">' +
          '<div class="b-filter__btn-move b-filter__btn-move_dir_left"></div>' +
          '<div class="b-filter__btn-move b-filter__btn-move_dir_right"></div>' +
          '<div class="b-filter__save-bar-inner">' +
        '</div>' +
        '</div>' +
      '{{?}}' +
      '{{?it.afilter.status}}' +
      '<div class="filter-active i-filter-applied">' +
      '<div class="filter-btns">' +
        '<div class="b-button b-button__filter-reset">{{=it.afilter.resetMsg}}</div>' +
        '<div class="b-button b-button__filter-change" class="b-filter__change-btn">{{=it.afilter.editMsg}}</div>' +
      '</div>' +
      '<div class="filter-msg">' +
        '<span class="head-filter-msg">{{=it.afilter.fname || it.afilter.fmsg}}</span> {{=it.afilter.msg}}</div>' +
        '<div class="clearBoth"></div>' +
      '</div>' +
      '{{?}}' +
      //active filter end
      //filter form wrapper
      '<div class="filter-wrapper" id="filter-{{=it.id}}"></div>' +
      //diagram wrappper
      '<div class="diagram-cont" id="diagram-{{=it.id}}"></div>' +
      //page wrapper
      '<div class="pager-wrapper">{{=it.pager}}</div>' +
    '</div>' +
    //content table
    '<div class="content" id="ltwr-{{=it.id}}" data-tabid={{=it.id}}>{{=it.table}}</div>' +
    //content table end
  '</div>';

  var tabContMap = '<div id="cont-{{=it.id}}" class="tab-content" data-tabid="{{=it.id}}" data-tab-type="map" data-func={{=it.func}} data-itemid="{{=it.itemId}}">' +

    '<div id="{{=it.id}}-progressbar-overlay" class="b-tab-overlay" data-tabid="{{=it.id}}"></div>' +
    '<div id="cont-{{=it.id}}-progressbar" class="b-progressbar"></div>' +
    //default progressbar
    '<div id="cont-{{=it.id}}-progressbar-default" class="b-progressbar">' +
      '<div id="{{=it.id}}-progressbar" class="b-progressbar__outer">' +
        '<div class="b-progressbar__inner">' +
          '<div class="b-progressbar__comment">{{=it.comment}}</div>' +
          '<div class="b-progressbar__loader-wr">' +
          '<div class="b-progressbar__loader b-progressbar__loader_type_animate"></div>' +
        '</div>' +
      '</div>' +
      '</div>' +
    '</div>' +

    '<div class="tab-content-wrapper list-content" id="tcw-{{=it.id}}">' +
      '<div class="topBar">' +
        '<div class="rightBar">' +
        '{{?it.devMode}}' +
          '<a href="{{=it.selfurl}}&out=devel" data-hint="{{=it.hDevel}}" target="_blank" class="hint"><div class="s-icon s16x16 l-devel"></div></a>' +
        '{{?}}' +
       '<a href="#" class="reload hint" data-tabid="{{=it.id}}" data-hint="{{=it.hReload}}" data-hint-mn="hint_reload"><img src="{{=it.theme}}img/blue-reload.png" width="16" height="16" /></a>' +
         '{{?it.inmenu}}' +
          '<a href="#" class="i-take-favorite hint {{?!it.favorite}}b-elem_style_gracescale{{?}}" data-hint-unfavorite="{{=it.hFavorite}}" data-hint-favorite="{{=it.hUnfavorite}}" data-state="{{?it.favorite}}favorite{{??}}unfavorite{{?}}">' +
            '<div class="s-icon s16x16 mbar-favorite"></div>' +
          '</a>' +
          '<div class="b-pin i-pin hint {{?!it.pin}}b-elem_style_gracescale{{?}}" data-state="{{?it.pin}}pin{{??}}unpin{{?}}" data-hint-pin="{{=it.hintPin}}" data-hint-unpin="{{=it.hintUnpin}}"></div>' +
         // '<a href="#" class="help hint" data-hint="{{=it.hHelp}}" data-help-type="{{=it.helpType}}" data-help="{{=it.help}}" data-help-func="{{=it.helpurl}}"><div class="s-icon s16x16 sb-help"></div></a>' +
        '{{?}}' +
    '</div>' +
        '<div class="leftBar b-leftbar b-leftbar_for_map">' +
          '<div class="reload hint fleft s48x48 s-icon i-tip-target_st_title_reload {{=it.tImg}}" {{=it.tStyle}} data-tabid="{{=it.id}}" data-hint-mn="hint_reload" data-hint="{{=it.hReload}}"></div>' +
          '<span><h2><span class="reload hint  b-title i-tip-target_st_typo " data-fn="{{=it.func}}" data-mn="title" data-hint-mn="hint_reload" data-tabid="{{=it.id}}" data-hint="{{=it.hReload}}">{{=it.tabTitle}}</span></h2></span>' +
          '<div class="clearBoth">' +
          '</div>' +
      '</div>' +

    messages +

    //toolbar
    toolbar +
      //close topbar
        '</div>' +
    //end toolbar
      '<div class="map" id="{{=it.id}}-map"></div>' +
   '</div>' +

  '</div>';


  //List pager
  var listPager =
      '<div class="slist">{{=it.slist}}</div>' +
      '<div class="pager_list pager-list_type_list">{{=it.pagerList}}</div>' +
      '<div class="page_cnt">' +
        '<span class="page_cnt_lb_began" data-mn="pagershow">{{=it.msgBegan}}</span>' +
        '<input type="text" value="{{=it.cnt}}" maxlength="4" class="cnt pager-list__input b-input b-input_for_pager" name="pcnt"/>' +
        '<span class="page_cnt_lb_end" data-mn="pagerline"> {{=it.msgEnd}}</span>' +
        '<div class="pager-list__input-submit b-button b-button_style_small">OK</div>' +
      '</div>';

  //Empty tab Template
  var tabContEmpty = '<div id="cont-{{=it.id}}"  class="tab-content hidden" data-itemid="{{=it.itemId}}">' +
    '<div id="{{=it.id}}-progressbar-overlay" class="b-tab-overlay" data-tabid="{{=it.id}}"></div>' +
    //default progressbar
    '<div id="cont-{{=it.id}}-progressbar-default" class="b-progressbar">' +
      '<div id="{{=it.id}}-progressbar" class="b-progressbar__outer">' +
      '<div class="b-progressbar__inner">' +
        '<div class="b-progressbar__comment">{{=it.comment}}</div>' +
        '<div class="b-progressbar__loader-wr"><div class="b-progressbar__loader b-progressbar__loader_type_animate"></div></div>' +
      '</div>' +
      '</div>' +
    '</div>' +
  '<div class="inner-content-empty">{{=it.text}}</div>' +
  '</div>';

  //Dashboard Template
  var tabContDashBoard = '<div id="cont-{{=it.id}}" class="tab-content" data-tabid="{{=it.id}}" data-func="dashboard" data-tab-type="dashboard">' +
    '<div id="incont-{{=it.id}}" >' +
      '<div>' +
        '<table class="dash-table">' +
        '<tbody class="b-table__tbody">' +
          '<tr>' +
            '<td colspan="2">' +
              '<div id="dash-top" class="b-dashboard_cell" data-pos="top">{{=it.top}}</div>' +
            '</td>' +
          '<tr>' +
          '<tr>' +
            '<td class="left-row">' +
              '<div id="dash-left" class="b-dashboard_cell" data-pos="left" >{{=it.left}}</div>' +
            '</td>' +
            '<td class="right-row">' +
              '<div id="dash-right" class="b-dashboard_cell" data-pos="right">{{=it.right}}</div>' +
            '</td>' +
          '<tr>' +
        '</tbody>' +
        '</table>' +
      '</div>' +
    '</div>' +
  '</div>';

  //Dashboard block Taskbar Template
  var dashTaskbar = '<div class="toolbar">' +
      '{{~it.toolbar :v :i}}' +
      '{{?v.window || v.link}}' +
      '<div class="toolbar-button">' +
        '<a href="{{=v.window || v.link}}" {{=v.target}} class="toolbar-button__item-img">' +
          '<div class="s-icon s48x48 {{=v.img}}" {{=v.style}}></div>' +
        '</a>' +
        '<a href="{{=v.window || v.link}}" {{=v.target}} data-fn="dashboard" data-mn="taskbar_{{=v.name}}">{{=v.msg}}</a>' +
      '</div>' +
      '{{??}}' +
      '<div data-hint="{{=v.hint}}" class="toolbar-button hint {{?!v.disabled}} multi-item {{?}} {{?v.disabled}} notActive {{?}} {{?v.top}}i-tip-target_st_dashboard_top{{?}}">' +
        '<span href="?func={{=v.func}}" {{?v.list}}data-list="{{=v.list}}"{{?}} {{?v.top}}data-top="{{=v.top}}"{{?}} {{?v.form}}data-form="{{=v.form}}"{{?}} data-type="{{=v.type}}" class="toolbar-button__item-img">' +
          '<div class="s-icon s48x48 {{=v.img}}" {{=v.style}}></div>' +
        '</span>' +
        '<span href="?func={{=v.func}}" {{?v.list}}data-list="{{=v.list}}"{{?}} {{?v.top}}data-top="{{=v.top}}"{{?}} {{?v.form}}data-form="{{=v.form}}"{{?}} data-type="{{=v.type}}" data-fn="dashboard" data-mn="taskbar_{{=v.name}}">{{=v.msg}}</span>' +
      '</div>' +
      '{{?}}' +
      '{{~}}' +
      '</div>';

  var button =
      '<div class="b-button i-button b-button_color_{{=val.color}} b-button_type_{{=val.type}} i-button_type_{{=val.type}} ' +
          'b-button_style_{{=val.type}} b-button_act_{{=val.act}} {{?val.focus}}b-form__focus-field{{?}} {{?val.default}}i-button_default_yes{{?}} {{?val.disabled}}b-button_st_disabled{{?}} hint" ' +
          'data-tabid="{{=it.id}}" ' +
          'data-name="{{=val.name}}" ' +
          'data-hint="{{=val.hint}}" ' +
          '{{=it.parentAttr}} ' +
          'data-type="{{=it.type}}" ' +
          'data-disabled="{{=val.disabledText}}" ' +
          'data-act="{{=val.act}}" ' +
          'data-id="{{=val.id}}" ' +
          'data-flags="{{=val.flags}}" ' +
          '{{?val.func}}data-func="{{=val.func}}"{{?}} ' +
          'tabindex="0" ' +
          'data-elemid="{{=ind}}" ' +
          'data-enabled="{{=val.msg}}">{{=val.msg}}' +
          '</div>';

  var buttons = '{{~it.buttons :val :ind}}' +
        button +
      '{{~}}';

  //Form & Report Template
  var tabContForm = '<div id="cont-{{=it.id}}" class="tab-content tab-content_st_active {{=it.tabClass}}" data-tabid="{{=it.id}}" data-tab-type="form" data-report="{{=it.type}}" data-func={{=it.func}} data-itemid="{{=it.itemId}}">' +
    '<div id="{{=it.id}}-progressbar-overlay" class="b-tab-overlay"></div>' +
    //default progressbar
    '<div id="cont-{{=it.id}}-progressbar-default" class="b-progressbar">' +
      '<div id="{{=it.id}}-progressbar" class="b-progressbar__outer">' +
      '<div class="b-progressbar__inner">' +
        '<div class="b-progressbar__comment">{{=it.comment}}</div>' +
        '<div class="b-progressbar__loader-wr">' +
          '<div class="b-progressbar__loader b-progressbar__loader_type_animate"></div>' +
        '</div>' +
      '</div>' +
      '</div>' +
    '</div>' +
    //default progressbar end

    '<div id="cont-{{=it.id}}-progressbar" class="b-progressbar"></div>' +
    '<div id="incont-{{=it.id}}" class="form-content">' +
//    '{{?(it.showcase)}}' +
//      '<div class="b-title">' +
//        '<h2 class="b-title__text">{{=it.tabTitle}}</h2>' +
//      '</div>' +
//    '{{??}}' +
    '{{?(!it.showcase)}}' +
    '<div class="topWrapper">' +
      //right buttons
      '<div class="rightBar">' +
      '{{?it.devMode}}' +
        '<a href="{{=it.selfurl}}&out=devel" data-hint="{{=it.hDevel}}" target="_blank" class="hint"><div class="s-icon s16x16 l-devel"></div></a>' +
      '{{?}}' +
        '{{?it.bands}}' +
        '{{?it.pdfOn}}<a href="{{=it.selfurl}}&out=pdf" data-hint="{{=it.hPdf}}" data-hint-mn="hint_pdf" target="_blank" class="pdf hint"><div class="s-icon s16x16 p-pdf"></div></a>{{?}}' +
        '<a href="{{=it.selfurl}}&out=print&sok=ok" data-hint="{{=it.hPrint}}" target="_blank" data-hint-mn="hint_print" class="print hint"><div class="s-icon s16x16 p-print"></div></a>' +
        '{{?}}' +
      '<a href="#" class="reload hint" data-hint="{{=it.hReload}}" data-hint-mn="hint_reload" data-tabid="{{=it.id}}"><img src="{{=it.theme}}img/blue-reload.png" width="16" height="16" /></a>' +
        '{{?it.inmenu}}' +
        '<a href="#" class="i-take-favorite hint {{?!it.favorite}}b-elem_style_gracescale{{?}}" data-hint-unfavorite="{{=it.hFavorite}}" data-hint-favorite="{{=it.hUnfavorite}}" data-state="{{?it.favorite}}favorite{{??}}unfavorite{{?}}">' +
          '<div class="s-icon s16x16 mbar-favorite"></div>' +
        '</a>' +
        '<div class="b-pin i-pin hint {{?!it.pin}}b-elem_style_gracescale{{?}}" data-state="{{?it.pin}}pin{{??}}unpin{{?}}" data-hint-pin="{{=it.hintPin}}" data-hint-unpin="{{=it.hintUnpin}}"></div>' +
        '{{?}}' +
       '<a href="{{=it.permaLink}}" data-clipboard-text="{{=it.permaLink}}" data-hint="{{=it.hCopy}}" target="_blank" data-hint-mn="hint_copylink" class="hint b-permalink" id="permalink-{{=it.id}}"><div class="p-permalink s16x16 s-icons"></div></a>' +
       //'<a href="#" class="help hint" data-hint="{{=it.hHelp}}" data-help-type="{{=it.helpType}}" data-help="{{=it.help}}" data-help-func="{{=it.helpurl}}"><div class="s-icon s16x16 sb-help"></div></a>' +
       '<a href="#" class="b-usefulLinks__icon hint i-tip-target_st_help_links" data-hint="{{=it.hHelp}}"><div class="s-icon s16x16 sb-help"></div></a>' +
     '</div>' +
      '<div class="leftBar b-leftbar b-leftbar_for_form">' +
      '<div class="reload hint fleft s48x48 s-icon i-tip-target_st_title_reload i-tip-target_st_typo {{=it.tImg}}" data-hint-mn="hint_reload" {{=it.tStyle}} data-tabid="{{=it.id}}" data-hint="{{=it.hReload}}"></div>' +
//showcase if end
        '{{?}}' +
        '{{?!it.notitle}}' +
        '<span class="tab_title">' +
            '<h2 class="reload hint b-title_type-form" data-fn="{{=it.func}}" data-mn="title" data-hint-mn="hint_reload" data-tabid="{{=it.id}}" data-hint="{{=it.hReload}}">' +
              '{{=it.tabTitle}}' +
              //devmode icons
              '{{?it.devMode}}' +
                '<div class="form-settings">' +
                  '<a href="#" class="devel-link-settings devel-link-settings--form" data-tabid="{{=it.id}}"></a>' +
                  '<a href="#" class="devel-link-add devel-link-add--field" data-tabid="{{=it.id}}"></a>' +
                '</div>' +
              '{{?}}' +
            '</h2>' +
          '{{=it.breadcrumb}}' +
          '{{?!it.showcase}}' +
          '{{?}}' +
        '</span>' +
//notitle if end
          '{{?}}' +
      '{{?!it.showcase}}' +
        '<div class="clearBoth"></div>' +
      '</div>' +
//showcase if end
      '{{?}}' +

    '{{?(!it.nostep)}}' +
    '{{?it.formflags.steps}}' +
    '<div class="b-wizard i-wizard">' +
      '<div class="b-wizard__inner i-wizard__inner">' +
        '<div class="l-wizard__triangle l-wizard__triangle_dir_left i-wizard__triangle_dir_left">' +
          '<div class="b-wizard__triangle b-wizard__triangle_dir_left"></div>' +
        '</div>' +
        '{{ var sNum = 0, active, actStep; for (var keyVar in it.formflags.steps) { sNum++ ; actStep = it.formflags.steps[keyVar]; if (keyVar == it.formflags.step ) { active = true; } else { active = false; } }}' +
          '{{?(sNum !== 1)}}' +
            '<div class="b-wizard__arrow"></div>' +
          '{{?}}' +
          '{{?active}}' +
            '<div class="b-wizard__step i-wizard__step-num_st_active b-wizard__step-num_st_active">' +
              '<div class="b-wizard__step-num b-wizard__step-num_st_active" data-mn="msg_wizard_step">{{=it.step}} {{=sNum}}</div>' +
              '<div class="b-wizard__step-desc b-wizard__step-desc_st_active">{{=actStep.name}}</div>' +
            '</div>' +
          '{{??(actStep.unavailable)}}' +
            '<div class="b-wizard__step">' +
              '<div class="b-wizard__step-num" data-mn="msg_wizard_step">{{=it.step}} {{=sNum}}</div>' +
              '<div class="b-wizard__step-desc">{{=actStep.name}}</div>' +
            '</div>' +
          '{{??}}' +
            '<div class="b-wizard__step action">' +
              '<div class="b-wizard__step-num">' +
                '<a href="#" data-href="func={{=keyVar}}" class="i-wizard__step-link b-wizard__step-link" data-mn="msg_wizard_step">{{=it.step}} {{=sNum}}</a>' +
              '</div>' +
              '<div class="b-wizard__step-desc">{{=actStep.name}}</div>' +
            '</div>' +
          '{{?}}' +
          '{{ } }}' +
        '<div class="l-wizard__triangle l-wizard__triangle_dir_right i-wizard__triangle_dir_right">' +
          '<div class="b-wizard__triangle b-wizard__triangle_dir_right"></div>' +
        '</div>' +
     '</div>' +
    '</div><div class="b-wizard__bottom-padding"></div>' +
    '{{?}}' +
      //showcase if
    '{{?}}' +

       '{{?it.message.status}}' +
          banner +
       '{{??it.message.length}}' +
          messages +
       '{{?}}' +
        //toolbar
          toolbar +
        //toolbar end

      '{{?it.reportInfo}}' +
      '<div class="report_info">{{=window.filterXSS(window.htmlEncode(it.reportInfo))}}</div>' +
      '{{?}}' +

        '<div class="error-message">{{=it.ermsg}}</div>' +
        //topWrapper end
        '{{?(!it.showcase)}}' +
          '</div>' +
        '{{?}}' +

        '<div class="l-form l-form__wrapper {{=it.formflags.maxwidth}}" id="form-scroll-{{=it.id}}">' +
           '<div class="l-form__overlay"><div class="l-form__loader"></div></div>' +
           '<div class="l-form__inner" id="form-scroll-in-{{=it.id}}">' +
            '<form action="{{=it.formflags.action}}" name="frm-{{=it.id}}" method="post" id="frm-{{=it.id}}" class="{{=it.files}} {{?it.showcase}}b-form_showcase_yes{{?}}" data-vars="{{=it.__innervars}}" {{=it.formflags.autocomplete}}>' +
            '<div id="form-wrapper-{{=it.id}}">' +
            '<input type="hidden" name="func" value="{{=it.func}}"/>' +
            //chrome password autofilling prevent from http://benjaminjshore.info/2014/05/chrome-auto-fill-honey-pot-hack.html
            '<input type="password" style="display:none;"/>' +

            '<input type="hidden" id="{{=it.id}}-progresstype" value="{{=it.progress}}"/>' +
            '<div id="{{=it.progress}}"></div>' +

            '<input type="hidden" name="elid" value="{{=it.elid}}" id="{{=it.id}}-elid"/>' +
            '{{?(it.plid != "")}}<input type="hidden" name="plid" value="{{=it.plid}}" id="{{=it.id}}-plid"/>{{?}}' +
            '{{?it.isUserexp}}' +
            '<div class="userexperience {{=it.arePages}}" data-level="{{=it.userexp}}" data-mn="msg_userexperience"> {{=it.userexpMsg}}</div>' +
            '{{?}}' +
            // check for form exist
              '{{?it.formstatus}}' +
              '{{=it.pages}}' +
          //submit buttons
          '{{?it.buttons.length}}' +
            '<div class="l-buttons i-buttons_form-type_{{=it.type}} l-buttons_for_form" data-type="buttons" id="{{=it.id}}-buttons">' +
            '{{~it.buttons :val :ind}}' +
              button +
            '{{~}}' +
            '</div>' +
          '{{?}}' +
          '{{?}}' +

              // check for form exist END
               '</div>' +
              '<div class="bands">{{=it.bands}}</div>' +
            '</form>' +
           '</div>' +
        '</div>' +
        '</div>' +
    '</div>';
  //captcha
  var formItemCaptcha = `<div class="b-captcha"><div class="b-captcha__inner"><div class="g-recaptcha" id="{{=it.id}}-{{=it.name}}" data-sitekey="{{=it.value}}"></div></div></div>`;

  //Input template
  var formItemInput = `<div class="l-form__input-wr {{=val.dependFields}} {{=val.setvalue}} {{=val.classes}}" >
      <input value="{{=val.value}}" {{=val.attr}} class="{{=val.classes}} force-hint b-input b-input_type_{{=val.type}} i-input-control" id="{{=val.name}}-{{=val.id}}" data-tabid="{{=val.id}}"/>
      {{?val.prefix}}<div class="b-input__prefix i-input__prefix">{{=val.prefix}}</div>{{?}}
    </div>`;

  //Input File Template
  var formItemFile = '<div class="{{=it.dependFields}} {{=it.setvalue}} b-input-file__wr" id="b-input-file__wr-{{=it.id}}">' +
      '<input  value="{{=it.value}}" {{=it.attr}} id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}" class="b-input b-input_type_file {{=it.classes}}" />' +
      '<div class="b-input-file-fake" data-source="{{=it.name}}-{{=it.id}}">' +
        '<div class="b-input-file-fake__input hint" id="f-{{=it.name}}-{{=it.id}}" data-hint=""></div>' +
        '<div class="b-input-file-fake__btn">{{=it.msg}}</div>' +
      '</div>' +
    '</div>';

  //Password check template
  var passwdCheck = '<div class="checkpass-indicator-wrapper">' +
      '<div id="checkpass-indicator-wrapper-{{=it.name}}-{{=it.id}}">' +
        '<span class="strength-pass-indicator">' +
          '<span class="ci-square si-one"></span>' +
            '<span  class="ci-square si-two"></span>' +
            '<span class="ci-square si-three"></span>' +
            '<span class="ci-square si-four"></span>' +
          '</span>' +
          '<span class="strength-pass-text">' +
          '<span class="st-text st-one">{{=it.short}}</span>' +
          '<span class="st-text st-two">{{=it.weak}}</span>' +
          '<span class="st-text st-three">{{=it.good}}</span>' +
          '<span class="st-text st-four">{{=it.strong}}</span>' +
        '</span>' +
      '</div>' +
    '</div>';

  var confirmCheck = '<div class="b-form-confirm-message" id="check-confirm-{{=it.name}}-{{=it.id}}">{{=it.doNotMatch}}</div>';

  //Password
  var formItemPassword =
    '<div class="l-form__input-wr {{=it.dependFields}} {{=it.setvalue}}" >' +
      '<input {{=it.attr}} class="{{=it.classes}} b-input b-input_type_password force-hint i-input-control" id="{{=it.name}}-{{=it.id}}" data-parent="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}" value="{{=it.value}}" data-confirm-field="{{=it.confirmField}}" autocomplete="off"/>' +
      '<input type="text" id="{{=it.name}}-{{=it.id}}-fake" data-parent="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}" style="display:none;" data-confirm-field="{{=it.confirmField}}" class="fakePasswd {{=it.classes}} force-hint b-input i-input-control" autocomplete="off"/>' +
    '</div>';

  //Input with zoom
  var formItemInputWithZoom = '<div class="l-form__input-wr {{=it.dependFields}} {{=it.setvalue}}" >' +
      '<input value="{{=it.value}}" {{=it.inputAttr}} class="{{=it.inputClasses}} {{=it.classes}} force-hint b-input b-input_type_text i-input-control" id="{{=it.inputName}}-{{=it.id}}" data-tabid="{{=it.id}}"/>' +
      '<textarea class="{{=it.textareaClasses}} force-hint b-textarea" {{=it.textareaAttr}} data-tabid="{{=it.id}}"></textarea>' +
    '</div>';

  //Input with zoom
  var formItemInputWithZoom1 = '<div class="{{=it.dependFields}}" >' +
      '<input {{=it.attr}} class="{{=it.classes}} force-hint  b-input b-input_type_text i-input-control" id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}"/>' +
      '<textarea class="{{=it.textareaClasses}} force-hint b-textarea" {{=it.textareaAttr}} data-tabid="{{=it.id}}"></textarea>' +
    '</div>';

  var formItemTextarea = '<div id="b-msg-templ-{{=it.name}}-{{=it.id}}" class="b-msg-templ__options"></div>' +
    '<div class="{{=it.setvalue}} {{=it.dependFields}} b-textarea__wrapper">' +
      '{{?it.quote}}' +
        '<div class="b-ticket-tools-link">' +
          '<a href="#" class="b-quote hint" data-target="{{=it.name}}-{{=it.id}}" data-hint-mn="hint_quote" data-hint="{{=App.u.escapeQuote(it.hint_quote)}}">{{=it.msg_quote}}</a>' +
        '</div>' +
      '{{?}}' +
      '{{?it.savedmessage}}' +
        '<div class="b-msg-templ__cont b-ticket-tools-link" data-target="{{=it.name}}-{{=it.id}}">' +
          '<a href="#" class="b-msg-templ__link hint" data-hint-mn="hint_savedmessage" data-hint="{{=App.u.escapeQuote(it.hint_savedmessage)}}" data-id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}">{{=it.msg_savedmessage}}</a>' +
        '</div>' +
      '{{?}}' +
      '<textarea class="{{=it.classes}} force-hint b-textarea b-textarea_responsive_yes" id="{{=it.name}}-{{=it.id}}" {{=it.attr}} data-tabid="{{=it.id}}" data-codelang="{{=it.codelang}}">{{=it.value}}</textarea>' +
      '{{?it.editor}}<div id="{{=it.name}}-{{=it.id}}-editor" data-id="{{=it.name}}-{{=it.id}}"></div>{{?}}' +
      '<div class="b-resizer i-tip-target_st_textarea_resize {{?it.editor}}b-resizer_for_editor {{??}}b-resizer_for_textarea{{?}}" id="resizer_editor-{{=it.name}}-{{=it.id}}" data-id="{{=it.name}}-{{=it.id}}{{?it.editor}}-editor{{?}}" {{?it.editor}}data-move-trigger="resizeEditor"{{?}} data-tabid="{{=it.id}}"></div>' +
    '</div>';

  var formItemCheckbox = '<div class="b-checkbox__wrapper {{=val.dependFields}} {{=val.setvalue}} {{?val.img}}l-checkbox-img{{?}}">' +
    '{{?val.img}}' +
    '<div class="s-icon s16x16 {{=val.img}} b-checkbox__img"></div>' +
    '{{?}}' +
    '<div class="b-checkbox checkboxel">' +
      '<div class="b-checkbox__control {{=val.cbclass}} {{=val.readonly}} force-hint" tabindex="0" id="{{=val.id}}-{{=val.name}}" data-tabid="{{=val.id}}" data-id="{{=val.name}}"></div>' +
    '</div>' +
    '<div class="l-label__wrapper l-label__wrapper_for_checkbox">' +
      '<div class="b-label__visible b-label__visible_for_checkbox" data-tabid="{{=val.id}}" data-id="{{=val.name}}">{{=val.desc}}</div>' +
      '<div class="b-label__invisible b-label__invisible_for_checkbox">{{=val.desc}}</div>' +
      '<div class="b-label__line-dotted b-label__line-dotted_for_checkbox"></div>' +
    '</div>' +
    '<input type="hidden" value="{{=val.value}}" class="{{=val.classes}}" data-handler-val="{{=hash(val.value)}}" name="{{=val.name}}" data-type="checkbox" data-tabid="{{=val.id}}" {{=val.attrInput}}/>' +
  '</div>';

  var formItemHtmldata = '<div class="b-htmldata__inner b-htmldata">' +
      '{{?it.img}}' +
        '<div class="b-htmldata__img">' +
          '{{?it.img.src}}<img data-type="img" src="{{=it.img.src}}" id="{{=it.id}}-{{=it.img.name}}" width="{{=it.img.width}}" height="{{=it.img.height}}"/>{{??it.img.img}}<div class="{{=it.img.img}}"></div>{{?}}' +
        '</div>' +
      '{{?}}' +
      '<div id="{{=it.id}}-{{=it.name}}">{{=window.filterXSS(window.htmlEncode(it.value))}}</div>' +
      '<div class="b-htmldata__clear"></div>' +
    '</div>';

  var formItemSelectList = '{{~val.slist :value:index}}' +
      '{{ var selected = ""; if (val.value == value.key) { selected="selected"; } }}' +
      '{{ var dependelem = ""; if (value.depend != "" && value.depend != undefined) { dependelem="dependelem"; } else { dependelem="b-myselect__select-li_show_yes"; } }}' +
      '<li data-val="{{=String(value.key).replace(/"/g, \'&quot;\')}}" data-code="{{=value.code}}" data-mask="{{=value.mask}}" data-handler-val="{{=hash(value.key)}}" data-dependkey="{{=value.depend}}" ' +
      'class="{{=selected}} {{=dependelem}} {{?value.src||value.img}}b-myselect__item-image{{?}} b-myselect__select-li">' +
        '{{?value.src}} <span class="b-myselect__img" style="background-image: url({{=value.src}}); ' +
        '{{?value.width}}width:{{=value.width}}px;{{?}}' +
        '{{?value.height}}height:{{=value.height}}px;{{?}}"></span>{{?}}' +
        '{{?value.img}} <span class="b-myselect__img {{=value.img}}"></span>{{?}}' +
        '<span class="{{=value.classes}} b-myselect__option-value">{{=value.value}}</span>' +
      '</li>' +
      '{{~}}';

  var formItemSelect = `<div class="b-myselect b-myselect_st_close {{=val.search}} {{=val.depend}} {{=val.dependFields}} {{=val.readonly}} {{=val.setvalue}}" data-depend="{{=val.dependMaster}}" id="_{{=val.name}}-{{=val.id}}">
    <div class="b-myselect__select-selected" data-id="_{{=val.name}}-{{=val.id}}">
      <div class="b-myselect__select-value force-hint" tabindex="0" data-tabid="{{=val.id}}">{{=val.msg}}</div>
      <div class="b-myselect__arrow-down"><div class="b-myselect__triangle-down"></div></div>
    </div>
    {{?val.search}}<div class="b-myselect__search-box">
      <input type="text" class="scrlbr b-input b-input_for_search sb-input force-hint" data-id="{{=val.id}}-{{=val.name}}" data-tabId="{{=val.id}}" id="sb-cont-{{=val.id}}-{{=val.name}}"/>
      <div class="sb-info" id="sb-info-{{=val.id}}-{{=val.name}}"></div>
    </div>{{?}}

    <div class="b-myselect__option-wr" id="opt_{{=val.name}}-{{=val.id}}" data-tabid="{{=val.id}}">
      <div class="b-myselect__select-list" id="cont-{{=val.id}}-{{=val.name}}">
        <ul data-id="_{{=val.name}}-{{=val.id}}" id="{{=val.id}}-{{=val.name}}" class="b-myselect__select-ul">
          ${formItemSelectList}
        </ul>
      </div>
    </div>
    <input type="hidden" value="{{=val.value}}" class="{{=val.classes}}" {{?val.targetfontfamilyview}}data-targetview="{{=val.targetfontfamilyview}}"{{?}} data-handler-val="{{=hash(val.value)}}" name="{{=val.name}}" id="_{{=val.name}}-{{=val.id}}-val" data-type="select" data-tabid="{{=val.id}}" {{=val.attrInput}}/>
  </div>`;

  var formItemMSelect = '{{ var l, selectedClass = ""; if (it.hasValue) { selectedClass = "selected"; } }}' +
    '<div class="b-mselect {{=selectedClass}} {{=it.readonly}} {{=it.setvalue}}" data-depend="{{=it.dependMaster}}" id="{{=it.id}}-{{=it.name}}-ms">' +
      '<div class="b-mselect__view-value force-hint" data-id="{{=it.id}}-{{=it.name}}" tabindex="0" id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}">' +
        '<div class="b-myselect__arrow-down b-myselect__arrow-down_for_mselect"><div class="b-myselect__triangle-down"></div></div>' +
        '<ul class="b-mselect__ul-view" id="{{=it.id}}-{{=it.name}}-ms-view" data-tabid="{{=it.id}}" data-maxselect="{{=it.maxselect}}">' +
          '<li class="b-mselect__item b-mselect__item_msg_unselected" data-default-msg="{{=it.msg}}">{{?it.mixed}}{{=it.msg_mixed}} {{??}} {{=it.msg}}{{?}}</li>' +
          '{{ var v = "", ind = 0; for (var i in it.values) {  }}' +
          '{{ var selected = ""; if (it.values[i]) { selected="chosen"; } }}' +
          '{{  if (it.slist[i]) { if (v !== "") { v += ","; } v += it.slist[i].key; ind++; }}' +
          '{{ var dependelem = ""; if (it.slist[i].depend != "" && it.slist[i].depend != undefined) { dependelem="dependelem"; } else { dependelem="b-myselect__select-li_show_yes"; } }}' +
            '<li class="b-mselect__item {{=selected}} {{=dependelem}} " data-val="{{=it.slist[i].key}}" data-dependkey="{{=it.slist[i].depend}}" unselectable="on" data-s-id="{{=it.id}}-{{=it.name}}-{{=i}}">' +
              '{{=it.slist[i].value}}' +
              '<span class="b-mselect__unselect"></span>' +
            '</li>' +
          '{{ } } }}' +
        '</ul>' +
      '</div>' +
      '<div class="b-mselect__options closed" id="{{=it.id}}-{{=it.name}}-ms-list-wrapper" data-id="{{=it.id}}-{{=it.name}}" data-tabid="{{=it.id}}">' +
        '<div class="b-mselect__list-value" id="{{=it.id}}-{{=it.name}}-ms-list">' +
          '<ul class="b-mselect__ul-choose" id="{{=it.id}}-{{=it.name}}-ms-list-ul" data-id="{{=it.id}}-{{=it.name}}">' +
            '<li class="b-mselect__item b-mselect__item_select-all">{{=it.msg_select_all}}</li>' +
            '{{ var l = it.slist.length; for (var i = 0; i < l; i++) {  }}' +
            '{{ var selected = ""; if (it.values[i]) { selected="chosen"; } }}' +
            '{{ var dependelem = ""; if (it.slist[i].depend != "" && it.slist[i].depend != undefined) { dependelem="dependelem"; } else { dependelem="b-myselect__select-li_show_yes"; } }}' +
              '<li class="b-mselect__item {{=selected}} {{=dependelem}}" data-handler-val="{{=hash(it.slist[i].key)}}" data-dependkey="{{=it.slist[i].depend}}" data-val="{{=it.slist[i].key}}" unselectable="on" id="{{=it.id}}-{{=it.name}}-{{=i}}">' +
               '{{=it.slist[i].value}}' +
                '<span class="b-mselect__unselect"></span>' +
              ' </li>' +
            '{{ } }}' +
          '</ul>' +
        '</div>' +
      '</div>' +
      //'<div class="b-input-btn b-input-btn_type_plus hint" data-hint-mn="msg_plus" data-hint="{{=App.u.escapeQuote(it.hintBtnPlus)}}" data-id="{{=it.id}}-{{=it.name}}"></div>' +
      //'<div class="b-input-btn b-input-btn_type_minus hint" data-hint-mn="msg_minus" data-hint="{{=App.u.escapeQuote(it.hintBtnMinus)}}" data-id="{{=it.id}}-{{=it.name}}"></div>' +
    '<input type="hidden" name="{{=it.name}}" class="{{=it.classes}}" value="{{=v}}" data-type="multiple" {{=it.requiredAttr}} id="{{=it.id}}-{{=it.name}}-ms-value" data-id="{{=it.id}}-{{=it.name}}" data-tabid="{{=it.id}}"/>' +
   '</div>';


  var formItemRadio = '<div class="b-radio {{=it.depend}} {{=it.dependFields}} {{=it.readonly}} {{=it.setvalue}}" id="{{=it.id}}-{{=it.name}}-radio" data-depend="{{=it.dependMaster}}">' +
  //foreach
    '{{~it.slist :value :index}}' +
  '{{ var rbclass = "", tabindex = ""; if (it.value == value.key) { rbclass="checked"; tabindex = "tabindex=0"; } }}' +
  '{{ var dependelem = ""; if (value.depend != "" && value.depend != undefined ) { dependelem="dependelem"; } else { dependelem="b-myselect__select-li_show_yes"; } }}' +
  '<div data-dependkey="{{=value.depend}}" class="{{=dependelem}} l-radio__item">' +
  '<div class="b-radio__control-wr">' +
      '<div {{=tabindex}} class="b-radio__control {{=it.name}}-{{=it.id}} {{=it.name}}-{{=it.id}}-{{=hash(value.key)}} {{=rbclass}} force-hint" data-id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}"  data-val="{{=value.key}}" data-handler-val="{{=hash(value.key)}}">' +
    '</div>' +
    '</div>' +
  '<div class="l-label__wrapper l-label__wrapper_for_radio">' +
    '<div class="b-label__visible b-label__visible_for_radio" data-r-class="{{=it.name}}-{{=it.id}}-{{=hash(value.key)}}">{{=value.value}}</div>' +
      '<div class="b-label__invisible b-label__invisible_for_radio">{{=value.value}}</div>' +
      '<span class="b-label__line-dotted b-label__line-dotted_for_radio"></span>' +
    '</div>' +
  '</div>' +
  //end foreach
  '{{~}}' +
  '<input type="hidden" name="{{=it.name}}" data-handler-val="{{=hash(it.value)}}" id="{{=it.name}}-{{=it.id}}" value="{{=it.value}}" class="{{=it.classes}}" data-type="radio" data-tabid="{{=it.id}}" {{=it.attrInput}}/>' +
  '</div>';

  var formItemRadioImg = '<div class="b-radio {{=it.setvalue}} {{=it.readonly}}">' +
      '<table class="b-radio-img">' +
        '<tbody class="b-table__tbody">' +
      '{{~it.slist :value :index}}' +
      '{{ var rbclass = "", tabindex = ""; if (it.value == value.key) { rbclass="checked"; tabindex = "tabindex=0"; } }}' +
      '<tr class="b-radio-img__row" data-r-class="{{=it.name}}-{{=it.id}}-{{=hash(value.key)}}">' +
      '<td class="b-radio-img__col b-radio-img__col_radio">' +
        '<div class="b-radio__control {{=it.name}}-{{=it.id}} {{=rbclass}} {{=it.name}}-{{=it.id}}-{{=hash(value.key)}}" {{=tabindex}} data-id="{{=it.name}}-{{=it.id}}"  data-tabid="{{=it.id}}"  data-val="{{=value.key}}" data-handler-val="{{=hash(value.key)}}"></div>' +
      '</td>' +
      '<td class="b-radio-img__col b-radio-img__col_img">' +
        '<div class="b-radio-img__img-wrapper">' +
          '{{?value.src}} <span class="b-radio-img__img" style="background-image: url({{=value.src}}); ' +
          '{{?value.width}}width:{{=value.width}}px;{{?}}' +
          '{{?value.height}}height:{{=value.height}}px;{{?}}"></span>{{?}}' +
          '{{?value.img}} <span class="b-radio-img__img {{=value.img}}"></span>{{?}}' +
        '</div>' +
      '</td>' +
      '<td class="b-radio-img__col b-radio-img__col_desc"><div class="b-radio-img__desc">{{=window.htmlDecode(value.value)}}</div></td>' +
      '</tr>' +
      '{{~}}' +
      '</tbody>' +
      '</table>' +
      '<input type="hidden" name="{{=it.name}}" id="{{=it.name}}-{{=it.id}}" data-handler-val="{{=hash(it.value)}}" class="{{=it.classes}}" value="{{=it.value}}" data-type="radio" data-tabid="{{=it.id}}" />' +
      '</div>';

      var formItemLink = '<div class="b-form-link{{?it.internal}} m-item{{?}}"><a href="{{=it.href}}" data-url="{{=it.href}}" {{?!it.newtab}}data-parent="{{=it.id}}"{{?}} data-type="link" id="{{=it.id}}-{{=it.name}}" {{?it.target}}target="{{=it.target}}"{{?}} class="i-menu-link {{?it.newtab}}newtab{{?}}">{{=it.text}}</a></div>';

  var formItemExtrBtn = '<{{=it.extrabtn}} data-tname="{{=it.name}}-{{=it.id}}"/>';

  var formItemDesk = '<span class="desc">{{=it.value}}</span>';

  var formItemDeskRadio = '<div class="desk">' +
      '<div class="desk-visible">{{=it.value}}</div>' +
      '<div class="desk-invisible">{{=it.value}}</div>' +
      '<span class="b-label__line-dotted"></span>' +
    '</div>';

  var formItemTextData = '{{?it.img}}<div class="b-textdata__img">{{?it.img.src}}<img data-type="img" src="{{=it.img.src}}" id="{{=it.id}}-{{=it.img.name}}" width="{{=it.img.width}}" height="{{=it.img.height}}"/>{{??it.img.img}}<div class="{{=it.img.img}}"></div>{{?}}</div>{{?}}' +
    '<div class="b-textdata {{=it.classes}}" id="{{=it.id}}-{{=it.name}}" data-type="textdata"><div class="b-textdata__inner" {{?it.mtype === "msg" || it.mtype === "msgdata"}} data-mn="{{=it.msgname}}"{{?}} id="{{=it.id}}-{{=it.name}}-inner">{{=window.filterXSS(it.value)}}</div></div>' +
    '<div class="b-textdata__clear l-clear-both"></div>';

  var formItemLabel =
    '<div class="l-label__wrapper">' +
      '<div class="l-label__inner">' +
        '<label class="b-label__visible" data-tabid="{{=it.tabId}}" data-id="{{=it.id}}" data-fn="{{=it.func}}" data-mn="{{=it.id}}">{{=it.img}}{{=it.label}}</label>' +
        '<label class="b-label__invisible">{{=it.img}}{{=it.label}}</label>' +
        '<span class="b-label__line-dotted"></span>' +
        '{{?it.required}}<span class="b-required-star">*</span>{{?}}' +
      '{{?it.devMode}}' +
        '<div class="field-settings">' +
          '<a href="#" class="devel-link-settings devel-link-settings--field" data-elid="{{=it.id}}" data-tabid="{{=it.tabId}}"></a>' +
          '<a href="#" class="devel-link-delete devel-link-delete--field" data-elid="{{=it.id}}" data-name="{{=it.label}}" data-tabid="{{=it.tabId}}"></a>' +
        '</div>' +
      '{{?}}' +
      '</div>' +
    '</div>';

  var filterItemLabel = '<label data-mn="{{=it.name}}" data-fn="{{=it.func}}">{{=it.label}}</label>';

  var formItemSlider = '<table class="b-slider">' +
      '<tbody class="b-table__tbody">' +
      '<tr>' +
        '<td class="l-slider__col l-slider__col_cont_slider">' +
          '<div class="l-slider__wr {{=it.readonly}}">' +
            '<div class="b-slider__line"></div>' +
            '<div class="b-slider__border b-slider__border_pos_left"></div>' +
            '<div class="b-slider__c-border b-slider__c-border_pos_top"></div>' +
            '<div class="b-slider__c-border b-slider__c-border_pos_bottom b-slider__c-bottom-border"></div>' +
            '<a id="{{=it.id}}-{{=it.name}}-slider" class="b-slider__el force-hint" tabindex="0" data-min="{{=it.min}}" data-tabid="{{=it.id}}"  data-max="{{=it.max}}" data-step="{{=it.step}}" data-id="{{=it.id}}-{{=it.name}}" data-value="{{=it.value}}">' +
              '<div class="b-slider__core"></div>' +
            '</a>' +
            '<div class="b-slider__border b-slider__border_pos_right"></div>' +
          '</div>' +
        '</td>' +
        '<td class="l-slider__col l-slider__col_cont_input {{=it.setvalue}}">' +
          '<div class="l-slider__input-wr {{=it.setvalue}}">' +
            '<input type="text" len="32" {{?it.targetfontsizeview}}data-targetview="{{=it.targetfontsizeview}}"{{?}} class="b-input b-input_for_slider {{?it.targetfontsizeview}}i-font-size-control{{?}} {{=it.readonly}} force-hint i-input-control {{=it.inputClass}}" id="{{=it.id}}-{{=it.name}}" data-tabid="{{=it.id}}" name="{{=it.name}}" value="{{=it.value}}" {{=it.readonly}} {{=it.attrInput}}/>' +
          '</div>' +
        '</td>' +
      '</tr>' +
      '</tbody>' +
    '</table>';

  var formItemSliderEditInList = '<div class="l-form__row_type_slider">' +
      '<div class="l-form__control-wr">' +
        formItemSlider +
      '</div>' +
    '</div>';

  var formItemTicketMsg = '{{~it.mlist :value:index}}' +
      '<tr class="b-ticket__table-row {{?value.isCollapsed}} b-ticket__table-row_is_collapsible b-ticket__table-row_is_collapsed {{?}}">' +
        '<td class="b-ticket__table-col b-ticket__table-col_type_msg">' +
          '<div class="b-ticket__item b-ticket__item_{{=value.type}} ">' +
            '<div class="b-ticket__item-inner b-ticket__item-inner_{{=value.type}} {{?value.rate.is}}b-ticket__item-inner_has_rate{{?}}">' +
            '{{?value.type === "info"}}' +
              '<table class="b-ticket__table-info">' +
              '<tbody class="b-table__tbody">' +
              '{{~value.rows :v :i}}' +
              '<tr class="b-ticket__row-info {{?v.header}}b-ticket__row-info_type_header{{?}}">' +
              '{{?v.header}}' +
              '<td class="b-ticket__col-info b-ticket__col-info_type_header" colspan="2">{{=v.label}}</td>' +
              '{{??}}' +
              '<td class="b-ticket__col-info b-ticket__col-info_type_label">{{=v.label}}</td>' +
              '<td class="b-ticket__col-info b-ticket__col-info_type_value">{{=String(v.v).replace(/(\\r\\n|\\n|\\r)/g," ").replace(/\\s+/g," ")}}</td>' +
              '{{?}}' +
              '</tr>' +
              '{{~}}' +
              '</tbody>' +
              '</table>' +
            '{{??}}' +
            '<div class="b-ticket__btn-collapse i-ticket__btn-collapse s16x16 s-icon mbar-showall"></div>' +
            '{{?value.title}}<div class="b-ticket__title">{{=value.title}}</div>{{?}}' +
            '<div class="b-ticket__body b-ticket__body_same_prop">{{var b = String(value.body).replace(/\\s\\r\\n|\\r\\n|\\s\\n|\\n/g, "<br/>");}}{{=b}}</div>' +
            //file
            '{{?value.file.is}}' +
              '{{~value.file.elems :vv :ii}}' +
                '<div class="b-ticket__file">' +
                  '<a href="?func={{=vv.action}}{{~vv.params :v:i}}&{{=v.name}}={{=v.value}}{{~}}" target="_blank" class="b-ticket__file-link {{?vv.preview}}b-image-for-view{{?}}">{{=vv.name}}</a>' +
                '</div>' +
              '{{~}}' +
            '{{?}}' +
            //rate
            '{{?value.rate.is}}' +
              '<div class="b-ticket__rate">' +
                '{{~value.rate.items :vv :ii}}' +
                '<div class="b-ticket__rate-item" data-id="{{=vv.id}}" data-elid="{{=vv.elid}}">' +
                  '<span class="b-ticket__rate-msg">{{=vv.msg}}</span>' +
                  '{{~vv.items :v:i}}' +
                  '<div class="b-ticket__rate-{{=v.name}} {{=v.classes}}" data-name="{{=v.name}}" data-func="{{=v.func}}" data-type="{{=v.type}}"><img src="{{=v.img}}" data-hint="{{=App.u.escapeQuote(window.filterXSS(v.hint))}}" class="b-ticket__rate-img hint"/><span class="b-ticket__rate-text">{{=v.msg}}</span></div>' +
                  '{{~}}' +
                  '</div>' +
                '{{~}}' +
                '</div>' +
            '{{?}}' +
            '<div class="b-ticket__clear"></div>' +
          '{{?}}' +
          '</div>' +
          '</div>' +
        '</td>' +
        '<td class="b-ticket__table-col b-ticket__table-col_type_avatar">' +
        '{{?value.avatar.is && (value.type === "incoming" || value.type === "outcoming")}}' +
          '<div class="b-ticket__avatar b-ticket__avatar_{{=value.type}}">' +
            '<img src="{{=value.avatar.src}}" width="{{=value.avatar.width}}" height="{{=value.avatar.height}}" class="b-ticket__avatar-img"/>' +
          '</div>' +
        '{{?}}' +
      '</td>' +
      '</tr>' +
    '{{~}}';

  var formItemTicket = '<div class="b-ticket" {{?it.fontsize||it.fontfamily}} style="{{?it.fontsize}}font-size: {{=it.fontsize}}px;{{?}} {{?it.fontfamily}}font-family: {{=String(it.fontfamily).replace(/"/g, \'&quot;\')}}{{?}}{{?}}">' +
      '<div class="b-ticket__btn-move-wrapper"><div class="b-ticket__btn-move_up b-ticket__btn-move i-ticket__btn-move_up" data-tabid="{{=it.id}}"></div><div class="b-ticket__btn-move_down b-ticket__btn-move i-ticket__btn-move_down" data-tabid="{{=it.id}}"></div></div>' +
      '<table class="b-ticket__table {{?it.fmsgtype === "outcoming"}}b-ticket__table_my_outcoming{{?}}" id="{{=it.id}}-{{=it.name}}" data-type="ticket">' +
        '<tbody class="b-table__tbody">' +
        formItemTicketMsg +
        '</tbody>' +
      '</table>' +
    '</div>';

  var formItemSelectAutocomplete = '<div class="{{=it.depend}} b-select-ac">' +
    '<input type="text" autocomplete="off" data-name="{{=it.name}}" {{=it.attr}} class="{{=it.classes}} b-input b-select-ac__input force-hint" id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}" />' +
    '</div>' +
    '<div class="b-select-ac__list-scroll-wrapper" id="opt-{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}">' +
      '<div class="b-select-ac__list-wrapper {{=it.dependFields}}" id="cont-b-select-ac-list__{{=it.name}}-{{=it.id}}">' +
        '<ul class="b-select-ac__list" data-id="{{=it.name}}-{{=it.id}}" id="b-select-ac-list__{{=it.name}}-{{=it.id}}"></ul>' +
        '<input value="{{=it.value}}" type="hidden" name="{{=it.name}}" class="{{=it.classes}}" id="key-{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}"/>' +
      '<div>' +
    '</div>';

  var formItemFrame = '<div class="b-form-frame">' +
      '<iframe frameborder="0" id="{{=it.name}}-{{=it.id}}" name="{{=it.name}}" class="{{?it.fullheight}}i-control__fullwidth{{?}}" data-type="frame" src="{{=it.value}}" width="100%" height="{{=it.height}}"></iframe>' +
      '<div class="b-resizer" id="resizer_editor-{{=it.id}}" data-id="{{=it.name}}-{{=it.id}}" data-tabid="{{=it.id}}"></div>' +
      '</div>';

  var formItemDateTime = '<div class="b-form-datetime" id="{{=it.id}}-{{=it.name}}" data-type="datetime" data-difftime="{{=it.difftime}}">{{=it.value}}</div>';

  var formPageTitle = '<h3 class="l-form-page__title-wr" data-name="{{=it.name}}" id="tblock-{{=it.id}}" data-type="{{=it.type}}" data-block-type="{{=it.blockType}}">' +
    '<div tabindex="0" class="b-form-page__title i-form-page__title">' +
      '<span class="b-form-page__title-content" data-mn="{{=it.name}}">{{=it.title}}</span>' +
      '{{?it.reload}}<span class="dashblock-reload hint" data-hint-mn="hint_reload" data-hint="{{=App.u.escapeQuote(it.hintReload)}}"></span>{{?}}' +
      '<span class="b-triangle hint" data-hint-expanded="{{=App.u.escapeQuote(it.hintCollapse)}}" data-hint-collapsed="{{=App.u.escapeQuote(it.hintExpand)}}" data-state="{{?it.collapsed}}collapsed{{??}}expanded{{?}}"></span>' +
    '</div>' +
    '<div class="b-form-page__vline"></div>' +
  '</h3>';

  var formItemMgrview = '<div class="mgrview" id="mgrview-{{=it.tabId}}"><!--<img src="{{=it.theme}}/img/hue.png" width="251" height="168"/>--><div id="{{=it.tabId}}-color1" class="color1 color"></div><div class="color2 color" id="{{=it.tabId}}-color2" ></div><div class="color3 color" id="{{=it.tabId}}-color3" ></div><div class="color4 color" id="{{=it.tabId}}-color4" ></div><div class="color5 color" id="{{=it.tabId}}-color5" ></div><div class="color6 color" id="{{=it.tabId}}-color6" ></div><div class="color7 color" id="{{=it.tabId}}-color7" ></div></div>';

  var formPageWrapper = '<div class="b-form-page b-form-page_view_{{=it.view}} {{=it.classes}} {{?it.withList}}b-form-page_withlist_yes{{?}} {{?it.collapsed}}b-form-page_st_collapsed{{?}}" id="page-{{=it.name}}-{{=it.tabId}}" data-tabid="{{=it.tabId}}" {{ if (it.hide) { for(var i =0; i< it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i< it.show.length; i++) { }} {{=it.show[i].name + "-" + it.hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '{{=it.title}}' +
    '<div class="b-form-page__inner" style="display:{{=it.display}};" >' +
      '<table class="l-form__table">' +
        '<tbody class="b-table__tbody">' +
        '{{=it.content}}' +
        '</tbody>' +
      '</table>' +
    '</div>' +
  '</div>';

  var filterWrapper = '<div class="filter-inner">' +
    '<form name="frm-{{=it.tabId}}" id="frm-{{=it.tabId}}">' +
      '<input type="hidden" value="{{=it.func}}" name="func"/>' +
      '<div class="filter-inner-inner">' +
        '<div class="filter-cont"><table><tr>{{=it.form}}</tr></table></div>' +
        '<div class="filter-btn-wrapper">' +
          '<div class="filter-btns">' +
            '<div class="b-button b-button__filter-set b-button_style_ok" data-tabid="{{=it.tabId}}" data-disabled="{{=it.disabled}}" tabindex="0">{{=it.filterMsg.findMsg}}</div>' +
            '<div class="b-button b-button__filter-save" data-id="{{=it.tabId}}" tabindex="0">{{=it.filterMsg.saveMsg}}<div class="b-button__filter-save-name">{{=it.sfname||""}}</div></div>' +
            '<div class="b-button b-button__filter-clear" data-tabid="{{=it.tabId}}" tabindex="0">{{=it.filterMsg.clearMsg}}</div>' +
          '</div>' +
        '</div>' +
        '<div class="clearBoth"></div>' +
      '</div>' +
    '</form>' +
  '</div>';

  var filterItem =
      '<tr class="filter-item {{=it.classes}} l-form__row" {{ if (it.hide) { for (var i = 0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i = 0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
        '<td class="filter-first">{{=it.first}}</td>' +
        '<td class="filter-second"><div class="filter-input">{{=it.second}}</div></td>' +
      '</tr>';

  var filterRow = '<td class="filter-col">' +
      '<table class="filter-item__table filter-table_n_{{=it.index}}">{{=it.content}}</table>' +
      '</td>';

  var filterSavedItem =
      '<div class="b-filter__saved-item {{?it.active}}b-filter__saved-item_st_active{{?}}">' +
          '<div class="b-filter__saved-item-inner">' +
            '<input type="text" class="b-filter__saved-name-edit" ' +
          'id="b-filter__saved-name-edit_tid_{{=it.id}}" value="{{=it.name}}" ' +
          'data-id="{{=it.id}}" data-func="{{=it.func}}" data-tabid="{{=it.tabId}}" data-name="{{=it.name}}" />' +
            '<span class="b-filter__saved-name">{{=it.name}}</span>' +
          '</div>' +
          '<span class="b-filter__saved-edit" data-id="{{=it.id}}"></span>' +
          '<span class="b-filter__saved-remove" data-id="{{=it.id}}"></span>' +
      '</div>';

  var formItemRowDesc = '<tr class="{{=it.classes}} l-form__row" {{ if (it.hide) { for (var i = 0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i  =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td class="l-form__col l-form__col_cont_label" colspan="4">{{=it.second}}</td>' +
  '</tr>';

  var formItemRow = '<tr class="{{=it.classes}} l-form__row i-form__item" {{ if (it.hide) { for (var i =0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td class="l-form__col l-form__col_cont_label">{{=it.first}}</td>' +
    '<td class="l-form__col l-form__col_cont_control" {{=it.colspan}}>' +
      '<div class="l-form__table-control-wrapper">' +
      '<table class="l-form__table-control">' +
        '<tbody class="b-table__tbody">' +
        '<tr>' +
          '<td class="l-form__col-control">' +
            '<div class="l-form__control-wr">{{=it.second}}</div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_hint">' +
            '<div class="field-help {{=it.hint}} hint" data-hint-mn="{{=it.fname}}" data-hint="{{=it.third}}"></div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_status">' +
            '<div class="field-desc" data-mn="{{=it.descName}}">{{=it.desc}}</div>' +
            '<div class="field-status"></div>' +
            '{{?it.devMode || it.testMode}}' +
              '<div class="field-settings">' +
                '{{?it.devMode}}' +
                '<a href="#" class="devel-link-settings devel-link-settings--field " data-elid="{{=it.fname}}" data-tabid="{{=it.tabId}}"></a>' +
                '<a href="#" class="devel-link-delete devel-link-delete--field" data-elid="{{=it.fname}}" data-name="{{=it.label}}" data-tabid="{{=it.tabId}}"></a>' +
                '{{??}}' +
                '<a href="#" class="testmode__form-link b-elem_style_gracescale" data-elid="{{=it.fname}}" data-tabid="{{=it.tabId}}"></a>' +
                '{{?}}' +
              '</div>' +
            '{{?}}' +
          '</td>' +
        '</tr>' +
        '<tr class="l-form__col-error">' +
          '<td colspan="3" class="">' +
            '<div class="b-error-box__wrapper" data-id="{{=it.id}}">' +
              '<div class="b-error-box">' +
                '<div class="b-error-box__top-triangle"></div>' +
                '<div class="b-error-box__inner">{{=it.error}}</div>' +
              '</div>' +
            '</div>' +
          '</td>' +
        '</tr>' +
        '</tbody>' +
      '</table>' +
      '</div>' +
    '</td>' +
    '<td class="l-form__col l-form__col_cont_row-end"></td>' +
  '</tr>';

  var formItemFullWidthRow = '<tr class="{{=it.classes}} l-form__row i-form__item" {{ if (it.hide) { for (var i =0; i < it. hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td colspan="3" class="l-form__col_type_fullwidth l-form__col l-form__col_cont_control">' +
      '{{=it.first}}' +
      '<table class="l-table-fullwidth">' +
        '<tbody class="b-table__tbody">' +
        '<tr>' +
          '<td class="l-form__col-control">' +
            '<div class="l-form__control-wr">{{=it.second}}</div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_hint">' +
            '<div class="field-help {{=it.hint}} hint" data-hint-mn="{{=it.fname}}" data-hint="{{=it.third}}"></div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_status">' +
            '<div class="field-status" ></div>' +
             '{{?it.devMode || it.testMode}}' +
              '<div class="field-settings">' +
                '{{?it.devMode}}' +
                '<a href="#" class="devel-link-settings devel-link-settings--field " data-elid="{{=it.fname}}" data-tabid="{{=it.tabId}}"></a>' +
                '<a href="#" class="devel-link-delete devel-link-delete--field" data-elid="{{=it.fname}}" data-name="{{=it.label}}" data-tabid="{{=it.tabId}}"></a>' +
                '{{??}}' +
                '<a href="#" class="testmode__form-link b-elem_style_gracescale" data-elid="{{=it.fname}}" data-tabid="{{=it.tabId}}"></a>' +
                '{{?}}' +
              '</div>' +
            '{{?}}' +
          '</td>' +
        '</tr>' +
        '<tr class="l-form__col-error">' +
          '<td colspan="3" class="error">' +
            '<div class="b-error-box__wrapper" data-id="{{=it.id}}">' +
              '<div class="b-error-box">' +
                '<div class="b-error-box__top-triangle"></div>' +
                '<div class="b-error-box__inner">{{=it.error}}</div>' +
              '</div>' +
            '</div>' +
          '</td>' +
        '</tr>' +
        '</tbody>' +
      '</table>' +
    '</td>' +
  '</tr>';

  var formItemFormWidthRow = '<tr class="{{=it.classes}} l-form__row i-form__item" {{ if (it.hide) { for (var i =0; i < it. hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td colspan="2" class="formwidth l-form__col l-form__col_cont_control">' +
      '{{=it.first}}' +
      '<table class="l-form__table-formwidth l-table-clean">' +
        '<tbody class="b-table__tbody">' +
        '<tr>' +
          '<td class="l-form__col-control">' +
            '<div class="l-form__control-wr">{{=it.second}}</div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_hint">' +
            '<div class="field-help {{=it.hint}} hint" data-hint-mn="{{=it.fname}}" data-hint="{{=it.third}}"></div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_status">' +
            '<div class="field-desc"></div>' +
            '<div class="field-status" ></div>' +
          '</td>' +
        '</tr>' +
        '<tr class="l-form__col-error">' +
          '<td colspan="3" class="error">' +
            '<div class="b-error-box__wrapper" data-id="{{=it.id}}">' +
              '<div class="b-error-box">' +
                '<div class="b-error-box__top-triangle"></div>' +
                '<div class="b-error-box__inner">{{=it.error}}</div>' +
              '</div>' +
            '</div>' +
          '</td>' +
        '</tr>' +
        '</tbody>' +
      '</table>' +
    '</td>' +
    '<td class="l-form__col l-form__col_cont_row-end"></td>' +
  '</tr>';

  var formItemRowWithoutLabel = '<tr class="{{=it.classes}} l-form__row i-form__item without-label" {{ if (it.hide) { for (var i =0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i = 0; i< it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td class="l-form__col l-form__col_cont_control" colspan="2">' +
      '<table class="l-table-clean">' +
        '<tbody class="b-table__tbody">' +
        '<tr>' +
          '<td class="l-form__col-control">' +
            '<div class="l-form__control-wr">{{=it.second}}</div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_hint">' +
            '<div class="field-help {{=it.hint}} hint" data-hint-mn="{{=it.fname}}" data-hint="{{=it.third}}"></div>' +
          '</td>' +
          '<td class="l-form__col l-form__col_cont_status">' +
            '<div class="field-desc">{{=it.desc}}</div>' +
            '<div class="field-status"></div>' +
          '{{?it.devMode}}' +
            '<div class="field-settings">' +
              '<a href="#" class="devel-link-settings devel-link-settings--field" data-elid="{{=it.fname}}" data-tabid="{{=it.tabId}}"></a>' +
              '<a href="#" class="devel-link-delete devel-link-delete--field" data-elid="{{=it.fname}}" data-name="{{=it.label}}" data-tabid="{{=it.tabId}}"></a>' +
            '</div>' +
          '{{?}}' +
          '</td>' +
        '</tr>' +
        '<tr class="l-form__col-error">' +
          '<td colspan="3" class="error">' +
            '<div class="b-error-box__wrapper" data-id="{{=it.id}}">' +
              '<div class="b-error-box">' +
                '<div class="b-error-box__top-triangle"></div>' +
                '<div class="b-error-box__inner">{{=it.error}}</div>' +
              '</div>' +
            '</div>' +
          '</td>' +
        '</tr>' +
        '</tbody>' +
      '</table>' +
    '<td class="l-form__col l-form__col_cont_row-end"></td>' +
//    '</td>' +
  '</tr>';

  var formItemRowHidden = '<tr class="hidden l-form__row_type_hidden">' +
      '<td class="l-form__col l-form__col_cont_control" colspan="4">{{=it.second}}</td>' +
    '</tr>';

  var formItemRowTextdata = '<tr class="{{=it.classes}} l-form__row i-form__item" {{ if (it.hide) { for (var i = 0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
    '<td colspan="3">{{=it.second}}</td>' +
    '</tr>';

  var formPlainHint = '<tr data-show-{{=it.name}}-{{=window.hash(it.key)}}="yes" class="depended-hidden-s l-form__row l-form__row_type_plainhint">' +
        '<td class="l-form__col-control" colspan="2">{{=window.htmlEncode(it.content)}}</td>' +
        '<td class="l-form__col l-form__col_cont_row-end"></td>' +
      '</tr>';

  var tabLi = '<li class="tab-group" id="{{=it.tabId}}">' +
    '<span class="subtab switch first hint {{?it.isPin}}subtab_is_pin{{?}}" id="switch-{{=it.tabId}}" data-hint="{{=it.hint}}" data-tabid="{{=it.tabId}}">' +
      '<a href="#" data-tabid="{{=it.tabId}}"><div {{=it.pinIcon}}></div><span class="short">{{=it.shortTitle}}</span><span class="full">{{=it.title}}</span></a>' +
      '<a href="#" class="close" rel="{{=it.tabId}}"><div class="b-tab-close"></div></a>' +
    '</span>' +
  '</li>';

  var tabChld = '<span id="{{=it.tabId}}"><span class="sepr"></span>' +
    '<span class="subtab switch hint" id="switch-{{=it.tabId}}" data-hint="{{=it.hint}}" data-tabid="{{=it.tabId}}">' +
      '<a href="#"  data-tabid="{{=it.tabId}}"><span class="short">{{=it.shortTitle}}</span><span class="full">{{=it.title}}</span></a>' +
      '<a href="#" class="close" rel="{{=it.tabId}}"><div class="i-tab-close b-tab-close"></div></a>' +
    '</span>' +
  '</span>';

  var progressBar = '<div id="{{=it.tabId}}-progressbar" class="b-progressbar__outer">' +
    '<div class="b-progressbar__inner">' +
      '<div class="b-progressbar__comment">{{=it.comment}}</div>' +
      '<div class="b-progressbar__loader-wr">' +
        '<div class="b-progressbar__loader {{=it.colorClass}}" style="width: {{=it.width}}%;">{{=it.per}}</div>' +
      '</div>' +
    '</div>' +
  '<div/>';

  var reportBand = '<div class="band-content {{=it.fullwidth}}" id="{{=it.aid}}">' +
    '<div class="band-title {{=it.titleClass}}">{{=it.title}}</div>' +
    '<div class="band-graphic" ><div class="anychart" id="{{=it.gid}}">' +
    //wrappers for graphics
    '{{ for (var i = 0; i < it.dc; i++) { }}' +
      '<div id="{{=it.gid}}{{=i}}"></div>' +
    '{{ } }}' +
  //wrappers for graphics
    '</div></div>' +
    '<div class="band_show">' +
    '<div class="band_show_button {{=it.hidden}}" data-id="{{=it.id}}">' +
      '<span class="show_msg">{{=it.showMsg}}</span>' +
      '<span class="hide_msg">{{=it.hideMsg}}</span>' +
      '<span class="triangle-band"></span></div>' +
    '</div>' +
    '<div class="band-table block-table {{=it.hiddenClass}}" id="{{=it.id}}">{{=it.table}}</div>' +
  '</div>';

  var emptyBandOverlay = '<div class="b-band__empty-overlay"></div>' +
      '<div class="b-band__empty-msg">{{=it.emptymsg}}</div>' +
      '<div class="b-band__empty-wrapper" id="{{=it.tabId}}-band-empty"></div>';

  var reportBandDash = '<div class="band-content {{=it.fullwidth}}">' +
    '{{?it.empty}}' +
      emptyBandOverlay +
    '{{?}}' +
    '<div class="band-title {{=it.titleClass}}">{{=it.title}}</div>' +
    '<div id="{{=it.gid}}" class="band-chart-cont"></div></div>' +
  '</div>';

  var fatalError = '<div id="fatal-error-{{=it.id}}" class="b-fatal-error b-err__{{=it.type}}">' +
    '<div class="b-fatal-error__round">' +
      '<div class="b-fatal-error__inner">' +
        '<div class="b-fatal-error__sign">' +
          '<div class="b-fatal-error__sign-top"></div>' +
          '<div class="b-fatal-error__sign-body"></div>' +
          '<div class="b-fatal-error__sign-empty"></div>' +
          '<div class="b-fatal-error__sign-dot"></div>' +
        '</div>' +
        '<div class="b-fatal-error__message">' +
            '{{=it.message}}' +
          '{{?it.ref}}' +
            '<div class="more b-fatal-error__more-link"><a href="{{=it.ref}}&newwindow=yes" target="_blank">{{=it.moreMsg}}</a></div>' +
          '{{?}}' +
          '{{?it.refreshLink}}' +
            '<div class="m-item b-fatal-error__refresh-link"><a href="#" data-url="{{=it.refreshLink}}" >{{=it.refreshLinkMsg}}</a></div>' +
          '{{?}}' +
        '</div>' +
        '{{?it.id}}' +
        '<div class="l-buttons l-buttons_for_fatalerror">' +
          '<div class="b-button b-button_type_cancel b-button_for_fatalerror i-button_type_cancel" data-flags="refresh" tabindex="0" data-tabid="{{=it.id}}">{{=it.msgClose}}</div>' +
        '</div>' +
        '{{?}}' +
      '</div>' +
    '</div>' +
    '<div class="b-fatal-error__triangle">' +
    '</div>' +
  '</div>';

  var editinListForm = '<div>' +
    '<form id="editinlist-form-{{=it.id}}" class="l-form__row">' +
      '{{=it.field}}' +
      '<input type="hidden" name="elid" value="{{=it.elid}}" />' +
      '<input type="hidden" name="sok" value="ok" />' +
      '<input type="hidden" name="func" value="{{=it.func}}" />' +
    '</form>' +
    '<div class="l-buttons l-buttons_for_editinlist">' +
      '<div class="b-button b-button_style_small b-button_style_green i-btn-editlis-ok" data-id="{{=it.id}}">&#10004</div>' +
      '<div class="b-button b-button_style_small b-button_style_red i-btn-editlis-cancel" data-id="{{=it.id}}">&#10008</div>' +
    '</div>' +
    '<div id="err-cont-{{=it.id}}" class="editlist-err-cont"></div>' +
  '</div>';

  var hintList = '{{?val.hintByName}}<div class="field-help field-help_available_yes hint b-form-list__hint" data-hint="{{=App.u.escapeQuote(val.hintByName)}}"></div>{{?}}';


  var formListFilterWrapper = '<div id="{{=it.id}}-{{=it.name}}" data-type="listfilter">{{=it.content}}</div>';

  var formListFilter = '<div class="checkbox i-form__item i-form-list__filter" data-srcname="{{=it.srcName}}" data-tabid="{{=it.id}}">' +
         '<div class="b-form-list__filter">' +
            '{{~it.list :val :ind}}' +
              '{{val.id = it.id;}}' +
              formItemCheckbox +
            '{{~}}' +
          '</div>' +
          '<div class="b-form-list__filter-clear i-form-list__filter-clear">{{=it.resetMsg}}</div>' +
          '<div class="b-form-list__filter-notfound">{{=it.notFoundMsg}}</div>' +
        '</div>';

  var formListContent =
      `<div class="b-form-list b-form-list_view_{{=it.view}} i-form-list" id="form-list-{{=it.id}}-{{=it.name}}">
          <table class="b-form-list__table" data-name="{{=it.name}}" data-key="{{=it.key}}" id="inner-form-list-{{=it.id}}-{{=it.name}}">
            <tbody class="b-table__tbody">
          {{~it.rows :v :i}}
            <tr class="b-form-list__row b-form-list__row_t_{{?(i % 2) === 0}}even{{??}}odd{{?}}
             {{?it.filterfield && v[it.filterfield]}} row__has__tags
              {{~v[it.filterfield].v :val :ind}} filter__{{=val}} {{~}}{{??}} row__nohas__tags{{?}}">
              {{ for (var key in it.coldata) { }}
                <td class="b-form-list__col b-form-list__col_align_{{=it.coldata[key].align}} b-form-list__col_type_{{=it.coldata[key].type}} {{?v[key] && v[key].header}}b-form-list__col_header_yes{{?}} b-form-list__col_name_{{=key}}" data-colname="{{=key}}" style="width: {{=it.coldata[key].width}}; min-width: {{=it.coldata[key].width}}">
                  <div class="b-form-list__col-inner b-form-list__col-inner_type_{{=it.coldata[key].type}} {{?it.coldata[key].hint && v[key + "_hint"]}}hint{{?}}" {{?it.coldata[key].hint && v[key + "_hint"]}}data-hint="{{=App.u.escapeQuote(v[key + "_hint"].v)}}" {{?}}>
                  {{?v[key]}}
                    {{?it.coldata[key].type === "data" || it.coldata[key].type === "msg" || v[key].header}}
                      <div class="b-form-list__data {{?v[key].color}}status-{{=v[key].color}}{{?}} {{?it.testMode}}i-testmode-field{{?}}">
                       {{~v[key].props :prop :index }}
                          {{?index !== 0}}
                          <div class="s-icon s16x16 props  hint" style="background-image: url({{=prop.img}})" data-hint="{{=App.u.escapeQuote(prop.hint)}}"></div>
                          {{?}}
                       {{~}}
                       {{=window.filterXSS(window.htmlDecode(v[key].v))}}</div>
                    {{??it.coldata[key].type === "img"}}
                      {{?v[key].src}}
                        {{?v[key].preview}}
                          <a href="{{=v[key].src}}" class="b-image-for-view" data-lightbox="formlist" target="_blank">
                        {{?}}
                        <img src="{{=v[key].src}}" class="b-form-list__img" width="{{=v[key].width}}" height="{{=v[key].height}}"/>
                        {{?v[key].preview}}
                          </a>
                        {{?}}
                      {{??v[key].img}}
                        <div class="{{=v[key].img}}"></div>
                      {{?}}
                    {{??it.coldata[key].type === "button"}}
                       {{~v[key] :val :ind}}
                          ${button}
                       {{~}}
                    {{??it.coldata[key].type === "control"}}
                      {{~v[key] :val :ind}}
                          {{?val.type === "checkbox"}}
                            {{val.id = it.id;}}
                           <div class="i-form__item b-form-list__form-item"><div class="b-form-list__control-wrapper">${formItemCheckbox}</div>${hintList}</div>
                         {{??val.type === "select"}}
                            {{val.id = it.id;}}
                            <div class="i-form__item b-form-list__form-item"><div class="b-form-list__control-wrapper">${formItemSelect}</div>${hintList}</div>
                          {{??val.type === "text"}}
                            {{val.id = it.id;}}
                            <div class="i-form__item b-form-list__form-item"><div class="b-form-list__control-wrapper">${formItemInput}</div>${hintList}</div>
                        {{?}}
                      {{~}}
                    {{?}}
                  {{?}}
                  </div>
                </td>
              {{ } }}
            </tr>
          {{~}}
          </tbody>
          </table>
      </div>`;

  var formListBlocksContent = '{{?it.label}}<h3 class="b-form-blocks__label">{{=it.label}}</h3>{{?}}' +
   '<div class="b-form-blocks">' +
      '{{~it.rows :v :i}}' +
        '<div class="b-form-blocks__block {{?it.filterfield && v[it.filterfield]}} row__has__tags' +
              '{{~v[it.filterfield].v :val :ind}} filter__{{=val}} {{~}}{{??}} row__nohas__tags{{?}}">' +
          '{{ for (var key in it.coldata) { }}' +
    //      '<td class="b-form-list__col align-{{=it.coldata[key].align}}" style="width: {{=it.coldata[key].width}};">' +
            '<div class="b-form-list__col-inner b-form-blocks__col-inner_type_{{=it.coldata[key].type}}">' +
            '{{?v[key]}}' +
              '{{?it.coldata[key].type === "data" || it.coldata[key].type === "msg"}}' +
              '<div class="b-form-list__data {{?v[key].color}}status-{{=v[key].color}}{{?}}">{{=window.filterXSS(window.htmlDecode(v[key].v))}}</div>' +
              '{{??it.coldata[key].type === "img"}}' +
                '{{?v[key].src}}' +
                  '<img src="{{=v[key].src}}" class="b-form-list__img" width="{{=v[key].width}}" height="{{=v[key].height}}"/>' +
                '{{??v[key].img}}' +
                  '<div class="{{=v[key].img}}"></div>' +
                '{{?}}' +
              '{{??it.coldata[key].type === "button"}}' +
              '<div class="b-form-list__button-wrapper">' +
              '{{~v[key] :val :ind}}' +
                button +
              '{{~}}' +
              '</div>' +
              '{{?}}' +
            '{{?}}' +
            '</div>' +
    //      '</td>' +
          '{{ } }}' +
        '</div>' +
      '{{~}}' +
      '</div>';

  var formListItemRow =
      '<tr class="{{=it.classes}} l-form__row" {{ if (it.hide) { for (var i =0; i < it.hide.length; i++) { }} {{=it.hide[i].name + "-" + hash(it.hide[i].value)}}="yes" {{ } } }} {{ if (it.show) { for (var i =0; i < it.show.length; i++) { }} {{=it.show[i].name + "-" + hash(it.show[i].value)}}="yes" {{ } } }}>' +
        '<td class="l-form__col l-form__col_cont_control" colspan="3">' +
          '<div id="{{=it.id}}-{{=it.name}}" class="{{=it.id}}-list" data-type="list" data-name="{{=it.name}}">' +
            '{{?it.view == "block"}}' +
              formListBlocksContent +
            '{{??}}' +
              formListContent +
            '{{?}}' +
          '</div>' +
        '</td>' +
      '</tr>';

  var tip = '<div class="b-tip b-tip_name_{{=it.name}}">' +
        '<div class="b-tip__inner">' +
          '{{=it.content}}' +
        '</div>' +
      '<div class="b-tip__close" data-name="{{=it.name}}"></div>' +
    '</div>';

  var usefulLinks = '<div class="b-useful-links {{?it.isCollapsed}}b-useful-links_is_collapsed{{?}}">' +
      '<div class="b-tip__close i-userful-links-collapse"></div>' +
      '<div class="b-tip__inner">' +
        '<div class="b-useful-links__title">{{=it.title}}</div>' +
        '<div class="b-useful-links__content">{{=it.content}}</div>' +
      '</div>' +
    '</div>';

  var infoList = '<div class="b-infolist">' +
        '<table class="b-infolist__table">' +
        '<tbody class="b-table__tbody">' +
          '{{~it.rows :v :i}}' +
          '<tr class="b-infolist__row {{?v.type === "header"}}b-infolist__row_type_header{{?}}">' +
            '{{?v.type === "header"}}' +
              '<td class="b-infolist__col b-infolist__col_type_header" colspan="2">{{=v.label}}</td>' +
            '{{??v.type === "data"}}' +
              '<td class="b-infolist__col b-infolist__col_type_label">{{=v.label}}</td>' +
              '<td class="b-infolist__col b-infolist__col_type_value status-{{=v.color}} {{?it.testMode}}i-testmode-field{{?}} hint" data-hint="{{=v.hint}}" data-name="{{=v.name}}">{{=v.value}}</td>' +
            '{{??v.type === "link"}}' +
              '<td class="b-infolist__col b-infolist__col_type_label">{{=v.label}}</td>' +
              '{{?v.link}}' +
              '<td class="b-infolist__col b-infolist__col_type_value m-item"><a href="#" data-url="{{=v.link}}" data-name="{{=v.name}}" data-hint="{{=v.hint}}" class="i-menu-link b-infolist__col_type_value {{?it.testMode}}i-testmode-field{{?}} hint">{{=v.value}}</a></td>' +
              '{{??v.url}}' +
              '<td class="b-infolist__col b-infolist__col_type_value"><a href="{{=v.url}}" target="_blank" class="b-infolist__col_type_value {{?it.testMode}}i-testmode-field{{?}} hint" data-hint="{{=v.hint}}">{{=v.value}}</a></td>' +
              '{{?}}' +
            '{{??v.type === "indicator"}}' +
              '<td class="b-infolist__col b-infolist__col_type_label">{{=v.label}}</td>' +
              '<td class="b-infolist__col b-infolist__col_type_value m-item {{?it.testMode}}i-testmode-field{{?}}" data-name="{{=v.name}}">{{=v.value}} (<span class="status-{{=v.color}}">{{=v.suffix}}</span>)</td>' +
            '{{?}}' +
          '</tr>' +
          '{{~}}' +
        '</tbody>' +
        '</table>' +
      '</div>';

  var fatalAlert = '<div class="b-alert__inner {{?it.refreshLink}} b-alert__inner_t_refresh-link{{?}}">' +
      '<div class="b-alert__icon">' +
        '<div class="b-alert__sign">' +
          '<div class="b-alert__sign-top"></div>' +
          '<div class="b-alert__sign-body"></div>' +
          '<div class="b-alert__sign-empty"></div>' +
          '<div class="b-alert__sign-dot"></div>' +
        '</div>' +
      '</div>' +
      '<div class="b-alert__msg-outter"><div class="b-alert__msg">{{=it.msg}}</div></div>' +
        '{{?it.ref}}' +
          '<div class="more b-fatal-error__more-link">' +
            '<a href="{{=it.ref}}" target="_blank">{{=it.moreMsg}}</a>' +
          '</div>' +
        '{{?}}' +
        '{{?it.refreshLink}}' +
          '<div class="m-item b-fatal-error__refresh-link">' +
            '<a href="#" data-url="{{=it.refreshLink}}" >{{=it.refreshLinkMsg}}</a>' +
          '</div>' +
        '{{?}}' +
      '</div>' +
      '<div class="b-alert__clear"></div>';

  var msgTemplList = '<div class="b-msg-templ" data-target="{{=it.id}}">' +
      '<div class="b-msg-templ__table">' +
        '<div class="b-msg-templ__table-col b-msg-templ__table-col_content_yes">' +
          '<ul class="b-msg-templ__title-content">' +
            '{{~it.templList  :v :i}}' +
              '<li class="b-msg-templ__title-content-item b-msg-templ__title-content-item_ind_{{=i}}">{{=v.msg}}</li>' +
            '{{~}}' +
          '</ul>' +
        '</div>' +
        '<div class="b-msg-templ__table-col b-msg-templ__table-col_title_yes">' +
          '<ul class="b-msg-templ__title-list">' +
            '{{~it.templList  :v :i}}' +
              '{{?i !== 0}}<li class="b-msg-templ__title-list-item b-msg-templ__title-list-item_is_comma">, </li>{{?}}<li class="b-msg-templ__title-list-item" data-ind="{{=i}}" data-id="{{=v.id}}">{{=v.name}}</li>' +
            '{{~}}' +
          '</ul>' +
        '</div>' +
      '</div>' +
    '</div>';

  var t = doT.template,
      vSettings = {};
  $.extend(vSettings, doT.templateSettings, { varname: 'val' });

  return {
    tabCont: t(tabCont),
    tabContEmpty: t(tabContEmpty),
    tabContForm: t(tabContForm),
    tabContMap: t(tabContMap),
    listPager: t(listPager),
    tabContDashBoard: t(tabContDashBoard),
    tabLi: t(tabLi),
    tabChld: t(tabChld),
    formPageTitle: t(formPageTitle),
    formItemInput: t(formItemInput, vSettings),
    formItemCaptcha: t(formItemCaptcha),
    formItemFile: t(formItemFile),
    formItemPassword: t(formItemPassword),
    formItemInputWithZoom: t(formItemInputWithZoom),
    formItemInputWithZoom1: t(formItemInputWithZoom1),
    formItemTextarea: t(formItemTextarea),
    formItemCheckbox: t(formItemCheckbox, vSettings),
    formItemLabel: t(formItemLabel),
    formItemExtrBtn: t(formItemExtrBtn),
    formItemDesk: t(formItemDesk),
    formItemDeskRadio: t(formItemDeskRadio),
    formItemSelect: t(formItemSelect, vSettings),
    formItemSelectList: t(formItemSelectList, vSettings),
    formItemMSelect: t(formItemMSelect),
    formItemHtmldata: t(formItemHtmldata),
    formItemTicket: t(formItemTicket),
    formItemLink: t(formItemLink),
    formItemSelectAutocomplete: t(formItemSelectAutocomplete),
    formItemTicketMsg: t(formItemTicketMsg),
    formPageWrapper: t(formPageWrapper),
    formItemRow: t(formItemRow),
    formItemFullWidthRow: t(formItemFullWidthRow),
    formItemFormWidthRow: t(formItemFormWidthRow),
    formItemRowWithoutLabel: t(formItemRowWithoutLabel),
    formItemRowTextdata: t(formItemRowTextdata),
    formItemRowHidden: t(formItemRowHidden),
    formItemFrame: t(formItemFrame),
    formListContent: t(formListContent),
    formListBlocksContent: t(formListBlocksContent),
    filterWrapper: t(filterWrapper),
    filterSavedItem: t(filterSavedItem),
    filterRow: t(filterRow),
    filterItemLabel: t(filterItemLabel),
    filterItem: t(filterItem),
    formItemRowDesc: t(formItemRowDesc),
    formListItemRow: t(formListItemRow),
    formPlainHintRow: t(formPlainHint),
    formItemSlider: t(formItemSlider),
    formItemMgrview: t(formItemMgrview),
    formItemRadio: t(formItemRadio),
    formItemRadioImg: t(formItemRadioImg),
    formItemTextData: t(formItemTextData),
    dashTaskbar: t(dashTaskbar),
    progressBar: t(progressBar),
    reportBand: t(reportBand),
    reportBandDash: t(reportBandDash),
    banner: t(banner),
    buttons: t(buttons),
    fatalError: t(fatalError),
    passwdCheck: t(passwdCheck),
    editinListForm: t(editinListForm),
    confirmCheck: t(confirmCheck),
    formItemSliderEditInList: t(formItemSliderEditInList),
    tip: t(tip),
    infoList: t(infoList),
    fatalAlert: t(fatalAlert),
    msgTemplList: t(msgTemplList),
    emptyBandOverlay: t(emptyBandOverlay),
    usefulLinks: t(usefulLinks),
    formListFilter: t(formListFilter),
    formListFilterWrapper: t(formListFilterWrapper),
    formItemDateTime: t(formItemDateTime)
  };
}());

// Event manager
//@todo unit test
var EventMgr = {

  o: function() {
    'use strict';
    return $('body');
  },

  hooks: {},

  isTouch: function() {
    return (navigator.userAgent.match(/Android/i) ||
     navigator.userAgent.match(/webOS/i) ||
     navigator.userAgent.match(/iPhone/i) ||
     navigator.userAgent.match(/iPad/i) ||
     navigator.userAgent.match(/iPod/i) ||
     navigator.userAgent.match(/BlackBerry/i) ||
     navigator.userAgent.match(/Windows Phone/i));
  },

  touchEvents: {},

  touchData: {},
  /**
   * bind custom event
   * @this {EventMgr} EventMgr object
   */
  bind: function(event, callback) {
    'use strict';
    var events = event.split(','),
        l = event.length;
    while (l--) {
      this.o().on(events[l], callback);
    }
  },
  /**
   * bind custom event for one time
   * @this {EventMgr} EventMgr object
   */
  one: function(event, callback, data) {
    'use strict';
    var events = event.split(','),
        l = event.length;
    while (l--) {
      this.o().one(events[l], data, callback);
    }
  },
  /**
   * wrapper for jQuery.one
   */
  oone: function(object, event, callback) {
    'use strict';
    if (typeof object === 'string') {
      $(object).one(event, callback);
    } else {
      object.one(event, callback);
    }
  },
  /**
   * wrapper for jQuery.obind
   */
  obind: function(object, event, callback) {
    'use strict';
    var touch;
    if (event === 'click' &&
         this.isTouch() &&
         typeof object === 'string') {
      event = 'touchstart';
      touch = true;
    }
    if (!touch) {
      if (typeof object === 'string') {
        $(object).on(event, callback);
      } else {
        object.on(event, callback);
      }
    } else {
      var data = {
          eventMgr: this,
          cb: callback
      };
      if (typeof object === 'string') {
        data.innerSelect = object;
        $(object).on(event, data, this.touchStart);
       // $(object).on('touchmove', data, this.touchMove);
        $(object).on('touchend', data, this.touchEnd);
      }
    }
  },

  /**
   * wrapper for jQuery.on
   * */
  on: function(outObject, innerSelect, event, callback) {
    'use strict';
    var touch = false;
    if (event === 'click' && this.isTouch()) {
      event = 'touchstart';
      touch = true;
    }
    if (!touch) {
      if (typeof outObject === 'string') {
        $(outObject).on(event, innerSelect, callback);
      } else {
        outObject.on(event, innerSelect, callback);
      }
    } else {
        var data = {
          innerSelect: innerSelect,
          eventMgr: this,
          cb: callback
        };
       if (typeof outObject === 'string') {
        $(outObject).on(event, innerSelect, data, this.touchStart);
        //$(outObject).on('touchmove', innerSelect, data, this.touchMove);
        $(outObject).on('touchend', innerSelect, data, this.touchEnd);
      } else {
        outObject.on(event, innerSelect, data, this.touchStart);
        //outObject.on('touchmove', innerSelect, data, this.touchMove);
        outObject.on('touchend', innerSelect, data, this.touchEnd);
      }
    }
  },
  /**
   * allow hooks for original events
   * @this {EventMgr} EventMgr object
   */
  onwithdata: function(outObject, innerSelect, event, customEvent, callback) {
    'use strict';
    var data = {
      targetEvent: customEvent,
      targetCallback: callback,
      eventMgr: this,
      innerSelect: innerSelect,
      withData: true
    },
    touch = false;

    if (event === 'click' && this.isTouch()) {
      event = 'touchstart';
      touch = true;
    }
    if (!touch) {
      if (typeof outObject === 'string') {
        $(outObject).on(event, innerSelect, data, this.onwithdataHandler);
      } else {
        outObject.on(event, innerSelect, data, this.onwithdataHandler);
      }
    } else {
      if (typeof outObject === 'string') {
        $(outObject).on(event, innerSelect, data, this.touchStart);
        //$(outObject).on('touchmove', innerSelect, data, this.touchMove);
        $(outObject).on('touchend', innerSelect, data, this.touchEnd);
      } else {
        outObject.on(event, innerSelect, data, this.touchStart);
        //outObject.on('touchmove', innerSelect, data, this.touchMove);
        outObject.on('touchend', innerSelect, data, this.touchEnd);
      }
    }
  },

  touchStart: function(e) {
    e.preventDefault();
    var selector = e.data.innerSelect,
        em = e.data.eventMgr;
    em.touchEvents[selector] = true;
  },

  touchMove: function(e) {
    var selector = e.data.innerSelect,
        em = e.data.eventMgr;
    em.touchEvents[selector] = false;
  },

  touchEnd: function(e) {
    var selector = e.data.innerSelect,
        em = e.data.eventMgr;
    if (em.touchEvents[selector]) {
      if (e.data.withData) {
        em.onwithdataHandler.apply(this, [e]);
        em.touchEvents[selector] = false;
      } else {
        e.data.cb.apply(this, [e]);
        em.touchEvents[selector] = false;
      }
    }
  },

  /**
   * handler for onwithdata
   * @this {HTMLNode} HTMLNode
   */
  onwithdataHandler: function(e) {
    'use strict';
    var eventData = e.data,
        targetEvent = eventData.targetEvent,
        targetCallback = eventData.targetCallback,
        data = {},
        self = eventData.eventMgr;
    if (this) {
      data.tabId = this.getAttribute('data-tabid');
      data.elemId = this.getAttribute('data-elemid');
    }
    if (targetEvent) {
      if (self.hooks[targetEvent] && self.hooks[targetEvent].length > 0) {
        var l = self.hooks[targetEvent].length;
        while (l--) {
          if (typeof self.hooks[targetEvent][l] === 'function') {
            self.hooks[targetEvent][l].apply(window, [data]);
          }
        }
      }
    }
    if (typeof targetCallback === 'function') {
      targetCallback.apply(this, [e, data]);
    }
  },
  /**
   * wrapper for jQuery.off
   */
  off: function(outObject, event) {
    'use strict';
    if (typeof outObject === 'string') {
      $(outObject).off(event);
    } else {
      outObject.off(event);
    }
  },
  /**
   * unbind event
   * @this {EventMgr} EventMgr object
   */
  unbind: function(event, callback) {
    'use strict';
    var events = event.split(','),
        l = event.length;
    while (l--) {
      this.o().off(events[l], callback);
    }
  },
  /**
   * wrapper for jQuery.trigger
   * @this {EventMgr} EventMgr object
   */
  trigger: function(event, data, delay) {
    'use strict';
    if (delay) {
      setTimeout(function(self) { return function() {
        if (typeof event !== 'string') {
          console.log('event !== string in trigger', event, data);
          event = String(event);
        }
        self.o().trigger(event, data);};
      } (this), delay);
    } else {
      if (this.hooks[event] && this.hooks[event].length > 0) {
        var l = this.hooks[event].length;
        while (l--) {
          if (typeof this.hooks[event][l] === 'function') {
            this.hooks[event][l].apply(window, [data]);
          }
        }
      }
      if (typeof event !== 'string') {
        console.log('event !== string in trigger', event, data);
        event = String(event);
      }
      this.o().trigger(event, data);
    }
    if (this.triggerStack[event]) {
      this.triggerStackHandler(event, data);
    }
  },
  triggerStack: {},
  /**
   * add to trigger stack
   * @param {String} event event name
   * @param {function} func function for call
   * @param {number} priority stack call order
   * @this {EventMgr} EventMgr object
   */
  addToTriggerStack: function(event, func, priority) {
    if (!this.triggerStack[event]) {
      this.triggerStack[event] = [];
    }
    this.triggerStack[event].push({
        func: func,
        priority: priority
    });
    this.triggerStack[event].sort(this.prioritySort);
  },

  triggerStackHandler: function(event, data) {
    if (this.triggerStack[event]) {
      var l = this.triggerStack[event].length;
      for (var i = 0; i < l; i++) {
         if (typeof this.triggerStack[event][i].func === 'function') {
           //break if return true
           if (this.triggerStack[event][i].func.apply(window, [{}, data])) {
            break;
           }
         }
      }
    }
  },
  prioritySort: function(a, b) {
    return a.priority - b.priority;
  },
  /**
   * add hook for custom event
   * @this {EventMgr} EventMgr object
   */
  addHook: function(event, callback) {
    'use strict';
    var events = event.split(','),
        l = event.length;
    while (l--) {
      if (this.hooks[events[l]]) {
        this.hooks[events[l]].push(callback);
      } else {
        this.hooks[events[l]] = [];
        this.hooks[events[l]].push(callback);
      }
    }
  },
  /**
   * remove hook
   * @this {EventMgr} EventMgr object
   */
  deleteHook: function(event, callback) {
    'use strict';
    if (this.hooks[event]) {
      var len = this.hooks[event].length - 1,
          ar = this.hooks[event];

      for (var i = len; i <= 0; i--) {
        if (ar(i) === callback) {
          ar.slice(i, i);
        }
      }
    }
  }
};

/**
 * ScrollHandler
 * @class
 */
var ScrollHandler = (function() {
  'use strict';
  var shiftY = 0,

      shiftX = 0,

      bigObj = {},
      /**
       * Current Scroll object
       */
      curObj = {
        /**
         * Object id
         */
        objId: null,
        /**
         * Wrapper id
         */
        contId: null,
        /**
         * Wrapper id
         */
        obj: null,
        /**
         * HTML Object of Object
         */
        cont: null,
        /**
         * HTML Object of ScrollHandler
         */
        sh: null,
        /**
         * Visible height (wrapper's height)
         */
        vh: null,
        /**
         * Scroll handler height
         */
        sch: null
      },

      moveObj = {}, //temp object moved elems
      down = false, //go down
      /* jslint evil:true */
      isIe = !!window.execScript,
      /* jslint evil:false */
      up = false, // go up
      left = false, //go left
      right = false,  //go right
      intId = null,
      /**
       * Block not needed events when scrolling
       */
      blockEvent = function(e) {
        e = e || window.event;
        if (e.stopPropagation) {
          e.stopPropagation();
        } else { e.cancelBubble = true; }
        if (e.preventDefault) {
          e.preventDefault();
        } else { e.returnValue = false; }
      },
      /**
       * Handler for mouseup
       * unbind mouseup/touchend handlers
       */
      mouseUp = function() {
        down = false;
        up = false;
        left = false;
        right = false;
        document.onmouseup = null;
        document.ontouchend = null;
      },
      /**
       * Set Position for object and scrollhandler
       */
      lastValues = {},

      setPosition = function(newPosition) {
        var sTop, scrollTop,
            middle = false,
            top = false,
            bottom = false;
        if ((newPosition <= moveObj.vh - moveObj.sch) && (newPosition >= 0)) {
          sTop = newPosition;
          middle = true;
        } else if (newPosition > moveObj.vh - moveObj.sch) {
          sTop = moveObj.vh - moveObj.sch;
          bottom = true;
        } else {
          sTop = 0;
          top = true;
        }

        moveObj.sh.style.top = sTop + 'px';
        scrollTop = Math.round(sTop * moveObj.delta);
        if (isIe) {
          moveObj.cont.scrollTop = 0;
          moveObj.obj.style.marginTop = scrollTop * (-1) + 'px';
        } else {
          moveObj.cont.scrollTop = scrollTop;
          moveObj.sw.style.top = scrollTop + 'px';
        }
        if (lastValues[moveObj.contId] !== sTop) {
          var body = document.querySelector('body') || document.body,
              event;
          try {
            event = new CustomEvent('verticalScroll', { 'detail': {
                top: top,
                middle: middle,
                bottom: bottom,
                id: moveObj.contId}});
            body.dispatchEvent(event);
          } catch (e) {}
        }
        lastValues[moveObj.contId] = sTop;
        return false;
      },
      /**
       * Set Position for horizontal object and scrollhandler
       */
      setPositionHor = function(newPosition) {
        var sLeft, scrollLeft;
        if ((newPosition <= moveObj.vw - moveObj.schH) && (newPosition >= 0)) {
          sLeft = newPosition;
        } else if (newPosition > moveObj.vw - moveObj.schH) {
          sLeft = moveObj.vw - moveObj.schH;
        } else {
          sLeft = 0;
        }
        moveObj.hSh.style.left = sLeft + 'px';
        scrollLeft = Math.round(sLeft * moveObj.deltaH);

        if (isIe) {
          moveObj.cont.scrollLeft = 0;
          moveObj.obj.style.marginLeft = scrollLeft * (-1) + 'px';
        } else {
          moveObj.cont.scrollLeft = scrollLeft;
          moveObj.hSw.style.left = scrollLeft + 'px';
        }
        return false;
      },
      /**
       * Mouse wheel handler
       */
      wheel = function(e) {
        e = e || window.event;
        var wheelDelta = 0,
            id = this.getAttribute('id'),
            currentPosition,
            newPosition,
            direction, delta, STEP = 64;
        moveObj = bigObj[id];
        //check for exist scroll
        if (!moveObj) { return; }
        delta = moveObj.delta;
        //detect direction
        if (e.wheelDelta) {
          direction = e.wheelDelta > 0 ? -1 : 1;
        } else if (e.detail) {
          direction = e.detail < 0 ? -1 : 1;
        }
        //check for native scroll
        if (e.target) {
          var target = e.target;
          //check for scroll
          //target.clientHeight > 0 ==> for opera
          if (target.clientHeight < target.scrollHeight &&
              target.clientHeight > 0 &&
              target.nodeName === 'TEXTAREA') {
            //scroll down
            if (
                //(target.clientHeight + 1) ==> for safari
                (direction === 1 && (target.scrollTop <
                    (target.scrollHeight - (target.clientHeight + 1)))) ||
                (direction === -1 && target.scrollTop !== 0)
                ) {
                  return true;
            }
          }
        }

        if (e.wheelDelta) {
          wheelDelta = -e.wheelDelta / 2.5;
        } else if (e.detail) { //for FF
          wheelDelta = e.detail * 16;
        }

        if (wheelDelta) {
          currentPosition = parseFloat(moveObj.sh.style.top);
          newPosition = ((wheelDelta / delta)) + currentPosition;
          setPosition(newPosition);
        }
        blockEvent(e);
      },
      /**
       * Scroll mover by UP/DOWN scroll btn
       */
      scrollMove = function(stopPos) {
        var currentPosition, mDelta, newPosition, magicNumber = 5;
        if (!moveObj) {
           clearInterval(intId);
        }
        currentPosition = parseFloat(moveObj.sh.style.top);
        mDelta = magicNumber / moveObj.delta;
        if (up) {
          newPosition = currentPosition - mDelta;
          setPosition(newPosition);
          if (stopPos && newPosition < stopPos) {
            clearInterval(intId);
          }
        } else if (down) {
          newPosition = mDelta + currentPosition;
          setPosition(newPosition);
          if (stopPos && newPosition > stopPos) {
            clearInterval(intId);
          }
        } else {
          clearInterval(intId);
        }
      },
      /**
       * Scroll mover horizontal by UP/DOWN scroll btn
       */
      scrollMoveHoriz = function(stopPos) {
        var currentPosition, mDelta, newPosition, magicNumber = 5;
        if (!moveObj) {
           clearInterval(intId);
        }
        currentPosition = parseFloat(moveObj.hSh.style.left);
        mDelta = magicNumber / moveObj.deltaH;
        if (left) {
          newPosition = currentPosition - mDelta;
          setPositionHor(newPosition);
          if (stopPos && newPosition < stopPos) {
            clearInterval(intId);
          }
       } else if (right) {
          newPosition = mDelta + currentPosition;
          setPositionHor(newPosition);
          if (stopPos && newPosition > stopPos) {
            clearInterval(intId);
          }
       } else {
          clearInterval(intId);
        }
      },
      /**
       * Handler for button move up
       */
      moveUp = function(id, stopPos) {
        var doc = document,
            timeOut = stopPos !== undefined ? 1 : 10;
        moveObj = bigObj[id];
        up = true;
        //some issues about
        if (!('ontouchstart' in doc.documentElement)) {
          doc.onmouseup = mouseUp;
        }
        //for touchpads
        doc.ontouchend = mouseUp;
        doc.ontouchcancel = mouseUp;
        scrollMove(stopPos);
        intId = setInterval(function() { scrollMove(stopPos); }, timeOut);
      },

      moveUpHandler = function(e) {
        e = e || window.event;
        var id = this.getAttribute('id').replace('-top-button', '');
        moveUp(id);
        blockEvent(e);
        return false;
      },

      moveLeftHandler = function(e) {
        e = e || window.event;
        var id = this.getAttribute('id').replace('-left-button', '');
        moveLeft(id);
        blockEvent(e);
        return false;
      },

      moveLeft = function(id, stopPos) {
        var doc = document,
            timeOut = stopPos !== undefined ? 1 : 10;
        moveObj = bigObj[id];
        left = true;
        //some issues about
        if (!('ontouchstart' in doc.documentElement)) {
          doc.onmouseup = mouseUp;
        }
        //for touchpads
        doc.ontouchend = mouseUp;
        doc.ontouchcancel = mouseUp;
        scrollMoveHoriz(stopPos);
        intId = setInterval(function() { scrollMoveHoriz(stopPos); }, timeOut);
      },
      /**
       * Handler for button move down
       */
      moveDown = function(id, stopPos) {
        var doc = document,
            timeOut = stopPos !== undefined ? 1 : 10;
        moveObj = bigObj[id];
        down = true;
        if (!('ontouchstart' in doc.documentElement)) {
          doc.onmouseup = mouseUp;
        }
        //for touchpads
        doc.ontouchend = mouseUp;
        doc.ontouchcancel = mouseUp;
        scrollMove(stopPos);
        intId = setInterval(function() { scrollMove(stopPos); }, timeOut);
      },

      moveDownHandler = function(e) {
        e = e || window.event;
        var id = this.getAttribute('id').replace('-bottom-button', '');
        moveDown(id);
        blockEvent(e);
        return false;
      },

      moveRightHandler = function(e) {
        e = e || window.event;
        var id = this.getAttribute('id').replace('-right-button', '');
        moveRight(id);
        blockEvent(e);
        return false;
      },

      moveRight = function(id, stopPos) {
        var doc = document,
            timeOut = stopPos !== undefined ? 1 : 10;
        moveObj = bigObj[id];
        right = true;
        if (!('ontouchstart' in doc.documentElement)) {
          doc.onmouseup = mouseUp;
        }
        //for touchpads
        doc.ontouchend = mouseUp;
        doc.ontouchcancel = mouseUp;
        scrollMoveHoriz(stopPos);
        intId = setInterval(function() { scrollMoveHoriz(stopPos); }, timeOut);
      },
      /**
       * Cancel scroll, hide scroll handler
       * @param {curObj} obj Current object
       */
      cancelScroll = function(obj) {
        if (!obj) { return; }
        //need to fix
        obj.sh.style.display = 'none';
        obj.vstatus = true;
        obj.cont.style.overflowY = '';
        //hide horiz scroll
        if (obj.hs) {
          obj.vstatus = false;
          obj.sw.style.display = 'none';
          obj.cont.style.paddingRight = '0px';
          // $(obj.cont).removeClass('vertical-scroll');
        }
        $(obj.cont).removeClass('vertical-scroll');
        $(obj.cont.parentNode).removeClass('vertical-scroll-child');
        //this._curObj.sh = null;
        obj.cont.onmousewheel = null;
        obj.bb.onmousedown = null;
        obj.tb.onmousedown = null;
        obj.cont.onkeydown = null;
        if (isIe) {
          obj.obj.style.marginTop = 0;
        }
        obj.cont.scrollTop = 0;
        obj.sh.style.top = 0 + 'px';
        obj.sw.style.top = 0 + 'px';
        if (obj.contWheelEvent) {
          obj.cont.removeEventListener('DOMMouseScroll', wheel, false);
          obj.contWheelEvent = false;
        }
      },
      /**
       * Cancel horiz scroll, hide scroll handler
       * @param {curObj} obj Current object
       */
      cancelScrollHoriz = function(obj) {
         if (!obj) { return; }
        //need to fix
        obj.hSh.style.display = 'none';
        obj.cont.style.overflowX = '';
        obj.hstatus = true;
        if (!obj.hss) {
          obj.hstatus = false;
          obj.hSw.style.display = 'none';
          $(obj.cont).removeClass('horizontal-scroll');
          obj.cont.paddingBottom = '0px';
        }
        //this._curObj.sh = null;
        obj.hBb.onmousedown = null;
        obj.hTb.onmousedown = null;
        if (isIe) {
          obj.obj.style.marginLeft = 0;
        }
        obj.cont.scrollLeft = 0 + 'px';
        obj.hSh.style.top = 0 + 'px';
      },
      /**
       * Update scroll method
       */
      updateFunc = function(key) {
        if (bigObj[key] === undefined) { return; }
        var scrollCorrect = 36, swStyle, tmpHeight, scrollTop, curObjUp;
            curObjUp = bigObj[key];
        if (curObjUp.hstatus) {
          scrollCorrect += 18;
        }
        //trackHeight
        var visibleHeight = curObjUp.cont.clientHeight,
            scrollTrackHeight = visibleHeight - scrollCorrect,
            deltaTop = (curObjUp.obj.offsetTop > 0) ?
                curObjUp.obj.offsetTop : 0,
            allHeight = curObjUp.obj.offsetHeight + deltaTop,
            deltaAV = allHeight / visibleHeight,
            scrollHandlerHeight = scrollTrackHeight / deltaAV,
            delta = allHeight / scrollTrackHeight;
        //if hide element exit
        if (visibleHeight === 0) { return; }
        curObjUp.vh = scrollTrackHeight;
        //all height, object height

        //var sch = (visibleHeight) / (allHeight /
        // (visibleHeight + scrollCorrect));
        if (scrollHandlerHeight < 25) {
          scrollHandlerHeight = 25;
          delta = (allHeight - (scrollTrackHeight + scrollCorrect)) /
              (scrollTrackHeight - 25);
        }
        //size of step
        curObjUp.delta = delta;
        curObjUp.sch = scrollHandlerHeight;
        //check for nothing scroll
        tmpHeight = scrollTrackHeight + scrollCorrect;
        if (scrollTrackHeight < scrollCorrect ||
            scrollHandlerHeight > scrollTrackHeight ||
            tmpHeight === allHeight) {
          cancelScroll(curObjUp);
          //scrollHandlerHeight = scrollTrackHeight;
        } else {
          //set scroll handler size
          swStyle = curObjUp.sw.style;
          //keep state
          curObjUp.cont.scrollTop = parseFloat(swStyle.top);
          //swStyle.top = curObjUp.cont.scrollTop;
          curObjUp.sh.style.height = scrollHandlerHeight + 'px';
          curObjUp.sh.style.display = 'block';
          swStyle.display = 'block';
          curObjUp.cont.style.paddingRight = '18px';
          curObjUp.cont.style.overflowY = 'hidden';
          if (curObjUp.cont.className.indexOf('vertical-scroll') === -1) {
            curObjUp.cont.className += ' vertical-scroll';
            curObjUp.cont.parentNode.className += ' vertical-scroll-child';
          }
          if (!curObjUp.contWheelEvent) {
            curObjUp.cont.addEventListener('DOMMouseScroll', wheel, false);
            curObjUp.contWheelEvent = true;
          }

          curObjUp.cont.onmousewheel = wheel;

          curObjUp.bb.onmousedown = moveDownHandler;
          curObjUp.tb.onmousedown = moveUpHandler;

          //check real behavior
          if (parseInt(curObjUp.sh.style.top, 10) + curObjUp.sch >
              curObjUp.vh) {
            curObjUp.sh.style.top = curObjUp.vh - curObjUp.sch + 'px';
            scrollTop = (curObjUp.vh - curObjUp.sch) * curObjUp.delta;
            swStyle.top = scrollTop + 'px';
            curObjUp.cont.scrollTop = scrollTop;
          }
        }
        bigObj[key] = curObjUp;
        curObjUp = null;
      },
      /**
       * Update horiz scroll method
       */
      updateFuncHoriz = function(key) {
        if (bigObj[key] === undefined) { return; }
        var scrollCorrect = 36,
            curObjUp = bigObj[key],
            vw, aw, delta, sch;
        if (curObjUp.vstatus) {
          scrollCorrect += 18;
        }

        vw = curObjUp.cont.offsetWidth - scrollCorrect;
        curObjUp.vw = vw;
        //ll height, object height
        aw = curObjUp.obj.offsetWidth;
        delta = aw / (vw);
        //scroll height
        sch = (vw) / (aw / (vw + scrollCorrect));

        if (sch < 25) {
          //var dp = 25 - sch;
          sch = 25;
          delta = (aw - (vw + scrollCorrect)) / (vw - 25);
        }
        //size of step
        curObjUp.deltaH = delta;
        curObjUp.schH = sch;
        //check for nothing scroll
        if (vw < scrollCorrect || sch > vw || vw + scrollCorrect === aw) {
          cancelScrollHoriz(curObjUp);
          //sch = vw;
        } else {
          //set scroll handler size
          curObjUp.hSh.style.width = sch + 'px';
          curObjUp.hSw.style.display = 'block';
          curObjUp.hSh.style.display = 'block';
          curObjUp.cont.style.overflowX = 'hidden';
          curObjUp.cont.style.paddingBottom = '18px';

          curObjUp.hBb.onmousedown = moveRightHandler;
          curObjUp.hTb.onmousedown = moveLeftHandler;

         //check real behavior
          if (parseInt(curObjUp.hSh.style.top, 10) + curObjUp.schH >
              curObjUp.vw) {
            curObjUp.hSh.style.left = curObjUp.vw - curObjUp.schH + 'px';
            curObjUp.obj.scrollLeft =
                (curObjUp.vw - curObjUp.schH) * curObjUp.deltaH;
          }
        }
        bigObj[key] = curObjUp;
        curObjUp = null;
      },
      /**
       * void method, update sizes
       */
      update = function(id) {
        if (id) {
          updateFunc(id);
          updateFuncHoriz(id);
        } else {
          var key;
          /* jslint forin:true */
          for (key in bigObj) {
            updateFunc(key);
            updateFuncHoriz(key);
          }
        }
      },
      /**
       * get sizes of objects and calculate delta
       */
      getSize = function() {
        //visible height
        var scrollCorrect = 36,
            visibleHeight = curObj.cont.clientHeight,
            scrollTrackHeight = visibleHeight - scrollCorrect,
            deltaTop = (curObj.obj.offsetTop > 0) ? curObj.obj.offsetTop : 0,
            allHeight = curObj.obj.offsetHeight + deltaTop,
            deltaAV = allHeight / visibleHeight,
            scrollHandlerHeight = scrollTrackHeight / deltaAV,
            delta = allHeight / scrollTrackHeight;

        //-18px for top/bottom buttons
        curObj.vh = scrollTrackHeight;
        curObj.delta = delta;
        //scroll height
        curObj.sch = scrollHandlerHeight;

        //check for nothing scroll
        if (scrollTrackHeight < 36 ||
            scrollHandlerHeight > scrollTrackHeight ||
            ((scrollTrackHeight + 36) === allHeight)) {
          cancelScroll(curObj);
        } else {
          curObj.vstatus = true;
          curObj.cont.className += ' vertical-scroll';
          curObj.cont.parentNode.className += ' vertical-scroll-child';
          if (scrollHandlerHeight < 25) {
            scrollHandlerHeight = 25;
          }
          //set scroll handler size
          curObj.sh.style.height = scrollHandlerHeight + 'px';
          curObj.sh.style.left = 0;
          curObj.cont.scrollTop = 0;
          curObj.cont.style.paddingRight = '18px';
          curObj.cont.style.overflowY = 'hidden';
        }
      },

      getSizeHor = function() {
        //visible height
        var visibleWidth = curObj.cont.offsetWidth - 36,
            //all height, object height
            aw = curObj.obj.offsetWidth,
            //size of step
            delta = aw / (visibleWidth),
            sch;

        //-20px for top/bottom buttons
        curObj.vw = visibleWidth;
        curObj.deltaH = delta;
        //scroll height
        sch = (visibleWidth) / (aw / (visibleWidth + 36));
        curObj.schH = sch;

        //check for nothing scroll
        if (visibleWidth < 36 ||
            sch > visibleWidth ||
            visibleWidth + 36 === aw) {
          cancelScrollHoriz(curObj);
          sch = visibleWidth;
        } else {
          curObj.hstatus = true;
          curObj.cont.className += ' horizontal-scroll';
          if (sch < 25) {
            sch = 25;
          }
          //set scroll handler size
          curObj.hSh.style.width = sch + 'px';
          curObj.hSh.style.left = 0;
          curObj.hSw.style.display = 'block';
          curObj.cont.scrollLeft = 0;
          curObj.cont.style.paddingBottom = '18px';
          curObj.cont.style.overflowX = 'hidden';
        }
      },

      forceMoveSelectItem = function(id, offsetTop, boxHeight, elemHeight) {
        moveObj = bigObj[id];
        if (!moveObj) { return; }
        var boxHeight =  boxHeight || 223,
            elemHeight = elemHeight || 16,
            newPosition = null,
            mTRaw = moveObj.cont.scrollTop,
            mT = 0,
            df;
        if (mTRaw !== '') {
          mT = parseFloat(mTRaw);
        }
        df = offsetTop - mT;
        if (boxHeight < df) {
          //movedown
          if (boxHeight < (df - 17)) {
            newPosition = (offsetTop) / moveObj.delta;
          } else {
            newPosition = (mT + elemHeight) / moveObj.delta;
          }
        } else if (df < 0) {
          //moveup
          newPosition = (mT - elemHeight) / moveObj.delta;
        }
        if (newPosition !== null) {
          setPosition(newPosition);
        }
      },

      TABKEY = 9,
      /**
       * force mov
       */
      forceMove = function(id) {
        if (!id) { return; }
        moveObj = bigObj[id];
        var scrollTop = moveObj.cont.scrollTop,
            newPosition = scrollTop / moveObj.delta;
        setPosition(newPosition);
      },

      checkTabKeyUp = function(e) {
        e = e || window.event;
        var codeKey, contId;
            codeKey = e.which || e.keyCode;
        if (codeKey === TABKEY) {
          contId = $(e.target || e.srcElement)
              .parents('div.vertical-scroll')
              .attr('id');
          forceMove(contId);
        }
      },
      animate = function(opts) {
        var start = new Date(),
            timer = setInterval(function() {
              var progress = (new Date() - start) / opts.duration;
              if (progress > 1) { progress = 1; }
              opts.step(progress);
              if (progress === 1) {
                clearInterval(timer);
              }
            }, opts.delay || 10);
      },

      animateMove = function(to, from) {
        from = from || 0;
        animate({
          duration: 350,
          step: function(progress) {
            //var newPos =  (1 - Math.sin(Math.acos(progress))) * to;
            var newPos = from + (Math.pow(progress, 2)) * to;
            setPosition(newPos);
          }
        });
      },
      /**
       * set scrollTop
       * @param {string} id  scroll contId
       * @param {number} offset Offset to move
       * @param {number} raw Raw value to Move in offset param
       * @param {boolean|undefined} animate Scrolling with animate
       */
      scrollTo = function(id, offset, raw, animate) {
        if (!id) { return; }
        moveObj = bigObj[id];
        if (!moveObj) { return; }
        var newPosition = 0,
            from = parseFloat(moveObj.sh.style.top) || 0;
        if (!raw) {
          newPosition = offset / moveObj.delta;
        } else {
          newPosition = offset;
        }
        if (!animate) {
          setPosition(newPosition);
        } else {
          newPosition -= from;
          animateMove(newPosition, from);
        }
      },
      /**
       * Handler for mouseup
       * unbind mousemove and mouseup
       */
      drop = function() {
        moveObj = null;
        document.onmousemove = null;
        document.onmouseup = null;
      },
      /**
       * Handler for touchend
       * unbind ontouchmove and touchend
       */
      tDrop = function() {
        moveObj = null;
        document.ontouchmove = null;
        document.ontouchend = null;
        document.ontouchcancel = null;
      },
      /**
       * Handler for move
       */
      move = function(e) {
        e = e || window.event;
        setPosition(e.clientY - shiftY);
        blockEvent(e);
        return false;
      },
      /**
       * Handler for move horizontal
       */
      moveHor = function(e) {
        e = e || window.event;
        setPositionHor(e.clientX - shiftX);
        blockEvent(e);
        return false;
      },
      /**
       * Handler for touchmove
       */
      tMove = function(e) {
        e = e || window.event;
        setPosition(e.touches[0].pageY - shiftY);
        blockEvent(e);
        return false;
      },
      /**
       * Handler for touchmove horizontal
       */
      tMoveHor = function(e) {
        e = e || window.event;
        setPositionHor(e.touches[0].pageX - shiftX);
        blockEvent(e);
        return false;
      },
      /**
       * Handler for mousedown for scrollhandler
       * bind handlers for touchmove, touchend
       */
      drag = function(e) {
        e = e || window.event;
        var id, doc, top;
        id = this.getAttribute('id').replace('-scrollbar-handler', '');
        top = this.style.top === '' ? 0 : parseFloat(this.style.top);
        shiftY = e.clientY - top;
        doc = document;
        moveObj = bigObj[id];
        doc.onmousemove = move;
        doc.onmouseup = drop;
        blockEvent(e);
        return false;
      },
      /**
       * Handler for mousedown for scrollhandler horizontal
       * bind handlers for touchmove, touchend
       */
      dragHor = function(e) {
        e = e || window.event;
        var id, doc, left;
        id = this.getAttribute('id').replace('-scrollbar-handler-horiz', '');
        left = this.style.left === '' ? 0 : parseFloat(this.style.left);
        shiftX = e.clientX - left;
        moveObj = bigObj[id];
        doc = document;
        doc.onmousemove = moveHor;
        doc.onmouseup = drop;
        blockEvent(e);
        return false;
      },
      /**
       * Handler for touchstart for scrollhandler
       * bind handlers for touchmove, touchend
       */
      tDrag = function(e) {
        e = e || window.event;
        var id, doc, top;
        id = this.getAttribute('id').replace('-scrollbar-handler', '');
        top = this.style.top === '' ? 0 : parseFloat(this.style.top);
        shiftY = e.touches[0].pageY - top;
        moveObj = bigObj[id];
        doc = document;
        doc.ontouchmove = tMove;
        doc.ontouchend = tDrop;
        doc.ontouchcancel = tDrop;
        blockEvent(e);
        return false;
      },
      /**
       * Handler for touchstart for scrollhandler horizontal
       * bind handlers for touchmove, touchend
       */
      tDragHor = function(e) {
        e = e || window.event;
        var id, doc, left;
        id = this.getAttribute('id').replace('-scrollbar-handler-horiz', '');
        left = this.style.left === '' ? 0 : parseFloat(this.style.left);
        shiftX = e.touches[0].pageX - left;
        moveObj = bigObj[id];
        doc = document;
        doc.ontouchmove = tMoveHor;
        doc.ontouchend = tDrop;
        doc.ontouchcancel = tDrop;
        blockEvent(e);
        return false;
      },
      /**
       * Scroll by scroll track click
       */
      scrollTrackMDHandler = function(e) {
        var id = String(this.getAttribute('id')).replace('-scrollbar-track', ''),
            sbh = document.getElementById(id + '-scrollbar-handler'),
            offsetY, offsetX,
            offsetST,
            horizScroll = false;
        if (!sbh) {
          id = String(this.getAttribute('id')).replace('-scrollbar-track-horiz', '');
          sbh = document.getElementById(id + '-scrollbar-handler-horiz');
          if (!sbh) {
            return;
          }
          horizScroll = true;
        }
        if (!horizScroll) {
          var borderTop = parseInt(sbh.style.top, 10),
              borderBottom = parseInt(sbh.style.height, 10);
          if (e.offsetX && e.offsetY) {
            offsetY = e.offsetY;
          } else {
            offsetST = $(this).offset();
            offsetY = e.clientY - offsetST.top;
          }
          if (offsetY < borderTop) {
            //direction up
            moveUp(id, offsetY);
          } else if (offsetY > borderBottom) {
            //direction down
            moveDown(id, offsetY - borderBottom);
          }
        } else {
          var borderLeft = parseInt(sbh.style.left, 10),
              borderRight = parseInt(sbh.style.width, 10);
          if (e.offsetX && e.offsetY) {
            offsetX = e.offsetX;
          } else {
            offsetST = $(this).offset();
            offsetX = e.clientX - offsetST.left;
          }
          if (offsetX < borderLeft) {
            //direction up
            moveLeft(id, offsetX);
          } else if (offsetX > borderRight) {
            //direction down
            moveRight(id, offsetX - borderRight);
          }
        }
      },
      /**
       * Bind handler for scrollhandler on mousedown and touchstart events
       */
      bindEvent = function() {
        if (curObj.sh) {
          curObj.sh.onmousedown = drag;
          curObj.sh.ontouchstart = tDrag;
          var contElem = curObj.cont;

          contElem.onkeyup = function(e) {
            checkTabKeyUp(e);
          };
          contElem = null;
        }
        if (curObj.hSh) {
          curObj.hSh.onmousedown = dragHor;
          curObj.hSh.ontouchstart = tDragHor;
        }
      },

      /**
       * void method for build scroll
       */
      buildScroll = function() {
        //@TODO might be add class?
        curObj.cont.style.overflowY = 'hidden';
        curObj.cont.style.position = 'relative';
        var sw, divId, tb, trt, st, sh, ln, lns, bb, trb;

        //create scroll wrapper
        sw = document.createElement('div');
        divId = curObj.contId + '-scrollbar-wrapper';
        sw.setAttribute('id', divId);
        sw.setAttribute('class', 'scrollbar-wrapper scrlbr');

        curObj.cont.appendChild(sw);

        //create scroll button top
        tb = document.createElement('div');
        tb.setAttribute('id', curObj.contId + '-top-button');
        tb.setAttribute('class', 'top-button scrlbr');
        sw.appendChild(tb);

        trt = document.createElement('div');
        trt.setAttribute('class', 'triangl-top scrlbr');
        tb.appendChild(trt);

        //create scroll button scrollbar-track
        st = document.createElement('div');
        st.setAttribute('id', curObj.contId + '-scrollbar-track');
        st.setAttribute('class', 'scrollbar-track scrlbr');
        sw.appendChild(st);
        //create scroll button scrollbar-handler
        sh = document.createElement('div');
        sh.setAttribute('id', curObj.contId + '-scrollbar-handler');
        sh.setAttribute('class', 'scrollbar-handler scrlbr');

        curObj.st = st;
        curObj.sh = sh;

        st.appendChild(sh);

        //create scroll button scrollbar-handler
        ln = document.createElement('div');
        ln.setAttribute('class', 'scrollbar-lines scrlbr');

        lns = document.createElement('div');
        lns.setAttribute('class', 'scrollbar-line scrlbr');

        ln.appendChild(lns);

        sh.appendChild(ln);

        //create scroll button bottom
        bb = document.createElement('div');
        bb.setAttribute('id', curObj.contId + '-bottom-button');
        bb.setAttribute('class', 'bottom-button scrlbr');
        sw.appendChild(bb);

        trb = document.createElement('div');
        trb.setAttribute('class', 'triangl-bot scrlbr');
        bb.appendChild(trb);

        curObj.sw = sw;
        curObj.bb = bb;
        curObj.tb = tb;

        if (curObj.sh !== null) {
          //for mouse wheel
          if (curObj.cont.addEventListener) {
            curObj.cont.addEventListener('DOMMouseScroll', wheel, false);
            curObj.contWheelEvent = true;
            curObj.st.addEventListener('mousedown', scrollTrackMDHandler, false);
          }
          curObj.cont.onmousewheel = wheel;
          //for button up/down scroll!!!
          if (!('ontouchstart' in document.documentElement)) {
            bb.onmousedown = moveDownHandler;
            tb.onmousedown = moveUpHandler;
          }
          //for touchpads
          bb.ontouchstart = moveDownHandler;
          tb.ontouchstart = moveUpHandler;
        }
        getSize();
      },

      buildHorizScroll = function() {
        curObj.cont.style.overflowX = 'hidden';
        curObj.cont.style.position = 'relative';

        //create scroll wrapper
        var sw, divId, tb, trt, st, sh, ln, lns, bb, trb;

        divId = curObj.contId + '-scrollbar-wrapper-horiz';
        sw = document.createElement('div');
        sw.setAttribute('id', divId);
        sw.setAttribute('class', 'scrollbar-wrapper-horiz scrlbr');

        curObj.cont.appendChild(sw);

        //create scroll button top
        tb = document.createElement('div');
        tb.setAttribute('id', curObj.contId + '-left-button');
        tb.setAttribute('class', 'left-button scrlbr');
        sw.appendChild(tb);

        trt = document.createElement('div');
        trt.setAttribute('class', 'triangl-left scrlbr');
        tb.appendChild(trt);

        //create scroll button scrollbar-track
        st = document.createElement('div');
        st.setAttribute('id', curObj.contId + '-scrollbar-track-horiz');
        st.setAttribute('class', 'scrollbar-track-horiz scrlbr');
        sw.appendChild(st);
        curObj.st = st;
        //create scroll button scrollbar-handler
        sh = document.createElement('div');
        sh.setAttribute('id', curObj.contId + '-scrollbar-handler-horiz');
        sh.setAttribute('class', 'scrollbar-handler-horiz scrlbr');

        curObj.hSh = sh;

        st.appendChild(sh);

        //create scroll button scrollbar-handler
        ln = document.createElement('div');
        ln.setAttribute('class', 'scrollbar-lines scrlbr');

        lns = document.createElement('div');
        lns.setAttribute('class', 'scrollbar-line scrlbr');

        ln.appendChild(lns);

        sh.appendChild(ln);

        //create scroll button bottom
        bb = document.createElement('div');
        bb.setAttribute('id', curObj.contId + '-right-button');
        bb.setAttribute('class', 'right-button scrlbr');
        sw.appendChild(bb);

        trb = document.createElement('div');
        trb.setAttribute('class', 'triangl-right scrlbr');
        bb.appendChild(trb);

        curObj.hSw = sw;
        curObj.hBb = bb;
        curObj.hTb = tb;

        if (curObj.hSh !== null) {
          //for button up/down scroll!!!!
          if (!('ontouchstart' in document.documentElement)) {
            bb.onmousedown = moveRightHandler;
            tb.onmousedown = moveLeftHandler;
          }
          //for touchpads
          bb.ontouchstart = moveRightHandler;
          tb.ontouchstart = moveLeftHandler;
        }
        if (curObj.st.addEventListener) {
          curObj.st.addEventListener('mousedown', scrollTrackMDHandler, false);
        }

        getSizeHor();
      },
      /**
       * Attach object for scrolling
       * @param {String} contId Id of wrapper object
       * @param {String} objId Id of object
       * @param {Boolean} hs HideScroll if nothing scrolling
       * @param {Boolean} hss hideHoriz scroll
       */
      attach = function(contId, objId, tabId, hs, hss) {
        var obj = document.getElementById(objId),
            cont = document.getElementById(contId);

        if (!obj || !cont) {
          return false;
        }
        //bind resize
        curObj = {
          'objId' : objId,
          'contId' : contId,
          'obj' : obj,
          'cont' : cont,
          'tabId' : tabId,
          'hs' : hs || false,
          'hhs' : hss || false
        };
        buildScroll();
        buildHorizScroll();
        bigObj[contId] = curObj;
        bindEvent();
        curObj = null;
        obj = null;
        cont = null;
        //return _curObj;
      },

      detach = function(tabId) {
        var keyVar, keyVar1;
        //rbin = document.getElementById('rbin');
        for (keyVar in bigObj) {
          if (bigObj[keyVar].tabId === tabId) {
            if (bigObj[keyVar].cont.removeEventListener) {
              if (bigObj[keyVar].contWheelEvent) {
                bigObj[keyVar].cont
                    .removeEventListener('DOMMouseScroll', wheel, false);
                bigObj[keyVar].contWheelEvent = false;
              }
            }
            for (keyVar1 in bigObj[keyVar]) {
              if (bigObj[keyVar].hasOwnProperty(keyVar1)) {
                bigObj[keyVar][keyVar1] = null;
              }
            }
            delete lastValues[bigObj[keyVar].contId];
            delete bigObj[keyVar];
          }
        }
      };
  return {
    attach: attach,
    update: update,
    bigObj: bigObj,
    scrollMove: scrollMove,
    scrollMoveHoriz: scrollMoveHoriz,
    scrollTo: scrollTo,
    forceMove: forceMove,
    forceMoveSelectItem: forceMoveSelectItem,
    detach: detach
  };
}());

/**
 * namespace APP
 */
var App = App || {};


/**
 * Init method of application
 */
App.init = function() {
  'use strict';
  App.mgr();

  //core methods here
  function nextEventBind(e, data) {
    var event = data.event,
        cb = data.cb,
        tData = data.tData;
    if (typeof cb === 'function') {
      EventMgr.one(event, cb, tData);
    }
  }

  EventMgr.bind('nextEventBind', nextEventBind);
};


/**
 * Global vars
 */
App.Global = function() {
  'use strict';
  var HeaderMoving = false,
      bannerHtml = null,
      warning = [],
      anychartXML = null,
      selid,
      scrollTop,
      targetId = '',
      msg = {};

  return {
    HeaderMoving: HeaderMoving,
    bannerHtml: bannerHtml,
    warning: warning,
    anychartXML: anychartXML,
    selid: selid,
    scrollTop: scrollTop,
    msg: msg,
    targetId: targetId
  };
}();

/**
 * Module with utilits
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 */
/*global App:true*/
App.u = App.Common = function(window, $, EventMgr) {
  'use strict';
  var init = function() {
    EventMgr.on($(window.document), linkSelector,
        'keydown', linkKeyDownHandler);
  },

      ENTERKEY = 13,

      SPACE = 32,

      linkSelector = 'a',

      getQueryString = function(queryObj, noesc) {
        var j = 0,
            paramString = '',
            curValue,
            keyVar;
        for (keyVar in queryObj) {
          if (keyVar !== '') {
            if (j !== 0) {
              paramString += '&';
            }
            curValue = queryObj[keyVar];
            //encode params
            if (noesc) {
              paramString += keyVar + '=' + curValue;
            } else {
              paramString += keyVar + '=' + encodeURIComponent(curValue);
            }
            j++;
          }
        }
        return paramString;
      },
      //parse url to object
      //@todo unit test
      parseParams = function(paramString) {
        if (paramString !== undefined && paramString !== null) {
          paramString = paramString.replace(/^\?/, '');
          var paramStirngArray = paramString.split('&'),
              paramStirngObj = {},
              re = /=(.+)?/,
              tmp;
          for (var i = 0; i < paramStirngArray.length; i++) {
            tmp = paramStirngArray[i].split(re);
            paramStirngObj[tmp[0]] = (tmp[1]) ? tmp[1] : '';
          }
          return paramStirngObj;
        } else {
          return {};
        }
      },
      //@todo unit test
      serializeForAttr = function(obj) {
        var keyVar, paramStr = '', i = 0;
        /* jslint forin:true */
        for (keyVar in obj) {
          i++;
          if (i !== 1) {
            paramStr += '&';
          }
          paramStr += keyVar + '=' + encodeURIComponent(obj[keyVar]);
        }
        return paramStr;
      },

      //from here
      // http://www.jonefox.com/blog/2009/05/21/internet-explorer-and-the-innerhtml-property/
      replaceHtml = function(el, html) {
        if (el) {
          var oldEl = (typeof el === 'string' ?
                  document.getElementById(el) : el),
              newEl = document.createElement(oldEl.nodeName);
          //Preserve any properties we care about (id and class in this example)
          newEl.id = oldEl.id;
          newEl.className = oldEl.className;
          //set the new HTML and insert back into the DOM
          newEl.innerHTML = html;
          if (oldEl.parentNode) {
            oldEl.parentNode.replaceChild(newEl, oldEl);
          } else {
            oldEl.innerHTML = html;
          }
          //return a reference to the new element in case we need it
          oldEl = null;
          return newEl;
        }
      },

      linkKeyDownHandler = function(e) {
        var codeKey = e.which || e.keyCode;
        if (ENTERKEY === codeKey || SPACE === codeKey) {
          $(this).trigger('click');
          e.preventDefault();
        }
      },

      wordWrap = function(str, wordLen) {
        if (!str) {return str;}
        wordLen = wordLen || 100;
        var wArr = str.split(' '),
            length = wArr.length,
            cWord, cWordLen, newWord,
            wordLenReg = new RegExp('(.{' + wordLen + '})', 'g');
        for (var i = 0; i < length; i++) {
          if (wArr[i].length > wordLen) {
            cWord = wArr[i].split(wordLenReg);
            cWordLen = cWord.length;
            newWord = '';
            for (var j = 0; j < cWordLen; j++) {
              if (cWord[j] !== '') {
                newWord += cWord[j] + '<br>';
              }
            }
            str = str.replace(wArr[i], newWord);
            //replace \n to <br/>
            str = str.replace(/\n/g, '<br/>');
          }
        }
        return str;
      },

      injectCss = function(url) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', url);
        document.getElementsByTagName('head')[0].appendChild(link);
      },

      required = function(file, callback, param) {
        var script = document.getElementsByTagName('script')[0],
            newjs = document.createElement('script');

        newjs.onreadystatechange = function() {
          if (newjs.readyState === 'loaded' ||
              newjs.readyState === 'complete') {
            newjs.onreadystatechange = null;
            if (App.u.isFunction(callback)) {
                callback(param);
                param = null;
                file = null;
            }
          }
        };

        newjs.onload = function() {
          if (App.u.isFunction(callback)) {
              callback(param);
              param = null;
              file = null;
          }
        };

        newjs.src = file;
        script.parentNode.insertBefore(newjs, script);
      },

      noMoreId = {},

      noMoreCheckTimeId,

      noMoreThan = function(id, timeOut, func) {
        var time = new Date().getTime(),
            dTime;
            timeOut = timeOut ? timeOut : 100;
        if (!noMoreId[id]) {
          noMoreId[id] = {
            q: false,
            lastRun: time,
            timeOut: timeOut
          };
          runFunc(func, time, id);
        } else {
          dTime = time - noMoreId[id].lastRun;
          //check for timeout
          if (dTime > timeOut) {
            runFunc(func, time, id);
            clearTimeout(noMoreCheckTimeId);
          //to queue
          } else {
            noMoreId[id].q = true;
            clearTimeout(noMoreCheckTimeId);
            //todo closure
            noMoreCheckTimeId = setTimeout(function() {
              checkLastCall(func, time, id);
            }, timeOut * 2);
          }
        }
      },

      checkLastCall = function(func, time, id) {
        if (noMoreId[id].q === true) {
          runFunc(func, time, id);
        }
      },

      runFunc = function(func, time, id) {
        if (typeof func === 'function') {
          func();
          noMoreId[id].lastRun = time;
          noMoreId[id].q = false;
        }
      },

      clone = function(obj) {
        // Handle the 3 simple types, and null or undefined
        if (null === obj || 'object' !== typeof obj) { return obj; }
        var copy;
        // Handle Date
        if (obj instanceof Date) {
          copy = new Date();
          copy.setTime(obj.getTime());
          return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
          copy = [];
          for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
          }
          return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
          copy = {};
          for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) { copy[attr] = clone(obj[attr]); }
          }
          return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
      },
      msg = {},

      storage = { breadcrumb: {}, dashboard: {}},
      /**
       * Cache jQuery Selector for static elems
       */
      selectorCache = function() {
        var selectors = {};
        return function(selector) {
          if (selectors[selector]) {
            return selectors.selector;
          }
          selectors.selector = $(selector);
          return selectors.selector;
        };
      }(),
      //check for string
      isString = function(string) {
        return (typeof string === 'string');
      },
      //check for function
      isFunction = function(func) {
        return (typeof func === 'function');
      },
      //check for type Number
      isNumber = function(num) {
        return (typeof num === 'number');
      },
      //escape regexp expression
      escapeRegExp = function(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      },
      //escape qoute & double quote
      escapeQuote = function(str) {
        return String(str).replace(/"/g, '&quot;');
      },

      getCaretPosition = function(obj) {
        obj.focus();
        if (obj.selectionStart) {
          return obj.selectionStart;
        } else if (document.selection) {
          var sel = document.selection.createRange();
          var clone = sel.duplicate();
          sel.collapse(true);
          clone.moveToElementText(obj);
          clone.setEndPoint('EndToEnd', sel);
          return clone.text.length;
        }
        return 0;
      },

      CSSEscape = function(value) {
        var string = String(value);
        var length = string.length;
        var index = -1;
        var codeUnit;
        var result = '';
        var firstCodeUnit = string.charCodeAt(0);
        while (++index < length) {
        codeUnit = string.charCodeAt(index);
        // Note: there’s no need to special-case astral symbols, surrogate
        // pairs, or lone surrogates.
        // If the character is NULL (U+0000), then throw an
        // `InvalidCharacterError` exception and terminate these steps.
        if (codeUnit == 0x0000) {
          throw new InvalidCharacterError(
            'Invalid character: the input contains U+0000.'
          );
        }
        if (
          // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
          // U+007F, […]
          (codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F ||
          // If the character is the first character and is in the range [0-9]
          // (U+0030 to U+0039), […]
          (index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
          // If the character is the second character and is in the range [0-9]
          // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
          (
            index == 1 &&
            codeUnit >= 0x0030 && codeUnit <= 0x0039 &&
            firstCodeUnit == 0x002D
          )
        ) {
          // http://dev.w3.org/csswg/cssom/#escape-a-character-as-code-point
          result += '\\' + codeUnit.toString(16) + ' ';
          continue;
        }
        // If the character is not handled by one of the above rules and is
        // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
        // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
        // U+005A), or [a-z] (U+0061 to U+007A), […]
        if (
          codeUnit >= 0x0080 ||
          codeUnit == 0x002D ||
          codeUnit == 0x005F ||
          codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
          codeUnit >= 0x0041 && codeUnit <= 0x005A ||
          codeUnit >= 0x0061 && codeUnit <= 0x007A
        ) {
          // the character itself
          result += string.charAt(index);
          continue;
        }
        // Otherwise, the escaped character.
        // http://dev.w3.org/csswg/cssom/#escape-a-character
        result += '\\' + string.charAt(index);
        }
        return result;
      },

      insertStringAfterCaret = function(elem, textToInsert, removeLine) {
        if (!elem || !textToInsert) {
          return;
        }
        elem.focus();
        var val = elem.value,
            end = (val.length === 0) ? 0 : getCaretPosition(elem),
            start = removeLine ? val.lastIndexOf('\n', end - 1) + 1 : end,
            before = val.substring(0, start),
            after = val.substring(end);
        elem.value = before + textToInsert + after;
        var r, index = (before + textToInsert).length;
        if (elem.setSelectionRange) {
          elem.setSelectionRange(index, index);
        } else {
          r = elem.createTextRange();
          r.collapse(true);
          r.select(index, index);
        }
      },

      formatDateTime = function(timestamp) {
        var date = new Date(timestamp);
        return date.getFullYear() + '-' +
          ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
          ('0' + date.getDate()).slice(-2) + ' ' +
          ('0' + date.getHours()).slice(-2) + ':' +
          ('0' + date.getMinutes()).slice(-2) + ':' +
          ('0' + date.getSeconds()).slice(-2);
      },

      parseDate = function(timeString) {
        var cArr = String(timeString).split(' ');
        if (cArr.length === 2) {
          var dArr = cArr[0].split('-'),
              tArr = cArr[1].split(':');
          if (dArr.length === 3 && tArr.length === 3) {
            return new Date(dArr[0], parseInt(dArr[1], 10) - 1, dArr[2], tArr[0], tArr[1], tArr[2]);
          }
        }
        return new Date();
      },
      //check file size function
      checkFileSize = function(tabId, name) {
        var inputFile = name ? $('#' + name + '-' + tabId) : $('#form-wrapper-' + tabId + ' input[type="file"]'),
            msg = null,
            field = null;
        inputFile.each(function() {
           var maxSize = this.getAttribute('data-max-size'),
               msgSize = this.getAttribute('data-maxsize-msg');
           field = this;
           if (this.files && maxSize) {
             maxSize -= 0;
             for (var i = 0, l = this.files.length; i < l; i++) {
               if (this.files[i].size > maxSize) {
                 msg = String(pageInfo.messages.fileMaxSize).replace('__VALUE__', msgSize);
                 return false;
               }
             }
           }
        });
        return {
          msg: msg,
          field: field
        };
      },

      openInNewWindow = function(url, param) {
        var newwindow = window.open('', param);
        if (newwindow) {
          newwindow.openner = null;
          newwindow.location = url;
        }
      },

      removeParam = function(form, param) {
        var len = form.length,
            i, name;
        for (i = 0; i < len; i++) {
          name = form[i].name;
          delete param[name];
        }
        return param;
      }, 
      /**
       *  Устанавливаем позиционирование выпадающего списка на форме
       */ 
      setOptionListPosition = function(prefixId, id) {
        var elemHeight, elem, bodyHeight, elemTop, formTop, form, tabId;
        bodyHeight = window.document.body.offsetHeight;
        //calculate position for list options
        elem = $(prefixId + id);
        elem[0].style.top = '';
        elemTop = elem.offset().top;
        elemHeight = elem[0].offsetHeight;
        if ((bodyHeight - elemTop) < elemHeight) {
          tabId = elem[0].getAttribute('data-tabid');
          form = $('#form-scroll-' + tabId);
          if (form.length === 0) {
            //if it filter
            form = $('#tcw-' + tabId);
          }
          formTop = form.offset().top;
          if (formTop > (elemTop - elemHeight - 19)) {
            elem[0].style.top = '-' + (elemHeight / 2) + 'px';
          } else {
            elem[0].style.top = '-' + elemHeight + 'px';
          }
        }
      },


      /**
       * Получить предыдущую html ноду
       * @param {HTMLElement} node - html node
       * @return {null | HTMLElement}
       */
      getPreviousNode = function(node) {
        var el = node;
        var previousSibling = null;
        if (el) {
          while (el = el.previousSibling) {
            if (el.nodeType === 1) {
              previousSibling = el;
            }
          }
        }

        return previousSibling;
      };

  return {
    init: init,
    setOptionListPosition: setOptionListPosition,
    parseParams: parseParams,
    replaceHtml: replaceHtml,
    serializeForAttr: serializeForAttr,
    wordWrap: wordWrap,
    required: required,
    noMoreThan: noMoreThan,
    clone: clone,
    injectCss: injectCss,
    msg: msg,
    removeParam: removeParam,
    storage: storage,
    selectorCache: selectorCache,
    isNumber: isNumber,
    isString: isString,
    isFunction: isFunction,
    getQueryString: getQueryString,
    escapeRegExp: escapeRegExp,
    insertStringAfterCaret: insertStringAfterCaret,
    getCaretPosition: getCaretPosition,
    escapeQuote: escapeQuote,
    formatDateTime: formatDateTime,
    parseDate: parseDate,
    checkFileSize: checkFileSize,
    openInNewWindow: openInNewWindow,
    CSSEscape: CSSEscape,
    getPreviousNode: getPreviousNode
  };
}(window, $, EventMgr);

/**
 * Модуль для работы с DOM
 *  App.Dom
 * @param {object} window global object
 * @return {{addClass: function, removeClass: function,
 * toggleClass: function, byId: function, hasClass: function
 * }}
 *
 */
App.Dom = function(window) {
  'use strict';
  var doc = document,
      testAPIelem = doc.createElement('div');

  /**
   * getElementById wrapper
   * @param {String} id value of id
   * @return {?null|object}
   */
  function byId(id) {
    if (typeof id !== 'string') { return null; }
    return doc.getElementById(id);
  }

  /**
   * add class to HTMLNode
   * @param {HTMLNode} elem HTML node
   * @param {string} className name of adding class
   * @type {Function}
   */
  var addClass = testAPIelem.classList ?
      function(elem, className) {
        if (!elem) { return; }
        if (typeof className !== 'string') { return; }
        elem.classList.add(className);

      } : function(elem, className) {
        if (!elem) { return; }
        if (typeof className !== 'string') { return; }
        if (!elem.className.match(className)) {
          elem.className += ' ' + className;
        }
      };

  /**
   * remove class
   * @param {HTMLNode} elem HTML node
   * @param {string} className name of removing class
   * @type {Function}
   */
  var removeClass = testAPIelem.classList ? function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    elem.classList.remove(className);
  } : function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    var regex = new RegExp(className, 'g');
    elem.className += elem.className.replace(regex, '');
  };

  /**
   * toggle class
   * @param {HTMLNode} elem HTML node
   * @param {string} className name of toggling class
   * @type {Function}
   * @return {undefined}
   */
  var toogleClass = testAPIelem.classList ? function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    elem.classList.toggle(className);
  } : function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    var classes = elem.className;
    if (classes.match(className)) {
      var regex = new RegExp(className, 'g');
      elem.className += classes.replace(regex, '');
    } else {
      elem.className += ' ' + className;
    }
  };

  /**
   * check for has class
   * @param {HTMLNode} elem HTML node
   * @param {string} className name of checking class
   * @type {Function}
   * @return {boolean|undefined}
   */
  var hasClass = testAPIelem.classList ? function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    return elem.classList.contains(className);
  } : function(elem, className) {
    if (!elem) { return; }
    if (typeof className !== 'string') { return; }
    var classes = elem.className;
    return classes.match(className);
  };
  return {
    init: function() {},
    byId: byId,
    addClass: addClass,
    removeClass: removeClass,
    toogleClass: toogleClass,
    hasClass: hasClass
  };
}(window);


/**
 * Form module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @param {object} ScrollHandler Scrollbar library
 */
App.Forms = function(window, $, EventMgr, App, ScrollHandler) {
  'use strict';
  function init() {
    EventMgr.on($content(), headerFormSelector, 'click', collapsedForm);
    EventMgr.on($content(), unlimitBtnSelector, 'click', insertUnlimValue);
    //zoom
    EventMgr.on($content(), zoomBtnSelector, 'click', zoomHandler);
    EventMgr.on($content(), zoomTextareaSelector, 'change', syncZoomValue);
    EventMgr.on($content(), zoomTextareaSelector,
        'keyup', addLineBreakToZoomField);
    EventMgr.on($content(), zoomTextareaELSelector, 'keyup', syncZoomValue);
    EventMgr.on($content(), passwdBtnSelector, 'click', genPassword);
    EventMgr.on($content(), showpwdBtnSelector, 'click', showPassword);
    EventMgr.on($content(), calendarBtnSelector, 'click', calendarHandler);
    //checkbox
    EventMgr.on($content(), checkboxChangeSelector, 'change', changeElHandler);
    EventMgr.on($content(), checkboxSelector, 'click', changeCheckboxValue);
    //radio
    EventMgr.on($content(), radiobuttonSelector, 'click', changeRadioValue);
    EventMgr.on($content(), descRadioSelector, 'click', radioLabelClickHandler);
    EventMgr.on($content(), radiobuttonSelector,
        'keydown', radioBtnKeyDownHandler);

    EventMgr.on($content(), bandShowSelector, 'click', bandShowHandler);
    EventMgr.on($content(), dependSlistSelector, 'change', dependSlistHandler);
    EventMgr.on($content(), setvalueSelector, 'change', setValueHandler);
    EventMgr.on($content(), setvalueBtnSelector, 'click', setValueHandler);
    EventMgr.on($content(), resetBtnSelector, 'click', resetHandler);
    EventMgr.on($content(), userexpLinkSelector, 'click', levelUp);
    EventMgr.on($content(), nestedreportSelector, 'click', nestedReportHandler);
    EventMgr.on($content(), fakePasswdSelector, 'change', fakePasswdCopy);
    EventMgr.bind('forceSetValues', forceSetValues);
    EventMgr.bind('appendForm,appendReport,appendedFilter,forceDepend',
        firstDependSlistHandler);
    EventMgr.bind('loadPage', loadPassList);
    EventMgr.bind('appendForm,appendReport,switchTabForm,setFocus', setFocus);
    EventMgr.bind('appendForm', scrollToSelectedBranch);
    EventMgr.bind('formSetValues', formSetValues);
    EventMgr.bind('syncInputToZoom', syncInputWithZoom);
    EventMgr.on($content(), passwdField, 'change', checkPass);
    EventMgr.on($content(), inputTypeTextSelector,
        'keyup', submitFormByEnter);
    EventMgr.on($content(), checkBoxSelectTextareaRadioFormSelector,
        'keydown', submitFormByCtrlEnter);
    EventMgr.on($content(), passwdField, 'keyup', checkPass);
    EventMgr.on($content(), novalueSelector,
        'change', changeNovalueFieldHandler);
    EventMgr.on($content(), formBtnSelector, 'keydown', formBtnKeyDownHandler);
    EventMgr.on($content(), descLabelCheckboxSelector,
        'click', checkboxDescClickHandler);
    EventMgr.bind('gotPasswdList', gotPasswdListHandler);
    EventMgr.on($content(), treeHitarea, 'click', treeCollpasedControl);
    EventMgr.on($content(), treeLabelSelector, 'click', treeSelectedControl);
    EventMgr.on($content(), treeMultiLabelSelector, 'click', treeMultiSelectedControl);
    EventMgr.on($content(), treeCommonLabelSelector,
        'dblclick', treeCollpasedControlWrapper);
    EventMgr.on($content(), fakeFileInput, 'click', fakeFileInputHandler);
    EventMgr.on($content(), FileInput, 'change', fileInputChangeHandler);
    EventMgr.on($content(), treeReszieConrtolSelector,
        'mousedown', treeResizeControl);
    EventMgr.on($content(), confirmField, 'keyup, change', checkConfirmField);
    EventMgr.on($content(), quoteSelector, 'click', quoteHandler);
    //clear tab cache
    EventMgr.bind('closeTabEvent,appendForm,appendFilter,appendReport',
        cleanTabCache);
    EventMgr.bind('appendForm', prefixFieldSetUp);
    EventMgr.bind('upPrefixField', prefixFieldSetUp);
    EventMgr.on($content(), formListRow, 'click', formListRowClickHandler);
    EventMgr.bind('focusOnErrorField', focusOnErrorField);
    EventMgr.on($content(), '.b-textarea_responsive_yes', 'keyup',
        textareaResize);
    EventMgr.bind('appendForm', checkTitleWidth);
    EventMgr.on($content(), ticketBtnUp, 'click', ticketMoveUpHandler);
    EventMgr.on($content(), ticketBtnDown, 'click', ticketMoveDownHandler);
    EventMgr.on($content(), ticketCollapse, 'click', ticketCollapseHandler);
  }

  var appDom = App.Dom;

  var CACHE = {};

  function cleanTabCache(e, data) {
    var tabId = data.tabId;
    if (CACHE[tabId]) {
      delete CACHE[tabId];
    }
  }

  function $content() {
    return App.Common.selectorCache('.i-form-wr');
  }

  var pageInfo = window.pageInfo,

      quoteSelector = '.b-quote',

      treeReszieConrtolSelector = '.b-resizer',

      fakeFileInput = '.b-input-file-fake',

      FileInput = '.b-input_type_file',

      treeHitarea = '.tree-wrapper .tree-hitarea',

      treeLabelSelector = '.b-tree_type_default .tree-handler',

      treeCommonLabelSelector = '.tree-wrapper .tree-handler',

      treeMultiLabelSelector = '.b-tree_type_multiple .tree-handler',

      fakePasswdSelector = 'input.fakePasswd',

      novalueSelector = 'input[data-novalue], textarea[data-novalue]',

      passwdField = '.b-form-passwd-field, .b-form-passwd-field + input',

      userexpLinkSelector = 'div.userexperience',

      //wrapper for zoom textarea
      zoomTextareaSelector = '.b-textarea_for_zoom',
      //zoom field in inline-edit
      zoomTextareaELSelector = '.edit-field-form .b-textarea_for_zoom',

      //wrapper for body

      //wrapper for radiobutton
      radiobuttonSelector = '.b-radio:not(".readonly")' +
          ' .b-radio__control',
      //wrapper for checkboxes
      checkboxSelector = '.b-checkbox__control',
      //wrapper for headers of form page
      headerFormSelector = '.b-form-page__title',

      bandShowSelector = '.band-content .band_show_button',
      //wrapper for unlim btn from form
      unlimitBtnSelector = '.b-input-btn_type_unlimit',
      //zoom button
      zoomBtnSelector = '.b-input-btn_type_zoom',
      //password button
      passwdBtnSelector = '.b-input-btn_type_passwd',
      //calendar button
      calendarBtnSelector = '.b-input-btn_type_calendar',
      //show passwd button
      showpwdBtnSelector = '.b-input-btn_type_showpwd',
      //checkbox onchange
      checkboxChangeSelector = 'input[type="checkbox"].onchange',

      //wrapper for control field select and radio
      dependSlistSelector = '.depend.b-myselect input[type="hidden"],' +
          ' .depend.b-select-ac input[type="hidden"],' +
          ' .depend.b-radio input[type="hidden"]',

      setvalueSelector = '.setvalue input[type="hidden"],' +
          ' .b-select-ac_setvalues_yes input[type="hidden"],' +
          ' .setvalue input[type="text"],' +
          ' .setvalue input[type="password"],' +
          ' .setvalue .b-textarea',

      setvalueBtnSelector = '.i-button_type_setvalues',

      resetBtnSelector = '.i-button_type_reset',

      formBtnSelector = '.i-button, .b-checkbox__control',

      inputTypeTextSelector = '.l-form__wrapper .i-input-control,' +
          ' .filter-wrapper .i-input-control',

      checkBoxSelectTextareaRadioFormSelector = '.l-form__wrapper' +
          ' .b-radio__control,' +
          ' .l-form__wrapper .b-textarea,' +
          ' .l-form__wrapper .b-myselect__select-value,' +
          ' .filter-wrapper .b-myselect__select-value,' +
          ' .l-form__wrapper .b-checkbox__control,' +
          ' .l-form__wrapper .b-mselect__view-value',

      nestedreportSelector = '.data-wrapper.nestedreport',

      descRadioSelector = '.b-label__visible_for_radio, .b-radio-img__row',

      descLabelCheckboxSelector = ' .l-form__row_type_checkbox .b-label__visible',

      confirmField = '.b-form-confirm-field, .b-form-passwd-field',

      ticketBtnUp = '.i-ticket__btn-move_up',

      ticketBtnDown = '.i-ticket__btn-move_down',

      ticketCollapse = '.i-ticket__btn-collapse',

      formListRow = '.b-form-list__row, .b-form-blocks__block';

  function $activeTab() {
    return $('.tab-content_st_active');
  }

  //check for title overwidth & set hint overwidth
  function checkTitleWidth(e, data) {
    $('#cont-' + data.tabId).find('.b-title_type-form').each(function() {
      var width = this.offsetWidth,
          scrollWidth = this.scrollWidth - 1;
      if (width < scrollWidth) {
        this.className += ' overwidth';
        this.removeAttribute('data-hint');
      }
    });
  }

  function quoteHandler(e) {
    e.preventDefault();
    var content = '', selection;
    if (typeof window.getSelection !== 'undefined') {
      var sel = window.getSelection();
      content = sel.toString();
    } else if (typeof document.selection !== 'undefined') {
      if (document.selection.type === 'Text') {
        selection = document.selection.createRange();
        content = selection.text;
      }
    }
    if (content === '') { return; }
    var lines = content.split('\n'),
        l = lines.length;
    content = '';
    for (var i = 0; i < l; i++) {
      content += '> ' + lines[i];
      if (i !== l - 1) {
        content += '\n';
      }
    }
    var targetId = this.getAttribute('data-target'),
        elem = App.Dom.byId(targetId);
    if (elem) {
      App.u.insertStringAfterCaret(elem, content);
    }
  }

  function fakeFileInputHandler() {
    var id = this.getAttribute('data-source');
    $('#' + id).trigger('click');
  }

  function checkFileSize(tabId, name) {
    var fileSizeRes = App.u.checkFileSize(tabId, name);
    if (fileSizeRes.msg) {
      EventMgr.trigger('errMsgValid', {
        self: fileSizeRes.field,
        err: fileSizeRes.msg,
        number: 0
      });
    } else {
       EventMgr.trigger('okMsgValid', {
         self: fileSizeRes.field,
         number: 0,
         notOk: true
       });
    }
  }

  function fileInputChangeHandler() {
    var id = this.id,
        tabId = this.getAttribute('data-tabid'),
        fElemInput = App.Dom.byId('f-' + id),
        value = this.value,
        startIndex = (value.indexOf('\\') >= 0 ?
            value.lastIndexOf('\\') : value.lastIndexOf('/')),
        filename = '',
        stateWrapper = App.Dom.byId('b-input-file__wr-' + tabId);
    if (this.files) {
      var filesList = this.files,
          l = filesList.length;
      for (var i = 0; i < l; i++) {
        if (i !== 0) {
          filename += ', ';
        }
        filename += filesList[i].name;
      }
      App.Dom.addClass(stateWrapper, 'b-input-file__wr_state_selected');
      //check file size
      checkFileSize(tabId, this.getAttribute('name'));
    } else {
      filename = value.substring(startIndex);
      if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
      }
      App.Dom.removeClass(stateWrapper, 'b-input-file__wr_state_selected');
    }
    filename = window.filterXSS(filename);
    fElemInput.innerHTML = filename;
    fElemInput.setAttribute('data-hint', filename);
  }
  //tree resizer
  var treeResizeObj = {};
  //tree resize drag
  function treeResizeControl(e) {
    var id = this.getAttribute('data-id'),
        tabId = this.getAttribute('data-tabid'),
        elem = App.Dom.byId(id),
        moveTrigger = this.getAttribute('data-move-trigger') || false,
        offsetTop = parseInt(this.offsetTop, 10),
        $tip = $('.b-tip_name_textarea_resize');
    //hide tip if it showing
    if ($tip.length) {
      $tip.find('.b-tip__close').trigger('click');
    }
    treeResizeObj.height = parseInt(elem.style.height, 10);
    if (!treeResizeObj.height) {
      treeResizeObj.height = elem.offsetHeight;
    }
    treeResizeObj.elem = elem;
    treeResizeObj.id = id;
    treeResizeObj.tabId = tabId;
    treeResizeObj.moveTrigger = moveTrigger;

    e = e || window.event;
    if (e.touches) {
      treeResizeObj.shiftY = e.touches[0].pageY;
      treeResizeObj.top = e.touches[0].pageY - offsetTop;
      document.ontouchmove = treeResizeMove;
      document.ontouchend = treeResizeDrop;
      document.ontouchcancel = treeResizeDrop;
    } else {
      treeResizeObj.shiftY = e.clientY;
      treeResizeObj.top = e.clientY - offsetTop;
      document.onmousemove = treeResizeMove;
      document.onmouseup = treeResizeDrop;
    }
    document.body.style.cursor = 'n-resize';
  }
  var treeResizerTimeId = 1;
  // tree resize move
  function treeResizeMove(e) {
    var diffY;
    if (e.touches) {
      diffY = e.touches[0].pageY - treeResizeObj.shiftY;
    } else {
      diffY = e.clientY - treeResizeObj.shiftY;
    }
    if (treeResizeObj.elem) {
      treeResizeObj.elem.style.height = (treeResizeObj.height + diffY) + 'px';
    }
    if (treeResizeObj.moveTrigger) {
      clearTimeout(treeResizerTimeId);
      treeResizerTimeId = setTimeout(function() {
        EventMgr.trigger(treeResizeObj.moveTrigger, {
          id: treeResizeObj.id, tabId: treeResizeObj.tabId });
      }, 100);
    }
    e.preventDefault();
  }
  // tree resize drop
  function treeResizeDrop(e) {
    if (e.touches) {
      document.ontouchmove = null;
      document.ontouchend = null;
      document.ontouchcancel = null;
    } else {
      document.onmousemove = null;
      document.onmouseup = null;
    }
    EventMgr.trigger('updFormHeight', { tabId: treeResizeObj.tabId });
    document.body.style.cursor = '';
    $(treeResizeObj.elem).removeClass('b-textarea_responsive_yes');
    e.preventDefault();
  }
  //dblclick handler
  function treeCollpasedControlWrapper(e) {
    e.preventDefault();
    var $self = $(this);
    $self.prev().trigger('click');
  }

  function treeCollpasedControl() {
    var parent = this.parentNode,
        className = parent.className,
        name, params, url, self, tabId, root, elem, img, src, id;
    self = $(this);
    root = self.parents('.tree-inner');
    tabId = root.attr('data-tabid');
    id = root.attr('id');
    //added class collapsed
    if (className.match(/t-opened/)) {
      className = className.replace(/t-opened/g, '');
      className += ' collapsed';
      //remove collapsed
    } else if (className.match(/collapsed/)) {
      //just open
      if (className.match(/loaded/)) {
        className = className.replace(/collapsed/g, '');
        className += ' t-opened';
        //load children
      } else if (!className.match(/loading/)) {
        name = App.Dom.byId(id + '-value').name;
        params = $('#frm-' + tabId).serializeObject();
        url = pageInfo.url;
        /* jslint camelcase:false */
        params.sv_field = name;
        params.sv_tree = 'yes';
        /* jslint camelcase:true */
        elem = self.siblings('.tree-handler');
        img = self.siblings('.tree-handler').children('.icon').children('img');
        src = img.attr('src');
        img.attr('src', pageInfo.theme + 'img/loader.gif');
        params[name] = elem.attr('data-val');
        //elem.parent().addClass('loading');
        className += ' loading';
        //get text node
        /* jshint camelcase: false */
        params.sv_text = $(elem).find('.tree-label').text();
        EventMgr.trigger('ajaxRequest', {
          url: url,
          param: params,
          trfunc: 'formGetTreeBranch',
          invar: {
            tabId: tabId,
            name: name,
            elem: elem,
            src: src,
            img: img,
            id: 'cont-' + id },
          type: 'get', outtype: 'json', queue: 'noqueue' });
      }
    }
    parent.className = className;
    EventMgr.trigger('updateScroll', { id: 'cont-' + id });
  }

  function treeSelectedControl(e) {
    var $self = $(this),
        id = $self.parents('.tree-inner').attr('id');
    //remove other selection
    $selectedTreeElem(id).removeClass('selected');
    var input = App.Dom.byId(id + '-value');
    input.value = this.getAttribute('data-val');
    $(input).trigger('change');
    this.className += ' selected';
  }

  function $selectedTreeElem(id) {
    return $('#' + id + ' .tree-handler.selected');
  }

  function treeMultiSelectedControl(e) {
    var $self = $(this),
        id = $self.parents('.tree-inner').attr('id'),
        value = '';
    //remove other selection
    var input = App.Dom.byId(id + '-value');
    if (e.ctrlKey || e.metaKey) {
      //unselected
      if ($self.hasClass('selected')) {
        $self.removeClass('selected');
      //add selection
      } else {
        $self.addClass('selected');
      }
      $selectedTreeElem(id).each(function(index) {
         if (index !== 0) {
           value += ',';
         }
         value += this.getAttribute('data-val');
      });
    } else {
      $selectedTreeElem(id).removeClass('selected');
      value = this.getAttribute('data-val');
      this.className += ' selected';
    }
    input.value = value;
    $(input).trigger('change');
  }

  function scrollToSelectedBranch() {
    setTimeout(function() {
      $('.tree-wrapper .selected').each(function() {
        var id = $(this).parents('.tree-wrapper').attr('id');
        EventMgr.trigger('scrollTo', { id: id, offsetTop: this.offsetTop });
      });
    }, 100);
  }

  function resetHandler() {
    var tabId = this.getAttribute('data-tabid'),
        form = App.Dom.byId('frm-' + tabId);
    form.reset();
  }

  function changeNovalueFieldHandler() {
    if (this.getAttribute('data-novalue')) {
      this.setAttribute('data-novalue', 'no');
      if (this.placeholder) {
        this.placeholder = '';
      }
    }
  }
  //submit form by ENTER keyup under text and password fields
  function submitFormByEnter(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode,
        tabId;
    if (codeKey === ENTERKEY) {
      //sometime form submit native...
      e.preventDefault();
      var $self = $(this);
      tabId = this.getAttribute('data-tabid');
      $self.trigger('change');
      $self.trigger('blur');
      clickButtonTrigger(tabId);
    }
  }
  //submit form by ENTER + CTRL under textarea, select, radio, checkbox
  function submitFormByCtrlEnter(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode,
        tabId;
    if (codeKey === ENTERKEY && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      $(this).trigger('blur');
      tabId = this.getAttribute('data-tabid');
      clickButtonTrigger(tabId);
    }
  }
  /**
   * Ищем кнопку типа ok для отправки формы, сперва ищем дефлотную(default="yes"), затем (type=ok), (type=next), кнопку фильтра()
   */
  function clickButtonTrigger(tabId) {
    // ищем кнопку default, кнопку ok, потом первую попавшусю
    var $defaultButton = $('#cont-' + tabId + ' .i-button_default_yes');
    var $okButton = $('#cont-' + tabId + ' .b-button_act_ok');
    var $nextButton = $('#cont-' + tabId + ' .b-button_act_next');
    var $filterButton = $('#frm-' + tabId + ' .b-button__filter-set');

    setTimeout(function() {
      var $button;
      if ($defaultButton[0]) {
        $button = $defaultButton;
      } else if ($okButton[0]) {
        $button = $okButton;
      } else if ($nextButton[0]) {
        $button = $nextButton;
      } else if ($filterButton) {
        $button = $filterButton;
      }
      $button.first().trigger('click');
    }, 1);
  }

  function loadPassList() {
    var url,
        data = getLocalStorage('mgr5-passwdlist'),
        version = getLocalStorage('mgr5-passwd-ver'),
        newVersion = false;

    if (pageInfo.version !== version) {
      setLocalStorage('mgr5-passwd-ver', pageInfo.version);
      newVersion = true;
    }

    if (data && data !== '' && !newVersion) {
      passwdlist = data;
    } else {
      url = '/manimg/common/passwd.list';
      EventMgr.trigger('ajaxRequest', {
        url: url, param: {}, trfunc: 'gotPasswdList',
        outtype: 'html', type: 'get' });
    }
  }

  function getLocalStorage(itemId) {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(itemId);
    } else {
      return false;
    }
  }

  function setLocalStorage(itemId, data) {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(itemId, data);
    } else {
      return false;
    }
  }

  var passwdlist = '';

  function gotPasswdListHandler(e, data) {
    passwdlist = '\n' + data + '\n';
    setLocalStorage('mgr5-passwdlist', passwdlist);
  }

  //The following function returns the logarithm of y with base x (ie. logx y):
  function getBaseLog(x, y) {
    return Math.log(y) / Math.log(x);
  }

  var passType = { 0: 'short', 1: 'weak', 2: 'good', 3: 'strong' };

  function checkConfirmField(e) {
    var self, tabId;
    if (this.getAttribute('data-check-field')) {
      tabId = this.getAttribute('data-tabid');
      self = App.Dom.byId(this.getAttribute('data-check-field') + '-' + tabId);
    } else {
      self = this;
    }
    var confirmId = self.getAttribute('data-confirm-field'),
        parentId = self.getAttribute('data-parent'),
        confirmField = App.Dom.byId(confirmId),
        messageElem = App.Dom.byId('check-confirm-' + parentId),
        isChanged = false, showConfirmMsg = false;
    if (App.Dom.hasClass(messageElem, 'b-form-confirm-message_show_true')) {
      showConfirmMsg = true;
    }
    if (!!confirmField && self.value !== confirmField.value) {
      if (!showConfirmMsg) {
        App.Dom.addClass(messageElem, 'b-form-confirm-message_show_true');
        isChanged = true;
      }
    } else {
      if (showConfirmMsg) {
        App.Dom.removeClass(messageElem, 'b-form-confirm-message_show_true');
        isChanged = true;
      }
    }
    if (isChanged) {
      EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
    }
  }

  function checkPass() {
    var strength,
        value = App.u.escapeRegExp($.trim(this.value)),
        name = this.getAttribute('data-parent'),
        regexp = new RegExp('\n' + value + '\n', 'i'),
        tabId = this.getAttribute('data-tabid'),
        id = 'checkpass-indicator-wrapper-' + name,
        wr = App.Dom.byId(id),
        isChanged = false;
    if (wr) {
      if (this.value !== '') {
        if (passwdlist.match(regexp)) {
          strength = 0;
        } else {
          strength = checkPassStrength(this.value);
        }
        if (wr.className !== (passType[strength] + ' showed')) {
          wr.className = passType[strength] + ' showed';
          isChanged = true;
        }
      } else {
        if (wr.className !== '') {
          wr.className = '';
          isChanged = true;
        }
      }
    }
    if (isChanged) {
      EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
    }
  }

  function checkPassStrength(value) {
    var len = value.length,
        str = value.split(''),
        uniq = 0,
        special = 0,
        repeatTypes = 0,
        varCase = 0,
        symbArr = {},
        strType = [],
        ind, i, lvl = 0;

    for (i = 0; i < len; i++) {
      //count uniq symbols
      if (!symbArr[str[i]]) {
        uniq++;
      }
      symbArr[str[i]] = true;
      //count special symbols
      if (str[i].match(/[!@#$%^&*?_~{}"'()|\\+\[\]]\s/)) {
        special++;
        strType.push('sn');
        //count lowcase
      } else if (str[i].match(/[a-z]/)) {
        strType.push('ll');
        //count uppercase
      } else if (str[i].match(/[A-Z]/)) {
        strType.push('lu');
        //count number
      } else if (str[i].match(/\d/)) {
        strType.push('dn');
        //any cyrillic symbol = 2 special
      } else {
        special++;
        special++;
        strType.push('sn');
      }
      if (i !== 0) {
        //check for repeat types symbol
        if (strType[i].substr(0, 1) === strType[i - 1].substr(0, 1)) {
          repeatTypes++;
        }
        //check for diffirent case
        if (strType[i].substr(1, 1) !== strType[i - 1].substr(1, 1)) {
          varCase++;
        }
      }
    }

    ind = (len + Math.sqrt(0.5 * special + varCase) -
        Math.sqrt(repeatTypes)) * (getBaseLog(len, uniq));
    if (ind < 3) {
      lvl = 0;
      //weak
    } else if (ind >= 3 && ind < 6) {
      lvl = 1;
      //good
    } else if (ind >= 6 && ind < 9) {
      lvl = 2;
      //hard
    } else if (ind >= 9) {
      lvl = 3;
    } else {
      lvl = 0;
    }
    return lvl;
  }
  //handler for level up link
  function levelUp(e) {
    e.preventDefault();
    var exp = this.getAttribute('data-level'),
        tabId = getActiveTabId(),
        form = $('#frm-' + tabId),
        param = form.serializeObject(),
        $mixedContols = form.find('.i-control-mixed');
    param.userexperience = exp;

    if ($mixedContols.length !== 0) {
      param = App.u.removeParam($mixedContols, param);
    }
    if (param.snext) {
      delete param.snext;
    }
    if (param.sback) {
      delete param.sback;
    }
    EventMgr.trigger('reloadTab', { tabId: tabId, param: param });
  }

  function nestedReportHandler(e) {
    e.preventDefault();
    var elid = this.getAttribute('data-elid'),
        $self = $(this),
        index = $self.parents('td').index(),
        th = $self.parents('table').find('th')[index],
        colname = th.getAttribute('data-colname'),
        nested = th.getAttribute('data-nestedreport'),
        parent = getActiveTabId(),
        plid = App.Dom.byId(parent + '-plid'),
        form = $('#frm-' + parent),
        param = form.serializeObject();
    elid = elid || $self.find('.b-list__table-col-content').first().html();
    param.func = nested;
    param.elid = elid;
    param.colname = colname;
    if (plid !== null) {
      param.plid = plid.value;
    }
    EventMgr.trigger('ajaxRequest', {
      param: param,
      invar: { parent: parent },
      type: 'get',
      outtype: 'json',
      trfunc: 'ajaxResponse',
      queue: 'nested-' + parent,
      failfunc: 'failCommonAjaxResponse' });
    EventMgr.trigger('tabLoading', { tabId: parent });
  }

  var isIE = '\v' === 'v';

  function scrollToFormRow($focusedField, tabId, animate) {
    setTimeout(function() {
      var formRow = $focusedField.closest('.l-form__row'),
          offsetTop = formRow[0] ? formRow[0].offsetTop : 0,
            $page = $focusedField.closest('.b-form-page'),
            formScrollEl = App.Dom.byId('form-scroll-' + tabId),
            heightViewPort = formScrollEl ? parseInt(formScrollEl.style.height, 10) : 0;
        if ($page[0]) {
          offsetTop += $page[0].offsetTop;
        }

      EventMgr.trigger('scrollTo', {
        id: 'form-scroll-' + tabId,
        offsetTop: offsetTop,
        animate: animate });
    }, 100);
  }

  function focusOnErrorField(e, data) {
    var $focusField = $('.row-error .b-input, .row-error .b-textarea, .row-error .b-checkbox__control'),
        tabId = data.tabId,
        $page;
    if ($focusField.length > 0) {
      $page = $focusField.closest('.b-form-page');
      if ($page.hasClass('b-form-page_st_collapsed')) {
        $page.find('.i-form-page__title').trigger('click');
      }

      $focusField.focus();
      scrollToFormRow($focusField, tabId, true);
    }
  }

  function setFocus(e, data) {
    if (isIE || window.pageInfo.mobile) { return; }
    var tabId = data.tabId,
        form = document.getElementById('frm-' + tabId);
    if (form === null) { return; }
    var len = form.length,
        elem = null,
        curElem, name, r1, readonly,
        forceFocused = $('#form-wrapper-' + tabId + ' .b-form__focus-field');
    //force focused field by attr focus="yes"
    if (forceFocused.length > 0) {
      forceFocused.focus();
      scrollToFormRow(forceFocused, tabId, false);
      return;
    }
    //find out accessable field
    for (var i = 0; i < len; i++) {
      elem = form[i];
      //for select
      if (elem.type === 'hidden' &&
          elem.getAttribute('data-type') === 'select') {
        curElem = $(elem).parent();
        if (!curElem.hasClass('readonly') && (curElem.width() !== 0)) {
          name = elem.getAttribute('name');
          $('#_' + name + '-' + tabId + ' .b-myselect__select-value').focus();
          window.scrollToTopLeft();
          return;
        }
        //for radio
      } else if (elem.type === 'hidden' &&
          elem.getAttribute('data-type') === 'radio') {
        curElem = $(elem).parent();
        if (!curElem.hasClass('readonly') && (curElem.width() !== 0)) {
          name = elem.getAttribute('name');
          $('.tab-content_st_active div[data-id="' + name + '"][tabindex="0"]').
              focus();
          window.scrollToTopLeft();
          return;
        }
      } else if (elem.type === 'hidden' &&
          elem.getAttribute('data-type') === 'checkbox') {
        name = elem.getAttribute('name');
        $('#' + tabId + '-' + name).focus();
        window.scrollToTopLeft();
        return;
      }
      r1 = elem.getAttribute('readonly');
      readonly = (r1 !== null);
      if (elem.type !== 'hidden' && (!readonly) && elem.offsetWidth !== 0) {
        elem.focus();
        window.scrollToTopLeft();
        return;
      }
    }
    form = null;
    elem = null;
  }

  function AttrIsSupported(element, attr) {
    var elem = document.createElement(element);
    return (attr in elem);
  }
  /**
   * forceSetValues
   * @param {object} e event object
   * @param {object} data object with data
   */
  function forceSetValues(e, data) {
    var tabId = data.tabId,
        url = pageInfo.url,
        name = data.name,
        params = $('#frm-' + tabId).serializeObject();
    /* jslint camelcase:false */
    params.sv_field = name;
    /* jslint camelcase:true */
    EventMgr.trigger('ajaxRequest', {
      url: url,
      param: params,
      trfunc: 'formSetValues',
      invar: { tabId: tabId },
      type: 'get',
      outtype: 'json',
      queue: 'multiload' });
  }

  /**
   * Callback setvalues field changed
   * send request for new values
   * @param {object} e  event object
   * @param {boolean} sv  setvalues once flag
   * @return {boolean}
   * @this {object} HTML node
   */
  var lastTargetElemId = 'default_value';
  function setValueHandler(e, sv, srcId) {
    var self = this;
    setTimeout(function() {
      EventMgr.trigger('preSetValues', [self, 100]);
      //check for loop
      var elemId = self.getAttribute('id'),
          $self = $(self),
          flags = $self.getFlags();
      if ($self.hasClass('b-textarea_for_zoom')) {
        return true;
      }
      if (lastTargetElemId === srcId) {
        return true;
      }
      lastTargetElemId = elemId;
      //check for setvalues once
      if (sv) { return true; }
      //var tabId = $activeTab().attr('data-tabid'),
      var tabId = self.getAttribute('data-tabid'),
          $form = $('#frm-' + tabId),
          params = $form.serializeObject(),
          addParams = {},
          url = pageInfo.url,
          once = App.Dom.hasClass(self.parentNode, 'sv_nochange'),
          blocking = App.Dom.hasClass(self.parentNode, 'sv_blocking') ||
              flags.blocking,
          name = (self.getAttribute('data-name')) ?
              self.getAttribute('data-name') : self.name,
          id = self.getAttribute('data-id'),
          isShowcaseForm = $form.hasClass('b-form_showcase_yes'),
          hasFile = $form.hasClass('withfiles'),
          $noSetValues = $form.find('.i-nosetvalues');

      if ($noSetValues.length !== 0) {
        params = App.u.removeParam($noSetValues, params);
      }

      //check for button id
      if (id && id !== 'undefined') {
        id = id.split('=', 2);
        if (id[1]) {
          params[id[0]] = id[1];
          addParams[id[0]] = id[1];
        }
      }

      /* jshint camelcase: false */
      params.sv_field = name;
      var options = {
        url: url,
        param: params,
        failfunc: 'failFormAjaxResponse',
        trfunc: 'formSetValues',
        invar: { tabId: tabId, once: once, blocking: blocking },
        type: 'post',
        outtype: 'json',
        queue: 'multiload' };
      //if form has input@type=file
      if (hasFile) {
      /* jshint camelcase: false */
        options.invar.blocking = true;
        addParams.sv_field = name;
        addParams.sfrom = 'ajax';
        EventMgr.trigger('setBrandSettings', {
           options: options,
           tabId: tabId,
           param: params,
           addParams: addParams
        });
      } else {
        /* jslint camelcase:true */
        EventMgr.trigger('ajaxRequest', options);
        if (blocking) {
          EventMgr.trigger('tabLoading', { tabId: tabId });
        }
      }
    }, 0);
  }
  /**
   * Проверяем на изменение значения мультиселекта
   */
  function isMultiSelectValuesChanged(stringVal, arrVal) {
    //check for empty value - only slist rerender
    if (arrVal === '') { return true; }
    if (typeof stringVal === 'string') {
      if (typeof arrVal === 'string') {
        arrVal = arrVal.split(',');
      } else if (typeof arrVal.join !== 'function') {
        return false;
      }
      var oldValues = stringVal.split(','),
          l = oldValues.length;
      oldValues.sort();
      arrVal.sort();
      if (oldValues.length !== arrVal.length) {
        return true;
      }
      while (l--) {
        if (oldValues[l] !== arrVal[l]) {
          return true;
        }
      }
      return false;
    }
    return false;
  }

  /**
   * Setvalues handler
   * change values in fields from response
   * @param {object} e event object
   * @param {object} data object with data
   **/
  function formSetValues(e, data) {
    //check for auth
    if (data.ok && data.reload) {
      window.location.reload();
    }
    var tabId = data.tabId,
        form = App.Dom.byId('frm-' + tabId),
        once = data.once,
        blocking = data.blocking,
        readonlyArray = [];
    if (blocking) {
      EventMgr.trigger('tabLoadingHide', { tabId: tabId });
    }
    if (form === null || data.error) { return; }
    var setvalues = data.setvalues,
        elem = '',
        keyVar, tagName, value, changed, dType, type, liAct, elemId;
    if (typeof setvalues === 'object') {
      /* jslint forin:true */
      for (keyVar in setvalues) {
        elem = form.elements[keyVar];
        //check for bad words
        if (keyVar === 'item' || keyVar === 'length') {
          continue;
        }
        if (elem) {
          tagName = elem.tagName;
          value = setvalues[keyVar];
          changed = true;
          if (value === null) {
            continue;
          }
          if (tagName === 'INPUT') {
            type = elem.getAttribute('type');
            if (elem.value !== value) {
              //input@type=text
              if (type === 'text' || type === 'password') {
                changed = (elem.value !== value.value);
                elem.value = value.value;
                if (value.prefix) {
                  var $prefixNode = $(elem).parent().find('.i-input__prefix');
                  if ($prefixNode.length) {
                    $prefixNode.html(value.prefix);
                    EventMgr.trigger('upPrefixField', { tabId: tabId });
                  }
                }
                //slider logic
                if (value.min !== undefined || value.max !== undefined || value.step !== undefined) {
                  var id = elem.id,
                      $sliderNode = $('#' + id + '-slider');
                  if (value.min !== undefined) {
                    $sliderNode.attr('data-min', value.min);
                  }
                  if (value.max !== undefined) {
                    $sliderNode.attr('data-max', value.max);
                  }
                  if (value.step !== undefined) {
                    $sliderNode.attr('data-step', value.step);
                  }
                  EventMgr.trigger('reloadSlider', { tabId: tabId });
                }
                //mask logic
                if (value.mask !== undefined) {
                  EventMgr.trigger('inputMaskChangeBySetvalues', { elem: elem, mask: value.mask, value: value.value });
                }
              } else if (type === 'file') {
                //reset file value
                if (value.value === '') {
                  var $elem = $(elem);
                  $elem.replaceWith($elem.val('').clone(true));
                  $(form.elements[keyVar]).trigger('change');
                }
              } else if (type === 'hidden') {
                // #17927 setvalues[keyVar].slist
                changed = (elem.value !== value.value ||
                    setvalues[keyVar].slist);
                if (changed) {
                  elemId = elem.getAttribute('id');
                  dType = elem.getAttribute('data-type');
                  //select
                  if (dType === 'select') {
                    //replace slist values
                    if (value.slist) {
                      $('ul#' + tabId + '-' + elem.name).
                          html(renderSlistElem(setvalues[keyVar].slist));
                      //clean slist cache for searching
                      EventMgr.trigger('cleanSlistCache', {
                        tabId: tabId,
                        id: tabId + '-' + elem.name });
                      //check for search in list
                      if (setvalues[keyVar].slist && setvalues[keyVar].slist.length > 10) {
                         var $mySelect = $('#_' + elem.name + '-' + tabId);
                         if (!$mySelect.hasClass('sb-select')) {
                           $mySelect.addClass('sb-select');
                         }
                      }
                      EventMgr.trigger('forceDepend', { tabId: tabId });
                      if (setvalues[keyVar].slist &&
                          setvalues[keyVar].slist.length !== 0) {
                        //set active item
                        if (setvalues[keyVar].value !== '') {
                          liAct = $('#' + tabId + '-' + keyVar +
                              ' li[data-val="' +
                              setvalues[keyVar].value + '"]');
                        } else {
                          liAct = $('#' + tabId + '-' + keyVar +
                              ' li[data-val="' + elem.value + '"]');
                          if (liAct.length === 0) {
                            liAct = $('ul#' + tabId + '-' + elem.name +
                                ' li:first');
                          }
                        }
                      } else {
                        //set null msg
                        $('#_' + keyVar + '-' + tabId + ' .b-myselect__select-value').
                            html(setvalues.nullmsg);
                      }
                    } else {
                      // case without slist
                      //set active item
                      liAct = $('#' + tabId + '-' + keyVar +
                          ' li[data-val="' + value.value + '"]');
                    }
                    //set value for select
                    if (liAct.length > 0) {
                      var $selectElem = $('#_' + keyVar + '-' + tabId),
                          isReadonly = $selectElem.hasClass('readonly');
                      //check for readonly
                      if (isReadonly) {
                        $selectElem.removeClass('readonly');
                      }
                      liAct.trigger('click', [once, elemId])
                      if (isReadonly) {
                        $selectElem.addClass('readonly');
                      }
                    }
                  //radio
                  } else if (dType === 'radio') {
                    if (value.slist &&
                         App.Tabs.tabs[tabId] &&
                         App.Tabs.tabs[tabId].formSource &&
                         App.Tabs.tabs[tabId].formSource[keyVar]) {
                       var sourceElem = App.Tabs.tabs[tabId].formSource[keyVar],
                           radioHtml = '';
                       sourceElem.slist = value.slist;
                       if (value.value) {
                         sourceElem.value = value.value;
                       //set first value
                       } else if (sourceElem.slist[0]) {
                         sourceElem.value = sourceElem.slist[0].key;
                       }
                       radioHtml = templates.formItemRadio(sourceElem);
                       $('#' + tabId + '-' + keyVar + '-radio').replaceWith(radioHtml);
                    }
                    if (!value.slist) {
                      $('#' + 'frm-' + tabId +
                          ' .' + keyVar + '-' +
                          tabId + '-' + window.hash(value.value)).
                          trigger('click', [once, elemId]);
                    }
                  // checkbox
                  } else if (dType === 'checkbox') {
                    $('#' + tabId + '-' + keyVar).
                        trigger('click', [[once, true]]);
                  // multiselect
                  } else if (dType === 'multiple') {
                    // replace value.value with value
                    var mvalue = value.value !== undefined ? value.value : value;
                    changed = isMultiSelectValuesChanged(elem.value, mvalue);
                    // вызываем при изменение значений или наличие slist
                    if (changed || value.slist) {
                      var id = elem.getAttribute('data-id');
                      EventMgr.trigger('selectValues', {
                        id: id, sElems: setvalues[keyVar] });
                    }
                  // input@type=hidden
                  } else if (dType === 'tree') {
                    $('#' + keyVar + '-' + tabId +
                        ' li[data-val="' + setvalues[keyVar].value + '"]').
                        trigger('click', [once, true]);
                  } else {
                    elem.value = value.value;
                  }
                }
              }
              if (changed) {
                elemId = elem.getAttribute('id');
                $(elem).trigger('change', [once, elemId]);
              }
            }
          } else {
            changed = (elem.value !== value.value);
            elem.value = value.value;
            if (changed) {
              elemId = elem.getAttribute('id');
              $(elem).trigger('change', [once, elemId]);
              if (elem.classList && elem.classList.contains('b-text-editor')) {
                EventMgr.trigger('TinyMCE_setContent', { content: elem.value, id: elemId });
              }
            }
          }
          //set readonly
          if (value.readonly) {
            var readonly = value.readonly === 'yes';
            //changeReadOnly($(elem).closest('.l-form__row'), readonly);
            //add to array and set after all
            readonlyArray.push({ elem: elem, readonly: readonly });
          }
        } else {
          //textdata
          elem = App.Dom.byId(tabId + '-' + keyVar);
          if (elem) {
            type = elem.getAttribute('data-type');
            if (type === 'img') {
              elem.src = setvalues[keyVar].value;
            //ticket
            } else if (type === 'ticket') {
              var newTicketHtml = templates.formItemTicketMsg(setvalues[keyVar]);
              if (newTicketHtml) {
                $(newTicketHtml).appendTo(elem);
              }
//              EventMgr.trigger('setFocus', { tabId: tabId });
            //list
            } else if (type === 'list') {
              setvalues[keyVar].id = tabId;
              setvalues[keyVar].type = 'form';
              if (setvalues[keyVar].view === 'blocklist') {
                elem.innerHTML = templates.formListBlocksContent(setvalues[keyVar]);
              } else {
                elem.innerHTML = templates.formListContent(setvalues[keyVar]);
              }
            } else if (type === 'listfilter') {
              setvalues[keyVar].id = tabId;
              elem.innerHTML = templates.formListFilter(setvalues[keyVar]);
            //buttons
            } else if (type === 'buttons') {
              var buttons = setvalues[keyVar],
                  l = setvalues[keyVar].length;
              for (var i = 0; i < l; i++) {
                //check for same buttons
                if ((data.__formModel && data.__formModel.__buttons[i]) &&
                    buttons[i].name !== data.__formModel.__buttons[i].name) {
                  var parent = $('#' + tabId + '-buttons .b-button')
                      .first().attr('data-parent');
                  elem.innerHTML = templates.buttons({
                    buttons: buttons,
                    id: tabId,
                    parent: parent,
                    type: 'form',
                    cancelBtnClass: ''
                  });
                  //update form model
                  EventMgr.trigger('updateModel', {
                    tabId: tabId,
                    name: '__buttons',
                    value: buttons
                  });
                  break;
                }
              }
              if (l === 0) {
                elem.innerHTML = '';
                //update form model
                EventMgr.trigger('updateModel', {
                  tabId: tabId,
                  name: '__buttons',
                  value: buttons
                });
              }
            } else if (type === 'link') {
              //unescape &amp; -> &
              var hrefLink = String(setvalues[keyVar].value).replace(/&amp;/g, '&');
              elem.href = hrefLink;
              elem.setAttribute('data-url', App.u.escapeQuote(hrefLink));
            } else if (type === 'datetime') {
              var d = App.u.parseDate(setvalues[keyVar].value),
                  dt = (new Date().getTime() - d.getTime());
              elem.setAttribute('data-difftime', dt);
            } else if (type === 'textdata') {
              elem = App.Dom.byId(tabId + '-' + keyVar + '-inner');
              elem.innerHTML = window.htmlDecode(setvalues[keyVar].value);
             // EventMgr.trigger('updateScroll', { id: tabId + '-' + keyVar });
            } else {
              elem.innerHTML = window.htmlDecode(setvalues[keyVar].value);
            }
            EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
          } else {
            //for frame
            elem = App.Dom.byId(keyVar + '-' + tabId);
            if (elem && elem.getAttribute('data-type') === 'frame') {
              elem.setAttribute('src', setvalues[keyVar].value);
            }
          }

        }
      }
    }
    //set readonly
    for (var i = 0, l = readonlyArray.length; i < l; i++) {
      App.FormUtils.changeReadOnly($(readonlyArray[i].elem).closest('.l-form__row'), readonlyArray[i].readonly);
    }
    EventMgr.trigger('setValuesDone', { tabId: tabId });
  }

  function renderSlistElem(elems) {
    var elemHTML = templates.formItemSelectList({ slist: elems, value: '' });
    return elemHTML;
  }
  //remove space and insert line break when press SPACE in zoom field
  function addLineBreakToZoomField(e) {
    var codeKey = e.which || e.keyCode;
    if (codeKey === SPACE) {
      e.preventDefault();
      var allText = this.value,
          currentPos = getCaret(this),
          beforeText = allText.substr(0, currentPos),
          afterText = allText.substr(currentPos);

      this.value = beforeText.replace(/((\s*\S+)*)\s*/, '$1') +
          '\n' + afterText.replace(/((\s*\S+)*)\s*/, '$1');
      setCaretPosition(this, beforeText.length);
    }
  }
  //from
  // http://stackoverflow.com/questions/11779140/how-to-push-cursor-to-the-next-line-when-user-hits-ctrl-enter
  function getCaret(el) {
    if (el.selectionStart) {
      return el.selectionStart;
    } else if (document.selection) {
      el.focus();

      var r = document.selection.createRange();
      if (r === null) {
        return 0;
      }

      var re = el.createTextRange(),
          rc = re.duplicate();
      re.moveToBookmark(r.getBookmark());
      rc.setEndPoint('EndToStart', re);

      return rc.text.length;
    }
    return 0;
  }

  function setCaretPosition(elem, caretPos) {
    if (elem !== null) {
      if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      }
      else {
        if (elem.selectionStart) {
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
        }
        else {
          elem.focus();
        }
      }
    }
  }

  //sync value zoom textarea and input
  function syncZoomValue(e) {
    var self = $(this),
        controlField = self.attr('data-control-field'),
        tabId = $activeTab().attr('data-tabid'),
        input = $('#cont-' + tabId + ' input[name="' + controlField + '"],' +
            ' #editinlist-wrapper-' + tabId +
            ' input[name="' + controlField + '"]'),
        value = self.val().
            replace(/\n+/g, ' ')
            .replace(/(^\s*|\s*$)/g, '')
            .replace(/\s+/g, ' ');
    input.val(value).trigger('change');
  }

  function syncInputWithZoom(e, data) {
    var tabId = data.tabId,
        input = data.self,
        controlField, textarea, value;
    if (input && App.Dom.hasClass(input, 'testzoom')) {
      controlField = input.name;
      textarea = $('#cont-' + tabId +
          ' .b-textarea[name="zoom-' + controlField + '"],' +
          ' #editinlist-wrapper-' + tabId +
          ' .b-textarea[name="zoom-' + controlField + '"]');
      value = input.value.replace(/(^\s*|\s*$)/g, '').replace(/\s+/g, '\n');
      if (textarea.length > 0) {
        textarea[0].value = value;
      }
    }
  }
  //calendar handler
  function calendarHandler(e) {
    var self = $(this),
        calendarFieldName = self.attr('data-control-field'),
        type = self.attr('data-type'),
        activeTab = $activeTab().attr('data-tabid'),
        calendarField = App.Dom.byId(calendarFieldName + '-' + activeTab),
        syncFieldName, syncField;
    if (calendarField) {
      syncFieldName = calendarField.getAttribute('data-syncfield');
      if (syncFieldName) {
        syncField = App.Dom.byId(syncFieldName + '-' + activeTab);
      }
    }
    //not good
    if (calendarField !== null) {
      if (type === 'month') {
        App.Calendar.showMonth(calendarField, syncField, e);
      } else {
        App.Calendar.show(calendarField, syncField, e);
      }
    }

  }
  //zoom handler
  function zoomHandler() {
    var self = $(this),
        controlField = self.attr('data-control-field'),
        row = self.parents('.l-form__row'),
        tabId = $activeTab().attr('data-tabid'),
        input = $('#cont-' + tabId + ' input[name="' + controlField + '"],' +
            ' #editinlist-wrapper-' + tabId +
            ' input[name="' + controlField + '"]'),
        textarea = $('#cont-' + tabId +
            ' .b-textarea[name="zoom-' + controlField + '"],' +
            ' #editinlist-wrapper-' + tabId +
            ' .b-textarea[name="zoom-' + controlField + '"]'),
        value;
    if (row.hasClass('zoom')) {
      //state = 'zoom';
      row.removeClass('zoom');
      value = textarea[0].value.
          replace(/\n+/g, ' ').
          replace(/(^\s*|\s*$)/g, '').
          replace(/\s+/g, ' ');
      input.val(value);
    } else {
      // state = 'unzoom';
      row.addClass('zoom');
      value = input.val().replace(/(^\s*|\s*$)/g, '').replace(/\s+/g, '\n');
      textarea[0].value = value;
    }
    EventMgr.trigger('updFormHeight', { tabId: tabId });
    EventMgr.trigger('updateFixedField', { tabId: tabId });
  }
  //toggle password field type text/password
  function showPassword() {
    var pwdFieldName = this.getAttribute('data-control-field'),
        tabId = this.getAttribute('data-tabid'),
        pwdField = App.Dom.byId(pwdFieldName + '-' + tabId);
    if (pwdField) {
      var type = pwdField.getAttribute('type');
      if (type === 'text') {
        pwdField.setAttribute('type', 'password');
        $(this).removeClass('b-input-btn_pwd_liketext');
      } else if (type === 'password') {
        pwdField.setAttribute('type', 'text');
        $(this).addClass('b-input-btn_pwd_liketext');
      }
    }
  }

  function fakePasswdCopy() {
    var parentId = this.getAttribute('data-parent'),
        parent = App.Dom.byId(parentId);
    if (parent !== null) {
      parent.value = this.value;
      $(parent).trigger('change');
    }
  }
  //password generation
  function genPassword() {
    var pwdFieldName = this.getAttribute('data-control-field'),
        pwdField = $('.tab-content_st_active input[name="' + pwdFieldName + '"]'),
        current = pwdField.val(),
        confFieldName = pwdField.attr('data-check-field'),
        pwdLen = pageInfo.pwgenlen || 8,
        pwdChar = pageInfo.pwgencharacters || '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        confField = $('.tab-content_st_active' +
            ' input[name="' + confFieldName + '"][type="password"]'),
        n = 0, rn, nnn = 0,
        tabId = $activeTab().attr('data-tabid'),
        pwdFake, confirmFake;
    if (pwdField.attr('readonly')) {
      return;
    }
    if (pwdFieldName) {
      $('.b-input-btn_type_showpwd[data-control-field="'+ pwdFieldName +'"]').remove();
    }
    pwdFake = App.Dom.byId(pwdFieldName + '-' + tabId + '-fake');
    confirmFake = App.Dom.byId(confFieldName + '-' + tabId + '-fake');

    if (pwdFake && pwdFake.offsetWidth === 0) {
      pwdFake.style.display = 'block';
      if (confirmFake) {
        confirmFake.style.display = 'block';
      }
      pwdField.hide();
      if (confField) {
        confField.hide();
      }
    }
    var lowerCase = pwdChar.match(/[a-z]/g),
        upperCase = pwdChar.match(/[A-Z]/g),
        number = pwdChar.match(/\d/g),
        special = pwdChar.match(/[!,@,#,$,%,^,&,*,?,_,~]/g),
        pwgenchar = {},
        typesPull = [],
        i, nn = 0, letters = 0;
    if (lowerCase || upperCase) {
      nn++;
      typesPull.push('l');
    }
    if (lowerCase) {
      lowerCase = lowerCase.join('');
      if (!upperCase) {
        pwgenchar.l = lowerCase;
      } else {
        pwgenchar.lc = lowerCase;
      }
      letters++;
    }
    if (upperCase) {
      upperCase = upperCase.join('');
      if (!lowerCase) {
        pwgenchar.l = upperCase;
      } else {
        pwgenchar.uc = upperCase;
      }

      letters++;
    }
    if (number) {
      number = number.join('');
      pwgenchar.d = number;
      typesPull.push('d');
      nn++;
    }
    if (special) {
      special = special.join('');
      pwgenchar.s = special;
      typesPull.push('s');
      nn++;
    }
    for (i = 0; i < pwdLen - nn; i++) {
      if (nnn === nn) {
        nnn = 0;
      }
      typesPull.push(typesPull[nnn]);
      nnn++;
    }
    rn = Math.floor(Math.random() * pwdLen + 1) % nn;
    typesPull = shiftArray(typesPull, rn);
    var elemObj = {
      passwdField: pwdField,
      confirmField: confField,
      passwdFake: pwdFake,
      confirmFake: confirmFake,
      pwdLen: pwdLen,
      //pwdChar : pwdChar,
      typesPull: typesPull,
      pwgenchar: pwgenchar,
      letters: letters
    };
    genPasswd(current, n, elemObj, 'lc');
  }

  //last to one
  function shiftArray(arr, n) {
    var elem,
        len = arr.length - 1;
    while (n--) {
      elem = arr[0];
      arr.splice(0, 1);
      arr[len] = elem;
    }
    return arr;
  }

  function genPasswd(current, n, elemObj, prevCase) {
    current = current.substr(0, n);
    var pwd = '',
        curCase = prevCase,
        curType,
        typesPull = elemObj.typesPull,
        pwgenchar = elemObj.pwgenchar,
        letters = elemObj.letters;

    for (var i = n; i < elemObj.pwdLen; i++) {
      curType = typesPull[i];
      if (curType === 'l' && letters === 2) {

        if (curCase === 'lc') {
          curCase = 'uc';
        } else {
          curCase = 'lc';
        }
        curType = curCase;
        if (i === n) {
          prevCase = curCase;
        }
      }
      pwd += pwgenchar[curType].
          substr(Math.floor((Math.random() * pwgenchar[curType].length)), 1);
    }
    n++;
    current += pwd;
    elemObj.passwdField.val(current);
    elemObj.confirmField.val(current);
    elemObj.passwdFake.value = current;
    if (elemObj.confirmFake) {
      setTimeout(function() {
        elemObj.confirmFake.value = current;
      }, 1);
    }
    if (n < elemObj.pwdLen) {
      setTimeout(function() { genPasswd(current, n, elemObj, prevCase);} , 35);
    } else {
      $(elemObj.passwdField).trigger('change');
      $(elemObj.passwdFake).trigger('change');
      $(elemObj.confirmField).trigger('change');
    }
  }


  function getActiveTabId() {
    return ($('.tab-content_st_active').attr('data-tabid') || false);
  }

  var UPKEY = 38,
      DOWNKEY = 40,
      LEFTKEY = 37,
      RIGHTKEY = 39,
      ENTERKEY = 13,
      TABKEY = 9,
      ESCKEY = 27,
      SPACE = 32;
  //trigger click if ENTER||SPACE KEYDOWN by element
  function formBtnKeyDownHandler(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode;
    if (codeKey === ENTERKEY || codeKey === SPACE) {
      e.preventDefault();
      $(this).trigger('click');
    }
  }

  function radioBtnKeyDownHandler(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode,
        name, id, tabId, radios;
    if (codeKey === UPKEY && !e.ctrlKey) {
      e.preventDefault();
      name = this.getAttribute('data-id');
      id = this.getAttribute('data-handler-val');
      radios = $(this).closest('.b-radio').find('div[data-id="' + name + '"]');
      var prev = null;
      radios.each(function() {
        var curId = this.getAttribute('data-handler-val');
        if (curId === id && prev !== null) {
          this.setAttribute('tabindex', '');
          prev.setAttribute('tabindex', '0');
          changeRadioValue.apply(prev);
          prev.focus();
          window.scrollToTopLeft();
          return false;
        }
        prev = this;
      });

    } else if (codeKey === DOWNKEY && !e.ctrlKey) {
      e.preventDefault();
      name = this.getAttribute('data-id');
      id = this.getAttribute('data-handler-val');
      radios = $(this).closest('.b-radio').find('div[data-id="' + name + '"]');
      var next = false;
      radios.each(function() {
        if (next) {
          this.setAttribute('tabindex', '0');
          changeRadioValue.apply(this);
          this.focus();
          return false;
        }
        var curId = this.getAttribute('data-handler-val');
        if (curId === id) {
          this.setAttribute('tabindex', '');
          next = true;
        }
      });

    }
  }

  function radioLabelClickHandler() {
    var rClass = this.getAttribute('data-r-class'),
        targetElem = $('.' + rClass);
    targetElem.trigger('click');
  }
  function checkboxDescClickHandler(e, sv) {
    var tabId = this.getAttribute('data-tabid'),
        id = this.getAttribute('data-id'),
        targetElem = $('.b-checkbox__control[data-tabid="' + tabId + '"]' +
            '[data-id="' + id + '"]');
    targetElem.trigger('click', [sv]);
  }
  //set radio value
  function changeRadioValue(e, sv) {
    var self = $(this),
        id = this.getAttribute('data-id'),
        val = this.getAttribute('data-val'),
        handlerVal = this.getAttribute('data-handler-val');

    if (self.hasClass('checked')) {
      return false;
    } else {
      $('.' + id).removeClass('checked').attr('tabindex', '');
      self.addClass('checked');
      this.setAttribute('tabindex', '0');
      this.focus();
      $('#' + id).val(val)
          .attr('data-handler-val', handlerVal).trigger('change', [sv]);

    }
  }
  /**
   * Callback checkbox click event
   * check/uncheck checkbox
   * @param  {object} e event object
   * @param {boolean} setvalues flag once
   * @return {boolean}
   * @this {object} HTML node
   */
  function changeCheckboxValue(e, param) {
    var $self = $(this),
        id = this.getAttribute('data-id'),
        elem;
    param = param || [];
    if ($self.hasClass('readonly') && !param[1]) {
      return false;
    }
    if ($self.hasClass('checked')) {
      $self.removeClass('checked');
      elem = $('input[name=' + id + ']').val('off')
          .attr('data-handler-val', hash('off'));
    } else {
      $self.addClass('checked');
      elem = $('input[name=' + id + ']').val('on')
          .attr('data-handler-val', hash('on'));
    }
    elem.trigger('change', [param[0]]);
  }

  function collapsedForm(e) {
    //dangerously
    var TIMEOUT = 300;
    e = e || window.event;
    //check for dashboard block reload click
    if (e && e.target) {
      if ($(e.target).hasClass('dashblock-reload')) {
        return;
      }
    }
    if (!App.Global.HeaderMoving) {
      var self = $(this),
          parent = self.parent(),
          elemSlide = parent.next(),
          elemParent = parent.parent(),
          tabId = elemParent.attr('data-tabid'),
          name = parent.attr('data-name'),
          type = parent.attr('data-type'),
          $stateElem = parent.find('.b-triangle'),
          collapsed = elemParent.hasClass('b-form-page_st_collapsed');
      if (collapsed) {
        elemSlide.slideDown(TIMEOUT);
        elemParent.removeClass('b-form-page_st_collapsed');
        $stateElem.attr('data-state', 'expanded');
      } else {
        elemSlide.slideUp(TIMEOUT);
        $stateElem.attr('data-state', 'collapsed');
        setTimeout(function() {
          elemParent.addClass('b-form-page_st_collapsed');
          elemParent = null;
        }, TIMEOUT - 20);
      }
      //form page
      if (type !== 'dashboard-block') {
        EventMgr.trigger('saveFormPageState', {
          tabId: tabId,
          name: name,
          collapsed: collapsed
        });
        setTimeout(function() {
          EventMgr.trigger('updFormHeight', { tabId: tabId });
          EventMgr.trigger('updateScroll', {});
          tabId = null;
        }, TIMEOUT);
      } else {
        //dashboard block
        setTimeout(function() {
          EventMgr.trigger('updateScroll', {});
        }, TIMEOUT);
        var position = self.parents('.b-dashboard_cell').attr('data-pos'),
            display = collapsed ? 'max' : 'min',
            block = self.parent().attr('data-name');
        var param = {
          func: 'dashboard.save', out: 'xml',
          block: block, display: display, position: position};
        var url = pageInfo.url;
        EventMgr.trigger('ajaxRequest', {
          url: url, param: param,
          trfunc: 'DoNothing', queue: 'noqueue' });
        if (!collapsed) {
          setTimeout(function() {
            EventMgr.trigger('updateScroll', {});
          }, TIMEOUT);
        } else {
          setTimeout(function() {
            EventMgr.trigger('updateScroll', {});
            EventMgr.trigger('upDashTableList', { tabId: 'block-' + block });
            block = null;
          }, 10);
        }
      }
    } else {
      App.Global.HeaderMoving = false;
    }
    e.preventDefault();
  }

  function insertUnlimValue() {
    var parId = this.getAttribute('data-control-field'),
        tabId = getActiveTabId(),
        parentEl = App.Dom.byId(parId + '-' + tabId),
        value = parentEl.getAttribute('data-unlimit');
    if (parentEl !== null) {
      parentEl.value = value;
      //for setvalues
      $(parentEl).trigger('change');
    }
  }

  function changeElHandler(e) {
    var showAttr = this.getAttribute('show'),
        show = showAttr.split(','),
        len = show.length,
        checked = this.getAttribute('checked'),
        className = 'hideEl';
    while (len--) {
      $('formItem' + show[len]).toggleClass(className);
    }
  }
  //hide/show depend items in select and radio
  function dependSlistHandler(e) {
    var value = this.value,
        name = this.getAttribute('name'),
        type = this.getAttribute('data-type'),
        tabId = this.getAttribute('data-tabid'),
        elem,
        selectElem, showElem;
    //hide select options
    $('#frm-' + tabId +
        ' div[data-depend="' + name + '"]' +
        ' .dependelem.b-myselect__select-li_show_yes').removeClass('b-myselect__select-li_show_yes');
    $('#frm-' + tabId +
        ' div[data-depend="' + name + '"]' +
        ' .dependelem[data-dependkey="' + value + '"]').addClass('b-myselect__select-li_show_yes');

    //uncheck radio
    selectElem = $('#frm-' + tabId +
        ' div[data-depend="' + name + '"] .b-myselect__select-li_show_yes .b-radio__control.checked');
    if (selectElem.length === 0) {
      $('#frm-' + tabId +
          ' div[data-depend="' + name + '"] .b-radio__control')
          .removeClass('checked');
      elem = $('#frm-' + tabId +
          ' div[data-depend="' + name + '"] .b-myselect__select-li_show_yes .b-radio__control')[0];
      if (elem) {
        changeRadioValue.apply(elem);
      }
    }
    //check for more one depend select
    var $dependSelect = $('#frm-' + tabId + ' div[data-depend="' + name + '"]');
    if ($dependSelect.length > 1) {
      $dependSelect.each(function() {
        var showElem = $(this).find('.dependelem[data-dependkey="' + value + '"].b-myselect__select-li_show_yes');
        dependSelectCheckForOprion(showElem, name, tabId, $(this));
      });
    } else {
      //unselect option
      showElem = $('#frm-' + tabId +
          ' div[data-depend="' + name + '"] ' +
          'li.dependelem[data-dependkey="' + value + '"].b-myselect__select-li_show_yes');
      dependSelectCheckForOprion(showElem, name, tabId);
    }
    //unselect multiselect
    if ($dependSelect.length) {
      $dependSelect.each(function() {
        if (appDom.hasClass(this, 'b-mselect')) {
          EventMgr.trigger('mselectUnselectByDepend', { self: this });
        }
      });
    }
    EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
  }

  function dependSelectCheckForOprion(showElem, name, tabId, $self) {
    var $elem = $self || $('#frm-' + tabId + ' div[data-depend="' + name + '"]');
    if (showElem.length === 0) {
      $elem.closest('.l-form__row')
          .css('display', 'none');
    } else {
      $elem.closest('.l-form__row').css('display', '');
    }
  }

  //show depend items in append form
  function firstDependSlistHandler(e, data) {
    var tabId = data.tabId;
    $('#cont-' + tabId + ' tr:not(".row-error") .depend.b-myselect ' +
        'input[type="hidden"],' +
        ' #cont-' + tabId + ' .depend.b-radio input[type="hidden"],' +
        ' #cont-' + tabId + ' .depend.b-select-ac input[type="hidden"]').
        each(function() {
          dependSlistHandler.apply(this);
        });
    EventMgr.trigger('updFormHeight', { tabId: tabId });
    EventMgr.trigger('reloadSlider', { tabId: tabId });

  }


  function bandShowHandler(e) {
    var id = this.getAttribute('data-id'),
        self = $(this),
        toggleClass = 'data-table-hidden';
    if (self.hasClass(toggleClass)) {
      self.removeClass(toggleClass);
      $('#' + id).slideDown(300);
    } else {
      self.addClass(toggleClass);
      $('#' + id).slideUp(300);
    }
    setTimeout(function() {
      EventMgr.trigger('updateScroll', {});
    }, 350);
  }

  /**
   * setUp padding for input with prefix
   * @param {object} e
   * @param {object} data
   */
  function prefixFieldSetUp(e, data) {
    var tabId = data.tabId;
    setTimeout(function() {
      $('#cont-' + tabId + ' .i-input__prefix').each(function() {
        var elemWidth = this.offsetWidth,
            input = App.Common.getPreviousNode(this),
            inputWidth,
            PADDING = 7,
            BORDER = 1;
        if (input) {
          inputWidth = input.offsetWidth;
          input.style.width = (inputWidth - (elemWidth) -
              (PADDING + (BORDER * 2))) + 'px';
          input.style.paddingLeft = (elemWidth) + 'px';
        }
      });
    }, 1);
  }

  //click for row in form list
  function formListRowClickHandler(e) {
    //check for loop
    if (e.target) {
      var $target = $(e.target);
      if ($target.hasClass('i-button') ||
          $target.prop('tagName') === 'A' ||
          $target.hasClass('b-checkbox__control')) {
        return;
      }
    }
    var $self = $(this),
        buttons = $self.find('.i-button_default_yes'),
        checkbox = $self.find('.i-checkbox_type_default');

    if (buttons.length === 1) {
      buttons.trigger('click');
    } else if (checkbox.length === 1) {
     checkbox.trigger('click');
    }
  }

  //
  function textareaResize(e) {
    var lastHeight = parseInt(this.style.height, 10),
        scrollHeight,
        maxHeight = (this.getAttribute('data-max-rows') - 0) * 12,
        BTNBOXHEIGHT = 62,
        id = this.getAttribute('id'),
        tabId = this.getAttribute('data-tabid');
    this.style.height = 'auto';
    scrollHeight = this.scrollHeight - 0;
    if (maxHeight < scrollHeight) {
      $(this).removeClass('b-textarea_responsive_yes');
    }
    this.style.height = scrollHeight + 'px';
    if (lastHeight !== scrollHeight) {

      EventMgr.trigger('updFormHeight', {
        tabId: tabId });
      //scroll textarea for visible area
      var textareaBotPos = $(this).offset().top + scrollHeight + BTNBOXHEIGHT,
          windowHeight = window.innerHeight;
      if (textareaBotPos > windowHeight) {
        var $self = $(this),
            offsetTop = $self.closest('.l-form__row')[0] ?
                $self.closest('.l-form__row')[0].offsetTop : 0,
            $page = $self.closest('.b-form-page'),
            formScrollEl = App.Dom.byId('form-scroll-' + tabId),
            heightViewPort = formScrollEl ? parseInt(formScrollEl.style.height, 10) : 0;
        if ($page[0]) {
          offsetTop += $page[0].offsetTop;
        }
        offsetTop -= (heightViewPort - (scrollHeight + BTNBOXHEIGHT + this.offsetTop));
        EventMgr.trigger('scrollTo', {
          id: 'form-scroll-' + tabId,
          offsetTop: offsetTop,
          raw: false
        });
      }
    }
  }

  function ticketMoveUpHandler(e) {
    var tabId = this.getAttribute('data-tabid'),
        $self = $(this),
        $row = $self.closest('.l-form__row'),
        offsetTop = 0;
    if ($row[0]) {
      offsetTop = $row[0].offsetTop;
      EventMgr.trigger('scrollTo', {
        id: 'form-scroll-' + tabId,
        offsetTop: offsetTop,
        animate: true
      });
    }
  }

  function ticketMoveDownHandler(e) {
    var tabId = this.getAttribute('data-tabid'),
        $self = $(this),
        $row = $self.closest('.l-form__row'),
        $form = $self.closest('.l-form__wrapper'),
        offsetTop = 0,
        height = 0,
        formHeight = 0,
        MAGICNUMBER2 = 120,//min height item for work
        MAGICNUMBER = 160; //btn box height
    if ($row[0] && $form[0]) {
      offsetTop = $row[0].offsetTop;
      height = $row[0].offsetHeight;
      if (height < 120) {
        return;
      }
      formHeight = $form[0].offsetHeight;
      EventMgr.trigger('scrollTo', {
        id: 'form-scroll-' + tabId,
        offsetTop: offsetTop + height - formHeight + MAGICNUMBER,
        animate: true
      });
    }
  }

  function ticketCollapseHandler(e) {
    e.preventDefault();
    var $self = $(this),
        tabId = $self.closest('.tab-content').attr('data-tabid');
    if ($self.hasClass('mbar-showall')) {
      $self.removeClass('mbar-showall').addClass('mbar-hideall');
      $self.closest('.b-ticket__table-row_is_collapsible').removeClass('b-ticket__table-row_is_collapsed');
    } else {
      $self.removeClass('mbar-hideall').addClass('mbar-showall');
      $self.closest('.b-ticket__table-row_is_collapsible').addClass('b-ticket__table-row_is_collapsed');
    }
    EventMgr.trigger('updFormHeight', { tabId: tabId });
  }

  return {
    init: init,
    checkPassStrength: checkPassStrength,
    CACHE: CACHE
  };
}(window, $, EventMgr, App, ScrollHandler);


/**
 * Модуль утилит для манипуляции с формой
 * @param {object} window глобальный объект
 * @param {object} $ jQuery глобальный объект
 * @param {object} App объект приложения
 */
App.FormUtils = function(window, $, App) {

  function changeReadOnly(elems, set) {
    if (!elems || elems.length === 0) { return; }
    if (set) {
      elems.find('.b-myselect,' +
              ' .b-radio,' +
              ' .b-checkbox__control,' +
              ' .l-slider__wr,' +
              ' .b-input_for_slider,' +
              ' .b-mselect')
        .addClass('readonly')
        .removeClass('mselect-av');
    } else {
      elems.find('.b-myselect, .b-radio,' +
              ' .b-checkbox__control,' +
              ' .l-slider__wr,' +
              ' .b-input_for_slider,' +
              ' .b-mselect')
        .removeClass('readonly')
        .addClass('mselect-av');
    }
    elems.find('.b-input, .b-textarea')
      .attr('readonly', set);
  }


  var api = {
    changeReadOnly: changeReadOnly
  };

  return api;

}(window, $, App);


/**
 * Модуль обработки скрытия полей на форме
 * @param {object} window глобальный объект
 * @param {object} $ jQuery глобальный объект
 * @param {object} EventMgr менеджер событий
 * @param {object} formUtils утилиты для манипуляции с формой
 * @param {object} commonUtils общие утилиты
 */
App.FormDependFields = function(window, $, EventMgr, formUtils, commonUtils) {
  /** селектор контролов управляющих скрытием полей  */
  const dependFieldSlistSelector = '.control-field input[type="hidden"],' +
      ' .control-field .b-input,' +
      ' .control-field .b-input_type_file,' +
      ' .control-field .b-textarea';

  /**
   * Получаем ссылку на ноду формы
   * @return {object} jQuery объект
   */
  function $content() {
    return commonUtils.selectorCache('.i-form-wr');
  }

  //hide/show field by select, radio and checkbox
  /**
   * Обработчик скрытия зависимых полей от данного контрола
   */
  function dependFieldsSlistHandler() {
    let handlerValue = this.getAttribute('data-handler-val');
    const name = this.getAttribute('name');
    const type = this.getAttribute('type');
    const tabId = this.getAttribute('data-tabid');
    let rowIsHidden = false,
        shadowShowElems, shadowHideElems, HideElems, shadowedRow;
    if (!name) { return; }
    console.log('name', name, handlerValue);
    //show hidden fields by "hide"
    shadowHideElems = $('.hidden-shadow-' + name);
    HideElems = $('.hidden-' + name);
    //unshadow shadow elems
    formUtils.changeReadOnly(shadowHideElems, false);
    shadowHideElems.removeClass('hidden-shadow-' + name);
    HideElems.removeClass('hidden-' + name);
    //hide field by else
    $('.showed-' + name)
      .addClass('depended-hidden-s')
      .addClass('l-form__row_hidden_yes')
      .removeClass('showed-' + name);
    //check row if already shadowed by else or 1st start
    shadowedRow = $('.depended-shadow-s');
    if (!shadowedRow.hasClass('row-shadow')) {
      shadowedRow.addClass('row-shadow');
      formUtils.changeReadOnly(shadowedRow, true);
    }
    //shadow field by else
    shadowShowElems = $('.showed-shadow-' + name)
      .removeClass('showed-shadow-' + name)
      .addClass('depended-shadow-s')
      .addClass('row-shadow');
    //add readonly from shadow
    formUtils.changeReadOnly(shadowShowElems, true);

    rowIsHidden = $(this).parents('.l-form__row, .filter-item').hasClass('l-form__row_hidden_yes');
    console.log('depend', this, rowIsHidden);
    // если поле не скрыто, то оно учавствует в скрытие полей
    if (!rowIsHidden) {
      //for text and native hidden
      if (type === 'text' || type === 'textarea' || !handlerValue) {
        const value = this.value;
        if (value === '') {
          //hide field by "hide" (empty = "yes")
          $('#frm-' + tabId +
              ' [data-hide-' + name + '-' + hash('empty-yes') + ' = "yes"]')
            .addClass('hidden-' + name)
            .addClass('l-form__row_hidden_yes');
          //shadow field by "hide" (empty = "yes")
          shadowHideElems = $('#frm-' + tabId +
              ' [data-shadow-' + name + '-' + hash('empty-yes') + ' = "yes"]')
            .addClass('hidden-shadow-' + name)
            .addClass('row-shadow');
          formUtils.changeReadOnly(shadowHideElems, true);
        } else {
          //hide fields by "hide" (empty = no)
          $('#frm-' + tabId + ' [data-hide-' + name +
              '-' + hash('empty-no') + ' = "yes"]')
            .addClass('hidden-' + name)
            .addClass('l-form__row_hidden_yes');
          //shadow fields by "hide" (empty = no)
          shadowHideElems = $('#frm-' + tabId +
              ' [data-shadow-' + name + '-' + hash('empty-no') + ' = "yes"]')
            .addClass('hidden-shadow-' + name)
            .addClass('row-shadow');
          formUtils.changeReadOnly(shadowHideElems, true);
        }
      // для селектов и радиобаттонов
      } else {
        //show field by "show"
        console.log('show field by else', '[data-show-' + name + '-' + handlerValue + ' = "yes"]');
        $(`#frm-${tabId} [data-show-${name}-${handlerValue} = "yes"]`)
          .addClass('showed-' + name)
          .removeClass('depended-hidden-s')
          .removeClass('l-form__row_hidden_yes');
        //unshadow field by "show"
        shadowShowElems = $(`#frm-${tabId} [data-show-shadow-${name}-${handlerValue} = "yes"]`)
          .addClass('showed-shadow-' + name)
          .removeClass('depended-shadow-s')
          .removeClass('row-shadow');
        formUtils.changeReadOnly(shadowShowElems, false);
        //hide field by "hide"
        $(`#frm-${tabId} [data-hide-${name}-${handlerValue} = "yes"]`)
          .addClass('hidden-' + name)
          .addClass('l-form__row_hidden_yes');
        //shadow field by "hide"
        shadowHideElems = $('#frm-' + tabId +
            ' [data-shadow-' + name + '-' + handlerValue + ' = "yes"]')
          .addClass('hidden-shadow-' + name)
          .addClass('row-shadow');
        formUtils.changeReadOnly(shadowHideElems, true);
      }
    }
  }


  /**
   * Вызываем обработчик if/else скрытия полей
   * @param {string} tabId id таба
   */
  function dependSlistHandlerRun(tabId) {
    $('#cont-' + tabId + ' tr:not(".row-error") .control-field' +
        ' input[type="hidden"],' +
      ' #cont-' + tabId + ' tr:not(".row-error") .control-field' +
        ' input[type="text"],' +
      ' #cont-' + tabId + ' tr:not(".row-error") .control-field' +
        ' input[type="password"],' +
      ' #cont-' + tabId + ' tr:not(".row-error") .control-field' +
        ' .b-input_type_file,' +
      ' #cont-' + tabId + ' .control-field.filter-item input[type="hidden"],' +
      ' #cont-' + tabId + ' .control-field .b-textarea,' +
      ' #cont-' + tabId + ' .control-field.filter-item input[type="text"]').
        each(function() {
          dependFieldsSlistHandler.apply(this);
        });
  }

  /**
   * Hide page if no visible fields
   * @param {String} tabId
   */
  function checkEmptyPage(tabId) {
    $('#form-wrapper-' + tabId + ' .b-form-page').each(function() {
      var id = this.getAttribute('id');
      if ($('#' + id + ' .l-form__row:not(.l-form__row_hidden_yes)').length > 0) {
        this.style.display = '';
      } else {
        this.style.display = 'none';
      }
    });
  }


  /**
   * Handler for changed control fields
   *
   * every contol field runs hide/show function from up to down from
   * @param {object} e event object
   * @param {object} data
   * @this {object} HTML node
   */
  function firstDependFieldsSlistHandler(e, data) {
    //проверяем на тип boolean для проверки на setvalue=once/final 
    var tabId = (!!data && typeof data !== 'boolean') ? data.tabId : this.getAttribute('data-tabid');
    // сбрасываем все правила скрытия
    $('#cont-' + tabId + ' .l-form__row_hidden_yes')
        .removeClass('l-form__row_hidden_yes')
        .removeClass('depended-hidden-s');
    $('#cont-' + tabId + ' .row-shadow').removeClass('row-shadow');

    setTimeout(function () {
       dependSlistHandlerRun(tabId);
     }, 0);

    setTimeout(function() {
      checkEmptyPage(tabId);
    }, 0);

    EventMgr.trigger('updFormHeight', { tabId: tabId });
    EventMgr.trigger('reloadSlider', { tabId: tabId });
    EventMgr.trigger('upPrefixField', { tabId: tabId });
  }



  function init() {
    EventMgr.bind('appendForm,appendReport,appendedFilter,initFuncRun',
        firstDependFieldsSlistHandler);
    EventMgr.on($content(), dependFieldSlistSelector,
        'change', firstDependFieldsSlistHandler);
  }

  var api = {
    init: init
  };

  return api;

}(window, $, EventMgr, App.FormUtils, App.Common);


/**
 * ScrollController
 * requires ScrollHandler!!!
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @param {object} ScrollHandler Scrollbar library
 */
App.ScrollController = function(window, $, EventMgr, App, ScrollHandler) {
  'use strict';
  var init = function() {
    EventMgr.bind('menuTypeChanged', updateScroll);
    EventMgr.obind($window(), 'resize', updateScroll);
    EventMgr.bind('updateScroll', updateScroll);
    EventMgr.bind('loadPage', attachScrollMenu);
    EventMgr.bind('appendForm,appendedFilter', attachScrollTabtoForm);
    EventMgr.bind('appendToolbarAce', attachScrollToToolbarAce);
    EventMgr.bind('appendReport', attachScrollTabtoForm);
    EventMgr.bind('appendList', attachScrollTabtoList);
    EventMgr.bind('appendMapDone', attachScrollTabtoRack);
    EventMgr.bind('loadLoginForm', attachScrolltoLoginForm);
    EventMgr.bind('appendDashboard', attachScrollTabtoDB);
    EventMgr.bind('appendDashList', attachScrolltoBlockDB);
    EventMgr.bind('closeTabEvent', detachScroll);
    EventMgr.bind('scrollTo', scrollTo);
  },

      $window = function() {
        return $(window);
      },

      updateScroll = function(e, data) {
        if (data && data.id) {
          ScrollHandler.update(data.id);
        } else {
          ScrollHandler.update();
        }
        data = null;
      },

      detachScroll = function(e, data) {
        ScrollHandler.detach(data.tabId);
        data = null;
      },

      attachScrollMenu = function() {
        setTimeout(function() {
          ScrollHandler.attach('menu-items-wr', 'menu-items', 'tab0');
        }, 10);
      },

      attachScrolltoBlockDB = function(e, data) {
        var blockId = data.tabId,
            cont = blockId + '-scrollwrapper',
            obj = 'lt-' + blockId;
        ScrollHandler.attach(cont, obj, blockId, true, true);
        data = null;
      },
      //вешаем сколл на форму
      attachScrollTabtoForm = function(e, data) {
        setTimeout(function() {
          var tabId = data.tabId;
          ScrollHandler.attach('form-scroll-' + tabId,
              'form-scroll-in-' + tabId, tabId, true);
          $('#frm-' + tabId + ' .band-table').each(function() {
            var id = this.id;
            ScrollHandler.attach(id, 'lt-' + id, tabId, true, true);
          });
          $('#frm-' + tabId + ' .b-form-list_view_table').each(function() {
            var id = this.id;
            ScrollHandler.attach(id, 'inner-' + id, tabId, true, true);
          });
          // for select
          $('#frm-' + tabId + ' .b-myselect__select-ul').each(function() {
            var id = this.getAttribute('id');
            ScrollHandler.attach('cont-' + id, id, tabId, true);
          });
          // for multiselect
          $('#frm-' + tabId + ' .b-mselect__ul-choose').each(function() {
            var id = this.getAttribute('data-id');
            ScrollHandler.attach(id + '-ms-list',
                id + '-ms-list-ul', tabId, true);
          });
          // for multiselect
          $('#frm-' + tabId + ' .b-mselect__view-value').each(function() {
            var id = this.getAttribute('data-id');
            ScrollHandler.attach(this.id,
                id + '-ms-view', tabId, true);
          });
          //for tree
          $('#frm-' + tabId + ' .tree-inner').each(function() {
            var id = this.getAttribute('id');
            ScrollHandler.attach('cont-' + id, id, tabId, true, true);
          });

          //for select autocomplite
          $('#frm-' + tabId + ' .b-select-ac__list').each(function() {
            var id = this.getAttribute('id');
            ScrollHandler.attach('cont-' + id, id, tabId, true);
          });
         // $('#frm-' + tabId + ' .b-textdata').each(function() {
         //   var id = this.getAttribute('id');
         //   ScrollHandler.attach(id, id + '-inner', tabId, true, true);
         // });
          tabId = null;
          data = null;
        }, 50);
      },

      attachScrollToToolbarAce = function(e, data) {
        var tabId = data.tabId;
        $('#frm-' + tabId + ' .b-myselect__select-ul').each(function() {
          var id = this.getAttribute('id');
          ScrollHandler.attach('cont-' + id, id, tabId, true);
        });
      },

      attachScrollTabtoDB = function(e, data) {
        var tabId = 'tab0';
        ScrollHandler.attach('cont-' + tabId, 'incont-' + tabId, 'tab0', true);
        tabId = null;
      },

      attachScrolltoLoginForm = function(e, data) {
        $('.b-myselect__select-ul').each(function() {
          var id = this.getAttribute('id');
          ScrollHandler.attach('cont-' + id, id, 'tab1', true);
          id = null;
        });
      },

      attachScrollTabtoList = function(e, data) {
        var tabId = data.tabId;
        ScrollHandler.attach('ltwr-' + tabId, 'lt-' + tabId, tabId, true);
        ScrollHandler.attach('cont-' + tabId + '-pager-slist',
            tabId + '-pager-slist', tabId, true);
        tabId = null;
      },

      attachScrollTabtoRack = function(e, data) {
        if (data.map.type === 'rack') {
          var tabId = data.tabId;
          ScrollHandler.attach(tabId + '-map', 'b-rack-' + tabId, tabId, true);
        }
      },

      scrollTo = function(e, data) {
        var offsetTop = data.offsetTop,
            id = data.id,
            raw = data.raw,
            animate = data.animate;
        ScrollHandler.scrollTo(id, offsetTop, raw, animate);
      };

  return {
    init: init
  };
}(window, $, EventMgr, App, ScrollHandler);

/**
 * ajax helper module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 */
App.AjaxHelper = function(window, $, EventMgr) {
  'use strict';
  var init = function() {
    EventMgr.bind('ajaxRequest', ajaxRequest);
    EventMgr.bind('ajaxRequestAbort', ajaxRequestAbort);
  },
      CACHE = {},

      ajaxRequestAbort = function(e, data) {
        var id = data.id;
        if (CACHE[id] && CACHE[id].xhr.abort) {
          CACHE[id].erMsg = 'Request canceled By User';
          CACHE[id].xhr.abort();
        }
      },

      addRequestHook = function(cb) {
        if (typeof cb === 'function') {
          requestHooks.push(cb);
        } 
      },

      addResponseHook = function(cb) {
        if (typeof cb === 'function') {
          responseHooks.push(cb);
        }
      },

      requestHooks = [],

      responseHooks = [],

      applyRequestHooks = function(data) {
        for (var i = 0, l = requestHooks.length; i < l; i++) {
          requestHooks[i].apply(this, [data]);
        }
      },

      applyResponseHooks = function(data) {
        for (var i = 0, l = responseHooks.length; i < l; i++) {
          responseHooks[i].apply(this, [data]);
        }
      },

      ajaxRequest = function(e, dataSource) {
       applyRequestHooks(dataSource);
        var cUrl = dataSource.url || pageInfo.url,
            param = dataSource.param || {},
            formData = dataSource.formData || {},
            inVar = dataSource.invar || {},
            trFunc = dataSource.trfunc || 'ajaxResponse',
            failFunc = dataSource.failfunc || false,
            type = dataSource.type || 'get',
            outType = dataSource.outtype || 'html',
            queueName = dataSource.queue || 'queue',
            noesc = !!dataSource.noesc,
            reqType = dataSource.reqType || 'jquery',
            progressCb = dataSource.progressCb || function() {},
            rp = dataSource.rp || [],
            id = dataSource.id;
        inVar.__dataSource = dataSource;
        if (queueName === 'noqueue') {
          queueName = new Date().getTime();
        }
        param.sfrom = 'ajax';
        param.operafake = new Date().getTime();
        var paramString = getQueryString(param, noesc);

        if (reqType === 'jquery') {
          EventMgr.trigger('getAjaxRequest', {});
          var ajaxParams = {
             url: cUrl,
             type: type,
             dataType: 'html',
             data: paramString,
             headers: { 'ISP-Client': 'Web-interface' },
             //data : param,
             async: true,
             success: success,
             xhrFields: { withCredentials: true },
             error: error
          };
          if (type === 'jsonp') {
            ajaxParams.jsonp = 'callback';
            ajaxParams.dataType = 'jsonp';
            ajaxParams.crossDomain = true;
          }
          $.ajaxq(queueName, ajaxParams);
        } else {
          //progress upload
          var xhr = new XMLHttpRequest();
          xhr.upload.addEventListener('progress', progressCb, false);
          xhr.open('POST', cUrl);
          //set header for long request
          xhr.setRequestHeader('ISP-Client', 'Web-interface');
          xhr.onreadystatechange = function() {
            if (this.readyState === 4) {
              if (this.status === 200) {
                delete CACHE[id];
                success(this.responseText);
              } else {
                error(this, this.statusText, this.statusText);
              }
            }
          };
          formData.append('sfrom', 'ajax');
          CACHE[id] = { xhr: xhr };
          xhr.send(formData);
        }
        /* jshint latedef: false*/
        function success(data) {
          if (type !== 'jsonp') {
            data = data.replace(/\\'/g, "'");
            data = data.replace(/^<![\w\s\"-\/]*>/g, '');
            if (!data) {
              //wtf?
              console.log('empty response');
              EventMgr.trigger('ajaxError', {});
              return;
            }
          }

          if (outType === 'json' && type !== 'jsonp') {
            //remove non-printable characters
            data = data.replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F]/g, '');
            try {
              data = jQuery.parseJSON(data);
            } catch (e) {
              //error
              console.log('jsonParseError', dataSource, failFunc);
              dataSource.erType = 'json';
              if (failFunc) {
                EventMgr.trigger(failFunc, dataSource);
              }
              //EventMgr.trigger('ajaxError', {});
              return;
            }
          }
          if (outType !== 'html') {
            data.sourceParamString = paramString;
            //add props in returned object
            $.extend(data, inVar);
            data.selfUrl = pageInfo.url + '?' + data.urlparam;
            //remove some param from response
            if (rp.length) {
              data = removeParams(data, rp);
            }
          }

          if (trFunc !== 'DoNothing') {
            EventMgr.trigger(trFunc, data);
          }
          EventMgr.trigger('giveAjaxRequest', {});
        }
        /* jshint latedef: false*/
        function error(jqXHR, textStatus, errorThrown) {
          //check for long request
          if (errorThrown === 'Service Unavailable' && !dataSource.ignore503) {
            //go to new url while request not end
            var longUrl = jqXHR.responseText;
            dataSource.url = pageInfo.host + '/' + longUrl;
            dataSource.reqType = 'jquery';
            EventMgr.trigger('ajaxRequest', dataSource);
          } else if (trFunc === 'ajaxResponse' &&
              inVar.exType === 'dashboard') {
            inVar.error = true;
            inVar.shithappend = true;
            EventMgr.trigger('ajaxResponse', inVar);
          } else if (failFunc) {
            var regex = /<div class="fatal-error-desc">(.*?)<\/div>/ig,
                errText = String(jqXHR.responseText).match(regex);
            if (errText && errText[0]) {
              dataSource.erMsg = errText[0];
            }
            if (CACHE[dataSource.id] &&
                App.u.isString(CACHE[dataSource.id].erMsg)) {
              dataSource.erMsg = CACHE[dataSource.id].erMsg;
            }
            EventMgr.trigger(failFunc, dataSource);
            delete CACHE[dataSource.id];
          }
          console.log(textStatus);
        }
      },

      removeParams = function(data, rp) {
        var l = rp.length;
        while(l--) {
          data[rp[l]] = null;
        }
        return data;
      },
      //join with &
      getQueryString = function(queryObj, noesc) {
        var j = 0,
            paramString = '',
            curValue,
            keyVar;
        for (keyVar in queryObj) {
          if (keyVar !== '') {
            if (j !== 0) {
              paramString += '&';
            }
            curValue = queryObj[keyVar];
            //encode params
            if (noesc) {
              paramString += keyVar + '=' + curValue;
            } else {
              paramString += keyVar + '=' + encodeURIComponent(curValue);
            }
            j++;
          }
        }
        return paramString;
      };
  return {
    init: init,
    addRequestHook: addRequestHook,
    addResponseHook: addResponseHook
  };
}(window, $, EventMgr);

/**
 * Valid checker module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 */
App.ValidChecker = function(window, $, EventMgr, App) {
  var init = function() {
    EventMgr.bind('checkValue', checkValue);
    EventMgr.bind('validatorResponse', managerValidator);
  },

      checkValue = function(e, data) {
        var nameValid = data.name,
            self = data.self,
            paramValid = data.param,
            number = data.number,
            value = data.value,
            prefix = data.prefix,
            fieldName = data.fieldname,
            funcName = data.funcname,
            convert = data.convert;
        //ajax request
        var param = {
          func: 'check.' + nameValid,
          value: value,
          name: fieldName,
          funcname: funcName };
        if (paramValid) {
          param.args = paramValid;
        }
        if (prefix) {
          param.prefix = prefix;
        }
        if (convert) {
          param.tconvert = convert;
        }
        EventMgr.trigger('ajaxRequest', {
          url: pageInfo.url,
          param: param,
          invar: {
            self: self,
            namevalid: nameValid,
            ovalue: self.value,
            vvalue: value,
            multi: data.multi,
            number: number },
          trfunc: 'validatorResponse',
          outtype: 'json',
          queue: 'multiload' });
      },

      managerValidator = function(e, data) {
        var self = data.self,
            nameValid = data.namevalid,
            ovalue = data.ovalue,
            value = data.value,
            number = data.number,
            vvalue = data.vvalue;
        if (data.ermsg) {
          validatorErrors[nameValid] = data.ermsg;
          if ((ovalue === self.value && self.offsetWidth !== 0) ||
              (self.nextSibling !== null &&
              self.nextSibling.nodeName.toLowerCase() === 'textarea' &&
              self.nextSibling.offsetWidth !== 0 && ovalue === self.value)) {
            EventMgr.trigger('errMsgValid', {
              type: nameValid,
              self: self,
              err: data.ermsg,
              number: number });
          } else {
            EventMgr.trigger('okMsgValid', {
              type: nameValid,
              self: self,
              number: number });
          }
        } else {
          if (ovalue === self.value) {
            //single valid
            EventMgr.trigger('okMsgValid', {
              type: nameValid,
              self: self,
              number: number,
              multi: data.multi,
              value: value,
              ovalue: ovalue,
              vvalue: vvalue });
          } else {
            //multivalid
            EventMgr.trigger('okMsgValid', {
              type: nameValid,
              self: self,
              multi: data.multi,
              number: number,
              value: value,
              ovalue: ovalue,
              vvalue: vvalue });
          }

        }
      },

      validatorErrors = {};


  return {
    init: init
  };
}(window, $, EventMgr, App);

/**
 * Form validators module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 */
App.Validators = function(window, $, EventMgr, App) {
  'use strict';
  var init = function() {
    EventMgr.on('#main-wrapper', 'input[type="text"].test', 'change', validate);
    EventMgr.on('#main-wrapper', 'input[type="text"].testzoom',
        'change', multiValidate);
    EventMgr.bind('errMsgValid', setErrorMessage);
    EventMgr.bind('okMsgValid', setOkMessage);
  },

      pageInfo = window.pageInfo,

      $activeTab = function() {
        return $('.tab-content_st_active');
      },
      //Callback for changed input value
      validate = function(e, data) {
        var nameValid = this.getAttribute('data-check'),
            paramValid = this.getAttribute('data-check-args'),
            errMsg = this.getAttribute('data-error-msg'),
            fieldName = this.getAttribute('data-fieldname'),
            funcName = this.getAttribute('data-funcname'),
            prefix = $(this).siblings('.b-input__prefix').html(),
            convert = this.getAttribute('data-convert');
        if (this.value === '') {
          EventMgr.trigger('okMsgValid', { self: this, number: 0, value: '' });
          return;
        }
        //trigger checkvalue
        EventMgr.trigger('checkValue', {
          name: nameValid,
          prefix: prefix,
          param: paramValid,
          err: errMsg,
          fieldname: fieldName,
          number: 0,
          funcname: funcName,
          convert: convert,
          self: this,
          value: this.value });
      },
      //function for checking duplicate
      checkDuplicate = function(values) {
        var i, j, n;
        n = values.length;
        // to ensure the fewest possible comparisons
        // outer loop uses each item i at 0 through n
        for (i = 0; i < n; i++) {
          // inner loop only compares items j at i+1 to n
          for (j = i + 1; j < n; j++) {
            if (values[i] === values[j]) { return true; }
          }
        }
        return false;
      },

      multiValidate = function(e, data) {
        if (this.value === '') {
          EventMgr.trigger('okMsgValid', { self: this, number: 0, value: '' });
          return;
        }
        var number = 0,
            value = this.value,
            values = this.value.split(/\s+/),
            len = values.length;
        if (data) {
          number = data.number;
          var nextNumber = number + 1;
          if (len === nextNumber) {
            number = 0;
          } else {
            number = nextNumber;
          }
          value = values[nextNumber - 1];
        } else {
          if (len === 1) {
            number = 0;
          } else {
            if (this.getAttribute('duplicate') !== 'yes') {
              if (checkDuplicate(values)) {
                EventMgr.trigger('errMsgValid', {
                  type: 'duplicate',
                  self: this,
                  err: pageInfo.duplicate,
                  number: 0 });
                return;
              }
            }
            number = 1;
          }
          value = this.value.split(/\s+/)[0];
        }
        var nameValid = this.getAttribute('data-check'),
            paramValid = this.getAttribute('data-check-args'),
            errMsg = this.getAttribute('data-error-msg'),
            fieldName = this.getAttribute('data-fieldname'),
            funcName = this.getAttribute('data-funcname'),
            convert = this.getAttribute('data-convert');
        EventMgr.trigger('checkValue', {
          name: nameValid,
          param: paramValid,
          err: errMsg,
          multi: true,
          fieldname: fieldName,
          funcname: funcName,
          self: this,
          number: number,
          value: value,
          convert: convert });
      },

      replaceValidValue = function(where, what, than) {
        var arr = String(where).split(/\s+|\n/),
            l = arr.length,
            obj = {
              v: '',
              changed: false
            };
        while (l--) {
          if (String(arr[l]) === String(what)) {
            if (String(what) !== String(than)) {
              obj.changed = true;
            }
            arr[l] = than;
            break;
          }
        }
        obj.v = arr.join(' ');
        return obj;
      },

      setOkMessage = function(e, data) {
        var self = data.self,
            number = data.number,
            value = data.value,
            ovalue = data.ovalue,
            vvalue = data.vvalue,
            multi = data.multi,
            notOk = data.notOk,
            tabId,
            secondTdElem,
            sData = data,
            o;
        data = {};
        data.number = number;
        //for multi value
        if ((number - 0) !== 0) {
          o = replaceValidValue(self.value, vvalue, value);
          self.value = o.v;
          if (o.changed) {
            setWarningError(e, sData);
          }
          multiValidate.apply(self, [null, data]);
        } else {
          secondTdElem = $(self).parents('.l-form__col_cont_control');
          if (secondTdElem.attr('colspan') - 0 === 2 &&
              !secondTdElem.hasClass('formwidth')) {
            secondTdElem.attr('colspan', '');
          }
          if ((value === '' && self.getAttribute('required')) || notOk) {
            secondTdElem.parents('.l-form__row')
                .removeClass('row-error')
                .removeClass('row-ok');
          } else {
            secondTdElem.parents('.l-form__row')
                .removeClass('row-error')
                .addClass('row-ok');
          }
          //replace value if this changed
          if (value !== undefined &&
              ovalue !== undefined &&
              vvalue !== undefined) {
            o = {};
            if (multi) {
              o = replaceValidValue(self.value, vvalue, value);
              self.value = o.v;
              if (o.changed) {
                setWarningError(e, sData);
              }
           } else if (value !== '') {
              if (self.value !== value || o.changed) {
                setWarningError(e, sData);
              }
             self.value = value;
            }
          }
        }
        tabId = $(self).closest('.tab-content').attr('data-tabid');
        EventMgr.trigger('syncInputToZoom', { tabId: tabId, self: self });
        EventMgr.trigger('updFormHeight', { tabId: tabId });
      },

      setWarningError = function(e, data) {
        data.warning = true;
        data.err = pageInfo.messages.validChangeVal;
        setErrorMessage.apply(window, [e, data]);
      },

      // Write error
      setErrorMessage = function(e, data) {
        var msg = data.err,
            self = data.self,
            name = self.getAttribute('name'),
            id = self.getAttribute('id'),
            number = data.number,
            arrValues = self.value ? self.value.split(' ') : [],
            tmp = '',
            warning = data.warning,
            i, index, tabId, r, secondTdElem;
        //show error box if created
        if (number - 0 === 0) {
          number = arrValues.length;
        }
        for (i = 0; i < number - 1; i++) {
          tmp += arrValues[i] + ' ';
        }
        index = tmp.length;

       var errHTML = '<div class="b-error-box"><div class="b-error-box__top-triangle"></div>' +
                '<div class="b-error-box__inner">' + msg + '</div></div>';
        $('.b-error-box__wrapper[data-id="' + id + '"]').html(errHTML);
        secondTdElem = $(self).parents('.l-form__col_cont_control');
        if (!secondTdElem.attr('colspan') && !warning) {
          secondTdElem.attr('colspan', '2');
        }
        if (!warning) {
          secondTdElem.parents('.l-form__row')
              .addClass('row-error')
              .removeClass('row-ok');
        } else {
           secondTdElem.parents('.l-form__row')
              .addClass('row-warning');
           setTimeout(function() {
              secondTdElem.parents('.l-form__row')
                .removeClass('row-warning');
           }, 2000);
        }
        tabId = $(self).closest('.tab-content').attr('data-tabid');
        EventMgr.trigger('updFormHeight', { tabId: tabId });
        EventMgr.trigger('updateFixedField', { tabId: tabId });
        if (!warning) {
          //scroll to field
          var $self = $(self),
              offsetTop = $self.closest('.l-form__row')[0] ?
                  $self.closest('.l-form__row')[0].offsetTop : 0,
              $page = $self.closest('.b-form-page'),
              $formSW = $('#form-scroll-' + tabId),
              MAGICNUMBER = 62 + 12 + 2 + 2; //button block height + padding + margin
          if ($page.hasClass('b-form-page_st_collapsed')) {
            $page.find('.i-form-page__title').trigger('click');
          }
          //it can be extform
          if ($formSW.length) {
            var height = parseFloat($formSW[0].style.height),
                scrollTop = $formSW[0].scrollTop;
            if ($page[0]) {
              offsetTop += $page[0].offsetTop;
            }
            //offsetTop -= MAGICNUMBER;
            offsetTop += MAGICNUMBER;
            //scrolltop when not in viewport
            if (offsetTop < scrollTop || height + scrollTop < offsetTop) {
              EventMgr.trigger('scrollTo', {
                id: 'form-scroll-' + tabId,
                offsetTop: offsetTop,
                animate: false,
                raw: false
              });
            }
          }
          //setfocus and cursor
          //check for type=file
          if (String(self.getAttribute('type')).toLowerCase() !== 'file') {
            if (self.offsetWidth !== 0) {
              self.focus();
              window.scrollTo(0, 0);
              if (self.setSelectionRange) {
                  self.setSelectionRange(index, index);
              } else if (self.createTextRange) {
                r = self.createTextRange();
                r.collapse(true);
                r.select(index, index);
              }
            } else if (self.nextSibling) {
              //for passwd I think
              self.nextSibling.focus();
              window.scrollTo(0, 0);
              if (self.setSelectionRange) {
                self.nextSibling.setSelectionRange(index, index);
              } else {
                r = self.nextSibling.createTextRange();
                r.collapse(true);
                r.select(index, index);
              }
            }
          }
        }
     };
  return {
    init: init
  };
}(window, $, EventMgr, App);

/**
 * Slider module
 * @param {object} window global object
 * @param {object|function} $ jQuery
 * @param {object} EventMgr Event manager
 * @param {object} App Application
 */
/*global App:true*/
App.Slider = function(window, $, EventMgr, App) {
  'use strict';
  var init = function() {
    EventMgr.on($content(), sliderSelector, 'mousedown', drag);
    EventMgr.on($content(), sliderWrapperSelector, 'mousedown', sliderToPoint);
    EventMgr.bind('appendForm', start);
    EventMgr.bind('appendEditInList', startEditInList);
    EventMgr.bind('reloadSlider', start);
    EventMgr.on($content(), sliderInputSelector, 'change', sliderMove);
    EventMgr.on($content(), sliderInputSelector,
        'keydown', sliderKeyDownHandler);
    EventMgr.on($content(), sliderInputSelector, 'keyup', deleteSliderHandler);
    EventMgr.on($content(), sliderSelector, 'ontouchstart', drag);
  },

      $content = function() {
        return $('#main-wrapper');
      },

      sliderSelector = '.l-slider__wr:not(".readonly") .b-slider__el',

      sliderInputSelector = '.b-input_for_slider:not(".readonly")',

      sliderWrapperSelector = '.l-slider__wr:not(".readonly")',

      max = 0, min = 0, self = null, maxleft = 0, shiftX = 0, width = 0,
          intId = null, tabId = '', inputId = null, step = 0,

      //flag for change input value
      fromInput = false,

      calcValue = function(np) {
        var bound = max - min,
            delta = (bound / maxleft),
            initDelta = (min % step),
            value = (Math.round(np * delta) + parseInt(min, 10)),
            el = App.Dom.byId(inputId),
            elSlider = App.Dom.byId(inputId + '-slider'),
            ldf = (value % step),
            rdf = step - ldf;
        if (ldf > rdf) {
          value += rdf;
        } else {
          value -= ldf;
        }
        value += initDelta;
        //check bounds
        if (value > max) {
          value = max;
        } else if (value < min) {
          value = min;
        }
        if (el !== null) {
          el.value = value;
        }
        if (elSlider) {
          elSlider.setAttribute('data-value', value);
        }
        EventMgr.trigger('changeSliderValue', { tabId: tabId });
      },

      getDataSlider = function() {
        tabId = self.getAttribute('data-tabid');
        inputId = self.getAttribute('data-id');
        min = self.getAttribute('data-min');
        step = parseInt(self.getAttribute('data-step'), 10);
        if (!step) { step = 1;}
        max = (self.getAttribute('data-max'));
        width = $(self).parent().width();
        maxleft = width - 9;
      },

      setPosition = function(newPosition) {
        var np = 0;
        if ((newPosition <= maxleft) && (newPosition >= 0)) {
          np = newPosition;
        }
        else if (newPosition > maxleft) {
          fromInput = false;
          np = maxleft;
        }
        else {
          fromInput = false;
          np = 0;
        }
        self.style.left = np + 'px';
        if (!fromInput) {
          calcValue(np);
        }
        fromInput = false;
        return false;
      },

      start = function(e, data) {
        tabId = data.tabId;
        $('#incont-' + tabId + ' .b-slider__el').each(function() {
          self = this;
          fromInput = true;
          getDataSlider();
          if (width !== 0) {
            var value = this.getAttribute('data-value'),
                bound = max - min,
                delta = bound / maxleft,
                np = value / delta - min / delta;
            setPosition(np);
          }
        });
      },

      startEditInList = function(e, data) {
        tabId = data.tabId;
        $('#editinlist-wrapper-' + tabId + ' .b-slider__el')
            .each(function() {
                self = this;
                fromInput = true;
                getDataSlider();
                var value = this.getAttribute('data-value'),
                    bound = max - min,
                    delta = bound / maxleft,
                    np = value / delta - min / delta;
                setPosition(np);
            });
      },

      sliderMove = function(e, sv) {
        e = e || window.event;
        var f = (this.value.substr(0, 1) === '-') ? '-' : '';
        this.value = f + this.value.replace(/\D/g, '');
        fromInput = true;
        var id = this.getAttribute('id');
        self = App.Dom.byId(id + '-slider');
        getDataSlider();
        var value = App.Dom.byId(inputId).value,
            ldf = value % step,
            rdf = step - ldf,
            bound = max - min,
            delta = bound / maxleft,
            initDelta = (min % step),
            np,
            elSlider = App.Dom.byId(inputId + '-slider');
        value -= 0;
        if (ldf > rdf) {
          value += rdf;
        } else {
          value -= ldf;
        }
        value += initDelta;
        this.value = value;
        np = value / delta - min / delta;

        if (np > maxleft) {
          fromInput = false;
        }
        setPosition(np);
        blockEvent(e);

        if (elSlider) {
          elSlider.setAttribute('data-value', value);
        }

        EventMgr.trigger('changeSliderValue', { tabId: tabId });
        return false;
      },

      sliderKeyDownHandler = function(e) {
        e = e || window.event;
        var codeKey = e.which || e.keyCode,
            id;
        if (codeKey === 38 || codeKey === 40) {
          id = this.getAttribute('id');
          self = $('a#' + id + '-slider')[0];
          getDataSlider();
          blockEvent(e);
        }
        if (codeKey === 38 && !e.ctrlKey) {
          clearInterval(intId);
          sliderMoveForKeyDown(true);
          intId = setInterval(function() { sliderMoveForKeyDown(true); }, 100);
          blockEvent(e);
        } else if (codeKey === 40 && !e.ctrlKey) {
          clearInterval(intId);
          sliderMoveForKeyDown(false);
          intId = setInterval(function() { sliderMoveForKeyDown(false); }, 100);
          blockEvent(e);
        }
      },

      deleteSliderHandler = function() {
        var f = (this.value.substr(0, 1) === '-') ? '-' : '';
        this.value = f + this.value.replace(/\D/g, '');
        clearInterval(intId);
      },

      sliderMoveForKeyDown = function(up) {
        var input = App.Dom.byId(inputId),
            value = input.value;
        if (up) {
          value = parseInt(value, 10) + step;
        } else {
          if (value === max) {
            value -= 3;
          } else {
            value -= step;
          }
        }
        input.value = value;
        EventMgr.trigger('changeSliderValue', { tabId: tabId });
        $('#' + inputId).trigger('change');
      },

      sliderToPoint = function(e) {
        e = e || window.event;
        self = $(this).children('.b-slider__el')[0];
        getDataSlider();
        shiftX = e.clientX - $(this).offset().left - 7;
        setPosition(shiftX);
        $('#' + inputId).trigger('change');
      },

      drag = function(e) {
        $(this).trigger('focus');
        e = e || window.event;
        if (e.touches) {
          shiftX = e.touches[0].pageX - parseInt(this.style.left, 10);
          document.ontouchmove = move;
          document.ontouchend = drop;
          document.ontouchcancel = drop;
        } else {
          shiftX = e.clientX - parseInt(this.style.left, 10);
          document.onmousemove = move;
          document.onmouseup = drop;
        }
        self = this;
        getDataSlider();
        blockEvent(e);
        return false;
      },
      //Handler for move
      move = function(e) {
        e = e || window.event;
        if (e.touches) {
          setPosition(e.touches[0].pageX - shiftX);
        } else {
          setPosition(e.clientX - shiftX);
        }
        blockEvent(e);
        return false;
      },
      //Handler for mouseup, unbind mousemove and mouseup
      drop = function(e) {
        $(this).trigger('blur');
        e = e || window.event;
        document.onmousemove = null;
        document.onmouseup = null;
        document.ontouchmove = null;
        document.ontouchend = null;
        document.ontouchcancel = null;
        $('#' + inputId).trigger('change');
        blockEvent(e);
      };

  return {
    init: init
  };

}(window, $, EventMgr, App);

/**
 * Progressbar module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @param {object} templates Templates of App
 */
App.ProgressBar = function(window, $, EventMgr, App, templates) {
  'use strict';

  var CACHE = {};
  // закончившиеся wait прогрессбары, на случай когда прогрессбар пришел раньше респонса формы
  var ENDED_WAIT_PROGRESSBAR = {};
  /**
   * Remove ProgressBar
   * @param {string} tabId
   */
  function removeProgressBar(tabId) {
    var tabCont = App.Dom.byId('cont-' + tabId);
    App.Dom.removeClass(tabCont, 'tab-content__progressbar_show');
    var progressbar = App.Dom.byId('cont-' + tabId + '-progressbar');
    if (progressbar === null) { return; }
    progressbar.style.display = 'none';
    progressbar.innerHTML = '';
    //show default loader
    var defProgress = App.Dom.byId('cont-' + tabId + '-progressbar-default');
    if (defProgress === null) { return false; }
    if (defProgress.style.display === 'none') {
      defProgress.style.display = null;
    }
    progressbar = null;
  }

  /**
   * Wait progressbar response after panel restart
   * @param {object} e
   * @param {object} data
   */
  function waitProgressBar(e, data) {
    if (data.progresstype === 'wait' || (data.invar && data.invar.progresstype === 'wait')) {
      setTimeout(function() {
        EventMgr.trigger('ajaxRequest', {
          param: data.param,
          invar: data.invar,
          type: 'get',
          outtype: 'json',
          trfunc: 'progressBarResponse',
          failfunc: 'progressBarResponseFail',
          queue: 'noqueue' });
      }, 1500);
    }
  }

  /**
   * Render Progressbar HTML
   * @param {object} e
   * @param {object} data
   */
  function renderProgressBar(e, data) {
    var start = data.start,
        progressType = data.progresstype,
        tabId = '', tabExist = false,
        progressId = data.param.elid;
    if (start !== '' && start !== undefined) {
      var done = data.done,
          now = data.now,
          steps = data.steps,
          comment = data.comment,
          param = data.param,
          colorClass = '';
      tabId = data.tabId;
      var per = 0,
          left = '';
      if (done !== '' && steps !== '') {
        per = Math.round((done / steps) * 100);
      }
      if (done !== '' && steps !== '' && progressType !== 'notime') {
        var elapsedTime = (now - start),
            elapsedSteps = steps - done;
        if (elapsedSteps !== 0 && done !== 0) {
          left = Math.round((elapsedTime / done) * elapsedSteps) + 'sec';
        }
      }
      var width = per * (0.98);
      if (per < 6) {
        per = '.';
        colorClass = 'blue-color';
      } else {
        if (per > 100) {
          per = 100;
          width = per * (0.98);
        }
        per += '%';
      }
      var html = templates.progressBar({
        tabId: tabId,
        per: per,
        width: width,
        left: '',
        comment: comment,
        colorClass: colorClass });
      tabExist = appendProgressBar(tabId, progressId, html);
      //if exist tab
      if (tabExist) {
        setTimeout(function() {
          EventMgr.trigger('ajaxRequest', {
            param: param,
            invar: { tabId: tabId, param: param, progresstype: progressType },
            type: 'get',
            outtype: 'json',
            trfunc: 'progressBarResponse',
            failfunc: 'progressBarResponseFail',
            queue: 'noqueue' });
          param = null;tabId = null;progressType = null;
        }, 1000);
      }

    } else {
      tabId = data.tabId;
      removeProgressBar(tabId);
      //@todo remove cache
    }
    if (data.ok && progressType === 'wait') {
      if (data.param && data.param.elid) {
        ENDED_WAIT_PROGRESSBAR[data.param.elid] = true;
        if (CACHE[data.param.elid]) {
          CACHE[data.param.elid].progresstype = null;
          if (CACHE[data.param.elid].progressok) {
            CACHE[data.param.elid].__dataSource.rp = ['progressok'];
            CACHE[data.param.elid].__dataSource.rp = ['progressok'];
            EventMgr.trigger('tabLoading', { tabId: data.tabId });
            EventMgr.trigger('ajaxRequest', CACHE[data.param.elid].__dataSource);
          } else {
            EventMgr.trigger('ajaxFormResponse', CACHE[data.param.elid]);
          }
          delete CACHE[data.param.elid];
        }
      }
    }
  }

  /**
   * Append Progressbar to form
   * @param {string} tabId
   * @param {string} html
   * @return {boolean}
   */
  function appendProgressBar(tabId, progressId,  html) {
    var progressChecker = App.Dom.byId(progressId),
        tabCont = App.Dom.byId('cont-' + tabId);
    if (!progressChecker) { return false; }
    App.Dom.addClass(tabCont, 'tab-content__progressbar_show');
    var progressbar = App.Dom.byId('cont-' + tabId + '-progressbar');
    if (progressbar === null) { return false; }
    progressbar.style.display = 'block';
    progressbar.innerHTML = html;
    progressbar = null;
    var defProgress = App.Dom.byId('cont-' + tabId + '-progressbar-default');
    if (defProgress === null) { return false; }
    defProgress.style.display = 'none';
    return true;
  }

  function progressBarSaveState(e, data) {
    // если wait прогресс уже пришел с ok
    if (ENDED_WAIT_PROGRESSBAR[data.progressid]) {
      data.progresstype = null;
      EventMgr.trigger('ajaxFormResponse', data);
    } else if (data && data.progressid) {
      CACHE[data.progressid] = data;
    }
   
  }

  function init() {
    EventMgr.bind('progressBarSaveState', progressBarSaveState);
    EventMgr.bind('progressBarResponse', renderProgressBar);
    EventMgr.bind('progressBarResponseFail', waitProgressBar);
  }

  return {
    init: init
  };

}(window, $, EventMgr, App, templates);

/**
 * Модуль кастомного мультиселекта
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 */
App.MultiSelect = function(window, $, EventMgr, App) {
  'use strict';
  var init = function() {
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__view-value',
        'click', listOpenHandler);
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__ul-choose li',
        'click', chooseElemHandler);
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__ul-view .b-mselect__unselect',
        'click', unChooseElemHandler);
   // EventMgr.on('#main-wrapper', '.mselect-av .b-input-btn_type_plus',
   //     'click', selectAllHandler);
   // EventMgr.on('#main-wrapper', '.mselect-av .b-input-btn_type_minus',
   //     'click', unSelectAllHandler);
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__item_select-all',
        'dblclick', unSelectAllHandler);
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__ul-view .b-mselect__item',
        'mouseover', checkSize);
    EventMgr.on('#main-wrapper', '.mselect-av .b-mselect__view-value',
        'keydown', keydownHandler);
    EventMgr.bind('selectValues', selectValues);
    EventMgr.bind('multiSelectUnselect', unSelectAllFromOut);
    EventMgr.bind('mselectUnselectByDepend', unselectByDepend);
  },

      listWrapperIdPostfix = '-ms-list-wrapper',

      listIdPostfix = '-ms-list',

      chooseListIdPostfix = '-ms-view',

      appDom = App.Dom,

      $body = function() {
        return $('body');
      },
      //show select options
      listOpenHandler = function(e) {
        var id = this.getAttribute('data-id'),
            list = appDom.byId(id + listWrapperIdPostfix),
            bodyHeight, elemHeight, formTop, elemTop, tabId, form;
        if (e.target && e.target.className.match('scrlbr')) {
          return;
        }
        if (list) {
          if (list.offsetWidth === 0) {
            //for close other list
            $('body').trigger('click');
            bodyHeight = window.document.body.offsetHeight;
            appDom.removeClass(list, 'closed');
            //calculate list options position
            elemHeight = list.offsetHeight;
            list.style.top = '';
            elemTop = $(list).offset().top;
            if ((bodyHeight - elemTop) < elemHeight) {
              tabId = list.getAttribute('data-tabid');
              form = $('#form-scroll-' + tabId);
              formTop = form.offset().top;
              if (formTop > (elemTop - elemHeight - appDom.byId(id + '-ms-view').offsetHeight)) {
                list.style.top = '-' + (elemHeight / 2) + 'px';
              } else {
                list.style.top = '-' + elemHeight + 'px';
              }
            }
            $body().on('click', listCloseHandler);
            e.stopPropagation();
            EventMgr.trigger('updateScroll', { id: id + listIdPostfix });
          } else {
            appDom.addClass(list, 'closed');
            EventMgr.off('body', 'click');
            $body().off('click', listCloseHandler);
          }
        }
      },
      //close select options
      listCloseHandler = function(e) {
        if (e.target) {
          if (!appDom.hasClass(e.target, 'b-mselect__item') &&
              !appDom.hasClass(e.target, 'scrlbr')) {
            closeList();
          } else {
            return;
          }
        }
        $body().off('click', listCloseHandler);
        e.stopPropagation();
      },
      //
      closeList = function(id) {
        var elems, selected;
        if (typeof id === 'string') {
          elems = $('#' + id + '-ms-list-wrapper');
        } else {
          elems = $('.b-mselect__options');
        }
        elems.addClass('closed');
        //remove selected hightlight
        if (typeof id === 'string') {
          selected = $('#' + id + '-ms-list-ul')
              .find('.b-mselect__item_st_selected');
        } else {
          selected = $('.b-mselect__item_st_selected');
        }
        selected.removeClass('b-mselect__item_st_selected');
      },

      checkAllSelectedElem = function(id) {
        var $items = $('#' + id + '-ms-list-ul'),
            selectedCount = $items.find('.chosen').length,
            allCount = $items.find('.b-mselect__item').length - 1;
        return {
          selectedCount: selectedCount,
          allCount: allCount,
          allSelected: allCount === selectedCount
        };
      },

      chooseElemHandler = function(e, data) {
        var clone = this.cloneNode(true),
            id = this.parentNode.getAttribute('data-id'),
            clist = App.Dom.byId(id + chooseListIdPostfix),
            maxSelect = clist.getAttribute('data-maxselect'),
            selectedObj = checkAllSelectedElem(id),
            selectedCount = selectedObj.selectedCount,
            preventChange = data ? data.preventChange ?  true : false : false;
        maxSelect = (maxSelect === '') ? 9999 : parseInt(maxSelect, 10);
        if (selectedCount === maxSelect) {
          //closeList(id);
          return;
        }

        //check for selected
        if (appDom.hasClass(this, 'b-mselect__item_select-all')) {
          if (selectedObj.allSelected) {
            unSelectAllValues(id);
          } else {
            selectAllValues(id);
          }
        } else if (appDom.hasClass(this, 'chosen')) {
          appDom.removeClass(this, 'chosen');
          $('.b-mselect__item[data-s-id="' + clone.id + '"] .b-mselect__unselect').trigger('click');
        } else {
          clone.setAttribute('data-s-id', clone.id);
          clone.id = '';
          if (!clist) { return; }
          appDom.addClass(this, 'chosen');
          appDom.addClass(clone, 'chosen');
          clist.appendChild(clone);
          setValue(id, preventChange);
        }
      },

      unChooseElemHandler = function(e) {
        var elem = this.parentNode,
            sid = elem.getAttribute('data-s-id'),
            sElem = appDom.byId(sid),
            id = sElem.parentNode.getAttribute('data-id');
        elem.parentNode.removeChild(elem);
        appDom.removeClass(sElem, 'chosen');
        setValue(id);
       // closeList(id);
        e.stopPropagation();
      },

      unSelectAllHandler = function(e) {
        var id = this.getAttribute('data-id');
        unSelectAllValues(id);
        e.preventDefault();
      },

      unSelectAllFromOut = function(e, data) {
        var id = data.id;
        unSelectAllValues(id);
      },
      //unselect all values
      unSelectAllValues = function(id) {
        $('#' + id + '-ms-view .b-mselect__item.chosen').remove();
        $('#' + id + '-ms-list-ul .chosen').removeClass('chosen');
        setValue(id);
      },

      selectAllHandler = function(e) {
        var id = this.getAttribute('data-id');
        selectAllValues(id);
        e.preventDefault();
      },
      //select all values
      selectAllValues = function(id) {
        var elems = $('#' + id + '-ms-list-ul .b-mselect__item'),
            l = elems.length, clone,
            clist = App.Dom.byId(id + chooseListIdPostfix),
            maxSelect = clist.getAttribute('data-maxselect'),
            selectedCount = $('#' + id + '-ms-list-ul li.chosen').length;
        maxSelect = (maxSelect === '') ? 9999 : parseInt(maxSelect, 10);
        for (var i = 0; i < l; i++) {
          if (selectedCount === maxSelect) {
            break;
          }
          if (appDom.hasClass(elems[i], 'dependelem') &&
             !appDom.hasClass(elems[i], 'b-myselect__select-li_show_yes')) {
            continue;
          }
          if (appDom.hasClass(elems[i], 'b-mselect__item_select-all')) {
            continue;
          }
          if (!appDom.hasClass(elems[i], 'chosen')) {
            clone = elems[i].cloneNode(true);
            clone.setAttribute('data-s-id', clone.id);
            clone.id = '';
            appDom.addClass(elems[i], 'chosen');
            appDom.addClass(clone, 'chosen');
            clist.appendChild(clone);
            selectedCount++;
          }
        }
        setValue(id);
      },

      //setvalue when change
      setValue = function(id, preventChange) {
        var elem = appDom.byId(id + chooseListIdPostfix),
            cElems = elem.children,
            l = cElems.length,
            val,
            value = '',
            input = appDom.byId(id + '-ms-value'),
            wrapper = appDom.byId(id + '-ms'),
            scrollId = $(wrapper).find('.b-mselect__view-value').attr('id'),
            tabId = elem.getAttribute('data-tabId');
        if (l !== 1) {
          while (l--) {
            val = cElems[l].getAttribute('data-val');
            value += val;
            if (l !== 1) {
              value += ',';
            } else {
              break;
            }
          }
        } else {
          value = '';
        }

        input.value = value;
        if (value === '') {
          appDom.removeClass(wrapper, 'selected');
        } else {
          appDom.addClass(wrapper, 'selected');
        }
        if (!preventChange) {
          $(input).trigger('change');
        }
        EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
        EventMgr.trigger('updateScroll', { id: scrollId });
      },
      //apply setvalues
      selectValues = function(e, data) {
        var id = data.id,
            slist = data.sElems.slist,
            values = data.sElems.value !== undefined ? data.sElems.value : data.sElems,
            l = values.length,
            elem,
            maxSelect = $('#' + id + '-ms-view').attr('data-maxselect');
        maxSelect = (maxSelect === '') ? 9999 : parseInt(maxSelect, 10);
        if (slist) {
          $('#' + id + '-ms-list-ul').html(renderMultiSelectValues(slist, id));
        }
        $('#' + id + '-ms').removeClass('selected');
        $('#' + id + '-ms-list-ul li.chosen').removeClass('chosen');
        $('#' + id + '-ms-view li.chosen').remove();
        if (typeof values === 'string' && values !== '') {
          elem = $('#' + id + '-ms-list-ul li[data-val="' + values + '"]')
              .trigger('click');
        } else {
          if (maxSelect < l) { l = maxSelect; }
          for (var i = 0; i < l; i++) {
            if (i === l - 1) {
              elem = $('#' + id + '-ms-list-ul li[data-val="' + values[i] + '"]')
                .trigger('click', { 'preventChange': false });
            } else {
               elem = $('#' + id + '-ms-list-ul li[data-val="' + values[i] + '"]')
                .trigger('click', { 'preventChange': true });
            }
          }
        }

      },

      unselectByDepend = function(e, data) {
        var self = data.self;
        $(self).find('.b-mselect__ul-view .dependelem:not(".b-myselect__select-li_show_yes") .b-mselect__unselect').each(function() {
          $(this).trigger('click');
        });

      },
      //render options for setvalues
      renderMultiSelectValues = function(slist, id) {
        var html = '',
            l = slist.length;

        html += '<li class="b-mselect__item b-mselect__item_select-all">' + pageInfo.messages.msg_select_all + '</li>';
        for (var i = 0; i < l; i++) {
          html += '<li class="b-mselect__item" data-val="' +
              slist[i].key + '" unselectable="on" data-handler-val="' +
              hash(slist[i].key) + '"  data-dependkey="' +
              slist[i].depend + '" id="' + id + '-' + i + '">' +
              slist[i].value + '<span class="b-mselect__unselect"></span></li>';
        }
        return html;
      },

      UPKEY = 38,
      DOWNKEY = 40,
      LEFTKEY = 37,
      RIGHTKEY = 39,
      ENTERKEY = 13,
      TABKEY = 9,
      ESCKEY = 27,
      SPACE = 32,

      keydownHandler = function(e) {
        var codeKey = e.which || e.keyCode,
            ctrlKey = e.metaKey || e.ctrlKey,
            closed = appDom.hasClass(appDom.byId(this.getAttribute('data-id') +
                listWrapperIdPostfix), 'closed');
        //go up
        if (codeKey === UPKEY && !closed) {
          selectPrevOption.apply(this, []);
          //go down
        } else if (codeKey === DOWNKEY && !closed) {
          selectNextOption.apply(this, []);
          //close tab
        } else if (codeKey === TABKEY && !closed) {
          closeList();
          //choose selected value & close select or not?
        } else if ((codeKey === ENTERKEY || codeKey === SPACE) && !ctrlKey) {
          if (closed) {
            listOpenHandler.apply(this, [e]);
          } else {
            chooseSelected.apply(this, [e]);
          }
          //close list
        } else if (codeKey === ESCKEY && !closed) {
          e.stopPropagation();
          closeList();
        }
      },

      selectPrevOption = function() {
        var id = this.getAttribute('data-id'),
            $list = $('#' + id + '-ms-list-ul'),
            selElem = $list.find('.b-mselect__item_st_selected'),
            prev = true,
            prevElem = selElem;
        if (selElem.length > 0) {
          while (prev) {
            prevElem = prevElem.prev();
            if (prevElem.length > 0) {
              prev = prevElem.hasClass('chosen');
            } else {
              prevElem = null;
              prev = false;
            }
          }
          if (prevElem) {
            selElem.removeClass('b-mselect__item_st_selected');
            prevElem.addClass('b-mselect__item_st_selected');
          }
        } else {
          selElem = $list.find('.b-mselect__item:first:not(".chosen")');
          selElem.addClass('b-mselect__item_st_selected');
        }
      },

      selectNextOption = function() {
        var id = this.getAttribute('data-id'),
            $list = $('#' + id + '-ms-list-ul'),
            selElem = $list.find('.b-mselect__item_st_selected'),
            nextElem = selElem,
            next = true;
        if (selElem.length > 0) {
          while (next) {
            nextElem = nextElem.next();
            if (nextElem.length > 0) {
              next = nextElem.hasClass('chosen');
            } else {
              nextElem = null;
              next = false;
            }
          }
          if (nextElem) {
            selElem.removeClass('b-mselect__item_st_selected');
            nextElem.addClass('b-mselect__item_st_selected');
          }
        } else {
          selElem = findFirst($list);
          if (selElem) {
            selElem.addClass('b-mselect__item_st_selected');
          }
        }
      },

      findFirst = function($list) {
        var finding = true,
            first = $list.find('.b-mselect__item:first');
        while (finding) {
          if (first.length > 0) {
            if (first.hasClass('chosen')) {
              first = first.next();
              finding = true;
            } else {
              return first;
            }
          } else {
            return false;
          }
        }
      },

      chooseSelected = function(e) {
        var id = this.getAttribute('data-id'),
            selected = $('#' + id + '-ms-list-ul')
              .find('.b-mselect__item_st_selected');
        if (selected.length > 0) {
          selected.trigger('click');
        } else {
          closeList(id);
        }
      },

      checkSize = function() {
        if (App.Dom.hasClass(this, 'overwidth') ||
            App.Dom.hasClass(this, 'notoverwidth')) {
          return;
        }
        if (this.scrollWidth > this.offsetWidth) {
          App.Dom.addClass(this, 'overwidth');
          $(this).trigger('mouseover');
        } else {
          App.Dom.addClass(this, 'notoverwidth');
        }
      };

  return {
    init: init
  };
}(window, $, EventMgr, App);

/**
 * Select Module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.Select = function(window, $, EventMgr, App) {
  'use strict';

  var UPKEY = 38,
      DOWNKEY = 40,
      LEFTKEY = 37,
      RIGHTKEY = 39,
      ENTERKEY = 13,
      TABKEY = 9,
      ESCKEY = 27,
      SPACE = 32,
      //wrapper for select
      selectSelector = '.b-myselect:not(".readonly")' +
          ' .b-myselect__select-selected',
      //wrapper for select item
      selectItemSelector = '.b-myselect:not(".readonly")' +
          ' .b-myselect__select-li',
      selectKeySelector = '.b-myselect:not(".readonly")' +
          ' .b-myselect__select-selected,' +
          ' .b-myselect:not(".readonly") .sb-input',
      CACHE = {},
      CACHEOPENEDSELECT = {},

      dependSlistSelector = '.depend.b-myselect input[type="hidden"],' +
          ' .depend.b-select-ac input[type="hidden"],' +
          ' .depend.b-radio input[type="hidden"]';

  function $body() {
    return $('body');
  }

  function getActiveTabId() {
    return ($('.tab-content_st_active').attr('data-tabid') || false);
  }
  //flag for active select list
  function $content() {
    return App.Common.selectorCache('.i-form-wr');
  }

  function $selectCont(id) {
    if (id) {
      return $('#' + id + '.b-myselect');
    } else {
      return $('.b-myselect');
    }
  }

  //add /remove handler for body, for close selectlist
  function addRemoveHandlerForBody(add) {
    if (add) {
      $body().on('click', bodyHandlerClick);
    } else {
      $body().off('click', bodyHandlerClick);
    }
  }

  function closeOtherSelectList(tabId, click) {
    if (!tabId) {
      tabId = getActiveTabId();
    }
    if (CACHEOPENEDSELECT[tabId] && CACHEOPENEDSELECT[tabId].removeClass) {
      CACHEOPENEDSELECT[tabId].addClass('b-myselect_st_close')
          .removeClass('b-myselect_st_open');
      addRemoveHandlerForBody();
    }
  }

  function bodyHandlerClick(e) {
    if (e) {
      var scrElemClass = e.srcElement ?
              e.srcElement.className : e.target ? e.target.className : '',
          scrollFlag = scrElemClass.indexOf('scrlbr'),
          highlightFlag = scrElemClass.indexOf('highlight');
      if (scrollFlag === -1 && highlightFlag === -1) {
        closeOtherSelectList();
      }
    } else {
      //what is it?!
      e.stopPropagation();
    }
  }
  //click for select
  function selectListHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    var id = this.getAttribute('data-id'),
        $selectContVar = $selectCont(id),
        ids, searchBox,
        tabId = getActiveTabId(), keySymbol, r;
    //check current state option list
    if (!$selectContVar.hasClass('b-myselect_st_open')) {
      $('body').trigger('click');
      closeOtherSelectList(tabId);
      $selectContVar
          .removeClass('b-myselect_st_close')
          .addClass('b-myselect_st_open');
      //set optionlist position
      App.Common.setOptionListPosition('#opt', id);

      ids = $selectContVar.find('.b-myselect__select-list').attr('id');
      EventMgr.trigger('updateScroll', { id: ids });
      addRemoveHandlerForBody(true);
      //set focus on searchbox
      if (this.parentNode.className.match('sb-select')) {
        searchBox = App.Dom.byId('sb-' + ids);
        if (searchBox) {
          //try guess symbol of pressed key
          if (e && e.originalEvent) {
            if (e.originalEvent.key) {
              keySymbol = e.originalEvent.key;
              if (keySymbol.length > 1) {
                keySymbol = null;
              }
            }
          }
          searchBox.value = keySymbol || '';
          setTimeout(function() {
            findElemsInSelect.apply(searchBox, [{ codeKey: 'ololo' }]);
          }, 1);
          searchBox.focus();
          //set cursor after 1st symbol
          if (keySymbol) {
            if (searchBox.setSelectionRange) {
              searchBox.setSelectionRange(1, 1);
            } else {
              r = searchBox.createTextRange();
              r.collapse(true);
              r.select(1, 1);
            }
          }
          window.scrollToTopLeft();
        }
      }
      CACHEOPENEDSELECT[tabId] = $selectContVar;
    } else {
      $selectContVar
          .removeClass('b-myselect_st_open')
          .addClass('b-myselect_st_close');
      delete CACHEOPENEDSELECT[tabId];
      addRemoveHandlerForBody(false);
      this.childNodes[1].focus();
      window.scrollToTopLeft();
    }
  }

  //select item handler
  function setSelectedValue(e, sv, close) {
    var self = $(this),
        val = this.getAttribute('data-val'),
        handlerVal = this.getAttribute('data-handler-val'),
        content = self.html(),
        id = self.parent().attr('data-id'),
        currentSelect = $('#' + id + ' .b-myselect__select-value');
    if (self.hasClass('group')) {
      return;
    }
    $('input#' + id + '-val').val(val)
        .attr('data-handler-val', handlerVal).trigger('change', [sv, close]);
    //if it clone from search - search self made it
    if (!self.hasClass('b-myselect__select-li_clone_true')) {
      self.addClass('selected').siblings().removeClass('selected');
    } else if (!e) {
      //up/down keydown
      self.addClass('selected')
          .siblings().removeClass('selected');
      self.trigger('customclick');
      content = self.siblings('.selected')
          .find('.b-myselect__option-value').html();
    }
    currentSelect.html(content);
    if (close !== false) {
      $body().trigger('click');
      if (e && !e.isTrigger) {
        currentSelect.focus();
        window.scrollToTopLeft();
      }
    }
    EventMgr.trigger('selectChange', { id: id });
  }

  //идем по селекту вниз downkey
  function selectListNext(e) {
    var tabId = getActiveTabId(),
        id = this.getAttribute('data-id'),
        l,
        currentLi = $('#' + id + ' li.selected'),
        nextLi = currentLi.next(),
        next = true,
        closed = currentLi.parent()[0].offsetWidth ? false : true;
    if (!currentLi[0].offsetWidth && !closed) {
      currentLi = $('#' + id + ' li[style$="display: block;"]');
      l = currentLi.length;
      if (l > 0) {
        setSelectedValue.apply(currentLi[0], [false, false, false]);
        return;
      }
    }
    while (next) {
      if (nextLi.length === 0) {
        return;
        //detect showed elements by class 'show'
      } else if (nextLi[0].offsetWidth && !closed) {
        next = false;
      } else if (closed && nextLi[0].className.match('b-myselect__select-li_show_yes')) {
        next = false;
      } else {
        nextLi = nextLi.next();
      }
    }
    setSelectedValue.apply(nextLi[0], [false, false, false]);
    var offsetTop = nextLi[0].offsetTop,
        scrollId = 'cont-' + id;

    //if (offsetTop != 0) {
    ScrollHandler.forceMoveSelectItem(scrollId, offsetTop);
    //}
  }

  //идем по селекту вверх upkey
  function selectListPrev() {
    var tabId = getActiveTabId(),
        id = this.getAttribute('data-id'),
        l,
        currentLi = $('#' + id + ' li.selected'),
        prevLi = currentLi.prev(),
        prev = true,
        closed = currentLi.parent()[0].offsetWidth ? false : true;
    if (!currentLi[0].offsetWidth && !closed) {
      currentLi = $('#' + id + ' li[style$="display: block;"]');
      l = currentLi.length;
      if (l > 0) {
        setSelectedValue.apply(currentLi[l - 1], [false, false, false]);
        return;
      }

    }
    while (prev) {
      if (prevLi.length === 0) {
        return;
        //detect showed elements by class 'show'
      } else if (prevLi[0].offsetWidth && !closed) {
        prev = false;
      } else if (closed && prevLi[0].className.match('b-myselect__select-li_show_yes')) {
        prev = false;
      } else {
        prevLi = prevLi.prev();
      }
    }

    setSelectedValue.apply(prevLi[0], [false, false, false]);
    var offsetTop = prevLi[0].offsetTop,
        scrollId = 'cont-' + id;

    //if (offsetTop !== 0) {
    ScrollHandler.forceMoveSelectItem(scrollId, offsetTop);
    //}
  }

  //обработчик клавишных нажатий по селекту
  function selectListKeyDownHandler(e) {
    var codeKey = e.which || e.keyCode,
        tabId = this.getAttribute('data-tabid'),
        listOpened = !!CACHEOPENEDSELECT[tabId];
    //by ENTER and SPACE
    if ((codeKey === ENTERKEY || codeKey === SPACE) &&
        !e.ctrlKey && this.type !== 'text') {
      e.preventDefault();
      selectListHandler.apply(this, [e]);
      //by ENTER and SPACE search field
    } else if (codeKey === ENTERKEY && !e.ctrlKey && this.type === 'text') {
      selectFindFirstElem(this);
      e.preventDefault();
      //by TABKEY when openlist
    } else if ((codeKey === TABKEY || codeKey === ESCKEY) && listOpened) {
//      e.preventDefault();
//      closeSelectList(e, true);
      e.stopPropagation();
      closeOtherSelectList(false, true);
      //UP or LEFT when list opened
    } else if ((codeKey === UPKEY || codeKey === LEFTKEY) &&
        ! listOpened && !e.ctrlKey && this.type !== 'text') {
      e.preventDefault();
      selectListPrev.apply(this, [e]);
      //DOWN or RIGHT list opened
    } else if ((codeKey === DOWNKEY || codeKey === RIGHTKEY) &&
        ! listOpened && !e.ctrlKey && this.type !== 'text') {
      e.preventDefault();
      selectListNext.apply(this, [e]);
      //DOWN when list closed
    } else if (codeKey === DOWNKEY && listOpened && !e.ctrlKey) {
      e.preventDefault();
      selectListNext.apply(this, [e]);
      //UP when list closed
    } else if (codeKey === UPKEY && listOpened && !e.ctrlKey) {
      e.preventDefault();
      selectListPrev.apply(this, [e]);
      //Open by any symbol
    } else if (this.type !== 'text' && codeKey > 32) {
      selectListHandler.apply(this, [e]);
    }
  }

  function selectFindFirstElem(self) {
    var id, sElem, selElem,
        currentSelect;
    id = self.getAttribute('data-id');
    sElem = $('#' + id);
    if (sElem.length === 0) { return; }
    selElem = sElem.find('li.selected:visible');
    if (selElem.length !== 0) {
      selElem.trigger('click');
    } else {
      selElem = sElem.find('li:visible:first');
      if (selElem.length !== 0) {
        selElem.trigger('click');
      } else {
        $('body').trigger('click');
      }
    }
    //set focus on select
    currentSelect = $('#' + sElem.attr('data-id') +
        ' .b-myselect__select-value');
    currentSelect.focus();
    window.scrollToTopLeft();
  }

  var matchesElems = {};
  //поиск по селекту
  function findElemsInSelect(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode;
    if (codeKey === UPKEY || codeKey === DOWNKEY || TABKEY === codeKey) {
      return;
    }
    var value, id, sElem, sElems, len, regEx, words, wLen,
        find, inner, searchAll = true, optListId,
        curElem, selElems, tabId, matches, listParent;
    value = this.value.toLowerCase();

    value = App.u.escapeRegExp(value);
    id = this.getAttribute('data-id');
    sElem = App.Dom.byId(id);
    if (!sElem) { return; }
    var $sElem = $(sElem);
    optListId = String(sElem.getAttribute('data-id'));
    sElems = sElem.children;
    len = sElems.length;
    tabId = this.getAttribute('data-tabId');
    //cache html nodes
    if (!CACHE[tabId]) {
      CACHE[tabId] = {};
    }
    if (!CACHE[tabId][id]) {
      sElems = sElem.children;
      selElems = [];
      var l = sElems.length,
          t1, pushed,
          clone;
      while (l--) {
        clone = sElems[l].cloneNode(true);
        clone.className += ' b-myselect__select-li_clone_true';
        t1 = $(clone).find('.b-myselect__option-value');
        /* jslint loopfunc:true */
        pushed = selElems.push({
          node: sElems[l],
          clone: clone,
          innerNode: t1,
          inner: t1.html(),
          bindClick: function() {
            var $clone = $(this.clone);
            $clone.bind('click', $.proxy(function(e) {
              this.returnDefValue();
              var $node = $(this.node);
              $node.addClass('selected')
                  .siblings().removeClass('selected');
              //for unknow reasons it doesn't bubble to parent li
              //force click
              if (e) {
                var scrElemClass = e.srcElement ?
                    e.srcElement.className : e.target ? e.target.className : '';
                if (scrElemClass.indexOf('highlight') === 0) {
                  $node.trigger('click');
                }
              }
            }, this));

            $clone.bind('customclick', $.proxy(function() {
              var $node = $(this.node);
              $node.addClass('selected');
            }, this));
          },
          returnDefValue: function() {
            if (this.isMatched) {
              this.innerNode.html(this.inner);
            }
            this.isMatched = false;
          }
        });
        /* jslint loopfunc:false */
        selElems[pushed - 1].bindClick();
        CACHE[tabId][id] = selElems;
      }
    } else {
      selElems = CACHE[tabId][id];
      len = selElems.length;
    }
    if (value === '') {
      //show all elems in list
      $sElem.removeClass('b-myselect__select-ul_searching_true');
      hideElement(matchesElems[id]);
      scrollToSelectedElement(sElem, id);
      EventMgr.trigger('updateScroll', { id: 'cont-' + id });
      return;
    } else {
      $sElem.addClass('b-myselect__select-ul_searching_true');
    }
    if (!searchAll) {
      regEx = new RegExp('^' + value);
    } else {
      regEx = new RegExp(value);
    }

    var wordLowerCase = '';
    matchesElems[id] = [];

    while (len--) {
      curElem = selElems[len];
      curElem.returnDefValue();
      inner = curElem.inner;
      words = inner.split(' ');
      wLen = words.length;
      find = false;
      while (wLen--) {
        wordLowerCase = words[wLen].toLocaleLowerCase();
        matches = wordLowerCase.match(regEx);
        if (matches) {
          selElems[len].isMatched = true;
          selElems[len].searchIndex = wordLowerCase.indexOf(matches[0]) +
              Math.pow(10, wLen);
          find = true;
          words[wLen] = addHightLight(value, words[wLen], searchAll);
          matchesElems[id].push(selElems[len]);
        }
      }
      if (!find) {
        hideElement(curElem);
      } else {
        showElement(curElem);
        curElem.innerNode.html(words.join(' '));
      }
    }
    //sort result of find

    if (matchesElems[id].length > 0) {
      var lMatchesElems = matchesElems[id];
      lMatchesElems.sort(sortMatches);
      listParent = $(sElem);
      var mLen = lMatchesElems.length;
      while (mLen--) {
        listParent.prepend(lMatchesElems[mLen].clone);
      }
    }
    EventMgr.trigger('updateScroll', { id: 'cont-' + id });
    ScrollHandler.scrollTo('cont-' + id, 0);
    App.Common.setOptionListPosition('#opt', optListId);
  }

  function sortMatches(a, b) {
    if (b.searchIndex === a.searchIndex) { return 0; }
    if (b.searchIndex < a.searchIndex) { return 1; } else { return -1; }
  }

  function scrollToSelectedElement(sElem, id) {
    var top,
        selectedElem;
    selectedElem = $(sElem)
        .find('.selected:not(".b-myselect__select-li_clone_true")');
    if (selectedElem.length) {
      top = selectedElem[0].offsetTop;
      setTimeout(function() {
        ScrollHandler.scrollTo('cont-' + id, top);
      }, 1);
    }
  }

  //показываем элемент или элементы в селекте
  function showElement(elem) {
    if (!elem) { return; }
    var len = elem.length;
    if (len) {
      while (len--) {
        if (elem[len].clone.className.match('b-myselect__select-li_show_yes')) {
          elem[len].clone.style.display = 'block';
        } else {
          elem[len].clone.style.display = 'none';
        }
      }
    } else {
      if (elem.clone) {
        if (elem.clone.className.match('b-myselect__select-li_show_yes')) {
          elem.clone.style.display = 'block';
        } else {
          elem.clone.style.display = 'none';
        }
      }
    }
  }

  //скрываем элемент или элементы в селекте
  function hideElement(elem) {
    if (!elem) { return; }
    var len = elem.length;
    if (len) {
      while (len--) {
        elem[len].clone.style.display = 'none';
      }
    } else {
      if (elem.clone) {
        elem.clone.style.display = 'none';
      }
    }
  }
  //добавляем выделение
  function addHightLight(rep, value, searchAll) {
    var re, elemValue;
    if (!searchAll) {
      re = rep ? new RegExp('(^' + rep + ')', 'i') : false;
    } else {
      re = rep ? new RegExp('(' + rep + ')', 'i') : false;
    }
    elemValue = value.replace(re, '<span class="highlight">$1</span>');
    return elemValue;
  }

  function dependSlistHandler() {
    var value = this.value,
        name = this.getAttribute('name'),
        type = this.getAttribute('data-type'),
        tabId = this.getAttribute('data-tabid'),
        elem,
        selectElem, showElem, $dependSelect;
    //hide select options
    $dependSelect = $('#frm-' + tabId + ' div[data-depend="' + name + '"]');
    if ($dependSelect.length > 1) {
      $dependSelect.each(function() {
        var $self = $(this);
        selectElem = $self.find('li.dependelem[data-dependkey="' + value + '"].selected.b-myselect__select-li_show_yes');
        dependSlistCheckSelected(selectElem, $self);
      });
    } else {
      selectElem = $dependSelect.find('li.dependelem[data-dependkey="' + value + '"].selected.b-myselect__select-li_show_yes');
      dependSlistCheckSelected(selectElem, $dependSelect);
    }
    //unselect option
    //showElem = $dependSelect.find('li.dependelem[data-dependkey="' + value + '"].show');
    //if (showElem.length === 0) {
    //  $dependSelect
    //      .closest('l-form__row').css('display', 'none');
    //} else {
    //  $dependSelect
    //      .closest('l-form__row').css('display', '');
    //}
    //set first value or prev key
    EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
  }

  function dependSlistCheckSelected(selectElem, $dependSelect) {
    if (selectElem.length === 0) {
      var id = $dependSelect.attr('id'),
          prevValue = $('#' + id + '-val').val();

      $dependSelect.find('li').removeClass('selected');
      var elem = $dependSelect.find('li.b-myselect__select-li_show_yes[data-val="' + prevValue + '"]')[0] ||
         $dependSelect.find('li.b-myselect__select-li_show_yes')[0];

      if (elem) {
        setSelectedValue.apply(elem);
      } else {
        //console.log('alarm!!! no elem');
      }
    }
  }

  /**
   * Clean cache if slist changed by setvalues
   * @param {object} e
   * @param {object} data
   */
  function cleanSlistCache(e, data) {
    var id = data.id,
        tabId = data.tabId;
    if (CACHE && CACHE[tabId] && CACHE[tabId][id]) {
      delete CACHE[tabId][id];
    }
  }

  function init() {
    //select
    EventMgr.on($content(), selectSelector, 'click', selectListHandler);
    EventMgr.on($content(), selectKeySelector,
        'keydown', selectListKeyDownHandler);
    EventMgr.on($content(), selectItemSelector, 'click', setSelectedValue);
    EventMgr.on($content(), '.sb-input', 'keyup', findElemsInSelect);
    EventMgr.on($content(), dependSlistSelector, 'change', dependSlistHandler);
    EventMgr.bind('cleanSlistCache', cleanSlistCache);
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Alert module
 * shows alert message
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @return {object} api
 */
App.Alert = function(window, $, EventMgr) {
  'use strict';
  var init = function() {
    EventMgr.bind('showAlert', showAlert);
    EventMgr.obind($modalBtn(), 'click', hideAlert);
  },

      $body = function() {
        return $('body');
      },

      $modalMsg = function() {
        return $('#modal_alert_message');
      },

      $modalBtn = function() {
        return $('#modal_alert_ok');
      },

      callback = null,

      himself = null,

      param = null,

      activeClass = 'active-modal-alert',

      showAlert = function(e, data) {
        var msg = data.msg,
            closeTimeout = data.closeTimeout,
            modalMsg = $modalMsg(),
            textarea;
        callback = data.callback || null;
        himself = data.himself || window;
        param = data.param;
        modalMsg.html(msg);
        $body().addClass(activeClass);
        setTimeout(function() {
          textarea = modalMsg.find('.b-textarea');
          if (textarea.length) {
            textarea.select();
          } else {
            $modalBtn().focus();
          }
        }, 1);

        if (closeTimeout) {
          setTimeout(function() {
            hideAlert();
          }, closeTimeout);
        }
      },

      hideAlert = function() {
        $body().removeClass(activeClass);
        if (callback !== null) {
          callback.apply(himself, [param]);
        }
      };

  return {
    init: init
  };
}(window, $, EventMgr);

/**
 * Calendar module
 *
 * show calendar
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} em EventMgr library
 */
App.Calendar = function(window, $, em) {
  'use strict';
  function init() {
    loadMessages();
  }

  function addListeners() {
    em.on($calCont(), toolsSelector, 'click', toolMouseupRep);
    em.on($calCont(), calMonthSel, 'click', chooseMonthHandler);
    em.on($calCont(), daysSelector, 'click', daysMousedownRep);
    em.on($calCont(), calMonthSelector, 'mousedown', toolMousedownRep);
    em.on($calCont(), calYearSelector, 'mousedown', toolMousedownRep);
    em.on($calMonthCombo(), calComboboxSelector, 'mouseup', comboMouseupRep);
    em.on($calYearCombo(), calComboboxSelector, 'mouseup', comboMouseupRep);
    em.on($calYearCombo(), calComboboxSelector, 'mouseover', comboMouseover);
    em.on($calYearCombo(), calComboboxSelector, 'mouseout', comboMouseout);
    em.on($calMonthCombo(), calComboboxSelector, 'mouseover', comboMouseover);
    em.on($calMonthCombo(), calComboboxSelector, 'mouseout', comboMouseout);
    addedListener = true;
  }

  var addedListener = false,
      isIe = (/msie/i.test(navigator.userAgent) &&
      !/opera/i.test(navigator.userAgent)),
      clActive = false,
      clCalendar = null,
      clCalendarCell = null,
      clField = null,
      clDate = null,
      clTimeout = null,
      clTtool = null,
      clElYears = null,
      clElMonths = null,
      clElHead = null,
      clElDays = null,
      clElDaysTbody = null,
      clSyncField = null,
      clMsgMonths = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'],
      clMsgSmonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'],
      clMsgWdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      calMonthSelector = '#calmonth',
      calYearSelector = '#calyear',
      toolsSelector = '.cl-tool-td',
      daysSelector = 'td.cl-days',
      calComboboxSelector = ' div',
      calMonthSel = '.b-cal__month',
      pageInfo = window.pageInfo;

  function loadMessages() {
    var i;
    for (i = 0; i < 12; i++) {
      clMsgMonths[i] = pageInfo.calendar['m' + i];
      clMsgSmonths[i] = pageInfo.calendar['ms' + i];
    }
    for (i = 0; i < 7; i++) { clMsgWdays[i] = pageInfo.calendar['w' + i]; }
  }

  function $calCont() {
    return $('#calendar');
  }

  function $calMonthCombo() {
    return $('#calendar-m');
  }

  function $calYearCombo() {
    return $('#calendar-y');
  }

  function getHtmlNodes() {
    if (!clCalendar) {
      clCalendar = document.getElementById('calendar');
      if (!clCalendar) {
        clCalendar = document.createElement('div');
        clCalendar.setAttribute('class', 'cl');
        clCalendar.setAttribute('id', 'calendar');
        clCalendarCell = document.createElement('div');
        clCalendarCell.setAttribute('class', 'cl-cell');
        clCalendarCell.setAttribute('id', 'calendar-cell');
        clCalendar.appendChild(clCalendarCell);
        document.body.appendChild(clCalendar);
      }
    }
    if (!clCalendarCell) {
      clCalendarCell = document.getElementById('calendar-cell');
    }
    if (!clElYears) {
      clElYears = document.getElementById('calendar-y');
      if (!clElYears) {
        clElYears = document.createElement('div');
        clElYears.setAttribute('id', 'calendar-y');
        clElYears.setAttribute('class', 'cl-ym-y');
        document.body.appendChild(clElYears);
      }
    }
    if (!clElMonths) {
      clElMonths = document.getElementById('calendar-m');
      if (!clElMonths) {
        clElMonths = document.createElement('div');
        clElMonths.setAttribute('id', 'calendar-m');
        clElMonths.setAttribute('class', 'cl-ym-m');
        document.body.appendChild(clElMonths);
      }
    }
    if (!addedListener) {
      addListeners();
    }
  }

  function setPosition(e) {
    // Set position
    // Get object which fire even
    var obj = (e.target) ? e.target : e.srcElement,
        ipos = $(obj).offset(),
        windowWidth = window.innerWidth,
        windowHeight = window.innerHeight,
        cWidth = clCalendar.offsetWidth,
        cHeight = clCalendar.offsetHeight,
        x = ipos.left - cWidth + obj.offsetWidth,
        y = ipos.top + obj.offsetHeight - 1,
        diffY = windowHeight - (y + cHeight),
        diffX = windowWidth - (x + cWidth);
    if (diffX < 0) {
      x = windowWidth - cWidth;
    }
    if (diffY < 0) {
      y = ipos.top - cHeight;
    }
    if (isIe) { x += 1; }
    clCalendar.style.left = x + 'px';
    clCalendar.style.top = y + 'px';
    clCalendar.style.visibility = 'visible';
    clActive = true;
  }

  var calTempl = '<div class="b-cal">' +
      '<div class="b-cal__head cl-head">' +
      '<div class="cl-tool-td" id="prevY"><div class="t-inner"></div></div>' +
      '<div class="cl-tool-td" id="calyear">{{=it.cYear}}</div>' +
      '<div class="cl-tool-td" id="nextY"><div class="t-inner"></div></div>' +
      '<div class="cl-tool-td b-cal__today" id="curMonth"></div>' +
      '</div>' +
      '<div class="cl-days-wrapper b-cal__month-wrapper">' +
      '{{~it.months :value :index}}' +
      '<div class="b-cal__month ' +
          '{{?index === it.month}}b-cal__month_selected{{?}}"' +
          ' data-value="{{=index}}">' +
      '{{=value}}' +
      '</div>' +
      '{{~}}' +
      '</div>' +
      '</div>',
      calTemplFunc = window.doT.template(calTempl);

  /**
   * show Month calendar
   * @param {object} field current field HTML node
   * @param {object} syncField HTML node
   * @param {object} e event object
   */
  function showMonthCal(field, syncField, e) {

    getHtmlNodes();

    buildComboBox();

    document.onmousedown = checkOutclick;

    clField = field;
    clSyncField = syncField;
    clDate = parseDate(field.value, true);

    var html = calTemplFunc({
      cYear: clDate.getFullYear(),
      months: clMsgMonths,
      month: clDate.getMonth()
    });

    clCalendar.setAttribute('data-type', 'month');

    clCalendarCell.innerHTML = html;

    setPosition(e);
  }

  function chooseMonthHandler(e) {
    e.preventDefault();
    if (!this) { return; }
    var month = this.getAttribute('data-value'),
        year = clDate.getFullYear();
    month -= 0;
    setMonth(year, month + 1);
    hide();
  }

  function showRep(field, syncField, e) {
    e = e || window.event;

    getHtmlNodes();

    // Register events
    document.onmousedown = checkOutclick;

    // Parse field date
    clField = field;
    clSyncField = syncField;
    clDate = parseDate(clField.value);

    // Draw calendar
    drawCalendarRep();
    drawDateRep(clDate);

    setPosition(e);
  }

  function hideRep() {
    if (!clCalendar) { clCalendar = document.getElementById('calendar'); }
    document.onmouseup = null;
    document.onmousedown = null;
    clCalendar.style.visibility = 'hidden';
    clActive = false;
  }

  function buildComboBox() {
    // COMBO BOXES
    if (clElYears.innerHTML !== '') { return; }
    var i;
    for (i = 0; i < 12; i++) {
      var elDiv = document.createElement('div');
      elDiv.id = 'ycombo' + i;
      elDiv.className = (i % 2 === 0) ? 'cl-ym-div' : 'cl-ym-diveven';
      elDiv.innerHTML = 'y ' + i;

      clElYears.appendChild(elDiv);

      elDiv = document.createElement('div');
      elDiv.id = 'mcombo' + i;
      elDiv.className = (i % 2 === 0) ? 'cl-ym-div' : 'cl-ym-diveven';
      elDiv.innerHTML = 'm ' + i;

      clElMonths.appendChild(elDiv);
    }
    // COMBO BOXES
  }

  function drawCalendarRep() {
    if (clElHead && clCalendar.getAttribute('data-type') === 'default') {
      return;
    }
    var i;
    clCalendarCell.innerHTML = '';
    // HEAD
    clElHead = document.createElement('div');
    clElHead.className = 'cl-head';

    clCalendarCell.appendChild(clElHead);
    clCalendar.setAttribute('data-type', 'default');
    clElHead.innerHTML = '';
    //HEAD

    buildComboBox();
    // TOOLBAR and DAYS
    var elWrDays = document.createElement('div');
    elWrDays.className = 'cl-days-wrapper';
    clCalendarCell.appendChild(elWrDays);
    clElDays = document.createElement('table');
    clElDays.className = 'cl-days';
    elWrDays.appendChild(clElDays);

    clElDaysTbody = document.createElement('tbody');
    clElDays.appendChild(clElDaysTbody);

    var toolcontent = {
      prevM: '.',
      calmonth: '',
      nextM: '.',
      prevY: '.',
      calyear: '',
      nextY: '.',
      today: ''
    };
    /* jslint forin:true */
    for (var keyVar in toolcontent) {
      var elToolTd = document.createElement('div');
      elToolTd.className = 'cl-tool-td';
      elToolTd.id = keyVar;
      elToolTd.setAttribute('unselectable', true);
      if (toolcontent[keyVar] === '.') {
        elToolTd.innerHTML = '<div class="t-inner"></div>';
      } else {
        elToolTd.innerHTML = toolcontent[keyVar];
      }

      clElHead.appendChild(elToolTd);
    }
    var emptyRow = document.createElement('tr');
    clElDaysTbody.appendChild(emptyRow);

    for (i = 0; i < 7; i++) {
      var elDaysTr = document.createElement('tr');
      if (i === 0) { elDaysTr.className = 'cl-dayst-tr'; }
      clElDaysTbody.appendChild(elDaysTr);

      for (var j = 0; j < 7; j++) {
        var elDaysTd = document.createElement('td');
        if (j === 6) { elDaysTd.style.borderRightWidth = 0; }
        elDaysTd.innerHTML = (i === 0) ? clMsgWdays[j] : '&nbsp;';
        if (j === 0) {
          addClass(elDaysTd, 'cl-first');
        } else if (j === 6) {
          addClass(elDaysTd, 'cl-last');
        }

        elDaysTr.appendChild(elDaysTd);
      }
    }
    // TOOLBAR and DAYS
  }
  /**
   * Draw calendar dates
   * @param {Date} cdate current Date object
   */
  function drawDateRep(cdate) {
    var cyear = cdate.getFullYear();
    var cmon = cdate.getMonth();
    var cday = cdate.getDate();
    var cyearb, cmonb;
    if (cmon === 0) {
      cyearb = cyear - 1;
      cmonb = 11;
    } else {
      cyearb = cyear;
      cmonb = cmon - 1;
    }
    var elMonth = document.getElementById('calmonth');
    var elYear = document.getElementById('calyear');

    elYear.innerHTML = cyear;

    if (!elMonth) { return; }
    elMonth.innerHTML = clMsgMonths[cmon];

    // 1th week day
    var firstdayDate = new Date(cdate.getFullYear(), cdate.getMonth(),
        cdate.getDate());
    firstdayDate.setDate(1);
    var startWday = firstdayDate.getDay();
    if (startWday === 0) { startWday = 7; }

    // last day in month
    var lastDay = getLastday(cyear, cmon);
    var lastDayBehind = getLastday(cyearb, cmonb);
    var cb = lastDayBehind - (startWday - 2);
    var showRows = [1, 1, 1, 1, 1, 1, 1, 1];
    var c = 1;
    var nextm = 1;
    var innerTd;
    for (var i = 2; i < 8; i++) {

      for (var j = 0; j < 7; j++) {
        clElDays.rows[i].className = '';
        if (i % 2 === 0) {
          clElDays.rows[i].cells[j].className = 'cl-days';
        } else {
          clElDays.rows[i].cells[j].className = 'cl-even cl-days';
        }
        if (j >= 5) { addClass(clElDays.rows[i].cells[j], 'cl-weekend'); }
        clElDays.rows[i].cells[j].id = '';
        //prev month
        if (i === 2 && j + 1 < startWday) {
          // ******
          //even day
          if (i % 2 === 0) {
            clElDays.rows[i].cells[j].className = 'cl-behind cl-days';
          } else {
            clElDays.rows[i].cells[j].className = 'cl-even cl-behind cl-days';
          }
          //weekend
          if (j >= 5) { addClass(clElDays.rows[i].cells[j], 'cl-weekend'); }
          innerTd = '<div class="inner-td">' + cb + '</div>';
          clElDays.rows[i].cells[j].innerHTML = innerTd;
          clElDays.rows[i].cells[j].id = cb;
          //add event behind day

          cb++;
        //next month
        } else if (c > lastDay) {
          // ******
          //even day
          if (i % 2 === 0) {
            clElDays.rows[i].cells[j].className = 'cl-days cl-future';
          } else {
            clElDays.rows[i].cells[j].className = 'cl-even cl-future cl-days';
          }
          //weekend
          if (j >= 5) { addClass(clElDays.rows[i].cells[j], 'cl-weekend'); }
          innerTd = '<div class="inner-td">' + nextm + '</div>';
          clElDays.rows[i].cells[j].innerHTML = innerTd;
          clElDays.rows[i].cells[j].id = nextm;
          nextm++;
          if (j === 0) { showRows[i] = 0; }
          //current month
        } else {
          innerTd = '<div class="inner-td">' + c + '</div>';
          clElDays.rows[i].cells[j].innerHTML = innerTd;
          if (c === cday) {
            addClass(clElDays.rows[i].cells[j], 'cl-selected');
          }
          c++;
        }
        if (j === 0) {
          addClass(clElDays.rows[i].cells[j], 'cl-first');
        } else if (j === 6) {
          addClass(clElDays.rows[i].cells[j], 'cl-last');
        }
        if (i === 2) {
          clElDays.rows[i].className = 'first-row';
        } else if (i === 7) {
          if (showRows[i] !== 0) {
            clElDays.rows[i].className = 'last-row';
          } else {
            clElDays.rows[i - 1].className = 'last-row';
          }
        }
      }
    }

    for (var ii = 5; ii < showRows.length; ii++) {
      if (showRows[ii] === 1) {
        clElDays.rows[ii].style.display = 'table-row';
      } else {
        clElDays.rows[ii].style.display = 'none';
      }
    }
  }

  /////// Select clicked day
  function daysMousedownRep(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement,
        inner = obj.innerHTML;
    if (!String(inner).match(/\d+/)) { return; }
    /* jslint validthis: true */
    inner = inner.replace(/\D[^\.]/g, '');
    var self = $(this),
        cday = parseInt(inner, 10);
    /* jslint validthis: false */
    if (self.hasClass('cl-behind')) {
      clDate.setMonth(clDate.getMonth() - 1, cday);
    } else if (self.hasClass('cl-future')) {
      clDate.setMonth(clDate.getMonth() + 1, cday);
    } else {
      if (isNaN(cday)) { return; }
    }

    setDate(clDate.getFullYear(), (clDate.getMonth() + 1), cday);
    hideRep();
    stopEvent(e);
  }

  /**
   * set month & year in input
   * @param {Number} y year XXXX
   * @param {Number|String} m month XX
   */
  function setMonth(y, m) {
    if (m < 10) { m = '0' + String(m); }
    if (clField.getAttribute('readonly') === null) {
      var value = y + '-' + m;
      clField.value = value;
      $(clField).trigger('change');
      if (clSyncField && clSyncField.value === '') {
        clSyncField.value = value;
        $(clSyncField).trigger('change');
      }
    }
  }

  /**
   * set full date in input
   * @param {Number|String} y year XXXX
   * @param {Number|String} m month XX
   * @param {Number|String} d day XX
   */
  function setDate(y, m, d) {
    if (m < 10) { m = '0' + String(m); }
    if (d < 10) { d = '0' + String(d); }
    if (clField.getAttribute('readonly') === null) {
      var value = y + '-' + m + '-' + d;
      clField.value = value;
      $(clField).trigger('change');
      if (clSyncField && clSyncField.value === '') {
        clSyncField.value = value;
        $(clSyncField).trigger('change');
      }
    }
  }

  function getLastday(y, m) {
    var months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (m === 1 && (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0))) {
      return 29;
    } else { return months[m]; }
  }

  function applyCurMonth() {
    $('.b-cal__month_selected').removeClass('b-cal__month_selected');
    $('.b-cal__month[data-value="' + clDate.getMonth() + '"]').
        addClass('b-cal__month_selected');
    $('#calyear').html(clDate.getFullYear());
  }

  function toolMouseupRep(e) {
    e = e || window.event;
    // Get object which fire event
    /* jslint validthis: true */
    var obj = this;
    /* jslint validthis: false */
    var cday = clDate.getDate();
    var cmonth = clDate.getMonth();
    var cyear = clDate.getFullYear();
    var lastDay, todayDate;
    clDate.setDate(1);
    if (obj.id === 'prevY') {
      clDate.setFullYear(clDate.getFullYear() - 1);
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    } else if (obj.id === 'prevM') {
      clDate.setMonth(clDate.getMonth() - 1);
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    } else if (obj.id === 'today') {
      todayDate = new Date();
      if (todayDate.getFullYear() === cyear &&
          todayDate.getMonth() === cmonth && todayDate.getDate() === cday) {
        setDate(cyear, (cmonth + 1), cday);
        hide();
      } else {
        clDate = todayDate;
        drawDateRep(clDate);
      }
    } else if (obj.id === 'curMonth') {
      todayDate = new Date();
      if (todayDate.getFullYear() === cyear &&
          todayDate.getMonth() === cmonth) {
        setMonth(cyear, cmonth + 1);
        hide();
      } else {
        clDate = todayDate;
        applyCurMonth();
      }
    } else if (obj.id === 'nextM') {
      clDate.setMonth(clDate.getMonth() + 1);
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    } else if (obj.id === 'nextY') {
      clDate.setFullYear(clDate.getFullYear() + 1);
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    }
    stopEvent(e);
  }

  /**
   * Year & month click handler
   * @param {object} e event object
   */
  function toolMousedownRep(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement;
    clTtool = obj;

    if (obj.id === 'calyear') {
      if (clTimeout) { clearTimeout(clTimeout); }
      clTimeout = setTimeout(function() {
        showYear();
      }, 250);
      document.onmouseup = hideMyRep;
    } else if (obj.id === 'calmonth') {
      if (clTimeout) { clearTimeout(clTimeout); }
      clTimeout = setTimeout(function() {
        showMonths();
      }, 250);
      document.onmouseup = hideMyRep;
    }
    stopEvent(e);
  }

  function hideMyRep() {
    if (clTimeout) { clearTimeout(clTimeout); }
    document.onmouseup = null;
    clElYears.style.visibility = 'hidden';
    clElMonths.style.visibility = 'hidden';
    if (clTtool) { removeClass(clTtool, 'cl-tool-selected'); }
  }

  function showMonths() {
    var cmonth = clDate.getMonth();
    for (var i = 0; i < 12; i++) {
      clElMonths.childNodes[i].innerHTML = clMsgSmonths[i];
      if (cmonth === i) {
        addClass(clElMonths.childNodes[i], 'cl-ym-selected');
      } else { removeClass(clElMonths.childNodes[i], 'cl-ym-selected'); }
    }

    var pos = $(clTtool).offset();

    var x = (clTtool.id === 'calmonth') ? pos.left :
        pos.left + clTtool.offsetWidth - clElMonths.offsetWidth;
    if (isIe) { x += 1; }
    clElMonths.style.left = x + 'px';
    clElMonths.style.top = pos.top + clTtool.offsetHeight - 1 + 'px';
    clElMonths.style.visibility = 'visible';
    addClass(clTtool, 'cl-tool-selected');
  }
  /**
   * Show years combo box
   */
  function showYear() {
    var cyear = clDate.getFullYear();
    cyear += 12;
    for (var i = 0; i < 12; i++) {
      clElYears.childNodes[i].innerHTML = cyear - 1 - i * 2;
    }
    var pos = $(clTtool).offset();
    //var pos = mn_get_obj_pos(clTtool);
    var x = (clTtool.id === 'calyear') ? pos.left - 1 :
        pos.left + clTtool.offsetWidth - clElYears.offsetWidth + 1;
    if (isIe) { x += 1; }
    clElYears.style.left = x + 'px';
    clElYears.style.top = pos.top + clTtool.offsetHeight - 1 + 'px';
    clElYears.style.visibility = 'visible';
    addClass(clTtool, 'cl-tool-selected');
  }
  /**
   * close calendar
   */
  function hide() {
    if (!clCalendar) { clCalendar = document.getElementById('calendar'); }
    document.onmousedown = null;
    clCalendar.style.visibility = 'hidden';
    clActive = false;
  }
  /**
   * Out caledar click handler
   * close calendar
   * @param {object} e event object
   */
  function checkOutclick(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement;
    while (obj.parentNode) {
      if (obj.id === 'calendar') {
        return;
      }
      obj = obj.parentNode;
    }
    hide();
  }

  /**
   * Combo month & year click handler
   * show chosen year or month
   * @param {object} e event object
   */
  function comboMouseupRep(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement;

    var cday = clDate.getDate();
    var lastDay;
    clDate.setDate(1);
    if (String(obj.id).match(/ycombo/)) {
      clDate.setFullYear(parseInt(obj.innerHTML, 10));
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    } else if (String(obj.id).match(/mcombo(\d+)/)) {
      clDate.setMonth(parseInt(RegExp.$1, 10));
      lastDay = getLastday(clDate.getFullYear(), clDate.getMonth());
      if (lastDay < cday) {
        clDate.setDate(lastDay);
      } else { clDate.setDate(cday); }
      drawDateRep(clDate);
    }
  }

  function parseDate(str, month) {
    var isfieldok = false,
        fy = null,
        fm = null,
        fd = null;
    if (month) {
      if (String(str).match(/^(\d\d\d\d)-(\d+)/)) {
        fy = parseInt(RegExp.$1, 10);
        fm = parseInt(RegExp.$2, 10);
        fd = 1;
        if (!isNaN(fy) && !isNaN(fm)) {
          fm -= 1;
          isfieldok = true;
        }
      }
    } else {
      if (String(str).match(/^(\d\d\d\d)-(\d+)-(\d+)/)) {
        fy = parseInt(RegExp.$1, 10);
        fm = parseInt(RegExp.$2, 10);
        fd = parseInt(RegExp.$3, 10);
        if (!isNaN(fy) && !isNaN(fm) && !isNaN(fd)) {
          fm -= 1;
          isfieldok = true;
        }
      }
    }
    var rdate = null;
    if (isfieldok) {
      rdate = new Date(fy, fm, fd);
    } else {
      rdate = new Date();
    }

    return rdate;
  }


  function comboMouseover(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement;
    addClass(obj, 'cl-ym-hover');
  }

  function comboMouseout(e) {
    e = e || window.event;
    // Get object which fire event
    var obj = (e.target) ? e.target : e.srcElement;
    removeClass(obj, 'cl-ym-hover');
  }

  // Remove class from element
  function removeClass(el, name) {
    if (!(el && el.className)) { return; }
    var cls = el.className.split(' ');
    var ar = [];
    for (var i = cls.length; i > 0;) {
      if (cls[--i] !== name) { ar[ar.length] = cls[i]; }
    }
    el.className = ar.join(' ');
  }

  // Add class to element
  function addClass(el, name) {
    removeClass(el, name);
    el.className += ' ' + name;
  }

  function stopEvent(e) {
    e = e || window.event;
    if (isIe) {
      e.cancelBubble = true; e.returnValue = false;
    } else {
      e.preventDefault(); e.stopPropagation();
    }
    return false;
  }


  return {
    init: init,
    show: showRep,
    showMonth: showMonthCal
  };
}(window, $, EventMgr);

/*
 try {
  if ( pageInfo.calendar['today'] ) clMsgToday = pageInfo.calendar['today'];
 } catch (ex) {}
 for ( var i=0; i<12; i++ ) {
 clMsgMonths[i] = pageInfo.calendar['m' + i];
  clMsgSmonths[i] = pageInfo.calendar['ms' + i]; }
 for ( var i=0; i<7; i++ ) { clMsgWdays[i] = pageInfo.calendar['w' + i];; }
 */

/**
  Select Autocomplete
  provide select with options autocomplete
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @param {object} ScrollHandler Scrollbar library
 *  @return {object}
 **/
App.SelectAutoComplete = function(window, $, EventMgr, App, ScrollHandler) {
  'use strict';

  var inputSelector = '.b-select-ac__input',
      chooseListItem = '.i-select-ac__list-item',
      keys = {
        '38': 'UPKEY',
        '40': 'DOWNKEY',
        '37': 'LEFTKEY',
        '39': 'RIGHTKEY',
        '13': 'ENTERKEY',
        '9': 'TABKEY'
      };

  function $content() {
    var content;
    return function() {
      if (!content || content.length === 0) {
        content = $('#main-wrapper');
      }
      return content;
    }();
  }

  function $body() {
    var content;
    return function() {
      if (!content || content.length === 0) {
        content = $('body');
      }
      return content;
    }();
  }

  function init() {
    EventMgr.on($content(), inputSelector, 'keyup', keyUpHandler);
    EventMgr.on($content(), inputSelector, 'keydown', tabUpHandler);
    EventMgr.on($content(), inputSelector, 'blur', checkValue);
    EventMgr.on($content(), inputSelector, 'click', getDefaultOptions);
    EventMgr.on($content(), inputSelector, 'click', preventDefault);
    EventMgr.bind('selectAutoCompleteResponse', makeChooseList);
    EventMgr.on($content(), chooseListItem, 'click', chooseListItemHandler);
  }

  var timer,
      lastValue;

  function preventDefault(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  function getChooseList(elem, firstRun) {
    var name = elem.getAttribute('data-name'),
        tabId = elem.getAttribute('data-tabid'),
        url = window.pageInfo.url,
        param = $('#frm-' + tabId).serializeObject(),
        value = elem.value;
    param[name] = elem.value;
    /* jslint camelcase: false */
    param.sv_field = name;
    param.sv_autocomplete = 'yes';
    /* jslint camelcase: true */
    if ((value !== lastValue) || firstRun) {
      EventMgr.trigger('ajaxRequest', {
        url: url,
        param: param,
        trfunc: 'selectAutoCompleteResponse',
        invar: { tabId: tabId, sourceField: name, value: value },
        type: 'post', outtype: 'json', queue: 'noqueue' });
    }
    lastValue = value;
  }

  function getDefaultOptions() {
    // close others list
    $body().trigger('click');
    var elem = this;
    getChooseList(elem, true);
  }

  /**
   * KeyUp handler
   * get choose list or set value from choose list
   * @param {object} e
   * @this {Node}
   */
  function keyUpHandler(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode;
    if (keys[codeKey]) {
      keyChooseListItem(e, keys[codeKey], this);
      return;
    }
    var elem = this;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      getChooseList(elem);
    }, 200);
  }

  /**
   * Choose value by up/down key
   * @param {Object} e Event object
   * @param {String} key Name of key
   * @param {HTMLElement} elem
   * @param {Boolean} dontPrevent Don't prevent default action
   */
  function keyChooseListItem(e, key, elem, dontPrevent) {
    var name = elem.getAttribute('data-name'),
        tabId = elem.getAttribute('data-tabid'),
        $selected = $('#b-select-ac-list__' + name + '-' + tabId +
            ' .b-select-ac__list-item_selected_yes');
    if ($selected.length === 0) {
      $selected = $('#b-select-ac-list__' + name + '-' + tabId +
          ' .i-select-ac__list-item:first');
      if ($selected.length === 0) {
        return;
      } else {
        $selected.addClass('b-select-ac__list-item_selected_yes');
        chooseListItemHandler.apply($selected[0], [e, true, dontPrevent]);
        return;
      }
    }

    if (key === 'UPKEY') {
      var prev = $selected.prev();
      if (prev.length !== 0) {
        $selected.removeClass('b-select-ac__list-item_selected_yes');
        prev.addClass('b-select-ac__list-item_selected_yes');
        chooseListItemHandler.apply(prev[0], [e, true, dontPrevent]);
      }
    } else if (key === 'DOWNKEY') {
      var next = $selected.next();
      if (next.length !== 0) {
        $selected.removeClass('b-select-ac__list-item_selected_yes');
        next.addClass('b-select-ac__list-item_selected_yes');
        chooseListItemHandler.apply(next[0], [e, true, dontPrevent]);
      }
    } else if (key === 'ENTERKEY') {
      chooseListItemHandler.apply($selected[0], [e, false, dontPrevent]);
    } else if (key === 'TABKEY') {
      //choose only when selected 1st elem
      if ($selected.index() === 0) {
        chooseListItemHandler.apply($selected[0], [e, true, dontPrevent]);
      }
    }
  }
  var chooseListStorage = {},
      VALUESCACHE = {};

  /**
   * Build choose list from response
   * @param {Object} e
   * @param {Object} data
   * @return {Boolean}
   */
  function makeChooseList(e, data) {
    var tabId = data.tabId,
        fieldName = data.sourceField,
        commonId = fieldName + '-' + tabId,
        listElem = App.Dom.byId('b-select-ac-list__' + commonId),
        listElemWrapperId = 'cont-b-select-ac-list__' + commonId,
        listElemWrapper = App.Dom.byId(listElemWrapperId),
        chooseList = data.setvalues[fieldName],
        defValue = data.value,
        l, html = '', value, re,
        options = {}, id = (new Date()).getTime(),
        focusedElem = document.activeElement;
    //show only if element is focused
    if (focusedElem) {
      if (focusedElem.getAttribute('data-name') !== fieldName) {
        return false;
      }
    }

    //trigger setvalues if somebody add other field values
    if (data[data.sourceField]) {
      data[data.sourceField] = null;
      EventMgr.trigger('formSetValues', data);
    }

    if (chooseList && chooseList.slist) {
      l = chooseList.slist.length;
      for (var i = 0; i < l; i++) {
        value = chooseList.slist[i].value;
        if (typeof value === 'string') {
          re = new RegExp('(' + App.u.escapeRegExp(defValue) + ')', 'i');
          value = value
              .replace(re, '<span class="b-select-ac__font-normal">$1</span>');
          html += '<li data-id="' + i + '" data-lid="' + id + '"' +
              ' class="b-select-ac__list-item i-select-ac__list-item">' + value + '</li>';
          options[String(i)] = {
            key: chooseList.slist[i].key,
            value: chooseList.slist[i].value
          };
        }
      }
      chooseListStorage[String(id)] = {
        options: options
      };
      listElem.innerHTML = html;
    } else {
      listElem.innerHTML =
          '<li class="b-select-ac__list-item i-select-ac__list-item ' +
              'b-select-ac__list-item_notfound_yes" data-lid="' + id + '">' +
          pageInfo.notfound + '</li>';
    }
    if (listElemWrapper.style.display !== 'block') {
      listElemWrapper.style.display = 'block';
      $body().on('click.closeChooseList',
          $.proxy(closeChooseList, listElem));
    } else {
      $body().off('click.closeChooseList');
      $body().on('click.closeChooseList',
          $.proxy(closeChooseList, listElem));
    }
    EventMgr.trigger('updateScroll', listElemWrapperId);
    App.Common.setOptionListPosition('#opt-', commonId);
  }

  function setValue(opt) {
    opt = opt || {};
    var inputValue = App.Dom.byId(opt.id),
        inputKey = App.Dom.byId('key-' + opt.id);
    if (inputValue) {
      inputValue.value = opt.value;
    }
    if (inputKey) {
      inputKey.value = opt.key;
      $(inputKey).trigger('change');
      VALUESCACHE[opt.id] = {
        key: opt.key,
        value: opt.value
      };
    }
  }

  /**
   * Set choosen value to element
   * @param {Object} e
   * @param {Boolean|Undefined} dontclose Don't close flag
   * @param {Boolean|Undefined} dontPrevent Don't prevent default action
   * @this {Node}
   */
  function chooseListItemHandler(e, dontclose, dontPrevent) {
    if (!dontPrevent) {
      e.preventDefault();
    }
    var elem = this,
        id = elem.getAttribute('data-id'),
        lid = elem.getAttribute('data-lid'),
        parentNode = elem.parentNode,
        inputId = parentNode.getAttribute('data-id');
    if (chooseListStorage[lid] && chooseListStorage[lid].options) {
      if (chooseListStorage[lid].options[id] !== undefined) {
        setValue({
          id: inputId,
          key: chooseListStorage[lid].options[id].key,
          value: chooseListStorage[lid].options[id].value
        });
      }
    }
    if (!dontclose) {
      closeChooseList.apply(parentNode, [{}, true]);
    }
  }
  function tabUpHandler(e) {
    e = e || window.event;
    var codeKey = e.which || e.keyCode;
    if (keys[codeKey] === 'TABKEY') {
      if (this.value !== '') {
        keyChooseListItem(e, 'TABKEY', this, true);
      }
      //close list
      $body().trigger('click');
    }
  }
  /**
   * check congruence for value & key
   */
  function checkValue(e, force) {
    var id = this.getAttribute('id'),
        optListWrapper = App.Dom.byId('cont-b-select-ac-list__' + id),
        optList = App.Dom.byId('b-select-ac-list__' + id);
    if (force || (optListWrapper && optListWrapper.style.display === 'none' ||
         $(optList).find('.b-select-ac__list-item_notfound_yes').length)) {
      var inputKey = App.Dom.byId('key-' + id);
      if (VALUESCACHE[id] && inputKey &&
           VALUESCACHE[id].key === inputKey.value) {
        if (this.value !== '') {
          this.value = VALUESCACHE[id].value;
        } else {
          setValue({id: id, key: '', value: ''});
        }
      } else {
        this.value = '';
      }
    }
  }

  /**
   * check fullmatch value & options
   */
  function checkFullmatch(options, value) {
    var fullmatch = false,
        fullmatchKey;
    if (options && value !== undefined) {
      var l = options.length;
      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          fullmatchKey = key;
          if (options[key].value === value) {
            fullmatch = true;
            break;
          }
        }
      }
    }
    return {
        yes: fullmatch,
        key: options[fullmatchKey].key
    };
  }
  /**
   * close Choose list
   * @param {Boolean|Undefined} chosen
   * @param {Object} e
   * @this {Node}
   */
  function closeChooseList(e, chosen) {
    var listItem = $(this).find('.i-select-ac__list-item');
    var listElemWrapper = this.parentNode;

    if (listItem[0] && !chosen) {
      var lid = listItem[0].getAttribute('data-lid'),
          id = this.getAttribute('data-id');
      if (id && chooseListStorage && chooseListStorage[lid]) {
        var inputValue = App.Dom.byId(id),
            fullmatch = checkFullmatch(chooseListStorage[lid].options, inputValue.value);
        //if (chooseListStorage[lid].fullmatchKey !== false) {
        if (fullmatch.yes) {
          //set valuesCache
          setValue({
            id: id,
            key: fullmatch.key,
            value: inputValue.value
          });
        } else {
          //check for valid value in value field
          checkValue.apply(inputValue, [{}, true]);
        }
      }
    }
    listElemWrapper.style.display = 'none';
    this.innerHTML = '';
    $body().off('click');
    chooseListStorage = {};
  }

  var api = {
    init: init
  };

  return api;
} (window, $, EventMgr, App, ScrollHandler);


//module loaders
App.mgr = function () {
	'use strict';
	var modules = [

			App.Common.init
			,App.Dom.init
			,App.Forms.init
			,App.FormUtils.init
			,App.FormDependFields.init
			,App.Wizards.init
			,App.ScrollController.init
			,App.AjaxHelper.init
			,App.ValidChecker.init
			,App.Validators.init
			,App.Slider.init
			,App.SelectAutoComplete.init
			,App.MultiSelect.init
			,App.Select.init
			,App.ActionHandler.init
			,App.Tabs.init
			,App.ExtFormHelper.init
			,App.ProgressBar.init
			,App.FormListFilter.init
			,App.PrefixSelect.init
			,App.Store.init
			,App.StoreBasket.init
			,App.StoreUserMenu.init

	],
	len = modules.length,
		i, data = 'data';

	for (i = 0; i < len; i++) {
    if (typeof modules[i] === 'function') {
      modules[i]();
    } else {
      console.log('undefined init function of module number: ', i);
    }
	}
	EventMgr.trigger('storeLoad', data);
};

/**
 *  Модуль.
 *  ваш К.О.
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 */
App.ActionHandler = function(window, $, EventMgr, App) {
  'use strict';
  var init = function() {
    EventMgr.onwithdata($content(), actionBtnSel, 'click', 'menuAction',
        actionController);
    EventMgr.on($content(), formBtnFunc, 'click', actionFormController);
    EventMgr.on($content(), cancelDefActionNonActSel, 'click', cancelDefAct);
    EventMgr.on($content(), reloadTabBtnSel, 'click', reloadTabController);
    EventMgr.on('#main-wrapper', formSubmitSel, 'click', submitForm);
    EventMgr.on($content(), ticketRate, 'click', ticketRateHandler);
    EventMgr.bind('rateResponse', rateResponseHandler);
//    EventMgr.onwithdata('#main-wrapper', formSubmitSel, 'click', 'formSubmit',
//        submitForm);
    EventMgr.bind('failedAjaxResponseForDashboard',
        failedDashboardBlockRequestHandler);
    EventMgr.bind('failMenuAjaxResponse', failMenuRequest);
    EventMgr.bind('failCommonAjaxResponse', failListRequest);
    EventMgr.bind('failFormAjaxResponse', failFormRequest);
    EventMgr.bind('tabLoading', tabLoadingHandler);
    EventMgr.bind('tabLoadingHide', tabLoadingHideHandler);
    EventMgr.on($content(), dismissMsgSelector, 'click', dismissMessage);
  },

      $content = function() {
        return $('#main-wrapper');
      },

      // wrapper for right menu links
      actionBtnSel = '.m-item a, .b-menu-item',

      //wrapper for reload tab btn
      reloadTabBtnSel = '.reload',
      // wrapper for toolbar's group btn

      //prevent default not active actions
      cancelDefActionNonActSel = '.notActive span',

      formSubmitSel = '.i-button_type_ok',

      formBtnFunc = '.i-button_type_func',

      dismissMsgSelector = '.i-message__dismiss-link',

      ticketRate = '.i-ticket__rate',

      cancelDefAct = function(e) {
        e.preventDefault();
      },

      tabLoadingId = {},

      tabLoadingHandler = function(e, data) {
        var tabId = data.tabId;
        clearTimeout(tabLoadingId[tabId]);
        tabLoadingId[tabId] = setTimeout(function() {
          $('#cont-' + tabId).addClass('loading');
        }, 350);
      },

      tabLoadingHideHandler = function(e, data) {
        var tabId = data.tabId;
        setTimeout(function() {
          clearTimeout(tabLoadingId[tabId]);
          $('#cont-' + tabId).removeClass('loading');
        }, 0);
        //for be sure what it fucking loading hide
        setTimeout(function() {
          $('#cont-' + tabId).removeClass('loading');
        }, 100);
        //for be defintly sure what it fucking loading hide
        setTimeout(function() {
          $('#cont-' + tabId).removeClass('loading');
        }, 200);
        //for be absolutly sure  what it fucking loading hide
        setTimeout(function() {
          $('#cont-' + tabId).removeClass('loading');
        }, 350);
      },
      //handler for failed request from menu
      failMenuRequest = function(e, data) {
        $('.m-item.loading').removeClass('loading');
        if (data.erType === 'json') {
          EventMgr.trigger('pullMsg', { msg: 'JSON Parse Error. Func: "' + data.param.func + '"' });
        } else if (data.erMsg) {
          EventMgr.trigger('pullMsg', { msg: data.erMsg });
        } else {
          EventMgr.trigger('pullMsg', { msg: 'Request failed. Try again. Func: "' + data.param.func + '"' });
        }
      },
      //handler for failed request from list
      failListRequest = function(e, data) {
        var tabId = (data.invar) ? (data.invar.tabId) ? data.invar.tabId :
            (data.invar.parent) ? data.invar.parent :
                (data.invar.targetTabId) : undefined;
        EventMgr.trigger('tabLoadingHide', { tabId: tabId });
        if (data.erType === 'json') {
          EventMgr.trigger('pullMsg', { msg: 'JSON Parse Error. Func: "' + data.param.func + '"' });
        } else if (data.erMsg) {
          EventMgr.trigger('pullMsg', { msg: data.erMsg });
        } else {
          EventMgr.trigger('pullMsg', { msg: 'Request failed. Try again. Func: "' + data.param.func + '"' });
        }
      },

      disabledButton = function(btn) {
        btn.addClass('b-button_st_disabled');
        btn.html(btn.attr('data-disabled'));
      },

      resetButtonForDefault = function(arg) {
        //return btn state
        var btn, tabId;
        if (typeof arg === 'string') {
          tabId = arg;
          btn = $('#form-wrapper-' + tabId + ' .b-button_st_disabled'); 
        } else {
          btn = arg;
        }
        if (btn.length) {
          btn.html(btn[0].getAttribute('data-enabled'));
          btn.removeClass('b-button_st_disabled');
        }
      },
      //handler fot failed request from form
      failFormRequest = function(e, data) {
        var tabId = data.invar.tabId;

        if (data.erType === 'json') {
          EventMgr.trigger('pullMsg', { msg: 'JSON Parse Error. Func: "' + data.param.func + '"' });
        } else if (data.erMsg) {
          EventMgr.trigger('pullMsg', { msg: data.erMsg });
        } else {
          EventMgr.trigger('pullMsg', { msg: 'Request failed. Try again. Func: "' + data.param.func + '"' });
        }
        //reset button
        resetButtonForDefault(tabId);
        //for run after upload callback
        setTimeout(function() {
          //return progressbar state
          var loader = $('#' + tabId + '-progressbar .b-progressbar__loader');
          $('#' + tabId + '-progressbar')
              .removeClass('b-progressbar_type_withbtn');
          //remove animated
          loader.addClass('b-progressbar__loader_type_animate');
          //add static color
          loader.removeClass('b-progressbar__loader_type_static');
          loader.css('width', '');
          loader.html('');
          //remove cancel btn
          $('#' + tabId + '-progressbar .b-progressbar__btn-wr').remove();
        }, 1);

        EventMgr.trigger('tabLoadingHide', { tabId: tabId });
      },

      failedDashboardBlockRequestHandler = function(e, data) {
        var blockId = data.invar.blockId,
            tblock = App.Dom.byId('t' + blockId);
        if (tblock) {
          tblock.className = tblock.className.replace(/loading/g, '');
        }
        if (data.erType === 'json') {
          EventMgr.trigger('pullMsg', { msg: 'JSON Parse Error. Func: "' + data.param.func + '"' });
        } else if (data.erMsg) {
          EventMgr.trigger('pullMsg', { msg: data.erMsg });
        } else {
          EventMgr.trigger('pullMsg', { msg: 'Request failed. Try again. Func: "' + data.param.func + '"' });
        }
      },

      //reload page handler
      reloadTabController = function(e, data) {
        var tabId = '',
            addedParam = {};
        if (e) {
          tabId = this.getAttribute('data-tabid');
          addedParam = {
            clickstat: 'title'
          };
          e.preventDefault();
        } else {
          tabId = data.tabId;
        }
        EventMgr.trigger('reloadTab', {
          addedParam: addedParam,
          tabId: tabId,
          help: true,
          selid: true,
          filter: true });
      },

      ticketRateHandler = function(e) {
        var func = this.getAttribute('data-func'),
            type = this.getAttribute('data-type'),
            name = this.getAttribute('data-name'),
            $parent = this.parentNode,
            elid = $parent.getAttribute('data-id'),
            plid = $parent.getAttribute('data-elid'),
            param = {
              func: func,
              elid: elid,
              plid: plid
            };
        if (type === 'setrate') {
          EventMgr.trigger('ajaxRequest', {
            param: param,
            invar: {
              $parent: $parent,
              rateType: name,
              self: this
            },
            outtype: 'json',
            trfunc: 'rateResponse',
            failfunc: 'failCommonAjaxResponse'
          });
        } else if (type === 'rate') {
          EventMgr.trigger('ajaxRequest', {
            param: param,
            invar: {
              parent: $(this).closest('.tab-content_st_active').attr('data-tabid')
            },
            type: 'get',
            outtype: 'json',
            trfunc: 'ajaxResponse',
            failfunc: 'failCommonAjaxResponse',
            queue: 'noqueue' });
        }
      },

      rateResponseHandler = function(e, data) {
        if (!data.error) {
          $(data.$parent).addClass('b-ticket__rate_rated_' + data.rateType);
          $(data.self).removeClass('i-ticket__rate');
        } else if (data.erMsg) {
          EventMgr.trigger('pullMsg', { msg: data.erMsg });
        }
      },

      actionFormController = function(e) {
        var $self = $(this),
            func = $self.attr('data-func'),
            id = $self.attr('data-id'),
            tabId = $self.attr('data-tabid'),
            param = {
              func: func
            };
        //check for button id
        if (id && id !== 'undefined') {
          id = id.split('=', 2);
          if (id[1]) {
            param[id[0]] = id[1];
          }
        }
        EventMgr.trigger('ajaxRequest', {
          param: param,
          invar: {
            parent: tabId
          },
          type: 'get',
          outtype: 'json',
          trfunc: 'ajaxResponse',
          failfunc: 'failMenuAjaxResponse',
          queue: 'menu' });
        EventMgr.trigger('tabLoading', { tabId: tabId });

      },

      checkSameTabsOpened = function(func, tabs) {
        var resp = {
          exist: false,
          tabId: null,
          status: 0
        };
        var curFunc, regExpWitDot;
        if (func && tabs && typeof tabs === 'object') {
          /* jslint forin:true */
          for (var key in tabs) {
            if (tabs[key]) {
              curFunc = tabs[key].func;
              if (!curFunc && tabs[key].paramObjAll) {
                curFunc = tabs[key].paramObjAll.func;
              }
              //check if empty func like basket.empty
              //regExpWitDot = new RegExp('^' + func + '\\.');
              //.empty
              regExpWitDot = func + '.empty';
              //if ((String(curFunc).match(regExpWitDot) || curFunc === func) &&
              if ((regExpWitDot === curFunc || curFunc === func) &&
                  tabs[key].hType === 'parent') {
                resp.exist = true;
                resp.tabId = key;
                resp.status = tabs[key].status;
                //be sure that found active same tab
                if (resp.status === 1) {
                  break;
                }
              }
            }
          }
        }
        return resp;
      },

      //handler for menu action
      actionController = function(e, data) {
        var self = $(this),
            href = this.getAttribute('data-url'),
            parent = this.getAttribute('data-parent'),
            re = new RegExp('/?func=+'),
            cgi = this.getAttribute('data-cgi'),
            sameModule = false,
            queue = 'menu',
            isFromMenu = self.hasClass('i-menu-link'),
            fromFatalError = self.parent()
                .hasClass('b-fatal-error__refresh-link'),
            newtab = false,
            url, param;
        if (e.ctrlKey || e.metaKey || self.hasClass('newtab')) {
          newtab = true;
          queue = 'noqueue';
        }
        if (self.hasClass('wohan')) {
          return true;
        }
        //if from fatal error close alertBox
        if (fromFatalError) {
          $('#modal_alert_ok').trigger('click');
        }

        if (href) {
          if (href.match(re)) {
            url = cgi ? pageInfo.host + cgi : pageInfo.url;
            href = href.replace('?', '');
            param = App.Common.parseParams(href);
            param.clickstat = 'yes';
            //check for same module open from menu
            if (!newtab) {
              var actFunc = $('.tab-content_st_active').attr('data-func');
              if (param.func === actFunc) {
                sameModule = true;
              }
            }
            //check for exist tabs with this function
            var checkTabs = checkSameTabsOpened(param.func, data.__tabs);
            if (checkTabs.exist && !checkTabs.status && isFromMenu) {
              $('#switch-' + checkTabs.tabId).trigger('lclick');
              EventMgr.trigger('reloadTab', { tabId: checkTabs.tabId, resetFilterOn: true });
            } else {
              EventMgr.trigger('ajaxRequest', {
                url: url,
                param: param,
                invar: {
                  parent: parent, newtab: newtab, sameModule: sameModule, __src: 'menuAction', __src_func: param.func },
                type: 'get',
                outtype: 'json',
                trfunc: 'ajaxResponse',
                failfunc: 'failMenuAjaxResponse',
                queue: queue });
              //add loading class to menu
              self.parents('.m-item').addClass('loading');
            }
          } else {
            //what else?
            console.log(url);
          }
        }
        if (e) { e.preventDefault(); }
      },

      //handler for submit form
      submitForm = function(e, data) {
        e.preventDefault();
        var self = $(this),
            flags = self.getFlags(),
            tabId = self.attr('data-tabid'),
            form = $('#frm-' + tabId),
            vars = form.getVars(),
            action = form.attr('action'),
            param = form.serializeObject(),
            parent = self.attr('data-parent'),
            type = self.attr('data-type'),
            hasFiles = form.hasClass('withfiles'),
            act = self.attr('data-act'),
            id = self.attr('data-id'),
            isShowcaseForm = form.hasClass('b-form_showcase_yes'),
            name = self.attr('data-name'),
            progressTypeElem = App.Dom.byId(tabId + '-progresstype'),
            progressType, confirmMsg, RequiredMsg, progressid,
            param1, text, passwdField,
            pwstrength, options;
        //prevent dbclick
        if (self.hasClass('b-button_st_disabled')) {
          return false;
        }
        disabledButton(self);
        if (progressTypeElem !== null) {
          progressType = progressTypeElem.value;
        }
        //check for valid
        if (act !== 'back') {
          //check file length
          var fileSizeRes = App.u.checkFileSize(tabId);
          if (fileSizeRes.msg) {
            EventMgr.trigger('errMsgValid', {
              self: fileSizeRes.field,
              err: fileSizeRes.msg,
              number: 0
            });
            resetButtonForDefault(self);
            return false;
          }
          //check passwd confirm fields
          confirmMsg = checkConfirm(tabId);
          if (confirmMsg.msg !== '') {
            EventMgr.trigger('showAlert', confirmMsg);
            resetButtonForDefault(self);
            return false;
          }
          //check required fields
          RequiredMsg = checkRequired(tabId);
          if (RequiredMsg.msg !== '') {
            EventMgr.trigger('errMsgValid', {
              self: RequiredMsg.himself,
              err: RequiredMsg.msg,
              number: 0
            });
            //watching while input not be empty for remove error
            $(RequiredMsg.himself).bind('keyup', function() {
              if (this.value !== '') {
                $(this).unbind('keyup');
                EventMgr.trigger('okMsgValid', {
                  self: this,
                  number: 0,
                  notOk: true
                });
              }
            });
            resetButtonForDefault(self);
            return false;
          }
          //maybe it not needed
         // if ($('#frm-' + tabId +
         //     ' .row-error:not(".l-form__row_hidden_yes") input.test').length !== 0) {
         //   return false;
         // }
          //check password strength
          passwdField = $('#frm-' + tabId + ' input[data-check-field]');
          if (passwdField.length !== 0) {
            pwstrength = getPwdStrength(passwdField);
            var badPwd = false;
            passwdField.each(function() {
              var pname = this.getAttribute('name');
              if (pwstrength !== 0 &&
                  param[pname] !== '' &&
                  $(this).width() !== 0) {
                if (pwstrength > App.Forms.checkPassStrength(param[pname])) {
                  EventMgr.trigger('showAlert', { msg: pageInfo.pwErrorMsg });
                  badPwd = true;
                  return false;
                }
              }
            });
            if (badPwd) {
              resetButtonForDefault(self);
              return false;
            }
          }
        }

        if (act === 'back') {
          param.sback = 'ok';
          //not needed progress when press back btn
          progressType = 'false';
        }
        //check for button id
        if (id && id !== 'undefined') {
          id = id.split('=', 2);
          if (id[1]) {
            param[id[0]] = id[1];
          }
        }

        //add name of button
        if (name) {
          /* jslint camelcase: false */
          param.clicked_button = name;
          /* jslint camelcase: true */
        }
        //add progressid
        progressid = progressType;
        param.progressid = progressid;
        param1 = { elid: progressid, func: 'progress.get', sfrom: 'ajax' };
        //check for target
        if (act === 'blank') {
          var $form, winId = progressid + new Date().getTime(),
              $formWrapper = $('#form-wrapper-' + tabId);
          $formWrapper.wrap(function() {
            return '<form action="' + action + '" id="form-' + winId +
                '" method="POST" enctype="multipart/form-data" target="' +
                winId + '"/>';
          });
          $form = $('#form-' + winId);
          $form.append('<input type="hidden" class="i-input-tmp-elem" value="ok" name="sok"/>');
          $form.append('<input type="hidden" class="i-input-tmp-elem" value="' + name +
              '" name="clicked_button"/>');
          if (id && id[1]) {
            $form.append('<input type="hidden" class="i-input-tmp-elem"' +
            ' value="' + id[1] + '" name="' + id[0] + '"/>');
          }
          //remove sfrom=ajax
          $form.find('input[name="sfrom"]').remove();
          window.open('', winId);
          $form.submit();
          if (!flags.keepform) {
            App.Tabs.closeTab(e, tabId);
            if (parent) {
              EventMgr.trigger('reloadTab', { tabId: parent });
            }
          } else {
            $formWrapper.unwrap();
            $('.i-input-tmp-elem').remove();
          }
          //try reload parent after close form
          resetButtonForDefault(self);
          return false;
        }
        var $mixedContols = $('#frm-' + tabId + ' .i-control-mixed');
        if ($mixedContols.length !== 0) {
          param = App.u.removeParam($mixedContols, param);
        }
        //get progressType before request
        progressType = String(progressType).split('_')[0];
        //options for form & form with files submit
        options = {
          url: pageInfo.host + action,
          param: param,
          invar: {
            tabId: tabId,
            parent: parent,
            type: type,
            progresstype: progressType,
            progressid: progressid,
            iType: 'replace',
            dataSaved: true,
            targetTabId: tabId,
            __vars: vars
          },
          type: 'post',
          outtype: 'json',
          trfunc: 'ajaxFormResponse',
          queue: 'noqueue',
          failfunc: 'failFormAjaxResponse' };
        //check for files
        //THIS IS FORM WITH FILE
        /* jshint camelcase: false */
        if (hasFiles) {
          param.sok = 'ok';
          EventMgr.trigger('setBrandSettings', {
            options: options,
            tabId: tabId,
            pid: progressid,
            name: name,
            param: param,
            addParams: {
              sok: 'ok',
              sfrom: 'ajax',
              clicked_button: name,
              pid: progressid
            },
            parent: parent });
        } else if (type === 'report') {
        //THIS IS REPORT
          param.sok = 'ok';
          options = {
            url: pageInfo.host + action,
            param: param,
            invar: { parent: parent, tabId: tabId, __src: 'report' },
            outtype: 'json',
            trfunc: 'ajaxResponse',
            queue: 'noqueue',
            failfunc: 'failCommonAjaxResponse'
          };
          EventMgr.trigger('ajaxRequest', options);
        } else {
          //THIS IS FORM
          param.sok = 'ok';
          EventMgr.trigger('ajaxRequest', options);
        }
        if (progressType !== 'false') {
          setTimeout(function() {
            EventMgr.trigger('ajaxRequest', {
              param: param1,
              invar: {
                tabId: tabId,
                param: param1,
                type: type,
                progresstype: progressType },
              outtype: 'json',
              trfunc: 'progressBarResponse',
              queue: 'noqueue' });
          }, 1000);
        }
        EventMgr.trigger('tabLoading', { tabId: tabId });
      },

      getPwdStrength = function(passwdField) {
        var pws = passwdField.attr('data-check-args'), firstSing;
        if (!pws) { return pageInfo.pwstrength; }
        firstSing = pws.substring(0, 1);
        if (firstSing === '-' || firstSing === '+') {
          return parseFloat(pws) + parseFloat(pageInfo.pwstrength);
        } else {
          return parseFloat(pws);
        }
      },

      //check required field on form
      checkRequired = function(tabId) {
        var field = $('#form-wrapper-' + tabId +
                ' input[required="required"],' +
                ' #form-wrapper-' + tabId +
                ' .b-textarea[required="required"]'),
            msg = '',
            self = null;
        if (field.length > 0) {
          field.each(function() {
            //check for empty and not hidden
            var value = String(this.value).replace(/\s/g, '');
            if (this.className.match('i-control-mixed')) {
              return true;
            }
            if (value === '' && this.offsetWidth !== 0) {
              msg = getRequiredMsg();
              self = this;
              return false;
            }
            if (this.getAttribute('data-type') === 'multiple' &&
                value === '') {
              var id = this.getAttribute('data-id'),
                  elem = App.Dom.byId(id + '-ms-view');
              if (elem && elem.offsetWidth !== 0) {
                msg = getRequiredMsg();
                self = elem.parentNode;
                return false;
              }
            }
          });
        }
        return {
          param: tabId,
          msg: msg,
          himself: self
        };
      },

      //get message for required error
      getRequiredMsg = function() {
        return pageInfo.messages.empty;
      },
      //check password confirm field
      checkConfirm = function(tabId) {
        var field = $('#form-wrapper-' + tabId + ' input[data-confirm="yes"]'),
            msg = '',
            self = null;
        if (field.length > 0) {
          field.each(function() {
            var confirmField = this.getAttribute('data-check-field'),
                value1 = this.value,
                confirmFieldElem = App.Dom.byId(confirmField + '-' + tabId),
                confirmFieldElemFake = App.Dom.byId(confirmField + '-' +
                    tabId + '-fake'),
                value2;
            if (confirmFieldElem !== null) {
              value2 = confirmFieldElem.value;
            }
            if (value1 !== value2 && (confirmFieldElem.offsetWidth !== 0 ||
                confirmFieldElemFake.offsetWidth !== 0)) {
              msg = pageInfo.confirm;
              self = this;
            }
            return;
          });
        }
        return {
          msg: msg,
          himself: self,
          callback: function() { this.focus(); }
        };
      },

      //banner dismiss link handler
      dismissMessage = function(e, data) {
        if (e) { e.preventDefault(); }
        var self = $(this),
            param;
        self.parents('.i-message').hide();
        param = this.getAttribute('data-href');
        EventMgr.trigger('updTableHeight');
        param = App.Common.parseParams(param);
        EventMgr.trigger('ajaxRequest', {
          url: pageInfo.url,
          param: param,
          trfunc: 'DoNothing',
          queue: 'noqueue' });
      };
  return {
    init: init
  };
}(window, $, EventMgr, App);

/**
 * Модуль отвечает за вкладки и их рендер
 * @param {object} window global object
 * @param {object|function} $ jQuery
 * @param {object} EventMgr Event manager
 * @param {object} App Application
 * @param {object} templates HTML templates
 */
App.Tabs = function(window, $, EventMgr, App, templates) {
  'use strict';
  var tabs = {},
      pageInfo = window.pageInfo,
      tabIndex = 1,

      tabN = 'tab',

      rowId = 0,

      activeTab = '', //current active tab id

      defaultTab = '', //defaultTab

      mainWrapperSel = '#main-wrapper',

      init = function() {
        EventMgr.bind('ajaxResponse', buildTabWrapper);
        EventMgr.bind('builtTab', appendTab);
        EventMgr.bind('comboCtrlShiftZKeyUp', closeAllTabs);
        EventMgr.bind('comboCtrlShiftXKeyUp', closeOthersTabs);
        EventMgr.on(mainWrapperSel, 'a.close', 'click', closeTabClickHandler);
        EventMgr.on(mainWrapperSel, 'span.back', 'click', backBtnHandler);
        EventMgr.on(mainWrapperSel, '#tabs .switch', 'click', switchTabs);
        EventMgr.on(mainWrapperSel, '#tabs .switch', 'mousedown', closeTabsByMiddleBtn);
        EventMgr.on(mainWrapperSel, '#tabs .switch', 'dblclick', upSwitchedTabs);
        EventMgr.bind('reloadTab', reloadTabData);
        EventMgr.bind('updateTab', updateTab);
        EventMgr.bind('ajaxFormResponse', formHandler);
        EventMgr.on(mainWrapperSel, '.i-button_type_cancel',
            'click', cancelBtnHandler);
        EventMgr.bind('ajaxResponseForDashboard', renderDashboardTable);
        EventMgr.bind('addedChart', addChartToTab);
        EventMgr.bind('formGetTreeBranch', formGetTreeBranch);
        EventMgr.bind('getActiveHint', getActiveHint);
        EventMgr.on(mainWrapperSel, 'input, textarea', 'change',
            formFieldChangeHandler);
        EventMgr.on(mainWrapperSel, '.i-list-icon__stop', 'click',
            stopAutoUpdate);
        EventMgr.addHook('formSetValues,formSubmit', addModelToSetvalues);
        EventMgr.bind('updateModel', updateModelBySetvalues);
        EventMgr.addHook('listMultiSelect,listSelect,listLiveFound,' +
            'listUnSelect,ajaxResponseEditInListSave,updateTotalList,' +
            'clickedGroupItem', addListModel);
        EventMgr.bind('saveFormPageState', saveFormPageState);
        EventMgr.on(mainWrapperSel, '.i-take-favorite', 'click', favoriteToggle);
        EventMgr.on(mainWrapperSel, '.i-pin', 'click', pinToggle);
        EventMgr.bind('loadPage', removeSfromParam);
        EventMgr.addHook('menuAction,testColCheck', addTabsModel);
        EventMgr.bind('changeTabSortIndex', changeTabSortIndex);
        EventMgr.bind('updateTotalWithConvertReport', updateTotalWithConvertReport);
        EventMgr.addToTriggerStack('escKeyUp', esckeyHandler, 1);
      },
      //remove sfrom param form url after login
      removeSfromParam = function() {
        var params = App.u.parseParams(window.location.search);
        if (params.sfrom) {
          if (window.history) {
            setTimeout(function() {
              window.history.pushState('default', '', pageInfo.binary);
            }, 10000);
          }
        }
      },

      checkDasboard = function(d) {
        if (d && d.dashboard) {
          $('#switch-tab0').trigger('click');
          return false;
        }
        return true;
      },

      checkFeatures = function(data) {
        //if has redirect keep new tabs
        if (data && data.__src !== 'okList' && data.__src !== 'okForm') {
          var params;
          if (data.features && pageInfo.features && !data.wizard &&
              data.features !== pageInfo.features) {
            params = App.u.parseParams(window.location.search);
            params.ssavetabs = 1;
            if (!params.scountreload) {
              params.scountreload = 1;
            } else {
              params.scountreload -= 0;
              params.scountreload += 1;
            }
            if (params.scountreload < 5) {
              window.location.search = '?' + App.u.getQueryString(params);
              return false;
            }
          } else {
            //remove params from url
            params = App.u.parseParams(window.location.search);
            if (params.ssavetabs) {
              setTimeout(function() {
                if (window.history) {
                  window.history.pushState('default', '', pageInfo.binary);
                }
              }, 10000);
            }
          }
        }
        return true;
      },

      checkReload = function(data) {
        if (data) {
          if (data.reload) {
            var newLocation = pageInfo.url;
            if (data.savetab) {
                newLocation += '?sfrom=sessionexpired';
            }
            if (data.__src && (data.__src === 'menuAction' ||
               data.__src === 'toolbarAction' ||
               data.__src === 'report' ||
               data.__src === 'reloadTab')) {
               makeFakeTab(data);
            }
            if (data.__src && data.__src === 'filterset') {
              addBeforeLoadRequest(data);
            }
            window.location = newLocation;
            return false;
          }
        }
        return true;
      },

      checkNewWin = function(data) {
        if (data) {
          if (data.location && data.newwin) {
            window.open(data.location, '_blank');
            //remove loading className
            $('.m-item.loading').removeClass('loading');
            return false;
          } else if (data.location) {
            window.location = data.location;
            return false;
          }
        }
        return true;
      },

      checkNewForm = function(data) {
        if (data) {
          var param, options,
              newFormParams = data.formParam,
              parent = data.parent;
          if (newFormParams) {
            param = App.u.parseParams(newFormParams);
            options = {
              noesc: true,
              param: param,
              invar: {
                waitingTabId: data.targetTabId,
                parent: parent,
                dataSaved: true,
                '__src_func': data.__src_func,
                '__src': 'okForm',
                '__srcBtn': data.__srcBtn,
                newtab: data.newtab
              },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponse',
              queue: 'noqueue' };
            if (data.openAsChild) {
              options.invar.parent = data.tabId;
            }
            EventMgr.trigger('ajaxRequest', options);
            return false;
          }
        }
        return true;
      },

      checkNewList = function(data) {
        if (data) {
          var param,
              newListParams = data.listParam,
              parent = data.parent;
          if (newListParams) {
            param = App.u.parseParams(newListParams);
            EventMgr.trigger('ajaxRequest', {
              noesc: true,
              param: param,
              invar: {
                waitingTabId: data.targetTabId,
                parent: parent,
                dataSaved: true,
                '__src': 'okList',
                '__srcBtn': data.__srcBtn,
                newtab: data.newtab
              },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponse',
              queue: 'noqueue' });
           if (data.openAsChild) {
             options.invar.parent = data.tabId;
           }
           EventMgr.trigger('tabLoading', { tabId: parent });
            return false;
          }
        }
        return true;
      },

      storage = App.Common.storage,
      //render breadcrumb
      getBreadcrumb = function(breadcrumb) {
        var str = '';
        /* jslint forin:true */
        for (var key in breadcrumb) {
          str += '<a href="#" data-id="' + key + '" class="breadcrumb">' +
              breadcrumb[key].name + '</a>';
        }
        return str;
      },

      resetToDefaultFormButton = function(tabId) {
        if (tabs[tabId] && tabs[tabId].type === 'form') {
          $('#frm-' + tabId + ' .b-button_st_disabled').each(function() {
            var $self = $(this);
            $self.html($self.attr('data-enabled'));
            $self.removeClass('b-button_st_disabled');
          });
        }
      },
      //cancel btn handler
      cancelBtnHandler = function(e) {
        var tabId = this.getAttribute('data-tabid'),
            func = this.getAttribute('data-func'),
            $self = $(this),
            form = $('#frm-' + tabId),
            isShowcaseForm = form.hasClass('b-form_showcase_yes'),
            flags = $self.getFlags(),
            parent, options;
        if (!tabs[tabId]) {
          return;
        }
        parent = tabs[tabId].parent;

        if (flags.refresh && parent) {
          EventMgr.trigger('reloadTab', { tabId: parent, __src: 'formCancelRefresh', filter: true });
        }
        //return list if it from sametab
        if (tabs[tabId].rParentObj) {
          var param = tabs[tabId].rParentObj,
              targetTabId = tabId;
          tabs[tabId].rParent = undefined;
          EventMgr.trigger('ajaxRequest', {
            url: pageInfo.url, param: param,
            invar: {
              parent: parent,
              targetTabId: targetTabId,
              iType: 'replace',
              dataSaved: true
            },
            type: 'get',
            outtype: 'json',
            trfunc: 'ajaxResponse',
            failfunc: 'failCommonAjaxResponse',
            queue: 'noqueue' });
          EventMgr.trigger('tabLoading', { tabId: tabId });
        } else if (func) {
          options = {
            param: {
              func: func
            },
            invar: {
              parent: parent,
              targetTabId: tabId,
              iType: 'replace',
              dataSaved: true
            },
            type: 'get',
            outtype: 'json',
            trfunc: 'ajaxResponse',
            failfunc: 'failCommonAjaxResponse',
            queue: 'noqueue'
          };
          EventMgr.trigger('ajaxRequest', options);
          EventMgr.trigger('tabLoading', { tabId: tabId });
        } else {
          closeTab(e, tabId);
        }
        e.preventDefault();
      },

      unsavedDataCheckboxHandler = function(val) {
        if (val === 'on') {
          var options = {
            param: {
              func: 'usrparam',
              elid: pageInfo.user,
              checkunsaved: 'off',
              sok: 'ok'
            },
            type: 'get',
            outtype: 'json',
            trfunc: 'DoNothing',
            queue: 'noqueue'
          };
          EventMgr.trigger('ajaxRequest', options);
          pageInfo.checkUnsaved = false;
        }
      },

      addBeforeLoadRequest = function(data) {
        var tabId = data.tabId;
        if (tabs[tabId]) {
          tabs[tabId].beforeRequest = data.sourceParamString;
        }
        EventMgr.trigger("changedTabs", {tabs: tabs, forceActive: true});
      },

      makeFakeTab = function(data) {
        var tabId, tabObj;
        tabId = tabN + tabIndex;
        tabObj = {
            status: 1,
            forceActive: true,
            title: '',
            paramObjAll: App.u.parseParams(data.sourceParamString)
        };
        //check for su func
        var func = tabObj.paramObjAll.func;
        if (String(func).match(/su$/) || func === 'chlevel') {
          return;
        }
        if (data.parent) {
          if (data.targetTabId || data.tabId) {
            tabId = data.targetTabId || data.tabId;
          }
          tabObj.hType = 'child';
          if (tabs[data.parent]) {
            tabs[data.parent].child = tabId;
          }
        } else {
          if (data.targetTabId) {
            tabId = data.targetTabId;
          }
          tabObj.hType = 'parent';
        }
        tabs[tabId] = tabObj;

        EventMgr.trigger('changedTabs', {tabs: tabs, forceActive: true});
      },
      //wrapper buildTab for check for unsaved form data
      buildTabWrapper = function(e, data) {
        var isChanged = false,
            tabId;
        //check for open in new tab & replace tab from redirect
        if (!data.newtab && !data.dataSaved && pageInfo.checkUnsaved) {
          //check for active tab is form
          if (tabs[activeTab]) {
            //find form in tab group
            tabId = findTabForm(activeTab);
            if (tabId !== activeTab) {
              //activate tab if not active
              if (tabs[tabId] && tabs[tabId].status === 0) {
                activateTab(tabId);
              }
            }
            var changedFields = checkFormChange(tabId);
            if (changedFields.isChanged) {
              isChanged = true;
              //show confirmBox
              EventMgr.trigger('confirmBoxShow', {
                callbackOk: buildTab,
                callbackCancel: function() {
                  $('.m-item.loading').removeClass('loading');
                },
                text: String(pageInfo.unsavedData)
                    .replace('__VALUE__', changedFields.count) +
                    '<br/><span class="b-text_style_bold">' + changedFields.labels +
                    '</span>',
                args: [e, data],
                checkbox: {
                  msg: pageInfo.unsavedDontShow,
                  cb: unsavedDataCheckboxHandler
                }
              });
            }
          }
        }
        if (!isChanged) {
          buildTab(e, data);
        }
      },

      findTabForm = function(tabId) {
        if (tabs[tabId] && tabs[tabId].type === 'form') {
          return tabId;
        } else {
          //form can be only last in tab group
          if (tabs[tabId].child) {
            return findTabForm(tabs[tabId].child);
          }
        }
        return false;
      },
      //build new tab
      buildTab = function(e, data) {
        EventMgr.trigger('hideHint');
        //check for user.su
        var parent = data.parent ? data.parent : '',
            ok = data.ok || false,
            tabId, obj, type, delay, timeId;
        //hide loader for parent tab
        if (parent) {
          EventMgr.trigger('tabLoadingHide', { tabId: parent});
          //reset btn on form if opened as a child
          resetToDefaultFormButton(parent);
        }
        //hide loader for targetTab (for case if has error)
        if (data.targetTabId) {
          EventMgr.trigger('tabLoadingHide', { tabId: data.targetTabId });
        }
        //hide loader for srcTab (when redirect) (for case if has error)
        if (data.srcTabId) {
          EventMgr.trigger('tabLoadingHide', { tabId: data.srcTabId });
        }

        if (!checkReload(data) ||
            !checkNewWin(data) ||
            !checkNewList(data) ||
            !checkNewForm(data)) {
          return false;
        }

        if (ok) {
          if (parent !== undefined) {
            EventMgr.trigger('reloadTab', { tabId: parent, filter: true, __src: 'buildTabOk' });
            return;
          }
        }

        EventMgr.trigger('startbuildTab', 'new empty tab');

        tabId = tabN + tabIndex;
        obj = data;
        type = obj.type || obj.id;

        if (obj.exType === 'dashboard') {
          tabId = 'tab0';
        } else if (obj.targetTabId) {
          tabId = obj.targetTabId;
        } else if (obj.showcase) {
          tabId = 'tab0';
        } else {
          tabIndex++;
        }

        //Гвозди
        //check for error on big Cicle
        if ((obj.error && !obj.ignErr &&
            (obj.type !== 'form' && obj.type !== 'inspectorForm' &&
                obj.type !== 'showcaseForm' && obj.type !== 'report')) ||
            (obj.userexpMsg === undefined &&
                obj.error &&
                obj.type === 'form')) {
          EventMgr.trigger('hideLoader');
          type = 'fatalerror';
        } else if (obj.error && obj.ignErr) {
          return;
        }
        if (type === '' && !tabs.tab0 || obj.exType === 'dashboard') {
          type = 'dashboard';
        }
        if (obj.msg) {
          $.extend(App.Common.msg, obj.msg);
        }

        switch (type) {
          case 'list':
            buildList(tabId, obj);
            break;
          case 'form':
            buildForm(tabId, obj);
            break;
          case 'dashboard':
            buildDashboard(tabId, obj);
            break;
          case 'report':
            buildReport(tabId, obj);
            EventMgr.trigger('reportLoad');
            break;
          case 'map':
          case 'rack':
            buildMap(tabId, obj);
            break;
          case 'fatalerror':
            buildFatalError(tabId, obj);
            break;
          case 'empty':
            buildEmpty(tabId, obj);
            break;
          case 'inspectorForm':
            buildInspectorForm(tabId, obj);
            break;
          case 'showcaseForm':
            buildShowcaseForm(tabId, obj);
            break;
          default:
            EventMgr.trigger('pullMsg', { msg: 'Do not support type = "' + type + '" of metadata' });
        }
        //handler for autoupdate
        //@TODO this shit must to rewrite
        delay = obj.autoupdate;

        if (!tabs[tabId]) { return; }

        if (tabs[tabId].timeId) {
          clearTimeout(tabs[tabId].timeId);
        }
        if (obj.autoupdate !== undefined) {
          timeId = setTimeout(function(tabId, delay) {
            return function() {
              EventMgr.trigger('updateTab', { tabId: tabId, delay: delay });
            };
          } (tabId, delay), obj.autoupdate * 1000);
          tabs[tabId].autoupdate = true;
          tabs[tabId].timeId = timeId;

        } else {
          tabs[tabId].autoupdate = false;
          tabs[tabId].timeId = undefined;
        }
        //show tips
        if (obj.tips) {
          setTimeout(function() {
            EventMgr.trigger('showTips', {
              tips: obj.tips,
              inTab: true,
              tabId: tabId,
              sameModule: obj.sameModule });
          }, 1);
        }
      },
      //build tab with list/table
      buildList = function(tabId, obj) {
        var plid = '',
            elid = '',
            pagerParam = '',
            breadcrumb,
            body = prepareTab(obj, tabId);
        if (obj.plid) {
          //what the hell?
          plid = '&plid=' + encodeURIComponent(obj.plid);
        }
        if (obj.elid) {
          elid = '&elid=' + encodeURIComponent(obj.elid);
        }

        if (obj.sortOrder) { pagerParam += '&p_order=' + obj.sortOrder; }
        if (obj.sortCol) { pagerParam += '&p_sort=' + obj.sortCol; }
        if (obj.pager.pager === 'true') {
          pagerParam += '&p_num=' + obj.pager.pageNum +
              '&p_cnt=' + obj.pager.pageCnt;
        }

        //flag for render bottom bar
        obj.sbar = true;
        if (App.Global.warning) {
          obj.warning = App.Global.warning;
        }
        if (obj.selid) {
          App.Global.selid = obj.selid;
        }
        if (obj.scrollTop) {
          App.Global.scrollTop = obj.scrollTop;
        }
        obj.tabId = tabId;

        //check for extra confirm
        if (obj.warning) {
          var warning = $.extend({}, obj.warning);
          EventMgr.trigger('checkWarningForConfirm', { d: obj, w: warning });
        }
        var table = renderTable(obj);
        //render pager
        var pager = '';
        if (obj.pager.pager === 'true') {
          pager = buildPager(obj.pager, tabId);
        }
        var filter = '';
        if (obj.filter === 'true') {
          if (obj.activeFilter.status) {
            filter = 'filter filter-hide filter-set';
          } else {
            filter = 'filter filter-hide';
          }
        }

        breadcrumb = getBreadcrumb(obj.breadcrumb);
        delete obj.breadcrumb.name;
        storage.breadcrumb[tabId] = obj.breadcrumb;

        body.autoupdate = (obj.autoupdate !== undefined);
        body.tsettings = App.u.escapeQuote(obj.hintTsettings) || '';
        body.hAutoupdate = App.u.escapeQuote(obj.hintAutoupdate) || '';
        body.hExport = App.u.escapeQuote(obj.hintExport) || '';
        body.hSelectAll = App.u.escapeQuote(obj.hintSelectAll) || '';
        body.fHelp = App.u.escapeQuote(obj.hintFilter) || '';
        body.pNum = obj.pager.pageNum;
        body.porder = obj.sortOrder;
        body.sortCol = obj.sortCol;
        body.pcnt = obj.pager.pageCnt;
        body.breadcrumb = breadcrumb;
        body.plidAttr = obj.plid ? 'data-plid= "' + obj.plid + '"' : '';
        body.convertAttr = obj.convert ? 'data-convert=' + obj.convert : '';
        body.oplid = obj.plid || '';
        body.tsplid = obj.tsplid || '';
        body.table = table;
        body.progressid = obj.progressid;
        //for toolbar btn
        body.tabIdAttr = 'data-parent=' + tabId;
        body.pager = pager;
        body.filter = filter;
        body.afilter = obj.activeFilter;
        body.param = pagerParam;
        body.livefilter = obj.liveFilter || '';

        tabs[tabId].body = body;
        //save model
        tabs[tabId].__content = obj.content;
        tabs[tabId].__headers = obj.headers;

        App.Global.bannerHtml = null;
        App.Global.targetId = '';
        //APP.Global.warning = null;

        if (obj.filter === 'true') {
          tabs[tabId].filter = true;
          tabs[tabId].filterFunc = obj.filterFunc;
        } else {
          tabs[tabId].filter = false;
        }

        EventMgr.trigger('builtTab', {
          tab: tabs[tabId],
          newtab: obj.newtab,
          targetTabId: obj.targetTabId,
          iType: obj.iType,
          srcData: obj });

        activateNewTab(tabId, obj.newtab, obj.iType);

        if (obj.children) {
          EventMgr.trigger('loadChildren', {
            parent: tabId,
            children: obj.children });
        }
        //if tab have progressbar - run it
        if (obj.progressid) {
          var param = { elid: obj.progressid, func: 'progress.get' };
          EventMgr.trigger('ajaxRequest', {
            url: pageInfo.url,
            param: param,
            invar: { tabId: tabId, param: param, progresstype: undefined },
            type: 'get',
            outtype: 'json',
            trfunc: 'progressBarResponse',
            queue: 'noqueue' });
        }
        //if tab have diagram - insert it
        if (obj.diagram && obj.diagram[0]) {
          EventMgr.trigger('appendListWithDiagram', {
            diagram: obj.diagram[0],
            content: obj.content,
            tabId: tabId,
            gid: 'diagram-' + tabId });
        }
        //check for saved live filter
        if (obj.liveFilter) {
          $('#' + tabId + '-search').trigger('keyup');
        }
      },
      //build tab with form
      buildForm = function(tabId, obj) {
        var body = prepareTab(obj, tabId);

        if (!obj.form) { return; }

        obj.form.id = tabId;
        obj.form.formflags = obj.formflags || {};
        obj.form.parent = obj.parent || '';
        obj.form.func = obj.func;

        body = prepareFormTab(obj, tabId, body);

        tabs[tabId].formModel = body.model;
        tabs[tabId].formSource = body.formSource;

        tabs[tabId].body = body;

        EventMgr.trigger('builtTab', {
          tab: tabs[tabId],
          newtab: obj.newtab,
          targetTabId: obj.targetTabId,
          iType: obj.iType,
          srcData: obj });

        activateNewTab(tabId, obj.newtab, obj.iType);
        if (obj.error) {
          EventMgr.trigger('focusOnErrorField', { tabId: tabId });
        }
      },
      //build tab with dashboard
      buildDashboard = function(tabId, obj) {
        var msg;
        tabs[tabId] = new TabObj(tabId, 1, 'dashboard');

        if (!obj.error && obj.blocks) {
          tabs[tabId].body = renderDashboard(obj.blocks);
        } else if (obj.lateLoad) {
          msg = pageInfo.loading;
          /*jslint sub: true*/
          tabs[tabId].body = { id: tabId, top: msg, left: '', right: '' };
          /*jslint sub: false*/
        } else if (!obj.shithappend) {
          msg = templates.fatalError({ message: obj.ermsg, ref: false });
          tabs[tabId].body = { 'id': tabId, top: msg, left: '', right: '' };
        } else {
          msg = pageInfo.loading;
          tabs[tabId].body = { id: tabId, top: msg, left: '', right: '' };
          //shit happend trying again
          setTimeout(function() {
            var url = pageInfo.url,
                param = { func: 'dashboard' };
            EventMgr.trigger('ajaxRequest', {
              url: url,
              param: param,
              invar: { exType: 'dashboard' },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponse',
              queue: 'dashboard' });
          } , 500);
        }
        //if was error
        $('#cont-tab0').remove();

        tabs[tabId].func = obj.func;

        EventMgr.trigger('builtTab', { tab: tabs[tabId] });

        defaultTab = tabId;
        //if dashboard loaded after list/form
        /*jslint sub: true*/
        if (!tabs['tab1'] || !tabs['tab1'].active) {
          activateNewTab(tabId);
        } else {
          tabs['tab0'].deactive();
        }
        /*jslint sub: false*/
      },

      buildFatalError = function(tabId, obj) {
        var ref, refreshLink,
            sTabId = obj.targetTabId || tabId,
            cb;
        $('.m-item.loading').removeClass('loading');
        if (obj.__src === 'groupAction' || obj.__src === 'report' ||
             obj.__src === 'toolbarAction-refresh') {
          EventMgr.trigger('tabLoadingHide', { tabId: obj.tabId });
          if (obj.__src === 'groupAction') {
            EventMgr.trigger('reloadTab', { tabId: obj.tabId, filter: true });
          }
        } else if (obj.__src === 'wizardLink') {
          EventMgr.trigger('tabLoadingHide', { tabId: obj.tabId });
          sTabId = false;
        } else if (obj.targetTabId) {
          EventMgr.trigger('tabLoadingHide', { tabId: obj.targetTabId ||
                obj.waitingTabId });
        } else if (obj.waitingTabId) {
          //reset to default form state
          EventMgr.trigger('tabLoadingHide', { tabId: obj.waitingTabId });
          resetToDefaultFormButton(obj.waitingTabId);
        }
        if (obj.ref) {
          ref = pageInfo.url + obj.ref;
        }
        if (obj.ertype === 'unavailable') {
          refreshLink = obj.sourceParamString;
        }
        //check for exist tab, and close it
        if (sTabId) {
          if (tabs[sTabId]) {
            closeTab({ preventDefault: function() {} }, sTabId);
          }
        }
        //reload parent, becase it can be unexist elem
        if (obj.parent) {
          cb = function() {
            EventMgr.trigger('reloadTab', { tabId: obj.parent, __src: 'fatalError' });
          };
        }
        var html = templates.fatalAlert({
          msg: obj.ermsg,
          ref: ref,
          refreshLink: refreshLink,
          refreshLinkMsg: pageInfo.tryreload,
          moreMsg: pageInfo.moreinfo
        });
        EventMgr.trigger('showAlert', {
          msg: html,
          callback: cb });
      },

      buildReport = function(tabId, obj) {
        //@todo вынести
        var bands,
            body = prepareTab(obj, tabId);

        obj.form.id = tabId;
        obj.form.func = obj.func;
        obj.reports.func = obj.func;

        bands = renderBands(obj.reports, tabId);
        body = prepareFormTab(obj, tabId, body);

        body.helpType = 'default';
        body.helpurl = '';
        body.type = 'report';
        body.bands = bands;
        body.reportInfo = obj.reportInfo;

        tabs[tabId].body = body;

        EventMgr.trigger('builtTab', {
          tab: tabs[tabId],
          newtab: obj.newtab,
          bands: obj.reports,
          targetTabId: obj.targetTabId});

        activateNewTab(tabId, obj.newtab, obj.iType);
      },

      buildMap = function(tabId, obj) {
        var body = prepareTab(obj, tabId),
            ermsg,
            type = obj.type;

        if (obj.ermsg && !obj.erobj) {
          ermsg = templates.banner({ message: {
            status: 'error',
            classes: '',
            id: tabId,
            text: App.Common.wordWrap(obj.ermsg, 100),
            ref: false,
            refText: pageInfo.moreinfo,
            dismiss: obj.msg.dismiss
          } });
        }

        body.helpType = 'default';
        body.helpurl = '';
        body.type = type;
        body.plid = (obj.plid) ? String(obj.plid).replace(/"/g, '&quot;') : '';
        body.elid = (obj.elid) ? String(obj.elid).replace(/"/g, '&quot;') : '';
        body.parent = obj.parent ? obj.parent : '';
        body.ermsg = ermsg;
        body.btng = obj.btng ? obj.btng : [];
        body.btnview = obj.btnview ? 'o-' + obj.btnview : '';
        body.plidAttr = obj.plid ? 'data-plid= "' + obj.plid + '"' : '';
        body.convertAttr = obj.convert ? 'data-convert=' + obj.convert : '';

        tabs[tabId].body = body;

        EventMgr.trigger('builtTab', {
          tab: tabs[tabId],
          map: obj[type],
          newtab: obj.newtab,
          targetTabId: obj.targetTabId });

        activateNewTab(tabId, obj.newtab, obj.iType);
      },

      buildEmpty = function(tabId, obj) {
        var body = pageInfo.loading,
            curTab;
        prepareTab(obj, tabId);
        curTab = tabs[tabId];
        curTab.body = { id: tabId, text: '', comment: body };
        curTab.status = 0;
        curTab.notLoaded = true;
        curTab.pin = obj.pin;

        if (obj.children) {
          EventMgr.trigger('loadChildren', {
            parent: tabId,
            children: obj.children });
        }

        EventMgr.trigger('builtTab', {
          tab: curTab,
          newtab: obj.newtab,
          targetTabId: obj.targetTabId });
        EventMgr.trigger('changedTabs', { tabs: tabs });
      },

      buildInspectorForm = function(tabId, obj) {
        //if fatal error without form
        if (obj.error && obj.userexpMsg === undefined) {
          EventMgr.trigger('pullMsg', { msg: obj.ermsg });
          return;
        }
        var body = prepareTab(obj, tabId);
        //rename id
        delete tabs[tabId];
        tabId = 'modal1';
        body.id = tabId;

        if (!obj.form) { return; }

        obj.form.id = tabId;

        body = prepareFormTab(obj, tabId, body);

        body.parent = obj.sourceTab;

        var html = templates.tabContForm(body);
        EventMgr.trigger('readyInspectorFormHtml', html);
      },
      //build external form
      buildShowcaseForm = function(tabId, obj) {
        tabId = 'tab0';
        var body = prepareTab(obj, tabId);
        obj.form.id = tabId;

        obj.form.formflags = obj.formflags || {};

        obj.form.parent = obj.parent || '';

        body = prepareFormTab(obj, tabId, body);

        tabs[tabId].formModel = body.model;
        tabs[tabId].formSource = body.formSource;

        body.showcase = true;
        body.nostep = !pageInfo.wizard_step;
        body.notitle = !pageInfo.title;

//        body.parent = obj.sourceTab;

        var html = templates.tabContForm(body);
        EventMgr.trigger('readyShowcaseFormHtml', html);
      },
      //fill body object for form
      prepareFormTab = function(obj, tabId, body) {
        if (!body || !obj) { return; }
        var ermsg = '',
            userexpMsg = String(obj.userexpMsg)
                .replace('__value__', obj.userexpHideFields),
            renderObject;
        //banner
        if (obj.ermsg && !obj.erobj) {
          ermsg = templates.banner({ message: {
            status: 'error',
            classes: 'i-message__outer-link',
            id: tabId,
            text: App.Common.wordWrap(obj.ermsg, 100),
            ref: obj.ref ? obj.ref : false,
            refText: pageInfo.moreinfo,
            dismiss: obj.msg.dismiss || pageInfo.dismiss
          } });
        }

        body.form = obj.form;
        body.tabClass = obj.testMode ? ' tab-content_st_testmode' : '';
        body.formstatus = obj.formstatus;
        body.files = obj.withfiles ? 'withfiles' : 'withoutfiles';
        body.bands = '';
        body.progress = (obj.progress ? (obj.progress + '_' + body.itemId) : false);
        body.helpType = obj.helpType;
        body.helpurl = obj.helpurl;
        obj.form.testMode = obj.testMode;
        renderObject = renderFormItems(obj.form, tabId);
        body.pages = renderObject.html;
        body.model = renderObject.model;
        body.formSource = renderObject.source;
        body.action = pageInfo.binary;
        body.step = pageInfo.step;
        body.formflags = (obj.formflags) ? obj.formflags : {};
        body.buttons = obj.buttons;
        body.parent = obj.parent ? obj.parent : '';
        body.plid = (obj.plid) ? String(obj.plid).replace(/"/g, '&quot;') : '';
        body.elid = (obj.elid) ? String(obj.elid).replace(/"/g, '&quot;') : '';
        body.plidAttr = obj.plid ? 'data-plid= "' + obj.plid + '"' : '';
        body.type = 'form';
        //body.isUserexp = obj.isUserexp;
        body.userexp = obj.userexp;
        body.userexpMsg = userexpMsg;
        body.reportInfo = undefined;
        body.arePages = (obj.form.length > 1) ? 'a-lot-of-pages' : '';
        body.ermsg = ermsg;
        body.__innervars = obj.__innervars ? objectToString(obj.__innervars) : '';

        //add buttons to formModel
        if (obj.buttons) {
          body.model.__buttons = obj.buttons;
        }

        return body;
      },

      objectToString = function(object) {
        var stringVars = '',
            index = 0;
        for (var key in object) {
          if (index !== 0) {
            stringVars += '|';
          }
          index++;
          stringVars += key + ':' + object[key];
        }

        return stringVars;
      },

      isAlreadyPinTab = function(obj, tabId) {
        var func = obj.func || (obj.urlObj ? obj.urlObj.func : ''),
            already = false,
            tab;
        for (var key in tabs) {
          tab = tabs[key];
          if (key === tabId) {
            return true;
          }
          if (tab && tab.paramObjAll && tab.paramObjAll.func === func) {
            return true;
          } else if (tab && tab.urlObj && tab.urlObj.func === func) {
            return true;
          }
        }
        return already;
      },
      //fill body object for all types
      prepareTab = function(obj, tabId) {
        var body = {}, title, titleLen = 0, shortTitle,
            hint, tImg, tStyle, imgId,
            selfUrl = obj.selfUrl ?
                obj.selfUrl.replace(/sfrom=ajax/g, '') : '',
                curTab;

        //dont show pin when isPin && from menu
        obj.pin = (obj.pin && obj.__src !== 'menuAction');
        //check already same pin tab
        if (obj.pin && !isAlreadyPinTab(obj, tabId)) {
          obj.pin = true;
        }
        /* jshint camelcase: false*/
        body.commonDir = pageInfo.commonDir;
        body.itemId = obj.type + new Date().getTime();
        body.id = tabId;
        body.func = obj.func;
        body.theme = obj.theme;
        body.hReload = App.u.escapeQuote(obj.hintReload) || '';
        body.comment = App.u.escapeQuote(obj.msg_loading) || '';
        body.hFavorite = App.u.escapeQuote(obj.hintFavorite) || '';
        body.hUnfavorite = App.u.escapeQuote(obj.hintUnFavorite) || '';
        body.hPrint = App.u.escapeQuote(obj.hintPrint) || '';
        body.hCopy = App.u.escapeQuote(obj.hintCopy) || '';
        body.hPdf = App.u.escapeQuote(obj.hintPdf) || '';
        body.hHelp = App.u.escapeQuote(obj.hHelp) || '';
        body.hintUnpin = App.u.escapeQuote(obj.hintPin) || '';
        body.hintPin = App.u.escapeQuote(obj.hintUnpin) || '';
        body.hDevel = 'out=devel';
        body.breadcrumb = '';
        body.message = '';
        body.selfurl = pageInfo.url + '?' + getQueryString(obj.urlObj);
        body.devMode = devMode;
        body.testMode = obj.testMode;
        body.pdfOn = pdfOn;
        body.btng = obj.btng ? obj.btng : [];
        body.btnview = obj.btnview ? 'o-' + obj.btnview : '';
        body.favorite = obj.favorite || false;
        body.pin = obj.pin || false;
        body.inmenu = !!App.Dom.byId('l-' + String(obj.func).replace(/\./g, '_'));
        //for btn in form
        body.parentAttr = obj.parent ? 'data-parent=' + obj.parent : '';
        //for toolbar btn
        body.tabIdAttr = 'data-parent=' + tabId;
        //make permalink
        var permaLinkObj = $.extend({}, obj.urlObj);
        delete permaLinkObj.sfrom;
        delete permaLinkObj.operafake;
        delete permaLinkObj.clickstat;
        permaLinkObj.startform = permaLinkObj.func;
        delete permaLinkObj.elname;
        delete permaLinkObj.func;
        body.permaLink = pageInfo.url + '?' + getQueryString(permaLinkObj);
        //remove error if not tagret tab
        if (App.Global.targetId && App.Global.targetId !== tabId &&
            App.Global.bannerHtml && App.Global.bannerHtml.length > 0) {
          var msgLen = App.Global.bannerHtml.length;
          while (msgLen--) {
            if (App.Global.bannerHtml[msgLen].status === 'error') {
              App.Global.bannerHtml.splice(msgLen, 1);
            }
          }
        }
        if (obj.message) {
          if (App.Global.bannerHtml) {
            body.message = obj.message.concat(App.Global.bannerHtml);
          } else {
            body.message = obj.message;
          }
        } else {
          if (App.Global.bannerHtml) {
            body.message = App.Global.bannerHtml;
          }
        }
        if (body.message) {
          //check for message exists
          var l = body.message.length;
          while (l--) {
            if (body.message[l].refText === '') {
              body.message[l].refText = obj.msg.moreinfo;
            }
            if (body.message[l].dismiss === '') {
              body.message[l].dismiss = obj.msg.dismiss || pageInfo.dismiss;
            }
          }
        }

        if (!obj.targetTabId) {
          tabs[tabId] = new TabObj(tabId, 1, obj.type, selfUrl);
        } else {
          tabs[tabId].type = obj.type;
          tabs[tabId].selfUrl = selfUrl;
        }
        //set menu func name
        if (obj.__src_func) {
          tabs[tabId].menuFunc = obj.__src_func;
        }

        curTab = tabs[tabId];

        if (obj.iType !== 'hardUpdate' && obj.iType !== 'replace') {
          if (!obj.parent) {
            curTab.hType = 'parent';
          } else {
            if (tabs[obj.parent] === undefined) { return; }
            curTab.hType = 'child';
            curTab.parent = obj.parent;
            curTab.gParent = tabs[obj.parent].gParent ?
                tabs[obj.parent].gParent : obj.parent;
            if (obj.type === 'empty') {
              tabs[obj.parent].child = tabId;
            }
          }
        } else {
          obj.parent = curTab.parent;
        }

        //get title
        if (obj.title && obj.title !== '') {
          titleLen = obj.title.length;
          if (titleLen < 25) {
            title = obj.title;
          } else {
            title = obj.title.substr(0, 25) + '...';
          }
          if (titleLen < 10) {
            shortTitle = obj.title;
          } else {
            shortTitle = obj.title.substr(0, 10) + '...';
          }
          hint = App.u.escapeQuote(obj.title);
        } else {
          title = '...';
        }
        curTab.title = obj.title;
        body.tabTitle = obj.title;

        //get icon for title
        if (obj.parent) {
          imgId = tabs[tabs[tabId].gParent].func;
        } else {
          imgId = obj.id;
        }
        tImg = getMainImg(imgId, obj.selfIcon, pageInfo.commonDir);
        tStyle = getMainImg(imgId, obj.selfIcon, pageInfo.commonDir, true);

        body.tImg = tImg;
        body.tStyle = tStyle;
        //remember parent params for return parent by cancel
        if (obj.rParent) {
          curTab.rParentObj = tabs[tabId].paramObjAll;
        } else {
          curTab.rParentObj = undefined;
        }

        //set tabs props
        curTab.paramObjAll = obj.urlObj;

        if (obj.type !== 'empty') {
          curTab.notLoaded = false;
        }

        curTab.iType = obj.iType;
        curTab.pinIcon = obj.pinIcon ? obj.pinIcon : getGroupIcon(imgId);
        curTab.pin = obj.pin || false;

        curTab.header = {
          tabId: tabId,
          title: title,
          hint: hint,
          isPin: obj.pin,
          pinIcon: curTab.pinIcon,
          shortTitle: shortTitle,
          theme: pageInfo.theme };


        curTab.func = obj.func;

        curTab.favorite = obj.favorite;

        curTab.features = obj.features;
        curTab.wizard = obj.wizard;
        //make help param
        if (obj.help) {
          curTab.help = obj.help;
        } else if (obj.__src === 'toolbarAction' ||
                   obj.__src === 'okForm' ||
                   obj.__src === 'tSetting') {
          if (obj.parent && tabs[obj.parent]) {
            curTab.help = tabs[obj.parent].help + '.' + obj.__srcBtn;
          } else {
            curTab.help = obj.func;
          }
        } else {
          //obj.__src === 'menuAction' ||
          //  obj.newtab ||
          //  obj.__src === 'dashboardBtn'
          curTab.help = obj.func;
        }
        body.help = curTab.help;

        return body;
      },

      getQueryString = function(queryObj) {
        var paramString = '', j = 0, curValue;
        for (var key in queryObj) {
          if (key !== '') {
            if (j !== 0) {
              paramString += '&';
            }
            //encode params
            paramString += key + '=' + encodeURIComponent(queryObj[key]);
            j++;
          }
        }
        return paramString;
      },

      /**
       * activate tab when switching
       * @param {String} tabId
       */
      activateTab = function(tabId) {
        var gParent = '', prevTabId = activeTab, pTabId = '', selid = [], func;
        //checking, probably deleted it early
        if (tabs[activeTab]) {
          tabs[activeTab].deactive();
          //remove actChild from gParent if child
          if (tabs[activeTab].gParent) {
            gParent = tabs[activeTab].gParent;
            tabs[gParent].actChild = null;
          }
        }
        //write actChild to gParent if child
        if (tabs[tabId].gParent) {
          gParent = tabs[tabId].gParent;
          tabs[gParent].actChild = tabId;
        }
        tabs[tabId].activate();
        if (!gParent) {
          pTabId = tabId;
        } else {
          pTabId = gParent;
        }

        EventMgr.trigger('activateTab', { tabId: tabId });
        EventMgr.trigger('changedTab', { tabId: tabId, prevTabId: prevTabId });
        EventMgr.trigger('changeTabStatus', {
          func: getMenuFunction(pTabId),
          type: 'activate' });
        EventMgr.trigger('changedTabs', { tabs: tabs });
        //EventMgr.trigger('switchTab', {tabId : tabId});
        activeTab = tabId;
        //updateTab or load if notloaded
        if (tabs[tabId].aupdate || tabs[tabId].notLoaded) {
          selid = true;
          EventMgr.trigger('reloadTab', {
            tabId: tabId,
            selid: selid,
            help: true,
            filter: true });
        }
      },

      isPinTab = function(tabId) {
        var isPin = false;
        if (tabs[tabId] && tabs[tabId].pin) {
           isPin = true;
        } else if (tabs[tabId] && tabs[tabId].gParent) {
          if (tabs[tabs[tabId].gParent] && tabs[tabs[tabId].gParent].pin) {
            isPin = true;
          }
        }
        return isPin;
      },

      getMenuFunction = function(pTabId) {
        var func = '';
        //get func name
        if (tabs[pTabId]) {
          if (tabs[pTabId].menuFunc) {
            func = tabs[pTabId].menuFunc;
          } else if (tabs[pTabId].func) {
            func = tabs[pTabId].func;
          } else if (tabs[pTabId].paramObjAll) {
            func = tabs[pTabId].paramObjAll.func;
          }
        }
        return func;
      },
      /**
       * activate new opened tab
       * @param {String} tabId Activated tabId
       * @param {Boolean} empty Empty Tabrea
       * @param {String} iType
       */
      activateNewTab = function(tabId, empty, iType) {
        var isPin = isPinTab(activeTab);
        if (activeTab === tabId) {
          tabs[tabId].activate();
          return;
        }
        var hType = tabs[tabId].hType,
            parent = tabs[tabId].parent || null,
            gParent = tabs[tabId].gParent || null,
            pTabId, child,
            update = (iType === 'hardUpdate' || iType === 'softUpdate'),
            replace = (iType === 'replace');
        //delete active tab if not default and not child
        if (activeTab && activeTab !== defaultTab &&
            !empty && hType !== 'child' && tabId !== 'tab0' &&
            !update && !replace && !isPin) {
          //close tabs group (parents & children)
          closeTabGroup(activeTab);
        }
        //delete sibling child
        if (parent && tabs[parent].child && !update && !replace) {
          child = tabs[parent].child;
          closeChildTab(child);
        }

        if (hType === 'child') {
          //write child to parent
          tabs[parent].child = tabId;
          //write actChild to greatParent
          tabs[gParent].actChild = tabId;
        }
        if (tabs[activeTab]) {
          tabs[activeTab].deactive();
        }
        tabs[tabId].activate();

        if (!gParent) {
          pTabId = tabId;
        } else {
          pTabId = gParent;
        }
        activeTab = tabId;
        //remove loading className
        $('.m-item.loading').removeClass('loading');
        EventMgr.trigger('activateTab', { tabId: tabId });
        EventMgr.trigger('changeTabStatus', {
          func: getMenuFunction(pTabId),
          type: 'activate' });
        EventMgr.trigger('changedTabs', { tabs: tabs });
      },
      /**
       * finding out new active tab
       * @param {String} tabId closed TabId
       */
      newActiveTab = function(tabId, src) {
        var newActTab, gParent, pTabId;
        //check actChild
        if (!tabs[tabId]) { return; }
        if (tabs[tabId].gParent) {
          gParent = tabs[tabId].gParent;
          if (!tabs[gParent].actChild) {
            return;
          }
        } else if (tabs[tabId].actChild) {

        } else if (tabId !== activeTab) {
          return;
        }
        //set active to dashboard
        if (tabs[tabId].hType === 'parent') {
          if (src === 'backBtn') {
            newActTab = 'tab0';
          } else {
            newActTab = getNextTab(tabId);
          }
        } else {
          //set active to parent
          newActTab = tabs[tabId].parent;
          if (tabs[tabId].gParent) {
            gParent = tabs[tabId].gParent;
            tabs[gParent].actChild = newActTab;
          }
        }
        //set actChild for
        if (tabs[newActTab].gParent) {
          tabs[tabs[newActTab].gParent].actChild = newActTab;
        }

        tabs[newActTab].activate();

        if (!gParent) {
          pTabId = newActTab;
        } else {
          pTabId = gParent;
        }
        activeTab = newActTab;
        EventMgr.trigger('activateTab', { tabId: newActTab });
        EventMgr.trigger('changeTabStatus', {
          func: getMenuFunction(pTabId),
          type: 'activate' });
        EventMgr.trigger('changedTab', { tabId: newActTab });
        EventMgr.trigger('changedTabs', { tabs: tabs });

        if (tabs[newActTab].aupdate || tabs[newActTab].notLoaded) {
          EventMgr.trigger('reloadTab', {
            tabId: newActTab,
            __src: 'activateTab',
            selid: true,
            filter: true });
        }
      },
      //get right or left tab
      getNextTab = function(tabId) {
        var tabsArr = [], ind = 0, selfIndex, next, prev;
        for (var key in tabs) {
          if (tabs[key].hType === 'parent') {
            tabsArr.push(key);
            if (key === tabId) {
              selfIndex = ind;
            }
            ind++;
          }
        }
        next = selfIndex + 1;
        prev = selfIndex - 1;
        if (tabsArr[next]) {
          return getChild(tabsArr[next]);
        } else if (tabsArr[prev]) {
          return getChild(tabsArr[prev]);
        } else {
          return defaultTab;
        }
      },
      //get last child tab
      getChild = function(tabId) {
        var childTabId = tabId;
        if (tabs[tabId].child) {
          childTabId = getChild(tabs[tabId].child);
        }
        return childTabId;
      },
      //switch tabs
      switchTabs = function(e) {
        e.preventDefault();
        var tabId = this.getAttribute('data-tabid');

        if (activeTab === tabId) {
          return;
        }
        activateTab(tabId);
        if (tabs[tabId].type === 'form' || tabs[tabId].type === 'report') {
          EventMgr.trigger('switchTabForm', { tabId: tabId });
          EventMgr.trigger('updFormHeight', { tabId: tabId });
        } else {
          EventMgr.trigger('updTableHeight');
        }
        EventMgr.trigger('switchTab', { tabId: tabId });
      },

      closeTabsByMiddleBtn = function(e) {
        if (e.which === 2 || e.button === 1) {
          var tabId = this.getAttribute('data-tabid');
          e.preventDefault();
          if (tabId !== 'tab0') {
            closeTabClickHandler.apply(this, [e]);
          }
        }
      },
      //update tab by dbclick
      upSwitchedTabs = function(e) {
        e.preventDefault();
        var tabId = this.getAttribute('data-tabid');
        EventMgr.trigger('reloadTab', { tabId: tabId, __src: 'dblclickTab', filter: true });
      },
      //append new tab
      appendTab = function(e, data) {
        var tabObj = data.tab,
            newtab = data.newtab || false,
            bands = data.bands || '',
            map = data.map || '',
            tabId,
            isPin = isPinTab(activeTab);
        if (activeTab !== defaultTab && !newtab && !isPin) {
          if (tabs[activeTab].gParent) {
            tabId = tabs[activeTab].gParent;
          } else {
            tabId = activeTab;
          }
        }
        if (!tabObj.iType) {
          tabObj.render().append(tabId).clean();
        } else if (tabObj.iType === 'hardUpdate') {
          tabObj.render().update().clean();
        } else if (tabObj.iType === 'softUpdate') {
          tabObj.softUpdate().clean();
        } else if (tabObj.iType === 'replace') {
          tabObj.render().replace().clean();
        }

        EventMgr.trigger('appended', { tabId: tabObj.id });
        //trigger events
        if (tabObj.type === 'form') {
          EventMgr.trigger('appendForm', {
            tabId: tabObj.id,
            tabObj: tabObj,
            srcData: data.srcData });
        } else if (tabObj.type === 'list') {
          EventMgr.trigger('appendList', { tabId: tabObj.id, srcData: data.srcData });
        } else if (tabObj.type === 'dashboard') {
          EventMgr.trigger('appendDashboard', {});
        } else if (tabObj.type === 'report') {
          EventMgr.trigger('appendReport', { tabId: tabObj.id, bands: bands });
        } else if (tabObj.type === 'map' || tabObj.type === 'rack') {
          EventMgr.trigger('appendMap', { tabId: tabObj.id, map: map });
        }
        //get filter
        if (tabObj.filter === true) {
          EventMgr.trigger('appendFilter', {
            tabId: tabObj.id,
            listParam: tabObj.paramObjAll,
            func: tabObj.filterFunc });
        }
        data = null;
        checkFeatures(tabObj);
      },

      closeTabClickHandler = function(e) {
        e.stopPropagation();
        var tabId = this.getAttribute('rel') || this.getAttribute('data-tabid'),
            isChanged = false,
            isPin = tabs[tabId].pin;
        if (isPin) {
          return;
        }
        if (tabs[tabId] && tabs[tabId].type === 'form' &&
            pageInfo.checkUnsaved) {
          var changedFields = checkFormChange(tabId);
          if (changedFields.isChanged) {
            isChanged = true;
            EventMgr.trigger('confirmBoxShow', {
              callbackOk: closeTab,
              callbackCancel: '',
              self: this,
              text: String(pageInfo.unsavedData)
                  .replace('__VALUE__', changedFields.count) +
                  '<br/><span class="b-text_style_bold">' +
                  changedFields.labels + '</span>',
              args: [e, tabId],
              checkbox: {
                msg: pageInfo.unsavedDontShow,
                cb: unsavedDataCheckboxHandler
              }
            });
          }
        }
        if (!isChanged) {
          closeTab(e, tabId);
        }
      },

      //close tab
      closeTab = function(e, data, src) {
        EventMgr.trigger('closeTab', {});
        var tabId, parent;
        if (data) {
          tabId = data;
        } else {
          tabId = this.getAttribute('rel');
        }
        if (!tabs[tabId]) { return; }
        //check for tab is pin
        if (tabs[tabId] && tabs[tabId].pin) {
          //reload tab if it form
          if (tabs[tabId].type === 'form') {
            EventMgr.trigger('reloadTab', { tabId: tabId, __src: 'pinForm' });
          }
          return;
        }
        EventMgr.trigger('closeTabEvent', { tabId: tabId });

        newActiveTab(tabId, src); //set new active tab
        //killing children
        if (tabs[tabId] && tabs[tabId].child) {
          closeChildTab(tabs[tabId].child);
        }
        //clear child from parent
        if (tabs[tabId] && tabs[tabId].hType === 'child') {
          parent = tabs[tabId].parent;
          tabs[parent].child = null;
        }
        tabs[tabId].close();
        delete tabs[tabId];
        if (e) { e.preventDefault(); }

        EventMgr.trigger('updTableHeight');
        EventMgr.trigger('changedTabs', { tabs: tabs });
      },
      /**
       * close tab's group
       * @param {Stirng} tabId closing tab
       */
      closeTabGroup = function(tabId) {
        EventMgr.trigger('closeTab', { tabId: tabId });
        if (tabs[tabId].child) {
          closeChildTab(tabs[tabId].child);
        }
        if (tabs[tabId].parent) {
          closeParentTab(tabs[tabId].parent);
        }
        if (tabId !== 'tab0') {
          tabs[tabId].close();
          delete tabs[tabId];
          EventMgr.trigger('closeTabEvent', { tabId: tabId });
        }
      },
      /**
       * close tab's parent
       * @param {String} tabId closing tab parent (will remove)
       */
      closeParentTab = function(tabId) {
        EventMgr.trigger('closeTabEvent', { tabId: tabId });
        if (tabs[tabId].parent) {
          closeParentTab(tabs[tabId].parent);
        }
        tabs[tabId].close();
        delete tabs[tabId];
      },
      /**
       * close tab's child
       * @param {Stirng} tabId closing tab child (will remove)
       */
      closeChildTab = function(tabId) {
        EventMgr.trigger('closeTabEvent', { tabId: tabId });
        if (tabs[tabId].child) {
          closeChildTab(tabs[tabId].child);
        }
        tabs[tabId].close();
        delete tabs[tabId];
      },
      //close all tabs
      closeAllTabs = function(e) {
        if (tabs) {
          for (var key in tabs) {
            if (tabs.hasOwnProperty(key)) {
              if (key !== 'tab0') {
               closeTab(e, key);
              }
            }
          }
        }
      },
      //close all tabs expect active
      closeOthersTabs = function(e) {
        if (tabs) {
          var actTabId = $('.tab-content_st_active').attr('data-tabid'),
              actParentTabId = tabs[actTabId].gParent ? tabs[actTabId].gParent : actTabId;
           for (var key in tabs) {
            if (tabs.hasOwnProperty(key)) {
              if (key !== 'tab0' && tabs[key].hType === 'parent' && key !== actParentTabId) {
               closeTab(e, key);
              }
            }
          }
        }
      },
      //back btn handler
      backBtnHandler = function(e, data) {
        e.preventDefault();
        var tabId, parentId, selid = [],
            self = $(this),
            plid = self.parents('.toolbar').attr('data-plid'),
            isReport = self.closest('.tab-content').attr('data-report') === 'report';
        if (data) {
          tabId = data;
        } else {
          tabId = this.getAttribute('rel');
        }
        selid.push(plid);
        parentId = tabs[tabId].parent;
        if (App.Dom.hasClass(this, 'updatetab')) {
          var pos = plid.lastIndexOf('/'),
              url = pageInfo.url,
              parent = null,
              targetId = tabId,
              funcName = (this.getAttribute('data-url')).replace('func=', ''),
              param = {};
          param.func = funcName;
          if (pos !== -1) {
            plid = plid.substring(0, pos);
            pos = plid.lastIndexOf('/');
            if (pos === -1) {
              param.elid = plid;
            } else {
              param.plid = plid.substring(0, pos);
              param.elid = plid.substr(pos + 1);
            }
          }
          EventMgr.trigger('ajaxRequest', {
            url: url,
            param: param,
            invar: { parent: parent, targetTabId: targetId, iType: 'replace', __src: 'toolbarAction' },
            type: 'get',
            outtype: 'json',
            trfunc: 'ajaxResponse',
            failfunc: 'failCommonAjaxResponse',
            queue: 'noqueue' });
          EventMgr.trigger('tabLoading', { tabId: tabId });
        } else {
          closeTab.apply(this, [e, tabId, 'backBtn']);
          if (parentId && !isReport) {
            EventMgr.trigger('reloadTab', {
              tabId: parentId,
              __src: 'backBtn',
              selid: selid,
              filter: true });
            EventMgr.trigger('tabLoading', { tabId: parentId });
          }
        }
      },
      //update tab by autoupdate
      updateTab = function(e, data) {
        var tabId = data.tabId,
            delay = data.delay,
            selid;
        if (activeTab !== tabId) {
          if (tabs[tabId] !== undefined && tabs[tabId].autoupdate) {
            setTimeout(function(tabId, delay) {
              return function() {
                EventMgr.trigger('updateTab', { tabId: tabId, delay: delay });
              };
            } (tabId, delay), delay * 1000);
            tabs[tabId].autoupdate = true;
          }
        } else {
          selid = true;
          EventMgr.trigger('reloadTab', {
            tabId: tabId,
            __src: 'autoUpdate',
            selid: selid,
            filter: true });
        }
      },
      //stop autoupdate by click button
      stopAutoUpdate = function(e) {
        e.preventDefault();
        var tabId = this.getAttribute('data-tabid');
        if (tabs[tabId]) {
          tabs[tabId].autoupdate = false;
          clearTimeout(tabs[tabId].timeId);
          App.Dom.removeClass(this, 'i-list-icon__stop');
          App.Dom.addClass(this, 'b-elem_style_gracescale');
        }
      },
      //get elid selected elements
      getSelectedElems = function(tabId) {
        var selid = [],
            elid;
        $('#cont-' + tabId + ' .list_table tr.selected:not(".filtred")')
            .each(function() {
              elid = this.getAttribute('data-elid');
              selid.push(elid);
            });
        return selid;
      },
      getScrollTop = function(tabId) {
        var elem = App.Dom.byId('ltwr-' + tabId + '-scrollbar-handler'),
            top = 0;
        if (elem) {
          top = parseFloat(elem.style.top, 10);
        }
        return top;
      },
      //render table
      //return with unopenned <div>,
      // for external usage need to add unclosed <div>
      renderTable = function(args) {
        var keyVar,
            headers = args.headers,
            headersName = {},
            tableHead, tableBody, output;
        /* jslint forin: true */
        for (keyVar in headers) {
          headersName[headers[keyVar].name] = {
            type: headers[keyVar].type,
            hidden: headers[keyVar].hidden ? true : false
          };
        }
        args.headersName = headersName;
        tableHead = renderTableHeader(args);
        tableBody = renderTableBody(args);
        output = tableHead.output;
        output += tableBody;
        if (args.sbar) {
          output += '<div class="bottom-bar">';
          output += tableHead.sBar;
        }
        return output;
      },

      renderTableHeader = function(args) {
        var output = '',
            dHeader = '',
            sBar = '',
            tabId = args.tabId,
            headers = args.headers,
            props = args.props,
            elKeyName = args.elKeyName || args.elKey,
            elKey = args.elKey,
            colLen = headers.length,
            keyVar, header, className, triangle, thAttr, divAttr, rowHandler,
            dataSorttype, text, total, first;

        output += '<table class="list_table init b-list__table_type_body" id="lt-' + tabId + '">' +
            '<thead><tr>';
        dHeader += '<table id="sort_table-' + tabId +
            '" class="sort_table b-list__table_type_head">' +
            '<thead class="1"><tr>';
        sBar += '<table id="statusbar-' + tabId +
            '" class="statusbar b-list__table_type_footer">' +
            '<tbody class="1"><tr>';
        /* jslint forin: true */
        for (keyVar in headers) {
          header = headers[keyVar];
          //check for only data diagram col
          if (header && header.hidden) {
            continue;
          }
          className = header.hint ? ' hint ' : '';
          className += header.align ? ' align-' + header.align : '';
          if (header.minimize) {
            className += ' i-minimize-col ';
          }
          triangle = '';
          first = (keyVar - 0 === 0);
          thAttr = ' data-colname="' + header.name + '" ';
          divAttr = ' data-colname="' + header.name + '" ';
          divAttr += ' data-coln="' + keyVar + '" ';
          thAttr += header.total ? ' data-type="' + header.type + '" ' : '';
          thAttr += header.nestedreport ?
              ' data-nestedreport="' + header.nestedreport + '" ' : '';
          thAttr += header.nestedlist ?
              ' data-nestedlist="' + header.nestedlist + '" ' : '';
          thAttr += header.nestedlistBlank ?
              ' data-nestedlist-blank="true" ' : '';
          thAttr += header.editform ?
              ' data-editform="' + header.editform + '" ' : '';
          header.hint = header.hint ?
              App.u.escapeQuote(header.hint) : undefined;
          thAttr += header.hint ? ' data-hint="' + header.hint + '" ' : '';
          thAttr += header.width ? ' width="' + header.width + '"' : '';
          //resize col handler
          rowHandler = (keyVar - 0 !== 0) ?
              '<div class="rowHandler"><div class="rowLine1"></div>' +
                  '<div class="rowLine2"></div></div>' : '';
          thAttr += header.edit ? ' data-edit-func="' + header.edit + '" ' : '';
          if (elKey === header.name) {
            className += ' keyfield ';
          }
          if (elKeyName === header.name) {
            className += ' keynamefield ';
          }
          if (first) {
            className += 'first ';
            text = pageInfo.selected + ' - 1';
          } else {
            text = '';
          }
          if (colLen - 1 === keyVar) {
            className += 'last';
          }
          //sorting cols
          if (header.sort && !args.band) {
            className += ' td_sort i-tip-target_st_sort i-tip-target_st_msort';
            dataSorttype = header.sort;
          } else if (header.sort && args.band) {
            className += ' td_client_sort i-tip-target_st_sort i-tip-target_st_msort';
            dataSorttype = header.sort;
          }
          divAttr += dataSorttype ? ' data-sorttype="' + dataSorttype + '" ' : '';
          //sorted col
          if (header.sorted) {
            if (String(header.sorted).match(/\+/)) {
              //asc
              triangle = '<div class="triangl-bot triangle"></div>';
            } else {
              //desc
              triangle = '<div class="triangl-top triangle"></div>';
            }
            if (args.sortedCount > 1) {
              triangle += '<div class="b-sort-table__sort-order">' +
                  String(header.sorted).charAt(1) + '</div>';
            }
            divAttr += 'sorting="' + header.sorted + '"';
          } else {
            triangle = '<div class="triangle"></div>';
          }

          triangle += '<div class="filter-icon hint"  data-hint=""></div>';
          //check for development flag
          if (devMode) {
            triangle += '<a href="#" class="devel-link-settings devel-link-settings--col" data-elid="' + header.name + '" data-tabid="' + tabId + '"></a>';
            triangle += '<a href="#" class="devel-link-delete devel-link-delete--col" data-elid="' + header.name + '" data-name="' + header.pName + '" data-tabid="' + tabId + '"></a>';
            if (first) {
              triangle += '<a href="#" class="devel-link-add devel-link-add--col"  data-tabid="' + tabId + '"></a>';
            }
          }

          if (header.type === 'button') {
            for (keyVar in header.confirm) {
              if (header.confirm[keyVar] !== '') {
                divAttr += ' data-confirm-' + keyVar + '="' +
                    header.confirm[keyVar] + '" ';
              }
            }
          }
          //@todo warning!!! diff html
          output += '<th  class="' + className + '" ' + thAttr + '>' +
              '<div class="ovf" ' + divAttr +'><span class="data-wrapper" data-mn="' + header.name + '" data-fn="' + args.func + '">' +
              header.pName + '</span>' + triangle +  '</div> ' + rowHandler + '</th>';
          dHeader += '<td  class="' + className + '" ' + thAttr + '>' +
              '<div class="ovf"  ' + divAttr + '><span class="data-wrapper" data-mn="' + header.name + '" data-fn="' + args.func + '">' +
              header.pName + '</span>' + triangle +  '</div> ' + rowHandler + '</td>';
          //row selected
          if (keyVar - 0 === 0) {
            sBar += '<td ' + thAttr + '>' +
                '<div class="ovf"><span class="sb-result sb-result_index_0 sb-result_st_active" data-mn="msg_total" data-fn="desktop">' +
                pageInfo.total + ': ' + args.pager.pageElems +
                '</span><span class="sb-selected sb-selected_index_0" data-mn="msg_selected" data-fn="desktop">' + pageInfo.selected +
                ': 1</span></div></td>';
          } else {
          //count total row
            if (header.total !== '') {
              //check for type props or not
              if (typeof header.total === 'object') {
                total = renderPropsStat(header.total, props);
                className += ' data';
              } else {
                total = header.total;
                className += ' data';
              }
            } else {
              total = '';
              className += ' empty';
            }

            sBar += '<td ' + thAttr + '>' +
                '<div class="ovf">' +
                '<span class="sb-result sb-result_st_active sb-result_index_' + keyVar + '">' + total + ' </span>' +
                '<span class="sb-selected sb-selected_index_' + keyVar + '">' + text + '</span></div></td>';
          }
        }

        output += '</tr></thead>';
        dHeader += '</tr></thead></table>';
        output = dHeader + output;
        sBar += '</tr></thead></table>';

        return {
          output: output,
          sBar: sBar };
      },

      renderTableBody = function(args) {
        var output = '<tbody>',
            plid = args.plid ? ' data-plid="' + args.plid + '" ' : '',
            keyVar, contentItem, elid, className, curElKeyName, curElKey,
            id, hint, attr, len,
            headers = args.headers,
            elKeyName = args.elKeyName || args.elKey,
            elKey = args.elKey,
            ii = 0,
            content = args.content;
        args.defProp = args.props ? findDefProp(args.props) : null;
        if (args.backBtn) {
          len = args.headers.length;
          output += '<tr class="back-btn"><td colspan="' + len + '">' +
              '<div class="back-btn-row hint" data-tabid="' + args.tabId + '" >' +
              '<div class="hint back-btn-row-hint" data-hint="' +
              App.u.escapeQuote(App.Common.msg.hintBack) + '"></div></td></tr>';
          ii++;
        }
        //render tbody
        /* jslint forin:true */
        for (keyVar in content) {
          contentItem = content[keyVar];
          elid = '';
          className = '';
          curElKeyName = '';
          curElKey = '';
          ii++;
          rowId++;
          id = '';
          hint = '';
          attr = plid;
          attr += ' id="i-' + rowId + '" ';
          //data-index for detect row in model
          attr += ' data-index="' + keyVar + '"';
          if (elKey !== undefined && contentItem[elKey] !== undefined) {
            curElKey = contentItem[elKey].v.replace(/"/g, '&quot;');
            attr += ' data-elid="' + curElKey + '" ';
            elid = contentItem[elKey].v;
          }
          if (elKeyName !== undefined && contentItem[elKeyName] !== undefined) {
            curElKeyName = contentItem[elKeyName].v.replace(/"/g, '&quot;');
            attr += ' data-elkeyname ="' + curElKeyName + '" ';
          }
          if (ii % 2 === 0) {
            className = ' even ';
          } else {
            className = '';
          }
          if (contentItem._ovcol) {
            className += ' ' + contentItem._ovcol + ' ';
          }
          if (contentItem._ovhide) {
            attr += ' data-hide="' + contentItem._ovhide + '" ';
            className += ' toolbtn-hide ';
          }
          if (contentItem._ovremove) {
            attr += ' data-remove="' + contentItem._ovremove + '" ';
            className += ' toolbtn-remove ';
          }
          if (contentItem._ovshow) {
            attr += ' data-show="' + contentItem._ovshow + '" ';
            className += ' toolbtn-show ';
          }
          if (args.warning) {
            if (args.warning[elid] !== undefined) {
              if (args.warning[elid].msg !== undefined) {
                className += ' warning';
                hint = App.u.escapeQuote(args.warning[elid].msg);
                delete args.warning[elid];
              }
            }
          }

          className += ' b-list__table-row';
          output += '<tr class="' + className + '"' + attr + ' >';
          output += buildRow(contentItem, args, hint);
          output += '</tr>';
        }
        if (args.warning) {
          EventMgr.trigger('nextEventBind', {
            event: 'appendList',
            tData: args.warning,
            cb: function(e, data) {
              if (e.data) {
                var tabId = data.tabId,
                    bannerText = $('#cont-' + tabId +
                        ' .b-message__text_warning').get(0),
                    warning = e.data,
                    extraText = '';

                if (bannerText) {
                  for (var key in warning) {
                    if (warning[key]) {
                      extraText += warning[key].msg + '<br/>';
                    }
                  }
                  if (extraText) {
                    bannerText.innerHTML = extraText;
                  }
                  EventMgr.trigger('updateScroll', { id: 'cont-' + tabId });
                }
              }
            }
          });
        }
        output += '</tbody>';
        output += buildLastRow(args);
        output += '</table>';
        output += '</div>'; //close table div from template
        return output;
      },

      //render Row
      buildRow = function(row, args, hint) {
        var headers = args.headersName,
            output = '',
            elKey = args.elKey,
            i = 0, ind = 0,
            warning, color, keyVar, usage, type, currentRow, editableClass,
            contentClassName, colNameClass,
            contentAttrs,
            attr, className, value, per, buttons, j, button, func, form, name,
            btnMsg, onlyForm;
        /* jslint forin:true */
        for (keyVar in headers) {
          //check for only diagram col
          if (headers[keyVar] && headers[keyVar].hidden) {
            continue;
          }
          i++;
          warning = '';
          className = '';
          editableClass = '';
          colNameClass = 'b-list__table-col_name_' + keyVar;
          color = '';
          value = '';
          attr = '';
          usage = '';
          per = '';
          contentAttrs = '';
          buttons = '';
          onlyForm = false;
          if (elKey === keyVar) {
            className += ' key-field ';
          }
          if (i === 1 && hint !== '' && hint !== undefined) {
            warning = '<div class="warning-img hint" data-hint="' + hint + '"></div>';
          }
          currentRow = row[keyVar];
          if (args.headers[ind].edit) {
            editableClass += ' editable ';
          }
          if (args.testMode) {
            editableClass += ' i-testmode-field ';
          }
          if (args.headers[ind].fastFilter && !args.blockId) {
            editableClass += ' i-filter-field ';
          }
          contentClassName = (args.headers[ind].nestedlist !== undefined && !currentRow.nestedlist) ?
              ' i-nestedlist b-list__table-col-content_type_link' : '';
          contentClassName += (args.headers[ind].editform !== undefined && !currentRow.nolink) ?
              ' i-editform b-list__table-col-content_type_link ' +
                  'b-list__table-col-content_style_underline' : '';
          if (currentRow !== undefined) {
            type = headers[keyVar].type;
            //data/prop/money
            if (type === 'data' || type === 'prop' || type === 'money') {
              if (currentRow.color !== undefined) {
                className += ' status-' + currentRow.color;
              }
              if (args.headers[ind].acthint) {
                className += ' acthint ';
              }
              value = args.headers[ind].noescaping ?
                  window.filterXSS(window.htmlDecode(currentRow.v)) : currentRow.v;
              className += args.headers[ind].wrap ? ' wrap ' : '';
              className += (args.headers[ind].nestedreport !== undefined) ?
                  ' nestedreport ' : '';
              className += (args.headers[ind].align) ?
                  ' align-' + args.headers[ind].align : '';
              attr += (currentRow.link) ?
                  ' data-child-id="' + args.oTabId + '-' +
                      currentRow.childid + '" ' : '';
              attr += (currentRow.elid) ?
                  ' data-elid="' + currentRow.elid + '" ' : '';
              contentAttrs += currentRow.orig ? 'data-orig="' + currentRow.orig + '"' : '';
              if (currentRow.props) {
                attr += currentRow.psp ?
                    ' data-stat="' + currentRow.psp + '" ' : '';
                output += '<td><div class="ovf i-text-content ' +
                    editableClass + '">' +
                    warning + '<span class="data-wrapper " ' + attr + ' >' +
                    makeProps(currentRow, args, row) +
                    '</span><span class="data middle ' + className + '"  >' +
                    '<span class="b-list__table-col-content ' +
                    contentClassName + '" ' + contentAttrs + '>' +
                    currentRow.v + '</span></span></div></td>';
              } else {
                output += '<td class="first ' + colNameClass + '">' + warning +
                    '<span class="i-text-content data-wrapper data ' + className + ' ' +
                    editableClass + '" ' + attr + '>' +
                    '<span class="b-list__table-col-content ' +
                    contentClassName + '" ' + contentAttrs + '>' + value + '</span></span></td>';
              }
            //indicator
            } else if (type === 'indicator') {
              if (currentRow.u && currentRow.l) {
                if (currentRow.color !== undefined) {
                  className = ' status-' + currentRow.color;
                }
                if (parseInt(currentRow.l, 10) !== 0) {
                  if (parseInt(currentRow.u, 10) === 0) {
                    per = 0;
                  } else {
                    per = Math.round((currentRow.u / currentRow.l) * 100);
                    if (per === 0 || !per) { per = 0; }
                    per = per > 100 ? 100 : per;
                  }
                  usage = '<div class="used-wr">' +
                      '<div class="used" style="width:' + per + '%"></div></div>';
                }
              }
              output += '<td class="first">' +
                  '<span class="i-text-content data-wrapper data ' + className + editableClass + '">' +
                   warning +
                  '<span class="b-list__table-col-content ' + contentClassName + '">' +
                      window.htmlDecode(currentRow.v) + '</span>' +
                    '</span>' +
                  usage + '</td>';
            //indicator brackets
            } else if (type === 'indicatorbrackets') {
              if (currentRow.color !== undefined) {
                className = ' status-' + currentRow.color;
              }
              value = currentRow.l || '';
              if (currentRow.u !== '') {
                value += ' (<span class="' + className + '">' + currentRow.u + '</span>)';
              }
              output += '<td class="first">' +
                  '<span class="i-text-content data-wrapper data">' +
                  warning +
                  '<span class="b-list__table-col-content ' + contentClassName + '">' +
                  value + '</span>' +
                  '</span></td>';
            //buttons
            } else if (type === 'button') {
              for (j = 0; j < currentRow.buttons.length; j++) {
                button = currentRow.buttons[j];
                if (button !== '') {
                  name = button;
                  //for billing dashboard show msg for btn from col & open only form
                  onlyForm = (args.btn[name].msgsrc && row[args.btn[name].msgsrc]);
                  attr = '';
                  if (!onlyForm) {
                    attr += ' data-func="func=' + args.func + '" ';
                  }
                  attr += ' data-type="' + args.btn[button].type + '" ';
                  attr += ' data-name="' + button + '" ';
                  type = args.btn[button].type;
                  if (onlyForm) {
                    btnMsg = row[args.btn[name].msgsrc].v;
                  } else {
                    btnMsg = args.btn[name].name;
                  }
                  if (type === 'edit' ||
                      type === 'group' ||
                      type === 'editlist') {
                    attr += ' data-form="func=' + args.btn[button].func + '&elid=' + row[args.elKey].v + '" ';
                  }

                  buttons += '<a href="#" ' + attr + ' class="dashboard-button">' + btnMsg + '</a> ';

                  //buttons += args.btn[currentRow.buttons[i]].name + ' ';
                }
              }
              output += '<td><span class="data-wrapper">' + buttons + '</span></td>';
            }
          } else {
            output += '<td><span class="data-wrapper  ' + className + '"></span></td>';
          }
          ind++;
        }
        return output;
      },

      /**
       * Рендерем props и xprop для статусбара
       * @param total
       */
      renderPropsStat = function(total, props) {
        var stat = '',
            i = 0,
            keyVar,
            cumma = '',
            propName,
            prop,
            sprite = false,
            extension,
            className = '';
        /* jslint forin:true */
        for (keyVar in total) {
          if (i !== 0) { cumma = ',</span> '; } else { cumma = ''; }
          if (total[keyVar] - 0 === 0) {
            className = 'no';
          } else {
            className = 'default';
          }
          prop = props[keyVar];
          sprite = prop.style === '';
          if (!sprite) {
            extension = prop.animated ? '.gif' : '.png';
            stat += cumma + '<span class="' + className + '"><img class="props" src="' + pageInfo.commonDir  + 'img/' + prop.onImg + extension + '"/>' + total[keyVar];
          } else {
            stat += cumma + '<span class="' + className + '"><div class="props s-icon s16x16 ' + prop.onImg + ' i-total-prop-' + keyVar + '"></div>' + total[keyVar];
          }
          i++;
        }
        stat += '</span>';
        return stat;
      },
      //render props
      makeProps = function(row, args, rows) {
        var output = '',
            propName, func, type, className, hide,
            hint, attr, props = row.props,
            len = props.length, i;
        for (i = 1; i < len; i++) {
          if (props[i].n) {
            propName = props[i].n;
            hint = App.u.escapeQuote(args.props[propName].hint);
            func = args.props[propName].func;
            type = args.props[propName].type;
            hide = args.props[propName].hide;
            attr = '';
            className = '';
            if (func && checkFunc(hide, rows)) {
              attr += ' data-func="' + func + '" ';
              attr += ' data-type="' + type + '" ';
              attr += ' data-value="' + props[i].v.replace(/"/g, '&quot;') + '" ';
              className += 'controlprop';
              if (type === 'group') {
                attr += ' data-confirm="' + args.props[propName].confirm + '" ';
              }
              if (args.props[propName].cgi) {
                attr += ' data-cgi="' + args.props[propName].cgi + '" ';
              }
            }
            attr += 'data-name="' + args.props[propName].name + '"';
            // I don't why this rules
            //if (args.props[propName].name !== propName) {
            //check for don't rewrite func attr
            if (!func) {
              attr += ' data-value="' + props[i].v.replace(/"/g, '&quot;') + '" ';
            }

            if (args.props[propName].acthint) {
              className += ' acthint';
            } else {
              className += ' hint';
            }
            if (hint !== '' && hint) {
              hint = App.u.escapeQuote(hint.replace('__value__', props[i].v));
              attr += ' data-hint="' + hint + '" ';
            } else if (props[i].v !== '' && props[i].v) {
              attr += ' data-hint="' + App.u.escapeQuote(props[i].v) + '" ';
            }
            if (args.props[propName].style) {
              attr += args.props[propName].style;
            }
            if (args.props[propName].animated) {
              output += '<img class="props ' + className + ' " ' + attr + ' src="' + pageInfo.commonDir  + 'img/' + args.props[propName].onImg + '.gif"/>';
            } else {
              output += '<div class="s-icon s16x16 props ' + className + ' ' + args.props[propName].onImg + '" ' + attr + '></div>';
            }
          }
        }
        return output;
      },
      //check for hide rule for function
      checkFunc = function(hide, rows) {
        if (!hide) { return true; }
        var l = hide.length,
            name, value;
        while (l--) {
          name = hide[l].n;
          value = hide[l].v;
          if (rows[name] && (rows[name].v === value)) {
            return false;
          }
        }
        return true;
      },
      //find default prop
      findDefProp = function(props) {
        var keyVar;
        for (keyVar in props) {
          if (props[keyVar].defImg) {
            return keyVar;
          }
        }
        return null;
      },
      //update total report for convert col
      updateTotalWithConvertReport = function(e, data) {
         var id = data.id;
         $('#' + id).html(data.convertValue);
      },

      buildLastRow = function(args) {
        var headers = args.headers,
            colCount = headers.length,
            tFoot = '<tfoot><tr>',
            content = args.content,
            total, hint = '', msg = App.Common.msg,
            align = '',
            name,
            id;

        for (var i = 0; i < colCount; i++) {
          if (headers && headers[i] && headers[i].hidden) {
            continue;
          }
          total = '';
          id = '';
          align = 'align-' + (headers[i].align || '');
          if (headers[i].total === 'sum') {
            name = headers[i].name;
            total = sumRows(name, content);
            hint = msg.totalSum || '';
          } else if (headers[i].total === 'sumsuffix') {
            hint = msg.totalSum || '';
            total = sumRowsSuffix(name, content, headers[i].convert);
            name = headers[i].name;
          } else if (headers[i].total === 'count') {
            total = content.length;
            hint = msg.totalCount || '';
          } else if (headers[i].total === 'avg') {
            name = headers[i].name;
            total = avgRows(name, content);
            hint = msg.totalAvg || '';
          }

          if (headers[i].convert && total !== '') {
            id = args.tabId + '-' + name;
            EventMgr.trigger('ajaxRequest', {
               param: {
                 func: 'convert',
                 name: headers[i].convert,
                 value: total
               },
               invar: {
                 id: id
               },
               type: 'get',
               outtype: 'json',
               trfunc: 'updateTotalWithConvertReport',
               failfunc: 'failMenuAjaxResponse',
               queue: 'multiload'
            });
          }
          tFoot += '<td id="' + id + '" class="hint ' + align + '" data-hint="' +
            App.u.escapeQuote(hint) + '">' + total + '</td>';
        }
        tFoot += '</tfoot>';
        return tFoot;
      },

      sumRows = function(name, rows) {
        var len = rows.length,
            sum = 0, v, maxDec = 0, curDec;
        while (len--) {
          if (rows[len][name].orig) {
            v = rows[len][name].orig - 0;
          } else if ((rows[len][name].v) === '') {
            v = 0;
          } else {
            v = parseFloat(rows[len][name].v.replace(/\s/g, ''));
          }
          curDec = decimalPlaces(v);
          maxDec = curDec > maxDec ? curDec : maxDec;
          sum += v;
        }
        if (maxDec > 0) {
          sum = sum.toFixed(maxDec);
        }
        return sum;
      },

      sumRowsSuffix = function(name, rows, convert) {
        var len = rows.length,
            resultC, resultSum = '';
        while (len--) {
          resultC = App.List.dataCalc(resultC, rows[len][name]);
        }
        /* jslint forin: true */
        for (var key in resultC) {
          if (resultSum !== '') {
            resultSum += '; ';
          }
          if (convert === 'money') {
            resultSum += App.Tabs.moneyFormat(resultC[key]) +
                ' ' + key;
          } else {
            resultSum += resultC[key] + ' ' + key;
          }
        }
        return resultSum;
      },

      avgRows = function(name, rows) {
        var len = rows.length,
            lenForLoop = len,
            sum = 0,
            avg, v;
        while (lenForLoop--) {
          v = ((rows[lenForLoop][name].v) === '') ?
              0 : parseFloat(rows[lenForLoop][name].v);
          sum += v;
        }
        avg = sum / len;
        if (avg.toFixed) { avg = avg.toFixed(2); }
        return avg;
      },

      moneyFormat = function(num) {
        var strNum = '' + parseFloat(num).toFixed(2),
            parts = strNum.split('.'),
            head = parts[0] || '',
            tail = parts[1] || '',
            s = [];
        if (head) {
          var l = head.length,
              p = Math.floor(l / 3);
          for (var i = 0; i < p; i++) {
            s.push(head.substr(l - (i * 3) - 3, 3));
          }
          s.push(head.substr(0, (l % 3)));
          s.reverse();
        }
        if (s.length > 0) {
          return s.join(' ') + '.' + tail;
        } else {
          return num;
        }
      },

      decimalPlaces = function(num)  {
        var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) { return 0; }
        return Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0),
            // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0));
      },
      /**
       * get Image for group
       * check for selficon, else get icon from menu group
       * @param {String} id
       * @param {String} name
       * @param {String} theme
       * @param {Boolean} style
       */
      getMainImg = function(id, name, theme, style) {
        var elem, output, pElem, extImg;
        elem = App.Dom.byId('l-' + id);
        pElem = $(elem).parent();
        extImg = pElem.attr('data-img');
        if (!name) {  //use this way because id can have dot.
          name = pElem.attr('data-group');
        }
        if (name && name.indexOf(".") != -1) {
          output = '';
        } else {
          output = 'mb-' + name;
        }

        if (style && extImg) {
          if (name && name.indexOf(".") != -1) {
             output = 'style="background: url(' + name + ') left top no-repeat"';
          } else {
             var prefix = 'img/mb-',
                 suffix = '.png';
             output = 'style="background: url(' +
                      theme + prefix + name + suffix + ') left top no-repeat"';
          }
        }
        if (!extImg && style) {
          output = '';
        }

        //output = theme + prefix + name + suffix;
        return output;
      },

      getGroupIcon = function(id) {
        var elem, pElem, output, extImg;
        id = String(id).replace(/\./g, '_');
        elem = App.Dom.byId('l-' + id);
        pElem = $(elem).parent();
        name = pElem.attr('data-group');
        extImg = pElem.attr('data-img');

        if (extImg) {
          output = 'class="subtab__text_for_pin s16x16 s-icon" style="background: url(/manimg/common/img/m-' + name + '.png) left top no-repeat"';
        } else {
          output = 'class="subtab__text_for_pin s16x16 s-icon m-' + name + '"';
        }
        return output;
      },

      devMode = pageInfo.devmode,

      pdfOn = pageInfo.pdfOn,

      dateTimeId,

      renderFormItem = function(item, tabId, classes) {
        var itemHTML = '';
        classes = classes || '';
        //render input text ||hidden || password
        if (item.type === 'text' ||
            item.type === 'hidden' ||
            item.type === 'color' ||
            item.type === 'password') {
          item.setvalue = item.setvalue || '';
          if (item.value) {
            item.value = App.u.escapeQuote(item.value);
          }
          if (item.test && !item.zoom) {
            classes += ' test';
          } else if (item.test && item.zoom) {
            classes += ' testzoom';
          }
          //render help buttons
          if (item.passwd) {
            itemHTML += '<div class="b-input-btn b-input-btn_type_passwd hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '"' +
                ' data-control-field="' + item.name + '"></div>';
          }
          if (item.showpwd) {
             itemHTML += '<div class="' + (item.passwd ? 'b-input-btn_is_left' : '') + ' b-input-btn b-input-btn_type_showpwd hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '"' +
                ' data-control-field="' + item.name + '"' +
                ' data-tabid="' + tabId + '"></div>';
          }
          if (item.date) {
            itemHTML += '<div class="b-input-btn b-input-btn_type_calendar hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '"' +
                ' data-control-field="' + item.name + '"' +
                ' data-type="' + item.date + '"></div>';
          }
          if (item.unlimit) {
            itemHTML += '<div class="b-input-btn b-input-btn_type_unlimit hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '"' +
                ' data-control-field="' + item.name + '"></div>';
          }
          if (item.change) {
            itemHTML += '<div class="b-input-btn b-input-btn_type_change hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '"></div>';
          }
          if (item.zoom) {
            itemHTML += '<div class="b-input-btn b-input-btn_type_zoom hint"' +
                ' data-hint="' + App.u.escapeQuote(item.hintBtn) + '" ' +
                'data-control-field="' + item.name + '"></div>';
            item.inputAttr = item.attr;
            item.inputClasses = classes;
            item.inputName = item.name;
            item.textareaClasses = ' b-textarea_for_zoom';
            itemHTML += templates.formItemInputWithZoom(item);

          } else if (item.type === 'password') {
            item.classes += classes;
            if (item.confirm) {
              item.confirmField = item.confirmField +
                  '-' + tabId;
              item.classes += ' b-form-confirm-field';
            } else if (item.passwd) {
              item.classes += ' b-form-passwd-field';
            }
            itemHTML += templates.formItemPassword(item);
            if (item.passwd) {
              item.pwcheck.id = tabId;
              item.pwcheck.name = item.name;
              itemHTML += templates.passwdCheck(item.pwcheck);
            } else if (item.confirm) {
              itemHTML += templates.confirmCheck(item);
            }
          } else {
            item.classes += classes;
            itemHTML += templates.formItemInput(item);
          }
          //render input@type=file
        } else if (item.type === 'file') {
          item.classes += classes;
          item.setvalue = '';
          item.value = '';
          itemHTML += templates.formItemFile(item);
        } else if (item.type === 'textarea') {
          //render textarea
          item.classes += item.editor;
          item.value = window.htmlEscape(item.value);
          itemHTML += templates.formItemTextarea(item);
          //data for plugin
          if (item.variables) {
            EventMgr.trigger('saveVarsTinyMCE', {
              name: item.name,
              tabId: tabId,
              vars: item.variables
            });
          }
        } else if (item.type === 'desc') {
          //render description
          itemHTML += templates.formItemDesk(item);
        } else if (item.type === 'htmldata') {
          //render htmldata
          itemHTML += templates.formItemHtmldata(item);
        } else if (item.type === 'select') {
          //render select
          //separate image & value for filtred value
          item.msg = window.filterXSS(item.msg);
          item.msg = item.img + item.msg;
          itemHTML += templates.formItemSelect(item);
        } else if (item.type === 'mselect') {
          //render multi select
          itemHTML += templates.formItemMSelect(item);
          if (item.msg_select_all && pageInfo && pageInfo.messages) {
            pageInfo.messages.msg_select_all = item.msg_select_all;
          }
        } else if (item.type === 'aselect') {
          //render select autocomplete
          itemHTML += templates.formItemSelectAutocomplete(item);
        } else if (item.type === 'radio') {
          if (item.hint === '') {
            item.readonly += ' nohint';
          }
          //render radio
          itemHTML += templates.formItemRadio(item);
        } else if (item.type === 'radioimg') {
          //render radio-img
          itemHTML += templates.formItemRadioImg(item);
        }
        else if (item.type === 'checkbox') {
          if (item.hint === '') {
            item.dependFields += ' nohint';
          }
          if (item.desc === '') {
            item.dependFields += ' nodesc';
          }
          itemHTML += templates.formItemCheckbox(item);
          //render slider
        } else if (item.type === 'slider') {
          //@TODO change with value
          itemHTML += templates.formItemSlider(item);
          //render mgrview
        } else if (item.type === 'mgrview') {
          itemHTML += templates.formItemMgrview({
            tabId: tabId, theme: pageInfo.theme });
          //render textdata
        } else if (item.type === 'textdata') {
          item.value = window.htmlDecode(item.value);
          itemHTML += templates.formItemTextData(item);
          //render tree
        } else if (item.type === 'tree') {
          itemHTML += renderTree(item, tabId);
        } else if (item.type === 'ticket') {
          itemHTML += templates.formItemTicket(item);
        } else if (item.type === 'link') {
          itemHTML += templates.formItemLink(item);
        } else if (item.type === 'frame') {
          itemHTML += templates.formItemFrame(item);
        } else if (item.type === 'datetime') {
          var d = App.u.parseDate(item.value);
          item.difftime = (new Date().getTime() - d.getTime());
          item.value = App.u.formatDateTime(d.getTime());
          itemHTML += templates.formItemDateTime(item);
          dateTimeId = setInterval(function(tabId, name) {
            return function() {
              var elem = App.Dom.byId(tabId + '-' + name);
              if (!tabs[tabId] || !elem) {
                clearInterval(dateTimeId);
                return;
              }
              var dt = elem.getAttribute('data-difftime') - 0;
              elem.innerHTML = App.u.formatDateTime(new Date().getTime() - dt);
            };
          } (tabId, item.name), 500);

        } else if (item.type === 'listfilter') {
          itemHTML += templates.formListFilterWrapper({ name: item.name, id: item.id, content: templates.formListFilter(item)});
        } else if (item.type === 'captcha') {
          itemHTML += templates.formItemCaptcha(item);
          EventMgr.trigger('appendCaptcha', { id: tabId + '-' + item.name });
        }
        return itemHTML;
      },
      //render form items
      renderFormItems = function(form, tabId) {
        var length = form.length,
            i, pages = '', formHtml, formItemsLen, j, formItems,
            formItemLen, k, formItem, formRow, classes, valuesForm = {},
            sourceForm = {};
        for (i = 0; i < length; i++) {
          formHtml = {
            name: form[i].name,
            title: '',
            content: '',
            classes: '',
            withList: form[i].withList,
            display: form[i].collapsed ? 'none' : 'block',
            collapsed: form[i].collapsed,
            hide: form[i].hide ? form[i].hide : {},
            show: form[i].show ? form[i].show : {},
            tabId: tabId
          };
          if (form[i].title !== '') {
            //render title Page
            formHtml.title = templates.formPageTitle({
              title: form[i].title,
              name: form[i].name,
              id: form[i].name,
              type: 'page',
              collapsed: form[i].collapsed,
              hintCollapse: pageInfo.pageCollapse,
              hintExpand: pageInfo.pageExpand,
              blockType: '',
              theme: pageInfo.theme,
              reload: false });
          }
          if (!form[i].formItems) { continue; }
          formItemsLen = form[i].formItems.length;

          formItems = form[i].formItems;
          //foreach for fields
          for (j = 0; j < formItemsLen; j++) {
            formItemLen = formItems[j].length;
            formItem = formItems[j];
            //foreach for elems
            for (k = 0; k < formItemLen; k++) {
              if (formItem[k].skip) {
                continue;
              }
              sourceForm[formItem[k].name] = formItem[k];
              //make form model for watching
              valuesForm[formItem[k].name] = {
                'defValue': formItem[k].value,
                'isChanged': false,
                'value': formItem[k].value,
                'label': formItem[k].label || formItem[k].desc || false
              };
              if (formItem[k].type === 'textarea') {
                if (formItem[k].value === '\n') {
                  formItem[k].value = '';
                  valuesForm[formItem[k].name].value = '';
                  valuesForm[formItem[k].name].defValue = '';
                }
              }
              formRow = {};
              formRow.first = '';
              formRow.second = '';
              formRow.third = '';
              formRow.hint = '';
              formRow.classes = '';
              formRow.hide = formItem[k].hide || {};
              formRow.show = formItem[k].show || {};
              formRow.id = formItem[k].name + '-' + form.id;
              formRow.desc = '';
              formRow.error = formItem[k].error ? formItem[k].error : '';
              formRow.colspan = formItem[k].error ? 'colspan="2"' : '';
              formRow.fname = formItem[k].name;
              formRow.label = formItem[k].label;
              formRow.tabId = form.id;
              formRow.devMode = devMode;
              formRow.testMode = form.testMode;
              formItem[k].id = form.id;
              //render label
              if (formItem[k].label) {
                formRow.first += templates.formItemLabel({
                  label: formItem[k].label,
                  img: formItem[k].l_img || '',
                  required: formItem[k].required,
                  tabId: form.id,
                  func: form.func,
                  id: formItem[k].name,
                  devMode: devMode });
              } else if (formItem[k].type !== 'textdata') {
                formRow.first += '<div></div>';
              }
              //render hint
              if (formItem[k].hint !== '' && formItem[k].hint) {
                formRow.third += App.u.escapeQuote(formItem[k].hint);
                if (formItem[k].shadowHint) {
                  formRow.third += " <span class='hint-shadow'>" +
                     App.u.escapeQuote(formItem[k].shadowHint) +
                      '</span>';
                  formRow.hint += ' shadow ';
                }
                formRow.hint += 'field-help_available_yes';
              }
              if (formItem[k].setvalue) {
                var timeout = parseInt(formItem[k].setvalue, 10),
                    timeId;
                if (!isNaN(timeout)) {
                  /* jslint loopfunc:true*/
                  timeId = setInterval(function(tabId, name) {
                    return function() {
                      if (!tabs[tabId]) {
                        clearInterval(timeId);
                      }
                      EventMgr.trigger('forceSetValues', {
                        tabId: tabId, name: name
                      });
                    };
                  } (tabId, formItem[k].name), timeout * 1000);
                }
              }
               else if (formItem[k].type === 'textarea') {
                if (formItem[k].quote) {
                  formRow.classes += ' b-form-row_with_quote ';
                }
                formItem[k].third = formRow.third;
                formItem[k].error = formRow.error;
              }
              //@todo move to template
              if (formItem[k].desc && formItem[k].desc !== '') {
                formRow.desc = formItem[k].desc || '';
                //check for checkbox desc
                if (formItem[k].type === 'checkbox') {
                  if (formItem[k].desc !== '') {
                    formRow.desc = '';
                  }
                }
                formRow.descName = formItem[k].descName || '';
              }
              if (formItem[k].type === 'checkbox' && !formItem[k].desc) {
                formRow.classes += ' row-with-no-desc ';
              }
              formRow.classes += ' l-form__row_type_' + formItem[k].type;
              if (formItem[k].fixed) {
                formRow.classes += ' i-form__row_fixed_yes b-form__row_fixed_yes';
              }
              if (formItem[k].error) {
                formRow.classes += ' row-error';
              }
              //check for hide/show rules
              if (formItem[k].show !== undefined) {
                if (formItem[k].shadow) {
                  formRow.classes += ' depended-shadow-s';
                } else {
                  formRow.classes += ' depended-hidden-s';
                }
              }
              //render form item
              formRow.second = renderFormItem(formItem[k], tabId, '');
              //render extra field
              if (formItem[k].hasAddition) {
                var nextFormItem = formItem[k + 1];
                if (nextFormItem) {
                  if (nextFormItem.type === 'checkbox') {
                    if (nextFormItem.desc !== '') {
                      formRow.desc = '';
                    }
                  } else if (nextFormItem.type === 'text') {
                     formRow.id = nextFormItem.name + '-' + form.id;
                  }
                  nextFormItem.id = form.id;
                  formRow.second += renderFormItem(nextFormItem, tabId, '');
                  formRow.classes += ' l-form__row_has_addition';
                  if (formItem[k].propWidth) {
                    formRow.classes += ' l-form__row_propwidth';
                  }
                  //check for error
                 if (nextFormItem.error) {
                   formRow.error = nextFormItem.error;
                   formRow.classes += ' row-error';
                   formRow.colspan = 'colspan="2"';
                 }
                }
              }
              //render form row
              //render input@type=hidden row
              if (formItem[k].type === 'hidden') {
                formHtml.content += templates.formItemRowHidden(formRow);
                //render fullwidth row
              } else if (formItem[k].fullwidth) {
                formRow.classes += ' fullwidth-row';
                formHtml.content += templates.formItemFullWidthRow(formRow);
                //render desc row
              } else if (formItem[k].formwidth) {
                formRow.classes += ' formwidth-row';
                formHtml.content += templates.formItemFormWidthRow(formRow);
                //render desc row
              } else if (formItem[k].type === 'desc') {
                formRow.third = '';
                formRow.hint = '';
                formHtml.content += templates.formItemRowDesc(formRow);
                //render row without label
              } else if (formItem[k].type === 'list') {
                formItem[k].id = form.id;
                formItem[k].formflags = form.formflags;
                formItem[k].parent = form.parent;
                formItem[k].testMode = form.testMode;
                //for btn template change type
                formItem[k].type = 'form';
                if (!(formItem[k].rows &&
                     formItem[k].rows.length === 1 &&
                     formItem[k].view === 'table')) {
                  formHtml.content += templates.formListItemRow(formItem[k]);
                }
              } else if (formRow.first === '') {
                formHtml.content += templates.formItemRowWithoutLabel(formRow);
                //render normal row
              } else {
                formHtml.content += templates.formItemRow(formRow);
              }
              if (formItem[k].plainhint) {
                var hLen = formItem[k].plainhint.length;
                //start from 1 because 1st elem empty
                for (var h = 1; h < hLen; h++) {
                  formItem[k].plainhint[h].name = formItem[k].name;
                  formHtml.content += templates.formPlainHintRow(formItem[k].plainhint[h]);
                }
              }
            }
          }
          formHtml.view = 'form';
          pages += templates.formPageWrapper(formHtml);
        }
        return {
          html: pages,
          model: valuesForm,
          source: sourceForm
        };
      },

      formGetTreeBranch = function(e, data) {
        var setvalues = data.setvalues,
            elem = data.elem,
            name = data.name,
            items = setvalues[name].tlist,
            html = renderTlist(items),
            id = data.id;
        elem.after(html);
        data.img.attr('src', data.src);
        elem.parent().addClass('loaded t-opened')
            .removeClass('collapsed loading');
        EventMgr.trigger('updateScroll', { id: id });
      },
      //render tree
      renderTree = function(items, tabId) {
        var elems = items.tlist, html,
            rows = items.rows * 18,
            id = items.name + '-' + tabId;
        html = renderTlist(elems, items.value);
        return '<div class="tree-wrapper ' + items.setvalue + ' ' + items.multiple + '" id="cont-' + id + '"  style="height:' + rows + 'px;">' +
          '<div id="'+ id +'" class="tree-inner" data-tabid="' + tabId + '">' +
            html +
          '<input data-type="tree" type="hidden" name="' + items.name + '" value="' +
            items.value +
            '" class="' + items.classes + '"id="' + items.name + '-' + tabId + '-value" data-tabid="' +
            tabId + '"/></div></div>' +
          '<div class="b-resizer" data-move-trigger="updateScroll" data-id="cont-' + id + '" data-tabid="' + tabId + '"></div>';
      },
      //render tree list
      renderTlist = function(items, value) {
        var len = items.length, i, html = '', child, className = '', selected;
        html = '<ul>';
        for (i = 0; i < len; i++) {
          child = items[i].child.length > 0;
          className = child ? 't-opened loaded' : items[i].collapsed ?
              'collapsed' : '';
          className += (len - 1 === i) ? ' last ' : '';
          selected = (items[i].key === value) ? ' selected ' : '';
          html += ' <li class="' + className + ' folder"> <div class="tree-hitarea bline"></div> <div class="tree-handler ' + selected + '"  data-val="' + items[i].key + '" ><div class="bline icon"><img src="' + pageInfo.commonDir + 'img/' + items[i].img + '.png" /></div><div class="tree-label bline">' + items[i].value + '</div></div>';
          if (child) {
            html += renderTlist(items[i].child, value);
          }
          html += '</li>';
        }
        html += '</ul>';
        return html;
      },

      renderInfoList = function(obj) {
        return templates.infoList({ rows: obj.rows, testMode: obj.testMode });
      },

      //render dashboard blocks
      renderDashboard = function(blocks) {
        var bLength = blocks.length,
            top = '',
            left = '',
            right = '',
            dashboard = '',
            contentBlock, title, param, classes, display, blockId, id,
            titleObject, contentObject, obj;
        storage.dashboard = {};
        for (var i = 0; i < bLength; i++) {
          blocks[i].name = String(blocks[i].name).replace(/\./g, '_');
          id = blocks[i].name;
          blockId = blocks[i].name;

          titleObject = {
            name: blocks[i].name,
            id: id,
            title: blocks[i].title,
            type: 'dashboard-block',
            blockType: blocks[i].type,
            theme: pageInfo.theme,
            collapsed: (blocks[i].display === 'min'),
            hintCollapse: pageInfo.pageCollapse,
            hintExpand: pageInfo.pageExpand,
            hintReload: blocks[i].hintReload,
            reload: false };
          if (blocks[i].type === 'toolbar') {
            contentBlock = templates.dashTaskbar({
              toolbar: blocks[i].toolbar });
          } else if (blocks[i].type === 'list') {
            /* jslint camelcase:false */
            param = {
              func: blocks[i].func,
              p_num: 1,
              dashboard: blocks[i].name };
            if (blocks[i].rows) {
              param.p_cnt = blocks[i].rows;
            }
            /* jslint camelcase:true */
            $.extend(param, blocks[i].params);
            storage.dashboard[blocks[i].name] = param;
            if (blocks[i].autoupdate) {
               setTimeout(function(block) {
                 return function() {
                   EventMgr.trigger('refreshDashBlock', { block: block });
                 };
               } (blocks[i]), blocks[i].autoupdate * 1000);
            }
            EventMgr.trigger('ajaxRequest', {
              url: pageInfo.url,
              param: param,
              invar: { blockId: 'block-' + blocks[i].name },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponseForDashboard',
              failfunc: 'failedAjaxResponseForDashboard',
              queue: 'noqueue' });
            contentBlock = '<div id="block-' + blockId +
                '" class="block-table" data-block-name="' + blocks[i].name +
                '" data-block-cnt="' + blocks[i].rows +
                '" data-block-pnum="1' +
                '" data-block-func="' + blocks[i].func + '">' +
                '<div class="dashboard-nodata">' +
                pageInfo.loading +
                '</div></div>';
            titleObject.reload = true;
          } else if (blocks[i].type === 'report') {
            param = { func: blocks[i].func, dashboard: blocks[i].name };
            $.extend(param, blocks[i].params);
            storage.dashboard[blocks[i].name] = param;
            EventMgr.trigger('ajaxRequest', {
              url: pageInfo.url,
              param: param,
              invar: { blockId: 'block-' + blocks[i].name },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponseForDashboard',
              failfunc: 'failedAjaxResponseForDashboard',
              queue: 'noqueue' });
            contentBlock = '<div id="block-' + blockId +
                '" class="block-table" data-block-name="' + blocks[i].name +
                '" data-block-func="' + blocks[i].func +
                '" data-block-param="' +
                App.Common.serializeForAttr(blocks[i].params) +
                '"><div class="dashboard-nodata">' +
                pageInfo.loading +
                '</div></div>';
            titleObject.reload = true;
          } else if (blocks[i].type === 'url') {
            var ifId = 'f-' + blocks[i].name;
            contentBlock = '<div><iframe id="' + ifId + '" width="100%" src="' +
                blocks[i].url + '"></iframe></div>';
          } else if (blocks[i].type === 'infolist') {
            param = { func: blocks[i].func, dashboard: blocks[i].name };
            storage.dashboard[blocks[i].name] = param;
            if (blocks[i].autoupdate) {
               setTimeout(function(block) {
                 return function() {
                   EventMgr.trigger('refreshDashBlock', { block: block });
                 };
               } (blocks[i]), blocks[i].autoupdate * 1000);
            }
            EventMgr.trigger('ajaxRequest', {
              url: pageInfo.url,
              param: param,
              invar: { blockId: 'block-' + blocks[i].name },
              type: 'get',
              outtype: 'json',
              trfunc: 'ajaxResponseForDashboard',
              failfunc: 'failedAjaxResponseForDashboard',
              queue: 'noqueue' });
            titleObject.reload = true;
            contentBlock = '<div class="" id="block-' + blockId +
                '" data-block-name="' + blocks[i].name + '"></div>';
          } else {
             EventMgr.trigger('pullMsg', { msg: 'Dashboard type "' + blocks[i].type + '" do not support.' });
             return;
          }
          //check for update
          if (blocks[i].update) {
            EventMgr.trigger('addBlockToUpdate', blocks[i]);
          }
          title = templates.formPageTitle(titleObject);

          classes = (blocks[i].display === 'min') ?
              ' b-form-page_st_collapsed ' : '';
          display = (blocks[i].display === 'min') ? 'none' : 'block';

          contentObject = {
            view: 'dblock',
            title: title,
            content: contentBlock,
            classes: classes,
            display: display,
            tabId: blocks[i].name,
            hide: [],
            show: [] };

          if (blocks[i].position === 'top' ||
              blocks[i].position === 'undefined') {
            top += templates.formPageWrapper(contentObject);
          } else if (blocks[i].position === 'left') {
            left += templates.formPageWrapper(contentObject);
          } else if (blocks[i].position === 'right') {
            right += templates.formPageWrapper(contentObject);
          }
          contentBlock = '';
          title = '';
          classes = '';
          display = '';
        }

        obj = {
          top: top,
          left: left,
          right: right,
          id: 'tab0'
        };
        return obj;
      },

      renderDashboardTable = function(e, data) {
        var resp = data,
            startTime = resp.startTime || 0,
            extraTime,
            blockId = resp.blockId.replace(/\./g, '_'),
            block, bandHTML, table, pagerList, blockHTML,
            bName, bCnt, bFunc, bPnum, tblock;
        resp.tabId = blockId;
        block = App.Dom.byId(blockId);
        //remove loading class
        tblock = App.Dom.byId('t' + blockId);
        //calc time end of animation
        extraTime = 1000 - (((new Date()).getTime() - startTime) % 1000);
        setTimeout(function() {
          if (tblock) {
            tblock.className = tblock.className.replace(/loading/g, '');
          }
        }, extraTime);
        if (block === null) { return; }
        if (resp.type === 'report') {
          bandHTML = renderBandDash(resp.bands, blockId);
          block.innerHTML = bandHTML;
          setTimeout(function() {
            EventMgr.trigger('loadGCharts', { bands: resp, tabId: blockId });
          }, 10);
        } else if (resp.type === 'infolist') {
          blockHTML = renderInfoList({ rows: resp.rows, testMode: resp.testMode });
          block.innerHTML = blockHTML;
        } else {
          table = '';
          pagerList = '';
          if (resp.error) {
            table = resp.ermsg;
          } else {
            table = renderTable(resp);
            if (resp.pager.pager === 'true') {
              pagerList = buildPagerList(resp.pager.pageCount, resp.pager.pageNum);
            }
          }

          blockHTML = '<div id="' + blockId + '-scrollwrapper">' + table +
              '</div><div class="pager_list pager-list_type_dashboard">' +
              pagerList + '</div>';
          bName = block.getAttribute('data-block-name');
          bCnt = block.getAttribute('data-block-cnt');
          bFunc = block.getAttribute('data-block-func');
          bPnum = block.getAttribute('data-block-pnum');

          block = App.Common.replaceHtml(block, blockHTML);
          block.setAttribute('data-block-pnum', resp.pager ? resp.pager.pageNum : 1);
          block.setAttribute('data-block-name', bName);
          block.setAttribute('data-block-cnt', bCnt);
          block.setAttribute('data-block-func', bFunc);
          block.setAttribute('data-block-pnum', bPnum);
          if (!resp.error) {
            EventMgr.trigger('appendDashList', { tabId: blockId });
          }
        }
        setTimeout(function() {
          EventMgr.trigger('updateScroll', { id: 'cont-tab0' });
        }, 300);
        setTimeout(function() {
          EventMgr.trigger('updateScroll', { id: 'cont-tab0' });
        }, 7000);
        block = null;
      },
      //render bands for
      renderBandDash = function(bands, id) {
        var bandLen = bands.length - 1,
            output = '',
            i, gid, title, titleClass, fullwidth;
        if (bandLen > 0) {
          for (i = 0; i < bandLen; i++) {
            gid = id + '-' + i + bands[i].id + '0';
            title = '';
            titleClass = '';
            fullwidth = bands[i].fullwidth ? 'fullwidth-band' : '';
            if (bands[i].bigTitle !== '') {
              title = bands[i].bigTitle || '';
              titleClass = 'big-title';
            } else if (bands[i].smallTitle !== '') {
              title = bands[i].smallTitle || '';
              titleClass = 'small-title';
            }
            output += templates.reportBandDash({
              empty: bands[i].empty,
              emptymsg: pageInfo.emptyreport,
              title: title,
              titleClass: titleClass,
              id: id,
              gid: gid,
              fullwidth: fullwidth });
          }
        } else {
          output = '<div class="dashboard-nodata">' + pageInfo.nodata + '</div>';
        }
        return output;
      },
      //render tables in reports
      renderBands = function(reports, tabId) {
        //if no data return fake chart
        if (reports.emptyBand) {
          if (reports.hasDiagram) {
            return templates.emptyBandOverlay({
              emptymsg: pageInfo.emptyreport, tabId: tabId });
          } else {
            return '<div class="report-nodata">' + pageInfo.nodata + '</div>';
          }
        }
        var bandsContent = '',
            bands = reports.bands,
            len = bands.length - 1,
            id = null, fullwidth,
            i;
        //go for bands
        for (i = 0; i < len; i++) {
          id = tabId + '-' + i;
          if (bands[i].content.length === 0) {
            if (bands[i - 1] && bands[i - 1].title) {
              bandsContent += '<div class="b-report-nodata">' + pageInfo.nodata + '</div>';
            }
            continue;
          }

          //check for band like title
          if (bands[i].title !== undefined) {
            fullwidth = bands[i].fullwidth ? 'fullwidth-band' : '';
            bandsContent += '<div class="band-content b-title ' + fullwidth +
                '"><div class="band-title big-title">' + bands[i].title +
                '</div></div>';
          } else {
            $.extend(bands[i], {
              elKey: bands[i].headers[0].name,
              pager: { pageElems: 0 },
              tabId: id, oTabId: tabId });
            bands[i].func = reports.func;
            var table = '<div>' + renderTable(bands[i]),
                gid = id + bands[i].id,
                aid = tabId + '-' + bands[i].id,
                title = '', titleClass = '',
                hidden = bands[i].hidden ? 'data-table-hidden' : '',
                showMsg = bands[i].showMsg,
                hideMsg = bands[i].hideMsg,
                hiddenClass = bands[i].hidden ? 'hidden' : '',
                diagrmCount = bands[i].diagram.length;
            fullwidth = bands[i].fullwidth ? 'fullwidth-band' : '';
            if (diagrmCount === 0) {
              fullwidth += ' nodiagram';
            }
            if (bands[i].smallTitle !== '') {
              title = bands[i].smallTitle;
              titleClass = 'small-title';
            }
            bandsContent += templates.reportBand({
              title: title || '',
              titleClass: titleClass,
              table: table,
              id: id,
              aid: aid,
              gid: gid,
              fullwidth: fullwidth,
              hidden: hidden,
              showMsg: showMsg,
              hideMsg: hideMsg,
              hiddenClass: hiddenClass,
              dc: diagrmCount });
            bandsContent += createTableRow(bands[i].headers, id);
          }          // EventMgr.trigger('loadChart', {diagram :
          // bands[i].diagram, gid : gid});
        }
        return bandsContent;
      },
      //render table with one row for sum in table reports
      createTableRow = function(headers, id) {
        var table = '<table id="table_sum-' + id + '"><tr>';
        for (var i = 0; i < headers; i++) {
          table += '<td>' +
              '<span class="data-sum" id="' + headers[i].name + '"></span>' +
              '</td>';
        }
        table += '</tr></table>';
        return table;
      },
      //data for reload page
      reloadTabData = function(e, data) {
        var tabId = data.tabId,
            resetFilterOn = data.resetFilterOn,
            url = pageInfo.url,
            iType = data.softUpdate ? 'softUpdate' : 'hardUpdate',
            filter = data.filter || false,
            param, scrollTop = 0,
            //stay help chain
            help = data.help,
            selid = data.selid || true;
        if (data.reload) {
          if (!checkReload(data)) {
            return;
          }
        }
        if (tabs[tabId] === undefined) { return; }
        var defParams = tabs[tabId].paramObjAll,
            parent = tabs[tabId].parent,
            newUrl = data.newurl ? true : false;
        if (data.param) {
          param = data.param;
          //check for pager
          /* jslint camelcase:false */
          if (param.p_num !== defParams.p_num) {
            selid = false;
          }
          /* jslint camelcase:true */
          /* jslint camelcase:false */
          if (param.p_num) {
            delete defParams.p_num;
          }
          /* jslint camelcase:true */
        } else {
          param = data.addedParam || {};
          if (tabs[tabId].param.match('p_num')) {
            param = App.Common.parseParams(tabs[tabId].param);
          }
        }
        defParams = $.extend(defParams, param);

        if (newUrl) {
          url = pageInfo.url;
        }
        //if has selected elems remember it
        if (selid) {
          scrollTop = getScrollTop(tabId);
          if (selid === true) {
            selid = getSelectedElems(tabId);
          }
        }
        //save filter value
        if (filter) {
          var filterBox = App.Dom.byId(tabId + '-search');
          if (filterBox) {
            filter = filterBox.value;
          } else {
            filter = false;
          }
        }

        //reset filter on when update from menu
        if (resetFilterOn) {
          delete defParams.filter;
        }

        //if request from filter drop, remove filter=on param from list
        if (data.__src === 'filterset' || data.__src === 'buildTabOk') {
          delete defParams.filter;
        }
        EventMgr.trigger('ajaxRequest', {
          url: url,
          param: defParams,
          invar: {
            dataSaved: true,
            parent: parent,
            targetTabId: tabId,
            selid: selid,
            scrollTop: scrollTop,
            iType: iType,
            __src: 'reloadTab',
            help: help ? tabs[tabId].help : false,
            liveFilter: filter },
          type: 'get',
          outtype: 'json',
          trfunc: 'ajaxResponse',
          queue: 'reloadTab' + tabId,
          failfunc: 'failCommonAjaxResponse' });
        if (iType !== 'softUpdate') {
          EventMgr.trigger('tabLoading', { tabId: tabId });
        }
      },

      //handler for submit form
      formHandler = function(e, data) {
        var tabId = data.tabId,
            selid = data.elid ? [data.elid] : true,
            parent = '', granny = '';
        //check for modal
        if (!tabs[tabId] && tabId === 'modal1') {
          EventMgr.trigger('formInspectorResponse', data);
        }
        //progressok for wizard form
        if (data.ok || data.progressok) {
          //check for notifyUp
          if (data.notifyUp) {
            EventMgr.trigger('forceCheckNotify');
          }
          //check for late update
          if (data.progresstype === 'wait') {
            EventMgr.trigger('progressBarSaveState', data);
            return false;
          }
          //check for banners
          if (data.message && data.message.length) {
            App.Global.bannerHtml = data.message;
            App.Global.warning = data.warning;
            App.Global.targetId = '';
          }
          if (tabs[tabId] && tabs[tabId].parent) {
            parent = tabs[tabId].parent;
          }

          if (!checkReload(data) ||
              !checkNewWin(data) ||
              !checkFeatures(data) ||
              !checkDasboard(data)) {
            closeTab(e, tabId);
            return false;
          }

          if (!checkNewForm(data) ||
              !checkNewList(data)) {
//            closeTab(e, tabId);
            return false;
          }

          if (data.bootTime) {
            EventMgr.trigger('startCheckRestart', { bootTime: data.bootTime });
          }
          //if has parent close self and reload parent
          if (tabs[tabId] && tabs[tabId].parent) {
            parent = tabs[tabId].parent;
            granny = tabs[tabs[tabId].parent].parent;
            closeTab(e, tabId);
            EventMgr.trigger('reloadTab', { tabId: parent, selid: selid, filter: true });
            EventMgr.trigger('tabLoading', { parent: granny });

          } else {
            closeTab(e, tabId);
          }
        } else if (data.error && !data.form) {
          showErrorOnForm(data);
        } else {
          EventMgr.trigger('ajaxResponse', data);
        }
      },

      showErrorOnForm = function(data) {
        if (data.error && data.targetTabId) {
          var ermsg = templates.banner({ message: {
            status: 'error',
            classes: '',
            id: data.targetTabId,
            text: App.Common.wordWrap(data.ermsg, 100),
            ref: false,
            refText: pageInfo.moreinfo,
            dismiss: data.msg.dismiss
          } });
          $('#cont-' + data.targetTabId).find('.error-message').html(ermsg);
          EventMgr.trigger('tabLoadingHide', { tabId: data.targetTabId });
          resetToDefaultFormButton(data.targetTabId);
          EventMgr.trigger('updateScroll', { id: 'form-scroll-' + data.targetTabId });
        }
      },

      //BuildPager
      buildPager = function(pager, tabId) {
        var slist = templates.formItemSelect({
              name: 'pager-slist',
              slist: pager.pageSlist,
              value: pager.pageNum,
              msg: pager.pageSlist[pager.pageNum - 1].value,
              depend: pager.depend,
              dependMaster: pager.dependMaster,
              dependFields: '',
              hide: '',
              show: '',
              readonly: '',
              setvalue: '',
              id: tabId,
              attrInput: '' }),
            pagerList = buildPagerList(pager.pageCount, pager.pageNum),
            pageCnt = pager.pageCnt,
            msgBegan = pager.msgPagershow,
            msgEnd = pager.msgPagerline,
            pagerHTML = templates.listPager({
              slist: slist,
              cnt: pageCnt,
              pagerList: pagerList,
              msgBegan: msgBegan,
              msgEnd: msgEnd });
        return pagerHTML;
      },
      //build list pager
      buildPagerList = function(pages, current) {
        var html = '',
            maxLen = 9,
            active = '',
            // length environment
            rl = Math.round((maxLen - 5) / 2);
        if (!current) {
          current = 1;
        }
        current = parseInt(current, 10);

        var standartPager = function(pages, current) {
          var html = '';
          for (var i = 1; i <= pages; i++) {
            if (i === current - 0) {
              active = 'pager-list__item_active';
            } else {
              active = 'pager-list__item_act';
            }
            html += '<span class="page pager-list__item ' + active + '" data-n="' + i + '">' + i + '</span>';
          }
          return html;
        },

            firstPageActive = function(maxLen, pages, current) {
              var html = '',
                  prevLast = maxLen - 1;
              for (var i = 1; i <= maxLen; i++) {
                if (i === current - 0) {
                  active = 'pager-list__item_active';
                } else {
                  active = 'pager-list__item_act';
                }
                if (i === prevLast) {
                  html += '<span class="page ellipsis">...</span>';
                } else if (i === maxLen) {
                  html += '<span class="page pager-list__item ' + active + '" data-n="' + pages + '">' + pages + '</span>';
                } else {
                  html += '<span class="page pager-list__item ' + active + '" data-n="' + i + '">' + i + '</span>';
                }
              }
              return html;
            },

            lastPageActive = function(maxLen, pages, current) {
              var html = '',
                  first = pages - maxLen;
              for (var i = 1; i <= maxLen; i++) {
                if (i + first === current - 0) {
                  active = 'pager-list__item_active';
                } else {
                  active = 'pager-list__item_act';
                }
                if (i === 2) {
                  html += '<span class="page ellipsis"> ... </span>';
                } else if (i === 1) {
                  html += '<span class="page pager-list__item ' + active + '" data-n="1">1</span>';
                } else {
                  html += '<span class="page pager-list__item ' + active + '" data-n="' + (i + first) + '">' + (i + first) + '</span>';
                }
              }
              return html;
            },

            middlePageActive = function(maxLen, pages, current, rl) {
              var html = '',
                  first = current - rl - 3,
                  prevLast = maxLen - 1;
              for (var i = 1; i <= maxLen; i++) {
                if (i + first === current) {
                  active = 'pager-list__item_active';
                } else {
                  active = '';
                }
                if (i === 1) {
                  html += '<span class="page pager-list__item pager-list__item_act' + active + '" data-n="1">1</span>';
                } else if (i === 2 || i === prevLast) {
                  html += '<span class="page ellipsis">...</span>';
                } else if (i === maxLen) {
                  html += '<span class="page pager-list__item pager-list__item_act ' + active + '"  data-n="' + pages + '">' + pages + '</span>';
                } else {
                  html += '<span class="page pager-list__item pager-list__item_act ' + active + '" data-n="' + (i + first) + '">' + (i + first) + '</span>';
                }
              }
              return html;
            };

        if (pages <= maxLen) {
          // console.log("case: standart");
          html = standartPager(pages, current);
        } else if (pages >= maxLen && (current - rl) <= 1) {
          // console.log("case: first");
          html = firstPageActive(maxLen, pages, current);
        } else if (pages >= maxLen && (current + rl) >= pages) {
          // console.log("case: last");
          html = lastPageActive(maxLen, pages, current);
        } else if (pages >= maxLen && ((current - rl) >= 1 ||
            (current + rl) <= pages)) {
          // console.log("case: middle");
          html = middlePageActive(maxLen, pages, current, rl);
        }

        return html;
      },

      addChartToTab = function(e, data) {
        var tabId = data.tabId,
            chart = data.chart;
        if (tabs[tabId] !== undefined) {
          tabs[tabId].chart = tabs[tabId].chart || [];
          tabs[tabId].chart.push(chart);
        }
      },

      getActiveHint = function(e, data) {
        var tabId = data.tabId,
            elid = data.elid,
            pName = data.pName,
            value = data.value,
            url = pageInfo.url,
            self = data.self,
            params;
        if (tabs[tabId] === undefined) { return; }
        params = App.Common.clone(tabs[tabId].paramObjAll);
        /* jslint camelcase:false */
        params.hint_field = pName;
        /* jslint camelcase:true */
        params.plid = params.elid;
        params.elid = elid;
        if (value) {
          params.value = value;
        }

        EventMgr.trigger('ajaxRequest', {
          url: url,
          param: params,
          invar: {
            hintTabId: tabId,
            hintElid: elid,
            hintValue: value,
            hintPName: pName,
            self: self },
          type: 'get',
          outtype: 'json',
          trfunc: 'ajaxResponseHint',
          queue: 'actHint' + tabId,
          failfunc: 'failCommonAjaxResponse' });
      },
      //hook for change field callbacks
      formFieldChangeHandler = function(e) {
        var tabId = this.getAttribute('data-tabid');
        //check for input contains in tab
        if (tabs[tabId]) {
          EventMgr.trigger('formFieldChanged', {
            tabObj: tabs[tabId],
            tabId: tabId,
            field: this });
        }
      },

      //  add formModel to data for setvalues
      addModelToSetvalues = function(data) {
        var tabId = data.tabId;
        if (tabs[tabId]) {
          data.__formModel = tabs[tabId].formModel;
        }
      },

      addListModel = function(data) {
        if (data.tabId) {
          var tabId = data.tabId.replace('cont-', '');
          if (tabs[tabId] && tabs[tabId].__content && tabs[tabId].__headers) {
            data.__content = tabs[tabId].__content;
            data.__headers = tabs[tabId].__headers;
          }
        }
      },

      updateModelBySetvalues = function(e, data) {
        var tabId = data.tabId;
        if (tabs[tabId]) {
          tabs[tabId].formModel[data.name] = data.value;
        }
      },

      addTabsModel = function(data) {
        if (data) {
          data.__tabs = tabs;
        }
      },
      //check form changed
      checkFormChange = function(tabId) {
        if (tabs[tabId] && tabs[tabId].formModel) {
          var formModel = tabs[tabId].formModel,
              count = 0,
              labels = '',
              isChanged = false;
          for (var keyVar in formModel) {
            if (formModel[keyVar].isChanged && formModel[keyVar].label) {
              count++;
              labels += formModel[keyVar].label + '<br/>';
              isChanged = true;
            }
          }
          return {
            isChanged: isChanged,
            count: count,
            labels: labels
          };
        } else {
          return {
            isChanged: false,
            count: 0
          };
        }
      },
      //save form page collapsed state to server
      saveFormPageState = function(e, data) {
        var tabId = data.tabId;
        if (tabs[tabId]) {
          var param = {
            page: data.name,
            action: tabs[tabId].func,
            func: 'collapse',
            collapse: data.collapsed ? 'off' : 'on'
          };
          EventMgr.trigger('ajaxRequest', {
            param: param,
            trfunc: 'DoNothing',
            queue: 'noqueue'
          });
        }
      },

      favoriteToggle = function(e) {
        e.preventDefault();
        var $self = $(this),
            tabId = $self.closest('.tab-content').attr('data-tabid'),
            favorite,
            options = {
              param: {},
              trfunc: 'favoriteMenuUpdateDone',
              outtype: 'json'
            };
        if (tabs[tabId]) {
          favorite = tabs[tabId].favorite;
          if (favorite) {
            options.param.func = 'usermenu.suspend';
            $self.addClass('b-elem_style_gracescale');
            $self.attr('data-state', 'unfavorite');
          } else {
            options.param.func = 'usermenu.resume';
            $self.removeClass('b-elem_style_gracescale');
            $self.attr('data-state', 'favorite');
          }
          options.param.elid = tabs[tabId].func;
          EventMgr.trigger('ajaxRequest', options);
          tabs[tabId].favorite = !favorite;
        }
      },

      pinToggle = function(e) {
        e.preventDefault();
        var $self = $(this),
            tabId = $self.closest('.tab-content').attr('data-tabid'),
            pin,
            $tabLi = $('#switch-' + tabId),
            options = {
              param: {},
              trfunc: 'pinTabDone',
              outtype: 'json'
            };
        if (tabs[tabId]) {
          pin = tabs[tabId].pin;
          if (pin) {
            options.param.func = 'usermenu.unpin';
            //options.param.func = 'usermenu.unpin';
            $self.addClass('b-elem_style_gracescale');
            $self.attr('data-state', 'unpin');
            $tabLi.removeClass('subtab_is_pin');
          } else {
            options.param.func = 'usermenu.pin';
            //options.param.func = 'usermenu.pin';
            $self.removeClass('b-elem_style_gracescale');
            $self.attr('data-state', 'pin');
            $tabLi.addClass('subtab_is_pin');
          }
          options.param.elid = tabs[tabId].func;
          EventMgr.trigger('ajaxRequest', options);
          tabs[tabId].pin = !pin;
          //update localstorage tabs
          EventMgr.trigger('changedTabs', { tabs: tabs });
        }

      },

      changeTabSortIndex = function(e, data) {
        if (data.s && data.t && tabs[data.s] && tabs[data.t]) {
           var sIndex = tabs[data.s].sIndex;
           tabs[data.s].sIndex = tabs[data.t].sIndex;
           tabs[data.t].sIndex = sIndex;
           EventMgr.trigger('changedTabs', { tabs: tabs });
        }
      },
      /**
       * close form & child list/report by ESC key
       * e {object} event object
       * data {object|undefined} event object data
       */
      esckeyHandler = function(e, data) {
        var $actTab = $('.tab-content_st_active'),
            type = $actTab.attr('data-tab-type'),
            tabId = $actTab.attr('data-tabid');
        if (type === 'list' || type === 'report') {
          $actTab.find('.toolbar-button__item-img.back').trigger('click');
        } else if (type === 'form') {
          $('#switch-' + tabId).find('.i-tab-close').trigger('click');
        }
      };

  return {
    init: init,
    //for dev
    tabs: tabs,
    closeTab: closeTab,
    moneyFormat: moneyFormat
  };
}(window, $, EventMgr, App, templates);


/**
 *  ExtFormHelper
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api API functions
 */
/*global App:true*/
App.ExtFormHelper = function(window, $, EventMgr, App) {
  'use strict';
  var self = '';
  // отправка формы по клику по кнопке
  var clickedButton = false;

  //convert rules for if/else in default format
  function convertIfRules(value, template) {
    var attrName = String(template).replace('__VALUE__', window.hash(value));
//    self.removeAttribute('data-init-func');
    self.setAttribute(attrName, 'yes');
  }
  //convert data-handler
  function convertDataHandler(value) {
//    self.removeAttribute('data-init-func');
    self.setAttribute('data-handler-val', window.hash(String(value)));
  }
  //run init function from attribute
  function initFunc() {
    var elems = $('*[data-init-func]'),
        l = elems.length,
        funcArr;
    while (l--) {
      self = elems[l];
      funcArr = String(self.getAttribute('data-init-func')).split('||');
      var funcLen = funcArr.length;
      for (var i = 0; i < funcLen; i++) {
        var func = funcArr[i].replace(/\s/g, '');
        try {
          /*jslint evil: true */
          eval('App.ExtFormHelper.' + func);
        } catch (e) {
          console.log('undefined function:', func);
        }
      }
      //remove attribute
      self.removeAttribute('data-init-func');
    }

    EventMgr.trigger('appendForm', { tabId: 'tab0' });

    setTimeout(function() {
      setRequiredField();
    }, 0);
  }

  function checkRequired() {
    var ok = true;
    $('#frm-tab0').find('input[required], textarea[required]').each(function() {
      var empty = (this.value === ''),
          hide = this.offsetWidth === 0;
      if (empty && !hide) {
        ok = false;
        return false;
      }
    });
    return ok;
  }

  function checkConfirm() {
    var field = $('#frm-tab0 input[data-confirm="yes"]'),
        confirmed = true;
    if (field.length > 0) {
      field.each(function() {
        var confirmField = this.getAttribute('data-check-field'),
            value1 = this.value,
            confirmFieldElem = App.Dom.byId(confirmField + '-tab0'),
            confirmFieldElemFake = App.Dom.byId(confirmField + '-' +
                'tab0-fake'),
            value2;
        if (confirmFieldElem !== null) {
          value2 = confirmFieldElem.value;
        }
        if (value1 !== value2 && (confirmFieldElem.offsetWidth !== 0 ||
            confirmFieldElemFake.offsetWidth !== 0)) {
          this.focus();
          confirmed = false;
        }
      });
    }
    return confirmed;
  }

  /**
   * Обработчик отправки формы по кнопке
   * @param { object } e объект события
   * @return { boolean } флаг отправки формы
   * @this button
   */
  function submitFormAction(e) {
    var name = this.getAttribute('name'),
        func = this.getAttribute('data-func'),
        isRequiredOk = checkRequired(),
        isPasswdConfirmed = checkConfirm();

    if (func) {
      e.preventDefault();
      window.location = pageInfo.host + pageInfo.binary + '?func=' + func;
    } else if (isRequiredOk && isPasswdConfirmed) {
      $('#i-clicked-button-input').val(name);
      this.value = this.getAttribute('data-disabled');
      this.className += ' b-button_st_disabled';
      clickedButton = true;
      $('#frm-tab0').submit();
      return false;
    } else if (!isPasswdConfirmed) {
      return false;
    }
  }

  /**
   * Обработчик отправки формы по ENTER
   */
  function formSubmitHandler() {
    var name = $('#i-default-button').attr('data-name');
    if (name && !clickedButton) {
      $('#i-clicked-button-input').val(name);
    }
  }

  /**
   *  Убирать у скрытых полей атрибут required, у видимых добавлять
   */
  function setRequiredField() {
    $('#frm-tab0').find('input[data-required], textarea[data-required]').each(function() {
      var hide = this.offsetWidth === 0;
      if (hide) {
        this.removeAttribute('required');
      } else if (!this.hasAttribute('required')) {
        this.setAttribute('required', 'required');
      }
    });
  }

  /**
   * Обработчик изменений полей, которые управляют скрытием других полей
   */
  function changeControlFieldHandler() {
    setTimeout(function() {
      setRequiredField();
    }, 0);
  }

  function init() {
    EventMgr.bind('pageLoad', initFunc);
    EventMgr.obind('.i-button-extform', 'click', submitFormAction);
    EventMgr.obind('#frm-tab0', 'submit', formSubmitHandler);
    EventMgr.obind('.control-field input[type="hidden"], .control-field .b-input, .control-field .b-input_type_file, .control-field .b-textarea', 'change', changeControlFieldHandler);
  }

  var api = {
    init: init,
    convertIfRules: convertIfRules,
    convertDataHandler: convertDataHandler
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Wizard Module
 * Control wizard steps
 * @param {object} window global object
 * @param {object|function} $ jQuery
 * @param {object} EventMgr Event manager
 */
/*global App:true*/
App.Wizards = function(window, $, EventMgr) {
  'use strict';

  /**
   * Event in appendForm for check wizard steps
   * @param {object} e
   * @param {object} data
   */
  function wizardLoad(e, data) {
    var tabId = data.tabId;
    setTimeout(function() {
      EventMgr.trigger('bindHorizScrollControl', {
        leftBtn: '#cont-' + tabId + ' .i-wizard__triangle_dir_left',
        rightBtn: '#cont-' + tabId + ' .i-wizard__triangle_dir_right',
        actElem: '#cont-' + tabId + ' .i-wizard__step-num_st_active',
        innerBox: '#cont-' + tabId + ' .i-wizard__inner',
        id: tabId
      });
    }, 50);
  }

  /**
   * Init function
   * Bind to needed events
   */
  function init() {
    EventMgr.bind('appendForm', wizardLoad);
  }

  var api = {
    init: init
  };

  return api;
}(window, $, EventMgr);

/**
 * Select Module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.PrefixSelect = function(window, $, EventMgr, App) {
  'use strict';

  var CACHE = {},
      selectPrefixSelector = '.i-myselect_is_prefix',
      inputPrefixSelector = 'input.i-input_has_prefix',
      timeOutId;

  function $content() {
    return App.Common.selectorCache('.i-form-wr');
  }

  function inputPrefixHandlerWrapper(e) {
    var self = this;
    clearTimeout(timeOutId);
    timeOutId = setTimeout(function() {
       inputPrefixHandler(self);
    }, 300);
  }
  /**
   * Input prefix handler
   *
   **/
  function inputPrefixHandler(elem, isInit) {
    var value = elem.value,
        tabId = elem.getAttribute('data-tabid'),
        prefixSelectName = elem.getAttribute('data-prefix-name'),
        selectIndex = getSelectIndex(tabId, prefixSelectName),
        prevPrefix = elem.getAttribute('data-prefix'),
        findObject = findInSelect(value, selectIndex),
        selectElem;
    if (isInit) {
      selectElem = $('#' + tabId + '-' + prefixSelectName + ' li.selected')
        .trigger('click', [null, { isIgnore: true }]);
      var prefix = selectElem.attr('data-code');
      var mask = selectElem.attr('data-mask');
      //set data-prefix
      elem.setAttribute('data-prefix', prefix);
      //set data-mask
      if (mask) {
        elem.setAttribute('data-mask', mask);
        EventMgr.trigger('inputMaskChangeBySetvalues', { elem: elem, mask: mask, value: value });
      }
      return;
    }
    //set find prefix value
    if (findObject.isFind && prevPrefix !== findObject.prefix) {
      $($('#' + tabId + '-' + prefixSelectName + ' li[data-code="' + findObject.prefix + '"]:not(".selected")')[0])
        .trigger('click', [null, { isIgnore: true }]);
      //set data-prefix
      elem.setAttribute('data-prefix', findObject.prefix);
      if (findObject.mask) {
        elem.setAttribute('data-mask', findObject.mask);
        EventMgr.trigger('inputMaskChangeBySetvalues', { elem: elem, mask: findObject.mask, value: value });
      }
    }
  }
  //get cached index
  function getSelectIndex(tabId, name) {
    if (!CACHE[tabId]) {
      CACHE[tabId] = {};
    } else if (CACHE[tabId][name]) {
      return CACHE[tabId][name];
    }

    CACHE[tabId][name] = makeIndex(tabId, name);
    return CACHE[tabId][name];
  }
  //make select values index
  function makeIndex(tabId, name) {
    var items = $('#' + tabId + '-' + name + ' li'),
        l = items.length,
        index = {};
    while (l--) {
      index[items[l].getAttribute('data-code')] = { mask: items[l].getAttribute('data-mask')};
    }
    return index;
  }
  //find in select index
  function findInSelect(value, selectIndex) {
    var searchPrefix = String(value).replace(/\)/g, '').replace(/\(/g, '').replace(/\s/g, '');
    for (var i = 0, l = String(value).length; i < l; i++) {
      if (selectIndex[searchPrefix]) {
        return { isFind: true, prefix: searchPrefix, mask: selectIndex[searchPrefix].mask };
      }
      searchPrefix = searchPrefix.substring(0, searchPrefix.length - 1);
    }
    return { isFind: false };
  }
  //remove value ignore white spaces
  function removeIgnoreWhiteSpace(replacement, value) {
    var valueArr = String(value).split(''),
        replacementArr = String(replacement).split(''),
        replacementLength = replacementArr.length,
        ii = 0;
    for (var i = 0, l = valueArr.length; i < l; i++) {
      if (valueArr[i] !== ' ' &&
          valueArr[i] !== '(' &&
          valueArr[i] !== ')' &&
          valueArr[i] !== '_' &&
          valueArr[i] !== '-') {

        if (valueArr[i] === replacementArr[ii]) {
          ii++;
          valueArr[i] = '';
          if (replacementLength === ii) {
            break;
          }
        }
      } else {
        valueArr[i] = '';
      }
    }
    return valueArr.join('');
  }
  /**
   * Select prefix handler 
   *
   **/
  function prefixHandler(e, data, d) {
    if (d && d.isIgnore) {
      return;
    }
    var targetName = this.getAttribute('data-targetinput'),
        tabId = this.getAttribute('data-tabid'),
        $target = $('#' + targetName + '-' + tabId),
        targetPrefix = $target.attr('data-prefix'),
        key = this.value,
        value = $target.val(),
        $selectElem = $('#' + tabId + '-' + this.getAttribute('name') + ' li[data-val="' + key + '"]'),
        newPrefix = $selectElem.attr('data-code'),
        mask = $selectElem.attr('data-mask');
    //remove prev prefix
    value = removeIgnoreWhiteSpace(targetPrefix, value);
    //just insert to 1st position
    value = newPrefix + value;
    $target.val(value);
    if (mask) {
      EventMgr.trigger('inputMaskChangeBySetvalues', { elem: $target[0], mask: mask, value: value });
    }
    //set new prefix
    $target.attr('data-prefix', newPrefix);
  }

  function checkInitValue(e, data) {
    var tabId = data.tabId;
    $('#cont-' + tabId + ' .i-input_has_prefix').each(function() {
        inputPrefixHandler(this, true);
    });
  }

  function init() {
    EventMgr.on($content(), selectPrefixSelector, 'change', prefixHandler);
    EventMgr.on($content(), inputPrefixSelector, 'change', inputPrefixHandlerWrapper);
    EventMgr.on($content(), inputPrefixSelector, 'keyup', inputPrefixHandlerWrapper);
    EventMgr.bind('appendForm', checkInitValue);
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Module provide filter with checkboxes for formlist`
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.FormListFilter = function(window, $, EventMgr, App) {
  'use strict';
  function $mainWrapper() {
    return $('#main-wrapper');
  }

  function filterListCallback(e, data) {
    var $filterWrapper = $(this).closest('.i-form-list__filter'),
        srcName = $filterWrapper.attr('data-srcname'),
        tabId = this.getAttribute('data-tabid'),
        $formList = $('#' + tabId + '-' + srcName);
    EventMgr.trigger('formListFilterHandler', {
         tabId: tabId,
         name: srcName,
         $formList: $formList,
         $filterWrapper: $filterWrapper })
    //filterListHandler($formList, $filterWrapper);
  }

  function filterListHandler(e, data) {
    var $formList = data.$formList,
        tabId = data.tabId,
        $filterWrapper = data.$filterWrapper,
        listName = data.name,
        $formRows = $formList.find('.row__has__tags');

    var $filterItems = $filterWrapper.find('input[type="hidden"]'),
        actFilter = [],
        actFilterLen = 0,
        hasCheckedFilters = false;

    //show elems
    $filterItems.each(function() {
       var name = this.getAttribute('name');
       if (this.value === 'on') {
         actFilter.push({ name: name, isChecked: true });
         actFilterLen ++;
       } else {
         //actFilter.push({ name: name, isChecked: false });
       }
    });

    var hasTag,
        countFound = 0;
    for (var i = 0, l = $formRows.length; i < l; i++) {
      hasTag = false;
      if (actFilterLen !== 0) {
        $formList.addClass('b-form-list__table_filter_yes');
        $filterWrapper.addClass('b-form-list__filter_filter_yes');
        for (var j = 0; j < actFilterLen; j++) {
          if ($formRows[i] && $formRows[i].className.match(actFilter[j].name)) {
            hasTag = true;
            //break;
          } else {
            hasTag = false;
            break;
          }
        }
        if (!hasTag) {
          $formRows[i].style.display = 'none';
        } else {
          $formRows[i].style.display = '';
          countFound++;
        }
      } else {
        $formRows[i].style.display = '';
        $formList.removeClass('b-form-list__table_filter_yes');
        $filterWrapper.removeClass('b-form-list__filter_filter_yes');
      }
    }
    if (countFound === 0 && actFilterLen !== 0) {
      $filterWrapper.find('.b-form-list__filter-notfound').css('display', 'block');
    } else {
      $filterWrapper.find('.b-form-list__filter-notfound').css('display', '');
    }
    EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
  }

  function updateFilter(e, data) {
    var tabId = data.tabId,
        $filterLists = $('#cont-' + tabId + ' .i-form-list__filter'),
        $formList, srcName;
    $filterLists.each(function() {
       srcName = this.getAttribute('data-srcname');
       $formList = $('#' + tabId + '-' + srcName);
       EventMgr.trigger('formListFilterHandler', {
            tabId: tabId,
            name: srcName,
            $formList: $formList,
            $filterWrapper: $(this) })
       //filterListHandler($filterList, $(this));
    });
  }

  function resetFilter() {
    var $filterWrapper = $(this).closest('.i-form-list__filter'),
        tabId = $filterWrapper.attr('data-tabid'),
        $filterItems = $filterWrapper.find('input[type="hidden"]');
    $filterItems.each(function() {
      if (this.value === 'on') {
        $(this).closest('.b-checkbox__wrapper').find('.b-checkbox__control').trigger('click');
      } 
    });
    EventMgr.trigger('updateScroll', { id: 'form-scroll-' + tabId });
  }

  function init() {
    EventMgr.on($mainWrapper(), '.b-form-list__filter input[type="hidden"]', 'change', filterListCallback);
    EventMgr.on($mainWrapper(), '.i-form-list__filter-clear', 'click', resetFilter);
    EventMgr.bind('setValuesDone', updateFilter);
    EventMgr.bind('formListFilterHandler', filterListHandler);
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Module provide store in site
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.Store = function(window, $, EventMgr, App) {
  'use strict';
  var project = pageInfo.project || 1;

  function $formContent() {
    return App.Dom.byId('isp-store-wrapper');
  }
  //init store func, get startform
  function storeInit() {
    if (pageInfo.startform) {
      var params = App.u.parseParams(pageInfo.startform);
     // params.authinfo = 'hank@tsjee.ru:q1w2e';
      //params.project = project;
      params.storemode = 'on';
      EventMgr.trigger('ajaxRequest', {
        param: params,
        outtype: 'json',
        trfunc: 'storeResp',
        invar: {
          showcaseForm: true
        }
      });
    }
  }
  //caught event & set type of content
  function preRespActions(e, data) {
    var obj = data;
    //caught fatal error
    if (obj.form || obj.formParam) {
      obj.type = 'showcaseForm';
      obj.showcase = true;
      EventMgr.trigger('ajaxResponse', obj);
      EventMgr.trigger('storeBasketForceUpdate');
    } else if (obj.error) {
      EventMgr.trigger('storeError', obj);
    //type url handler
    } else if (obj.ok && obj.location) {
      window.location = obj.location;
    }
  }
  //insert form in tab-content box
  function insertStoreForm(e, data) {
    var html = data;
    $formContent().innerHTML = html;
    EventMgr.trigger('tabLoadingHide', { tabId: 'tab0' });
    EventMgr.trigger('appendForm', { tabId: 'tab0' });
  }
  //ajax request hook, set type json & change trFunc
  function ajaxRequestHook(data) {
    var options = data;
    //options.param.authinfo = 'hank@tsjee.ru:q1w2e';
    //options.param.project = project;
    options.param.storemode = 'on';
    delete options.param.callback;
    if (options.trfunc === 'ajaxResponse' ||
        options.trfunc === 'ajaxFormResponse') {
      options.trfunc = 'storeResp';
    }
  }

  function ajaxResponseHook(data) {
  }

  function storeError(e, data) {
    var html = templates.fatalAlert({
      msg: data.ermsg
    });
    $formContent().innerHTML = html;
  }

  function openBasket(e, data) {
    var params = { func: 'basket' };
    //params.authinfo = 'hank@tsjee.ru:q1w2e';
    //params.project = project;
    params.storemode = 'on';
    EventMgr.trigger('ajaxRequest', {
      param: params,
      outtype: 'json',
      trfunc: 'storeResp',
      invar: {
        showcaseForm: true
      }
    });
  }

  function init() {
    EventMgr.bind('readyShowcaseFormHtml', insertStoreForm);
    EventMgr.bind('storeResp', preRespActions);
    EventMgr.bind('storeLoad', storeInit);
    EventMgr.bind('storeError', storeError);
    EventMgr.bind('openStoreBasket', openBasket);
    //add hooks for ajax request/response
    if (App.AjaxHelper) {
      if (App.AjaxHelper.addRequestHook &&
          typeof App.AjaxHelper.addRequestHook === 'function') {
        App.AjaxHelper.addRequestHook(ajaxRequestHook);
      }
     // if (App.AjaxHelper.addResponseHook &&
     //     typeof App.AjaxHelper.addResponseHook === 'function') {
     //   App.AjaxHelper.addResponseHook(ajaxResponseHook);
     // }
    }
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Module provide basket in store in site
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.StoreBasket = function(window, $, EventMgr, App) {
  'use strict';

  var timeout = 60000,
      project = pageInfo.project || 1;

  var basketTempl = '({{=it.count}}шт.) {{=it.sum}} {{=it.iso}}';


  var tempFunc = window.doT.template(basketTempl);

  function $basketWrapper() {
    return App.Dom.byId(pageInfo.basket.blockId);
  }
  //init store func, get startform
  function storeBasketInit() {
    if (pageInfo.basket) {
      setTimeout(function() {
        getBasket();
      }, 300);
      setInterval(function() {
        getBasket();
      }, timeout);
    }
  }

  function getBasket() {
    var params = {
      func: 'showroom.menu',
      out: 'sjson'
    };
    params.storemode = 'on';
    EventMgr.trigger('ajaxRequest', {
      param: params,
      outtype: 'json',
      trfunc: 'storeBasketResp',
      invar: {
        showcaseForm: true
      }
    });
  }

  function updateBasket(basket) {
    var html = tempFunc(basket),
        $basketWrapperNode = $basketWrapper();
    if ($basketWrapperNode) {
      $basketWrapperNode.innerHTML = html;
    }
  }

  function storeBasketRespHandler(e, data) {
    EventMgr.trigger('storeUserMenuResp', data);
    if (data &&
        data.doc &&
        data.doc.basket &&
        data.doc.basket.count &&
        data.doc.basket.sum &&
        data.doc.basket.currency &&
        data.doc.basket.currency.iso) {
        var basket = data.doc.basket;
        updateBasket({ count: basket.count.$, sum: basket.sum.$, iso: basket.currency.iso.$ });
    }
  }

  function basketClickHandler(e) {
    e.preventDefault();
    EventMgr.trigger('openStoreBasket', {});
  }

  function init() {
    if (pageInfo.basket && pageInfo.basket.blockId) {
      EventMgr.bind('storeLoad', storeBasketInit);
      EventMgr.bind('storeBasketForceUpdate', getBasket);
      EventMgr.bind('storeBasketResp', storeBasketRespHandler);
      EventMgr.on($($basketWrapper()), '.i-store__basket', 'click', basketClickHandler);
    }
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 * Module provide store in site
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
App.StoreUserMenu = function(window, $, EventMgr, App) {
  'use strict';

  var project = pageInfo.project;

  var menuItemsForUser = '.dropdown-menu__list-item_for_user',
      menuItemsForGuest = '.dropdown-menu__list-item_for_guest';

  var userMenuTempl = '<div class="b-store__usermenu i-store__usermenu">' +
    '<div class="b-store__usermenu-value">{{=it.username}}<span class="caret"></span></div>' +
  '</div>';

  var tempFunc = window.doT.template(userMenuTempl);

  function $userMenuWrapper() {
    return App.Dom.byId(pageInfo.usermenu.blockId);
  }

  function renderUserMenu(e, data) {
    if (data.doc &&
        data.doc.user &&
        data.doc.user.user &&
        data.doc.user.user.$level !== '8') {
      var html = tempFunc({ username: data.doc.user.user.$name }),
          $userMenuNode = $userMenuWrapper();
      if ($userMenuNode) {
        //$userMenuNode.removeAttribute('data-toggle');
        $userMenuNode.innerHTML = html;
      }
      //hide guest menu items
      $(menuItemsForGuest).hide();
      //show user menu items
      $(menuItemsForUser).show();
    } else if (data.doc &&
               data.doc.error &&
               data.doc.error.$type === 'access') {
       $userMenuNode = $userMenuWrapper();
       if ($userMenuNode) {
         $userMenuNode.innerHTML = 'Личный кабинет <span class="caret"></span>';
       }
      //show guest menu items
      $(menuItemsForGuest).show();
      //hide user menu items
      $(menuItemsForUser).hide();
    }
  }

  function init() {
    if (pageInfo.usermenu && pageInfo.usermenu.blockId) {
      EventMgr.bind('storeUserMenuResp', renderUserMenu);
    }
  }

  var api = {
    init: init
  };

  return api;

} (window, $, EventMgr, App);


/**
 *  ErrorReport module
 *  @param {object} window  global object
 *  @param {function} $ jQuery library
 *  @param {object} EventMgr EventMgr library
 *  @param {object} App Application
 *  @return {object} api
 */
/*global App:true*/
/*global EventMgr:true*/
/*global $:true*/
App.ErrorReport = function(window, $, EventMgr, App) {
  'use strict';

  function errorReport(errorMsg, url, lineNumber, colNumber, error) {
    var param = {};
    param.error_url = url + '______' + window.location.href;
    param.error_message = errorMsg;
    param.stack_trace = lineNumber;
    param.error = error;
    param.col_number = colNumber;
    param.user_level = pageInfo.userLevel;
    param.product = pageInfo._product;
    param.is_branding = pageInfo.isBranding;
    param.theme = 'orion';
    param.module = $('.tab-content_st_active').attr('data-func');
    param.version = pageInfo.version;
    EventMgr.trigger('ajaxRequest', {
      url: 'https://themereport.ispsystem.net:3001/api/errorreport/',
      param: param,
      type: 'jsonp'
    });
  }

  window.onerror = errorReport;

} (window, $, EventMgr, App);

//Constructor for tabs
(function(window, $, templates) {
  'use strict';
  function TabObj(id, status, type, selfUrl) {
    this.id = id;
    this.cid = 'cont-' + this.id;
    //this.title = title;
    this.status = status || 0;
    this.type = type;
    this.selfUrl = selfUrl;
    this.body = '';
    this.header = '';
    this.param = '';
    this.sIndex = String(id).replace('tab', '') - 0;
  }

  TabObj.fn = TabObj.prototype;

  TabObj.fn.deactive = function() {
    $('#' + this.id).removeClass('active');
    $('#switch-' + this.id).removeClass('active');
    //$('#s-' + this.id).removeClass('active');
    if (this.hType === 'child') {
      $('#' + this.gParent).removeClass('active');
      $('#switch-' + this.gParent).removeClass('active');
    }
    $('#' + this.cid).removeClass('tab-content_st_active').addClass('hidden');
    this.status = 0;
  };

  TabObj.fn.activate = function() {
    $('#' + this.id).addClass('active');
    $('#switch-' + this.id).addClass('active');
    //$('#s-' + this.id).addClass('active');
    if (this.hType === 'child') {
      $('#' + this.gParent).addClass('active');
    }
    $('#' + this.cid).addClass('tab-content_st_active').removeClass('hidden');
    this.status = 1;
  };
  //render HTML for tabHead and tabBody
  TabObj.fn.render = function() {
    switch (this.type) {
      case 'empty':
        this.htmlBody = templates.tabContEmpty(this.body);
        if (this.hType === 'parent') {
          this.htmlHeader = templates.tabLi(this.header);
        } else {
          this.htmlHeader = templates.tabChld(this.header);
        }
        break;
      case 'list':
        this.htmlBody = templates.tabCont(this.body);
        if (this.hType === 'parent') {
          this.htmlHeader = templates.tabLi(this.header);
        } else {
          this.htmlHeader = templates.tabChld(this.header);
        }
        break;
      case 'form':
        this.htmlBody = templates.tabContForm(this.body); //going replace
        if (this.hType === 'parent') {
          this.htmlHeader = templates.tabLi(this.header);
        } else {
          this.htmlHeader = templates.tabChld(this.header);
        }
        break;
      case 'report':
        this.htmlBody = templates.tabContForm(this.body); //going replace
        if (this.hType === 'parent') {
          this.htmlHeader = templates.tabLi(this.header);
        } else {
          this.htmlHeader = templates.tabChld(this.header);
        }
        break;
      case 'dashboard':
        this.htmlBody = templates.tabContDashBoard(this.body);
        break;
      case 'map':
      case 'rack':
        this.htmlBody = templates.tabContMap(this.body); //going replace
        if (this.hType === 'parent') {
          this.htmlHeader = templates.tabLi(this.header);
        } else {
          this.htmlHeader = templates.tabChld(this.header);
        }
        break;

    }
    return this;
  };
  //append tabBody and tabHead
  TabObj.fn.append = function(tabId) {
    if (this.htmlHeader && this.htmlBody) {
      if (this.hType === 'parent') {
        tabId = tabId || 'add-tab';
        $('#nav-tabs #' + tabId).before(this.htmlHeader);
      } else {
        $('#' + this.gParent).append(this.htmlHeader);
      }
      $('#wr-content').append(this.htmlBody);
    } else if (this.htmlBody) {
      $('#wr-content').append(this.htmlBody);
    }

    return this;
  };
  //replace tabBody
  TabObj.fn.update = function() {
    var body = document.getElementById(this.cid);
    if (body !== null) {
      body.parentNode.removeChild(body);
    }
    $('#wr-content').append(this.htmlBody);
    return this;
  };
  //replace only table
  TabObj.fn.softUpdate = function() {
    var table = document.getElementById('ltwr-' + this.id),
        newTable = '';
    if (table !== null) {
      newTable = '<div class="content" id="ltwr-' + this.id +
          '" data-tabid=' + this.id + '>' + this.body.table + '</div>';
      $(table).replaceWith(newTable);
    }
    return this;
  };
  //replace tabBody and tabHeader
  TabObj.fn.replace = function() {
    var tabHeader = document.getElementById(this.id),
        tabBody = document.getElementById(this.cid);
    if (tabBody !== null) {
      tabBody.parentNode.removeChild(tabBody);
    }
    $('#wr-content').append(this.htmlBody);
    if (tabHeader !== null) {
      $(tabHeader).replaceWith(this.htmlHeader);
    }
    return this;
  };
  //remove temprorary properties
  TabObj.fn.clean = function() {
    this.htmlBody = null;
    this.htmlHeader = null;
    this.header = null;
    this.body = null;
  };
  //close tab
  TabObj.fn.close = function() {
    if (this.chart !== undefined) {
      var myArray = this.chart,
          i = this.chart.length;
      while (i--) {
        if (typeof myArray[i].clearChart === 'function') {
          myArray[i].clearChart();
          myArray[i] = null;
        }
      }
    }
    var header = document.getElementById(this.id),
        body = document.getElementById(this.cid);
    if (header !== null) {
      header.parentNode.removeChild(header);
    }
    if (body !== null) {
      body.parentNode.removeChild(body);
    }
    header = null;
    body = null;
  };

  window.TabObj = TabObj;
  //Constructor for menuGroup
  function MenuGroup(level, id, status, self) {
    this.level = level;
    this.id = id;
    this.status = (status !== null) ? status : '0';
    this.self = self;
  }
  MenuGroup.fn = MenuGroup.prototype;
  //methods
  MenuGroup.fn.statusUp = function(status) {
    this.status = status;
  };

  MenuGroup.fn.activate = function() {
    this.status = '1';
    this.self.removeClass('collapsed');
  };

  MenuGroup.fn.disactivate = function() {
    this.status = '0';
    this.self.addClass('collapsed');
  };

  MenuGroup.fn.toggle = function() {
    if (this.status === '1') {
      this.status = '0';
    } else {
      this.status = '1';
    }
    this.self.toggleClass('collapsed');
  };

  window.MenuGroup = MenuGroup;
  //utilits
  //setCookie
  function setCookie(cName, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var cValue = encodeURIComponent(value) + ((exdays === null) ? '' :
        '; expires=' + exdate.toUTCString());
    document.cookie = cName + '=' + cValue;
  }
  window.setCookie = setCookie;
  //getCookie
  function getCookie(cName) {
    var i, x, y, ARRcookies = document.cookie.split(';');
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === cName) {
        return decodeURIComponent(y);
      }
    }
    return '';
  }
  window.getCookie = getCookie;
  //jquery !plugins
  $.fn.switchClass = function(added, removed) {
    return this.removeClass(removed).addClass(added);
  };

  $.fn.serializeObject = function() {
    var formArray = this.serializeArray(),
        formObject = {},
        length = formArray.length,
        i;
    for (i = 0; i < length; i++) {
      formObject[formArray[i].name] = formArray[i].value;
    }
    return formObject;
  };
  //get flags from attr data-flag="default|reload"
  $.fn.getFlags = function() {
    var flags = {},
        flagString = this.attr('data-flags'),
        flagStringArr;
    if (flagString) {
      flagStringArr = flagString.split('|');
      for (var i = 0, l = flagStringArr.length; i < l; i++) {
        flags[$.trim(flagStringArr[i])] = true;
      }
    }
    return flags;
  };

  //get vars from attribute data-vars="t:1|r:25"
  $.fn.getVars = function() {
    var vars = {},
        varsString = this.attr('data-vars'),
        varsStringAttr,
        varsStringValue;
    if (varsString) {
      varsStringAttr = String(varsString).split('|');
      for (var i = 0, l = varsStringAttr.length; i < l; i++) {
        varsStringValue = varsStringAttr[i].split(':');
        if (varsStringValue && varsStringValue[0] && varsStringValue[1]) {
          vars[varsStringValue[0]] = varsStringValue[1];
        }
      }
    }
    return vars;
  };

  //@todo remove from all

  function blockEvent(e) {
    e = e || window.event;
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    else {
      e.cancelBubble = true;
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    else {
      e.returnValue = false;
    }
  }
  window.blockEvent = blockEvent;

  //from here https://github.com/janl/mustache.js/blob/master/mustache.js#L47
  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>' ,
    '&quot;': '"',
    '&#39;': "'" ,
    '&#x2F;': '/'
  };

  function scrollToTopLeft() {
    if (!window.pageInfo.mobile && !window.pageInfo.store && !window.pageInfo.extform) {
      window.scrollTo(0, 0);
    }
  }

  window.scrollToTopLeft = scrollToTopLeft;

  function htmlEscape(string) {
    return String(string).replace(/[&<>"'\/]/g, function(s) {
      return entityMap[s];
    });
  }

  window.htmlEscape = htmlEscape;
  function htmlDecode(value) {
    return $('<div/>').html(value).text();
  }
  window.htmlDecode = htmlDecode;

  function htmlEncode(s) {
    s = String(s).replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    return s;
  }
  window.htmlEncode = htmlEncode;
  function blockSelection() {
    if (window.getSelection) { window.getSelection().removeAllRanges(); }
    //else if (document.selection && document.selection.clear) {
    // document.selection.clear();
    // }
    else if (document.selection && document.selection.empty) {
      document.selection.empty();
    }
  }
  window.blockSelection = blockSelection;
  function hash(input) {
    var hashI = 0, charI, i;
    if (input.length === 0) {
      return hashI;
    }
    for (i = 0; i < input.length; i++) {
      charI = input.charCodeAt(i);
      hashI = ((hashI << 5) - hashI) + charI;
      hashI = hashI & hashI; // Convert to 32bit integer
    }
    return 'id' + hashI;
  }
  window.hash = hash;


  var split;

  // Avoid running twice; that would break the `nativeSplit` reference
  split = window.split || function(undef) {

    var nativeSplit = String.prototype.split,
        // NPCG: nonparticipating capturing group
        compliantExecNpcg = /()??/.exec('')[1] === undef,
        self;

    self = function(str, separator, limit) {
      // If `separator` is not a regex, use `nativeSplit`
      if (Object.prototype.toString.call(separator) !== '[object RegExp]') {
        return nativeSplit.call(str, separator, limit);
      }
      var output = [],
          flags = (separator.ignoreCase ? 'i' : '') +
          (separator.multiline ? 'm' : '') +
          (separator.extended ? 'x' : '') + // Proposed for ES6
          (separator.sticky ? 'y' : ''), // Firefox 3+
          lastLastIndex = 0,
          // Make `global` and avoid `lastIndex` issues by working with a copy
          separator2, match, lastIndex, lastLength;
      separator = new RegExp(separator.source, flags + 'g');
      str += ''; // Type-convert
      if (!compliantExecNpcg) {
        // Doesn't need flags gy, but they don't hurt
        separator2 = new RegExp('^' + separator.source + '$(?!\\s)', flags);
      }

      limit = limit === undef ?
          -1 >>> 0 : // Math.pow(2, 32) - 1
          limit >>> 0; // ToUint32(limit)
      /* jslint boss:true*/
      while (match = separator.exec(str)) {
        // `separator.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0].length;
        if (lastIndex > lastLastIndex) {
          output.push(str.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently
          // return `undefined` for
          // nonparticipating capturing groups
          /* jslint loopfunc:true*/
          if (!compliantExecNpcg && match.length > 1) {
            match[0].replace(separator2, function() {
              for (var i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === undef) {
                  match[i] = undef;
                }
              }
            });
          }
          if (match.length > 1 && match.index < str.length) {
            Array.prototype.push.apply(output, match.slice(1));
          }
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= limit) {
            break;
          }
        }
        if (separator.lastIndex === match.index) {
          separator.lastIndex++; // Avoid an infinite loop
        }
      }
      if (lastLastIndex === str.length) {
        if (lastLength || !separator.test('')) {
          output.push('');
        }
      } else {
        output.push(str.slice(lastLastIndex));
      }
      return output.length > limit ? output.slice(0, limit) : output;
    };

    // For convenience
    String.prototype.split = function(separator, limit) {
      return self(this, separator, limit);
    };

    return self;

  }();

}(window, $, templates));
